/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//g.mdcdn.cn/wp/dist/m_event_mall_base/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	try {
	    var iosFixedDate = function iosFixedDate(strDatetime) {
	        return strDatetime ? strDatetime.replace(/-/g, '/') : '';
	    };
	
	    var strtotime = function strtotime(date) {
	        date = new Date(Date.parse(date.replace(/-/g, "/")));
	        date = date.getTime();
	        return date;
	    };
	
	    var func = __webpack_require__(10);
	    var Mustache = __webpack_require__(51);
	    var report = __webpack_require__(52);
	    __webpack_require__(33);
	
	    var dialogTpl = __webpack_require__(92);
	
	    var miniProgram = __webpack_require__(53);
	    var wx = __webpack_require__(46);
	    window.IsWxMiniProgram = false;
	
	    var func = __webpack_require__(10);
	    window.miniapp = func.getUrlParam('miniapp');
	
	    var HasBinTipBtn = false;
	
	    var widgetVipcard = __webpack_require__(57);
	    var widgetCouponlist = __webpack_require__(55);
	    var widgetMiaoCouponlist = __webpack_require__(56);
	    var hasInitOnce = false;
	
	    var Swiper = __webpack_require__(93);
	
	    var isLs = 0;
	
	    var mEventAppDomain = '';
	    if (window.location.host.indexOf('.littleswan.com') > -1) {
	        isLs = 1;
	    }
	
	    var isSH = 0;
	    if (window.location.host.indexOf('wx506caed3066ee044') > -1) {
	        isSH = 1;
	    }
	
	    var isDZ = 0;
	    if (window.location.host.indexOf('m.toshiba-lifestyle.cn') > -1) {
	        isDZ = 1;
	    }
	
	    var shop_type = 11;
	    if (isLs) {
	        shop_type = 1;
	    }
	    if (isSH) {
	        shop_type = 2;
	    }
	    if (isDZ) {
	        shop_type = 3;
	    }
	    window.shop_type = shop_type;
	    window.isLs = isLs;
	    if (isLs) {
	        var login = __webpack_require__(49).init();
	        mEventAppDomain = '//m.littleswan.com';
	    } else {
	        var login = __webpack_require__(9).init();
	        mEventAppDomain = '//w.midea.com';
	    }
	
	    if (isSH) {
	        var login = __webpack_require__(9).init();
	        mEventAppDomain = '//wx506caed3066ee044.midea.com';
	    }
	    if (isDZ) {
	        var login = __webpack_require__(9).init();
	        mEventAppDomain = 'm.toshiba-lifestyle.cn';
	    }
	
	    var countObj = __webpack_require__(30);
	
	    var aTime = {},
	        countDown = {};
	    var fsid = func.getUrlParam('fsid');
	
	    if (isLs) {
	        fsid = '1002953470295277';
	    }
	    if (!fsid) {
	        fsid = false;
	    }
	
	    if (isSH) {
	        fsid = '1001097550297192';
	    }
	    if (isDZ) {
	        fsid = '1003089850308984';
	    }
	    window.fsid = fsid;
	    ;
	
	    var product = {
	
	        getPrice: function getPrice() {
	            var $priceDOM = $('.js-widget-price');
	            if ($priceDOM.length > 0) {
	                var skuidArr = [];
	                $priceDOM.each(function (index, el) {
	
	                    if ($(el).attr('data-price-type') == 2) {
	                        func.getGoodsActData({
	                            skuId: $(el).attr('data-goods-skuid'),
	                            activeId: $(el).attr('data-activeid')
	                        }, function (data) {
	                            var price = data.data[$(el).attr('data-goods-skuid')] ? data.data[$(el).attr('data-goods-skuid')][0].lActiveFee / 100 : '';
	                            $(el).html(price);
	                        });
	                    } else {
	                        skuidArr.push($(el).attr('data-goods-skuid'));
	                    }
	                    if (skuidArr.length > 0) {
	                        console.log(skuidArr);
	                        func.getGoodsData(skuidArr, function (data) {
	                            console.log(data);
	                            for (var i in data) {
	                                var price = parseInt(data[i].nSalePrice);
	                                console.log(i);
	                                $('.js-widget-price[data-goods-skuid="' + i + '"]').html(price);
	                            }
	                        });
	                    }
	                });
	            }
	        },
	        updateLink: function updateLink() {
	            $('.js-widget-link,.widget_link').each(function (index, el) {
	                var $link = $(el).find('.link_a');
	                var href = $link.attr('href');
	
	                if (!isLs) {
	                    var newHref = func.updateUrl(href);
	                    $link.attr('href', newHref);
	                }
	            });
	        },
	
	        init: function init() {
	            this.getPrice();
	        }
	    };
	    var lazy = {
	        updateImage: function updateImage() {
	            var _self = this;
	            this.$willBgItems.each(function (i, el) {
	
	                if ($(el).data('lazy').length > 0 && $(el).data('lazy') != el.src) {
	                    if (_self.topArray[i] < $(window).scrollTop() + _self.$willDistance) {
	
	                        $(el).attr('src', $(el).data('lazy'));
	                    }
	                }
	            });
	        },
	
	        renderPoolList: function renderPoolList() {
	            var _self = this;
	            this.$willPoolList.each(function (i, el) {
	                if ($(el)[0].innerHTML === '') {
	                    if (_self.poolArray[i] < $(window).scrollTop() + _self.$willDistance) {
	                        var taoIdType = $(el).attr('data-tao-id-type') ? $(el).attr('data-tao-id-type') : 'pool';
	                        var poolId = $(el).attr('data-pool-id');
	                        var poolLen = $(el).attr('data-pool-len');
	                        var poolTpl = $(el).attr('data-pool-tpl');
	                        var proPrice = $(el).attr('data-pro-price');
	                        var perPoolLen = parseInt($(el).attr('data-per-pool-len'));
	                        var isMore = $(el).attr('data-is-more');
	
	                        func.getPoolsData(poolId, poolLen, fsid, shop_type, proPrice, function (data) {
	                            data.forEach(function (item, index) {
	                                if (item.vecSellStageList) {
	                                    item.stage1Limit = item.vecSellStageList[0] ? item.vecSellStageList[0].lStageNum : '';
	                                    item.stage1Price = item.vecSellStageList[0] ? item.vecSellStageList[0].lstagePrice : '';
	                                    item.stage2Limit = item.vecSellStageList[1] ? item.vecSellStageList[1].lStageNum : '';
	                                    item.stage2Price = item.vecSellStageList[1] ? item.vecSellStageList[1].lstagePrice : '';
	                                    item.stage3Limit = item.vecSellStageList[2] ? item.vecSellStageList[2].lStageNum : '';
	                                    item.stage3Price = item.vecSellStageList[2] ? item.vecSellStageList[2].lstagePrice : '';
	                                }
	                            });
	                            var output = Mustache.render(poolTpl, { data: data });
	                            $(el).html(output);
	                            if (isMore == 1) {
	                                $(el).find('.mc_product_item,.product_major_item').each(function (index, item) {
	                                    $(el).attr('data-page-num', 1);
	                                    if (index >= perPoolLen) {
	                                        $(item).css('display', 'none');
	                                    }
	                                });
	                            }
	                            $(el).removeAttr('data-pool-tpl');
	                            lazy.init_bg();
	                            if ($('#eventLift').length > 0) {
	                                lift.updateFloorTop();
	                            }
	                        }, { taoIdType: taoIdType });
	                    }
	                }
	            });
	        },
	
	        init_bg: function init_bg() {
	
	            var _self = this;
	            var $willBgItems = $('[data-lazy]');
	            this.$willDistance = $(window).height() * 2.5;
	            if ($willBgItems.length > 0) {
	                var topArray = [];
	
	                $willBgItems.each(function (i, el) {
	                    topArray[i] = $(el).offset().top;
	                });
	                this.$willBgItems = $willBgItems;
	                this.topArray = topArray;
	
	                this.updateImage();
	
	                $(window).bind('scroll', function (event) {
	
	                    func.throttle(_self.updateImage, _self);
	                });
	            }
	        },
	
	        init_pool: function init_pool() {
	            var _self = this;
	            var $willPoolList = $('[data-pool-lazy]');
	
	            if ($willPoolList.length > 0) {
	                var poolArray = [];
	                $willPoolList.each(function (i, el) {
	                    poolArray[i] = $(el).offset().top;
	                });
	                this.$willPoolList = $willPoolList;
	                this.poolArray = poolArray;
	
	                this.renderPoolList();
	
	                $(window).bind('scroll', function (event) {
	
	                    func.throttle(_self.renderPoolList, _self);
	                });
	            }
	        }
	    };
	
	    var $mask = $('.black_cover');
	    var coupon = {
	
	        popAll: function popAll(popId) {
	            console.log(navigator.userAgent);
	            if (navigator.userAgent.indexOf('baiduboxapp') >= 0) {
	                console.log('baiduboxapp');
	                $mask[0].style.display = 'block';
	                $('#' + popId)[0].style.display = 'block';
	                console.log($mask[0].style.display);
	            } else {
	                console.log('not baiduboxapp');
	                $mask.addClass('open');
	                $('#' + popId).addClass('open');
	            }
	        },
	        getGeneralCoupon: function getGeneralCoupon() {
	            $('.floor').on('click', '.js_widget_coupon,.js_item_coupon,.js_widget_coupon_yuyue', function (e) {
	                e.preventDefault();
	                var $coupon = $(this);
	
	                var obtainId = $coupon.data('oid');
	
	                var isYuyue = false;
	                if ($coupon.hasClass('js_widget_coupon_yuyue')) {
	                    isYuyue = true;
	                }
	                login.start(function () {
	                    $.ajax({
	                        type: 'GET',
	                        url: '/coupon/get_user_coupon',
	                        data: { obtainId: obtainId },
	                        timeout: 10000,
	                        dataType: 'json',
	                        success: function success(data) {
	                            var errCode = data.errcode;
	                            if (navigator.userAgent.indexOf('baiduboxapp') >= 0 && navigator.userAgent.indexOf('Android') >= 0) {
	                                if (errCode == 0) {
	                                    if (!isYuyue) {
	                                        alert('领取成功~');
	                                    } else {
	                                        alert('预约成功~');
	                                    }
	                                } else if (errCode == 549064771) {
	                                    alert('还没到领取时间~');
	                                } else if (errCode == 549064739) {
	                                    if (!isYuyue) {
	                                        alert('您已领取过~');
	                                    } else {
	                                        alert('您已预约过~');
	                                    }
	                                } else if (errCode == 549064758 || errCode == 549064802) {
	                                    alert('已抢光~');
	                                } else {
	                                    alert('系统繁忙~');
	                                }
	                            } else {
	                                if (errCode == 0) {
	                                    if (!isYuyue) {
	                                        coupon.popAll('getSuc');
	                                    } else {
	                                        coupon.popAll('getYuyueSuc');
	                                    }
	                                } else if (errCode == 549064771) {
	                                    coupon.popAll('getNotTime');
	                                } else if (errCode == 549064739) {
	                                    if (!isYuyue) {
	                                        coupon.popAll('getDone');
	                                    } else {
	                                        coupon.popAll('getYuyueDone');
	                                    }
	                                } else if (errCode == 549068803) {
	                                    coupon.popAll('getNotProMember');
	                                } else if (errCode == 549068804) {
	                                    coupon.popAll('getNotLevel');
	                                } else if (errCode == 549064758 || errCode == 549064802) {
	                                    coupon.popAll('getNone');
	                                } else {
	                                    coupon.popAll('getFailed');
	                                }
	                            }
	                        },
	                        error: function error() {
	                            coupon.popAll('getFailed');
	                        }
	                    });
	                }, function () {});
	            });
	        },
	
	        closeLayerFun: function closeLayerFun() {},
	        init: function init() {
	            this.getGeneralCoupon();
	            this.closeLayerFun();
	        }
	    };
	
	    var cart = {
	        popAll: function popAll(popId, type, title, content, btnHtml) {
	            $mask.addClass('open');
	            var that = $('#' + popId);
	            that.find('.js_tips_ico').removeClass('success').addClass(type);
	            that.find('.js_title').html(title);
	            that.find('.js_content').html(content);
	            that.find('.js_btn_box').html(btnHtml).find('.ok_btn,.check_btn').off().on('click', function () {
	                that.find('.close').click();
	            });
	            that.addClass('open');
	        },
	        addItemToCart: function addItemToCart() {
	            $('.js_widget_cart').on('click', function (e) {
	                e.preventDefault();
	                var title = '加入购物车成功',
	                    $cart = $(this),
	                    skuid = $cart.data('skuid'),
	                    subtitle = $cart.data('subtitle');
	
	                if (isLs || isSH || isDZ) {
	                    var fsid = fsid;
	                } else {
	                    var fsid = '1000000000100511';
	                }
	                login.start(function () {
	                    $.ajax({
	                        type: 'POST',
	                        url: '/cart/index/ajax_add_item',
	                        data: {
	                            num: 1,
	                            itemid: '' + fsid + skuid
	                        },
	                        timeout: 10000,
	                        dataType: 'json',
	                        success: function success(data) {
	                            if (data.errcode == 0) {
	                                cart.popAll('popTips', 'success', title, subtitle, '<a href="javascript:;" class="tip_btn ok_btn">再逛逛</a><a target="_blank" href="' + mEventAppDomain + '/cart?fsid=' + fsid + '" class="tip_btn check_btn" >前往购物车</a>');
	
	                                if (window.IsWxMiniProgram && !HasBinTipBtn) {
	                                    miniProgram.bindTipBtnEvent();
	                                    HasBinTipBtn = true;
	                                }
	                            } else if (data.errcode == 0x21531004) {
	                                cart.popAll('popTips', '', '加入购物车失败', data.errmsg, '<a href="javascript:;" class="tip_btn ok_btn">知道了</a><a target="_blank" href="' + mEventAppDomain + '/cart?fsid=' + fsid + '" class="tip_btn check_btn" >整理购物车</a>');
	                            } else if (data.errcode == 559091715) {
	                                cart.popAll('popTips', '', '加入购物车失败', '该商品可能已下架或不存在', '<a href="javascript:;" class="tip_btn ok_btn">看看别的商品</a>');
	                            } else {
	                                cart.popAll('popTips', '', '加入购物车失败', data.errmsg, '<a href="javascript:;" class="tip_btn ok_btn">知道了</a>');
	                            }
	                        },
	                        error: function error() {
	                            cart.popAll('popTips', '', '加入购物车失败', '网络繁忙，请稍后再试', '<a href="javascript:;" class="tip_btn ok_btn">知道了</a>');
	                        }
	                    }, function () {});
	                });
	            });
	        },
	        addGoodsListItemToCart: function addGoodsListItemToCart() {
	            var that = this;
	            $('.js-pool-goodslist').on('click', '.js_goods_add_cart', function (e) {
	                e.preventDefault();
	                var title = '加入购物车成功',
	                    $cart = $(this),
	                    itemid = $cart.data('itemid'),
	                    subtitle = '1件商品已成功加入您的购物车';
	
	                if (isLs || isSH || isDZ) {
	                    var fsid = fsid;
	                } else {
	                    var fsid = '1000000000100511';
	                }
	                login.start(function () {
	                    $.ajax({
	                        type: 'POST',
	                        url: '/cart/index/ajax_add_item',
	                        data: {
	                            num: 1,
	                            itemid: itemid
	                        },
	                        timeout: 10000,
	                        dataType: 'json',
	                        success: function success(data) {
	                            if (data.errcode == 0) {
	                                that.showCartNum();
	                                $.mpopup({
	                                    type: 'info',
	                                    contentTxt: '加入购物车成功',
	                                    icoType: 'right',
	                                    autoClose: 1000,
	                                    mask: true
	                                }).show();
	
	                                if (window.IsWxMiniProgram && !HasBinTipBtn) {
	                                    miniProgram.bindTipBtnEvent();
	                                    HasBinTipBtn = true;
	                                }
	                            } else if (data.errcode == 0x21531004) {
	                                $.mpopup({
	                                    type: 'info',
	                                    contentTxt: '购物车已满',
	                                    icoType: 'error',
	                                    autoClose: 1000,
	                                    mask: true
	                                }).show();
	                            } else if (data.errcode == 559091715) {
	                                $.mpopup({
	                                    type: 'info',
	                                    contentTxt: '商品不存在',
	                                    icoType: 'error',
	                                    autoClose: 1000,
	                                    mask: true
	                                }).show();
	                            } else {
	                                $.mpopup({
	                                    type: 'info',
	                                    contentTxt: '加入购物车失败:' + data.errmsg,
	                                    icoType: 'error',
	                                    autoClose: 1000,
	                                    mask: true
	                                }).show();
	                            }
	                        },
	                        error: function error() {
	                            $.mpopup({
	                                type: 'info',
	                                contentTxt: '网络繁忙，请稍后再试',
	                                icoType: 'error',
	                                autoClose: 1000,
	                                mask: true
	                            }).show();
	                        }
	                    }, function () {});
	                });
	            });
	        },
	        addTaoZhuangToCart: function addTaoZhuangToCart() {
	            $('.js-pool-goodslist').on('click', '.js_tao_buy_btn', function (e) {
	                e.preventDefault();
	                var title = '加入购物车成功',
	                    $cart = $(this),
	                    items = $cart.data('allitemids').split(','),
	                    act_id = $cart.data('active-id'),
	                    subtitle = items.length + '件商品已加入您的购物车';
	                login.start(function () {
	                    $.ajax({
	                        type: 'POST',
	                        url: '/cart/index/ajax_add_item',
	                        data: {
	                            num: 1,
	                            act_id: act_id,
	                            act_type: 7,
	                            itemid: items[0]
	                        },
	                        timeout: 10000,
	                        dataType: 'json',
	                        success: function success(data) {
	                            if (data.errcode == 0) {
	                                cart.popAll('popTips', 'success', title, subtitle, '<a href="javascript:;" class="tip_btn ok_btn">再逛逛</a><a target="_blank" href="' + mEventAppDomain + '/cart?fsid=' + fsid + '" class="tip_btn check_btn" >前往购物车</a>');
	
	                                if (window.IsWxMiniProgram && !HasBinTipBtn) {
	                                    miniProgram.bindTipBtnEvent();
	                                    HasBinTipBtn = true;
	                                }
	                            } else if (data.errcode == 0x21531004) {
	                                cart.popAll('popTips', '', '加入购物车失败', data.errmsg, '<a href="javascript:;" class="tip_btn ok_btn">知道了</a><a target="_blank" href="' + mEventAppDomain + '/cart?fsid=' + fsid + '" class="tip_btn check_btn" >整理购物车</a>');
	                            } else if (data.errcode == 559091715) {
	                                cart.popAll('popTips', '', '加入购物车失败', '该商品可能已下架或不存在', '<a href="javascript:;" class="tip_btn ok_btn">看看别的商品</a>');
	                            } else {
	                                cart.popAll('popTips', '', '加入购物车失败', data.errmsg, '<a href="javascript:;" class="tip_btn ok_btn">知道了</a>');
	                            }
	                        },
	                        error: function error() {
	                            cart.popAll('popTips', '', '加入购物车失败', '网络繁忙，请稍后再试', '<a href="javascript:;" class="tip_btn ok_btn">知道了</a>');
	                        }
	                    }, function () {});
	                });
	            });
	        },
	        cartIcon: function cartIcon() {
	            $('.js_acrt').on('click', function (e) {
	                if (window.location.search.indexOf('appview=1') > -1) {
	                    e.preventDefault();
	
	                    login.start(function () {
	                        window.location.href = 'https://m.midea.cn/cart';
	                    });
	                }
	            });
	        },
	        showCartNum: function showCartNum() {
	            $.ajax({
	                type: 'GET',
	                url: '/my/index/ajax_index_cart_num',
	                timeout: 10000,
	                dataType: 'json',
	                success: function success(data) {
	                    if (data.errcode == 0) {
	                        if (data.data.nRedDot && data.data.nCount) {
	                            $('#cartNum').show();
	                            $('#cartNumInner').text(data.data.nCount);
	                        }
	                    }
	                },
	                error: function error() {}
	            });
	        },
	
	        init: function init() {
	            this.addItemToCart();
	            this.addTaoZhuangToCart();
	            this.addGoodsListItemToCart();
	            this.showCartNum();
	            this.cartIcon();
	        }
	    };
	
	    var rule = {
	
	        event: function event() {
	            $('.js-rule-header').on('click', function (e) {
	                $(this).parent().toggleClass('rule-unfold');
	            });
	        },
	        init: function init() {
	            this.event();
	        }
	    };
	
	    var lift = {
	        isClickItem: false,
	        switchLiftCurrent: function switchLiftCurrent() {
	            var _self = this;
	            if (_self.isClickItem) {
	                _self.isClickItem = false;
	                return;
	            }
	            for (var i = 0; i < this.floorIdArr.length; i++) {
	                if (parseInt(_self.floorTopArr[i]) <= $(window).scrollTop() + 10) {
	                    $('#eventLift a').parent().removeClass('event_mod_lift_item_cur').eq(i).addClass('event_mod_lift_item_cur');
	                    if (Math.floor(i / 4) > 0) {
	                        document.querySelector('#eventLift').scrollTo(Math.floor(i / 4) * 80, 0);
	                    }
	                    console.log($('#eventLift a').parent().eq(i));
	                    if ($('.lift-data-list').length > 0) {
	                        $('.lift-data-list a').parent().removeClass('event_mod_lift_item_cur').eq(i).addClass('event_mod_lift_item_cur');
	                    }
	                }
	            }
	        },
	
	        getLiftFloor: function getLiftFloor() {
	            var floorIdArr = [];
	            $('#eventLift a').each(function (index, elem) {
	                var href = $(elem).attr('href');
	                if (href.indexOf('#') == 0) {
	                    floorIdArr.push(href);
	                }
	            });
	
	            this.floorIdArr = floorIdArr;
	        },
	
	        updateFloorTop: function updateFloorTop() {
	
	            var floorTopArr = [];
	
	            for (var i = 0; i < this.floorIdArr.length; i++) {
	                console.log(i);
	                var id = this.floorIdArr[i];
	                var top;
	                var $floor = $(id);
	                if ($floor.length > 0) {
	                    top = $floor.offset().top;
	                    floorTopArr.push(top);
	                }
	            }
	
	            this.floorTopArr = floorTopArr;
	        },
	
	        clickLiftItem: function clickLiftItem() {
	            var $liftLink = $('#eventLift a');
	            var _self = this;
	            $liftLink.off('click').on('click', function (e) {
	                _self.isClickItem = true;
	                $('#eventLift a').parent().removeClass('event_mod_lift_item_cur');
	                $(this).parent().addClass('event_mod_lift_item_cur');
	                if ($('.lift-data-list').length > 0) {
	                    $('.lift-data-list a').parent().removeClass('event_mod_lift_item_cur');
	                    $('.lift-data-list').find('a[href="' + $(this).attr('href') + '"]').parent().removeClass('event_mod_lift_item_cur').addClass('event_mod_lift_item_cur');
	                }
	            });
	            if ($('.lift-data-list').length > 0) {
	                var $liftLink = $('.lift-data-list a');
	                var _self = this;
	                $liftLink.off('click').on('click', function (e) {
	                    _self.isClickItem = true;
	                    $liftLink.parent().removeClass('event_mod_lift_item_cur');
	                    $(this).parent().addClass('event_mod_lift_item_cur');
	
	                    $('#eventLift a').parent().removeClass('event_mod_lift_item_cur');
	                    $('#eventLift').find('a[href="' + $(this).attr('href') + '"]').parent().removeClass('event_mod_lift_item_cur').addClass('event_mod_lift_item_cur');
	                });
	                $('.js_show_overlayer').off('click').on('click', function (e) {
	                    if (!$(this).parents('.event_mod_lift_style_3').hasClass('show')) {
	
	                        $(this).parents('.event_mod_lift_style_3').addClass('show');
	                    } else {
	
	                        $(this).parents('.event_mod_lift_style_3').removeClass('show');
	                    }
	                });
	            }
	        },
	
	        init: function init() {
	            var _self = this;
	            if ($('#eventLift').length > 0) {
	                $('#eventLift').parents('.floor').css('z-index', 4);
	                this.getLiftFloor();
	                this.updateFloorTop();
	                this.clickLiftItem();
	                $(window).bind('scroll', function (event) {
	                    func.throttle(_self.switchLiftCurrent, _self);
	                });
	            }
	        }
	    };
	
	    var giftPack = {
	        sendGiftRequest: false,
	        popAll: function popAll(popId) {
	            $mask.addClass('open');
	            $('#' + popId).addClass('open');
	        },
	        getGeneralgiftPack: function getGeneralgiftPack() {
	            var _this = this;
	            $('.js_widget_gift_package').on('click', function (e) {
	                e.preventDefault();
	                var _selfEle = $(this);
	                login.start(function () {
	                    if (_this.sendGiftRequest) {
	                        return;
	                    }
	                    _this.sendGiftRequest = false;
	                    var gid = _selfEle.attr('data-gid');
	                    $.ajax({
	                        url: '/promote/w/mabapp/get_user_gift',
	                        type: 'post',
	                        dataType: 'json',
	                        data: { gid: gid },
	                        success: function success(data) {
	                            if (data.errcode == 0) {
	                                _this.popAll('getGiftSuccess');
	                            } else if (data.errcode == 3) {
	                                _this.popAll('getGiftNotLevel');
	                            } else if (data.errcode == 4) {
	                                _this.popAll('getGiftHasGain');
	                            } else if (data.errcode == 539299861) {
	                                _this.popAll('getGiftUserInfoErr');
	                            } else {
	                                _this.popAll('getGiftError');
	                            }
	                            _this.sendGiftRequest = false;
	                        },
	                        error: function error() {
	                            _this.popAll('getGiftError');
	                            _this.sendGiftRequest = false;
	                        }
	
	                    });
	                }, function () {});
	            });
	        },
	
	        closeLayerFun: function closeLayerFun() {
	            $('.close,.ok_btn').on('click', function () {
	                if (navigator.userAgent.indexOf('baiduboxapp') >= 0) {
	                    $(this).parents('.open_tips').css({ 'display': 'none' });
	                    $mask.css({
	                        'display': 'none'
	                    });;
	                } else {
	                    $(this).parents('.open_tips').removeClass('open');
	                    $mask.removeClass('open');
	                }
	            });
	
	            $('.i_close').on('click', function () {
	                if (navigator.userAgent.indexOf('baiduboxapp') >= 0) {
	                    $('.open_tips_img').hide();
	                    $mask.css({ 'display': 'none' });
	                } else {
	                    $('.open_tips_img').hide();
	                    $mask.removeClass('open');
	                }
	            });
	
	            $('.black_cover').on('click', function () {
	                if (navigator.userAgent.indexOf('baiduboxapp') >= 0) {
	                    $('.open_tips_img').hide();
	                    $('.open_tips').css({ 'display': 'none' });
	                    $mask.css({ 'display': 'none' });
	                } else {
	                    $('.open_tips_img').hide();
	                    $('.open_tips').removeClass('open');
	                    $mask.removeClass('open');
	                }
	            });
	        },
	        gotoLogin: function gotoLogin() {
	            $(document).on('click', '.js_goto_login', function () {
	                if (window.IsWxMiniProgram) {
	                    var hashs = location.href.split('/');
	                    var id = hashs[hashs.length];
	                    var navigateUrl = '/page/login/login?page=' + encodeURIComponent('/page/web_view_promote/web_view_promote?id=' + id);
	                    wx.miniProgram.navigateTo({
	                        url: navigateUrl
	                    });
	                } else {
	                    window.location.href = '/mlogin/web_login?rurl=' + encodeURIComponent(location.href);
	                }
	            });
	        },
	
	        init: function init() {
	            this.getGeneralgiftPack();
	            this.closeLayerFun();
	            this.gotoLogin();
	        }
	    };
	    var linkPopLayer = {
	        eventBind: function eventBind() {
	            $(document).on('click', '.js_widget_pop_layer', function (e) {
	                if ($('.md-popup').length == 0) {
	                    var data = {
	                        title: '',
	                        content: $(this).attr('data-content'),
	                        btnConfirmTxt: '知道啦~'
	                    };
	                    var output = dialogTpl(data);
	                    $('body').append(output);
	                } else if ($('.md-popup').length > 0) {
	                    $('.md-popup-text').html($(this).attr('data-content'));
	                    $('.md-popup').addClass('md-popup-in');
	                    $('.md-popup-backdrop').addClass('md-active');
	                }
	            });
	            $(document).on('click', '.md-popup-button.confirm', function () {
	                $('.md-popup').removeClass('md-popup-in');
	                $('.md-popup-backdrop').removeClass('md-active');
	            });
	            $(document).on('click', '.more-btn-box', function () {
	
	                var $el = $(this).parents('.js-pool-goodslist');
	                var poolLen = parseInt($el.attr('data-pool-len'));
	                var perPoolLen = parseInt($el.attr('data-per-pool-len'));
	                var isMore = $el.attr('data-is-more');
	                var pageNum = parseInt($el.attr('data-page-num'));
	
	                $el.find('.mc_product_item,.product_major_item').each(function (index, item) {
	                    if ($(item).css('display') == 'none') {
	                        $(item).css('display', 'block');
	                    }
	                });
	                $(this).hide();
	            });
	        },
	        init: function init() {
	            this.eventBind();
	        }
	    };
	
	    var miaoV2 = {
	        timeStart: function timeStart(t, _ele) {
	            _ele.find('.js_miao_item').each(function () {
	                var $li = $(this);
	                if ($(this).data('state') == 4) {
	                    miaoV2.timeOver(t, $(this), _ele);
	                    $li.find('.mc_btn_will_start').addClass('hide');
	                    $(this).countDown && clearInterval($(this).countDown.timeInterVal);
	                } else {
	                    if ($li.hasClass("js_sec_section")) {
	                        _ele.find('.js_sec_section').removeClass("mc_sec_will_start ").removeClass("mc_sec_over ").addClass("mc_sec_on_going");
	                        _ele.find('.js_sec_section').find(".mc_btn_on_going").find('.mc_des').html('立即秒杀<i class="mc_icon_arrow mc_icon_arrow_white"></i>');
	                    } else {
	                        $li.removeClass(" mc_pro_will_start").removeClass(" mc_pro_over").addClass("mc_pro_on_going");
	
	                        $li.find(".mc_btn").addClass('hide');
	                    }
	                    $li.find(".mc_btn_on_going").removeClass('hide');
	                    $li.find(".mc_btn_on_going").find('.mc_des').html('立即秒杀');
	                    $li.find('.mc_btn_will_start').addClass('hide');
	                    var $count = _ele.find('.js_miao_count');
	
	                    $count.find('.js_count_d').text(t.days);
	                    $count.find('.js_count_d').text(t.days);
	                    $count.find('.js_count_h').text(t.hours);
	                    $count.find('.js_count_m').text(t.minutes);
	                    $count.find('.js_count_s').text(t.seconds);
	                }
	            });
	        },
	
	        timeBefore: function timeBefore(t, _ele) {
	            _ele.find('.js_sec_section').removeClass("mc_sec_over").removeClass("mc_sec_on_going").addClass("mc_sec_will_start");
	
	            _ele.find('.js_goods_section').each(function () {
	                var $li = $(this);
	                $li.removeClass("mc_pro_over").removeClass("mc_pro_on_going").addClass("mc_pro_will_start");
	                $li.find(".mc_btn_will_start").find('.mc_des').html("即将开始");
	                $li.find(".mc_btn").addClass('hide');
	            });
	            _ele.find(".mc_btn_will_start").removeClass('hide');
	            _ele.find(".mc_btn_will_start").find('.mc_des').html('即将开始');
	
	            var $count = _ele.find('.js_miao_count');
	            $count.find('.js_count_d').text(t.days);
	            $count.find('.js_count_h').text(t.hours);
	            $count.find('.js_count_m').text(t.minutes);
	            $count.find('.js_count_s').text(t.seconds);
	        },
	
	        timeBeforeLong: function timeBeforeLong(t, _ele) {
	            _ele.find('.js_sec_section').removeClass("mc_sec_over").removeClass("mc_sec_on_going").addClass("mc_sec_will_start");
	
	            _ele.find('.js_goods_section').each(function () {
	                var $li = $(this);
	
	                $li.find(".mc_btn_will_start").find('.mc_des').html("未开始");
	                $li.find(".mc_btn").addClass('hide');
	            });
	            _ele.find(".mc_btn_will_start").removeClass('hide');
	            _ele.find(".mc_btn_will_start").find('.mc_des').html('未开始');
	
	            var $count = _ele.find('.js_miao_count');
	            $count.find('.js_count_d').text(t.days);
	            $count.find('.js_count_h').text(t.hours);
	            $count.find('.js_count_m').text(t.minutes);
	            $count.find('.js_count_s').text(t.seconds);
	        },
	
	        timeOver: function timeOver(t, $li, _ele) {
	            if ($li.hasClass("js_sec_section")) {
	                _ele.find('.js_sec_section').removeClass("mc_sec_will_start ").removeClass("mc_sec_on_going").addClass("mc_sec_over");
	                _ele.find('.js_sec_section').find(".mc_btn_over").find('.mc_des').html("已抢光");
	                _ele.find('.js_sec_section').find(".mc_btn_over").find('.mc_des').css("background", "#999");
	            } else {
	                $li.removeClass(" mc_pro_will_start").removeClass("mc_pro_on_going").addClass("mc_pro_over");
	
	                $li.find(".mc_btn").addClass('hide');
	            }
	            _ele.find(".mc_btn_will_start").addClass('hide');
	            $li.find(".mc_btn_sold_over").removeClass('hide');
	            $li.find(".mc_btn_sold_over").find('.mc_des').html('已抢光');
	            $li.find('.mc_modal_over').addClass('hide');
	            $li.find('.mc_modal_sold_over').removeClass('hide');
	
	            var $count = _ele.find('.js_miao_count');
	
	            $count.find('.js_count_d').text(t.days);
	            $count.find('.js_count_h').text(t.hours);
	            $count.find('.js_count_m').text(t.minutes);
	            $count.find('.js_count_s').text(t.seconds);
	        },
	        timeEnd: function timeEnd(t, _ele) {
	            _ele.find('.js_sec_section').removeClass("mc_sec_over").removeClass("mc_sec_on_going").addClass("mc_sec_will_start");
	
	            _ele.find('.js_goods_section').each(function () {
	                var $li = $(this);
	                $li.removeClass("mc_pro_over").removeClass("mc_pro_on_going").addClass("mc_pro_will_start");
	
	                $li.find(".mc_btn").addClass('hide');
	            });
	            _ele.find(".mc_btn_over").removeClass('hide');
	            _ele.find(".mc_btn_over").find('.mc_des').html('已结束');
	            _ele.find('.mc_modal_over').addClass('hide');
	            _ele.find('.mc_modal_time_over').removeClass('hide');
	            _ele.find('.mc_modal_time_over').css('display', 'block');
	            _ele.find('.js_sec_section').find(".mc_btn_sold_over").addClass('hide');
	            var $count = _ele.find('.js_miao_count');
	            $count.find('.js_count_d').text('0');
	            $count.find('.js_count_h').text('0');
	            $count.find('.js_count_m').text('0');
	            $count.find('.js_count_s').text('0');
	        },
	
	        timeCallback: function timeCallback(t, _ele) {
	
	            if (t.total > 30 * 60 * 1000) {
	                miaoV2.timeBeforeLong(t, _ele);
	            } else if (t.total > 0) {
	                miaoV2.timeBefore(t, _ele);
	            } else if (t.total <= 0) {
	
	                var nextEndTime;
	                var myMiaoServerTime = new Date(func.timestampToTime(parseInt(window.miaoServerTime))).getTime();
	
	                if (_ele.attr('data-miao-time-nav-type') == '1') {
	                    var $dateli = _ele.find('.nav_date_li.active');
	                    if ($dateli.attr('data-endtime')) {
	                        nextEndTime = iosFixedDate($dateli.attr('data-date') + ' ' + $dateli.attr('data-endtime'));
	                    } else {
	                        nextEndTime = iosFixedDate($dateli.attr('data-date') + ' 23:59:59');
	                    }
	                } else if (_ele.attr('data-miao-time-nav-type') == '2') {
	                    var $timeli = _ele.find('.nav_time.active');
	                    if ($timeli.attr('data-endtime')) {
	                        nextEndTime = iosFixedDate($timeli.attr('data-date') + ' ' + $timeli.attr('data-endtime'));
	                    } else {
	                        nextEndTime = iosFixedDate($timeli.attr('data-date') + ' 23:59:59');
	                    }
	                } else {
	                    nextEndTime = iosFixedDate(_ele.find('.nav_time.active').find('.time-state').attr('data-enddatetime'));
	                }
	
	                this.startSwitchCountDownInit({ serverTime: myMiaoServerTime, startTime: nextEndTime }, _ele);
	            }
	        },
	        toEndtimeCallback: function toEndtimeCallback(t, _ele) {
	            if (t.total > 0) {
	                this.timeStart(t, _ele);
	            } else {
	                this.timeEnd(t, _ele);
	            }
	        },
	
	        startSwitchCountDownInit: function startSwitchCountDownInit(aTime, _ele) {
	            window.MIAOV2CURACTIVETIMEVALLIST.forEach(function (item, index) {
	                if (item.id == _ele.attr('id') && item.ele && item.ele.countDown) {
	                    clearInterval(item.ele.countDown.timeInterVal);
	                    item.ele.countDown.init(aTime, function (t) {
	                        miaoV2.toEndtimeCallback(t, _ele);
	                    });
	                }
	            });
	        },
	
	        countDownInit: function countDownInit(_ele, aTime) {
	            if (_ele.length > 0) {
	                var userData = JSON.parse(_ele.attr('data-miao-userdata'));
	                var $miao_count = _ele.find('.js_miao_count');
	                var miaoServerTime = Date.parse(new Date());
	                if ($miao_count[0]) {
	                    _ele.countDown = countObj.countDown();
	                }
	            }
	        },
	
	        miaoInit: function miaoInit() {
	            window.MIAOV2CURACTIVETIMEVALLIST = [];
	            var _self = this;
	            var $willMiaoPoolList = $('.js-pool-miao-v2');
	            if ($willMiaoPoolList.length > 0) {
	                $willMiaoPoolList.each(function () {
	                    var _ele = $(this);
	                    var miaoType = $(this).attr('data-miao-type'),
	                        miaoStyleType = $(this).attr('data-miao-style-type'),
	                        miaoIdType = $(this).attr('data-miao-id-type'),
	                        miaoData = JSON.parse($(this).attr('data-miao-data')),
	                        isShowNav = $(this).attr('data-is-show-nav'),
	                        styleColor = $(this).attr('data-miao-style-color'),
	                        userData = JSON.parse($(this).attr('data-miao-userdata'));
	                    _self.miaoType = miaoType;
	                    _self.miaoStyleType = miaoStyleType;
	                    _self.styleColor = styleColor;
	                    $(this).html('');
	                    var params = {
	                        miao_type: miaoType,
	                        type: miaoStyleType,
	                        style_color: styleColor,
	                        pc: 1
	                    };
	                    var endTime = userData.miao_data[0].endtime ? userData.miao_data[0].endtime : "23:59";
	                    params.date = userData.miao_data[0].date;
	                    params.datetime = userData.miao_data[0].date + ' ' + userData.miao_data[0].time + ':00';
	                    params.endDatetime = userData.miao_data[0].date + ' ' + endTime + ':00';
	                    params.pool_id = userData.miao_data[0].pool_id;
	                    params.length = userData.miao_data[0].pool_length;
	                    params.userdata = userData;
	                    params.shop_type = shop_type;
	                    params.miao_id_type = miaoIdType;
	                    params.miao_sort_type = $(this).attr('data-miao-sort-type');
	                    params.is_ls = isLs;
	
	                    func.getMiaoPoolsData(params, fsid, function (html) {
	                        html = '<div class="floor_bg js_miaosha_content">' + html + '</div>';
	                        var $miaoPoolListHtml = $(html);
	                        _ele.append($miaoPoolListHtml);
	                        var miaoServerTime = Date.parse(new Date());
	                        aTime = { serverTime: miaoServerTime, startTime: params.datetime };
	                        _self.clickDateNav(_ele);
	                        _self.clickTimeNav(_ele);
	                        _self.countDownInit(_ele, aTime);
	                        window.MIAOV2CURACTIVETIMEVALLIST.push({
	                            id: _ele.attr('id'),
	                            ele: _ele
	                        });
	                        if (miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))) {
	                            aTime = { serverTime: miaoServerTime, startTime: params.endDatetime, endTime: params.endDatetime };
	                            _ele.countDown.init(aTime, function (t) {
	                                miaoV2.toEndtimeCallback(t, _ele);
	                            });
	                        } else {
	                            aTime = { serverTime: miaoServerTime, startTime: params.datetime, endTime: params.endDatetime };
	                            _ele.countDown.init(aTime, function (t) {
	                                miaoV2.timeCallback(t, _ele);
	                            });
	                        }
	
	
	                        if (userData.time_nav_type == 2) {
	                            _self.getNearTime(_ele);
	                        } else {
	                            _self.getNearDate(_ele);
	                        }
	                    });
	                });
	            }
	        },
	        getNearDate: function getNearDate(_ele) {
	            console.log(_ele);
	            var curDate = new Date();
	            var hour = curDate.getHours() > 9 ? curDate.getHours() : '0' + curDate.getHours();
	            var min = curDate.getMinutes() > 9 ? curDate.getMinutes() : '0' + curDate.getMinutes();
	            var time = hour + ':' + min + ':00';
	            var year = curDate.getFullYear();
	            var mon = curDate.getMonth() + 1;
	            mon = (mon + '').length > 1 ? mon : '0' + mon;
	
	            var date = curDate.getDate() > 9 ? curDate.getDate() : '0' + curDate.getDate();
	            date = year + '-' + mon + '-' + date;
	
	            var clickDateO;
	            var lDate = '',
	                hDate = '';
	
	            _ele.find('.js_date_li').each(function (index, item) {
	                console.log('date:', date);
	                console.log('data-date:', $(item));
	                console.log('data-date:', $(item).attr('data-date'));
	                if (date >= $(item).attr('data-date')) {
	                    console.log('lDate data-date:', $(item).attr('data-date'));
	                    lDate = $(item);
	                } else {
	                    if (index == _ele.find('.js_date_li').length - 1 && date > $(item).attr('data-date')) {
	                        console.log('lDate else data-date:', $(item).attr('data-date'));
	                        lDate = $(_ele.find('.js_date_li')[0]);
	                    } else {
	                        console.log('hDate else data-date:', $(item).attr('data-date'));
	                        hDate = $(item);
	                    }
	                }
	            });
	            clickDateO = lDate;
	
	
	            if (clickDateO) {
	                console.log(clickDateO);
	                clickDateO.trigger('click');
	            }
	        },
	        getNearTime: function getNearTime(_ele) {
	            console.log(_ele);
	            var curDate = new Date();
	            var hour = curDate.getHours() > 9 ? curDate.getHours() : '0' + curDate.getHours();
	            var min = curDate.getMinutes() > 9 ? curDate.getMinutes() : '0' + curDate.getMinutes();
	            var time = hour + ':' + min + ':00';
	            var year = curDate.getFullYear();
	            var mon = curDate.getMonth() + 1;
	            mon = (mon + '').length > 1 ? mon : '0' + mon;
	            var date = curDate.getDate() > 9 ? curDate.getDate() : '0' + curDate.getDate();
	            date = year + '-' + mon + '-' + date;
	            var dateTime = date + ' ' + time;
	
	            var clickTimeO;
	            var lTime = '',
	                hTime = '';
	            _ele.find('.nav_time').each(function (index, item) {
	
	                if (dateTime >= $(item).attr('data-datetime')) {
	                    lTime = $(item);
	                } else {
	                    if (index == _ele.find('.nav_time').length - 1 && !lTime) {
	                        lTime = $(_ele.find('.nav_time')[0]);
	                    } else {
	                        hTime = $(item);
	                    }
	                }
	            });
	            clickTimeO = lTime;
	
	            if (clickTimeO) {
	
	                clickTimeO.trigger('click');
	            }
	        },
	
	        clickDateNav: function clickDateNav(_ele) {
	            var _self = this;
	
	            var userData = JSON.parse(_ele.attr('data-miao-userdata')),
	                miaoIdType = _ele.attr('data-miao-id-type');
	            _ele.on('click', '.js_date_li', function () {
	                var That = $(this),
	                    ThatDatetime = That.attr('data-datetime'),
	                    ThatPoolId = That.attr('data-sku-pool-id'),
	                    ThatLength = That.attr('data-length'),
	                    miaoStyleType = That.attr('data-style-type');
	                _ele.find('.nav_date_li').removeClass('active');
	                $(this).addClass('active');
	                var params = {
	                    miao_type: this.miaoType,
	                    type: miaoStyleType,
	                    style_color: this.styleColor,
	                    'datetime': ThatDatetime,
	                    'endDatetime': That.find('.time-state').attr('data-enddatetime') ? That.find('.time-state').attr('data-enddatetime') : ThatDatetime.substr(0, 10) + ' 23:59:59',
	                    'date': ThatDatetime.substr(0, 10),
	                    'pool_id': ThatPoolId,
	                    'length': ThatLength,
	                    'shop_type': shop_type,
	                    'is_ls': isLs,
	                    'pc': 1,
	                    'userdata': userData,
	                    'miao_id_type': miaoIdType,
	                    'miao_sort_type': _ele.attr('data-miao-sort-type')
	                };
	                func.getMiaoPoolsData(params, fsid, function (html) {
	                    var $miaoPoolListHtml = $(html);
	
	                    _ele.find('.js_miaosha_content').html($miaoPoolListHtml);
	                    var miaoServerTime = Date.parse(new Date());
	
	                    aTime = { serverTime: miaoServerTime, startTime: params.datetime };
	                    window.MIAOV2CURACTIVETIMEVALLIST.forEach(function (item, index) {
	                        if (item.id == _ele.attr('id') && item.ele && item.ele.countDown) {
	                            clearInterval(item.ele.countDown.timeInterVal);
	                            if (miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))) {
	                                aTime = { serverTime: miaoServerTime, startTime: params.endDatetime, endTime: params.endDatetime };
	                                _ele.countDown.init(aTime, function (t) {
	                                    miaoV2.toEndtimeCallback(t, _ele);
	                                });
	                            } else {
	                                aTime = { serverTime: miaoServerTime, startTime: params.datetime, endTime: params.endDatetime };
	                                _ele.countDown.init(aTime, function (t) {
	                                    miaoV2.timeCallback(t, _ele);
	                                });
	                            }
	                        }
	                    });
	                    var nonStockCount = 0;
	                    _ele.find('.js_miao_item').each(function (index, item) {
	                        if ($(item).attr('data-state') == 4) {
	                            nonStockCount++;
	                        }
	                    });
	                    if (nonStockCount == _ele.find('.js_miao_item').length) {
	                        console.log(That.parents('li.nav_date'));
	                        console.log(That.parents('li.nav_date').next());
	                        var clickDateO = That.next('.js_date_li').length ? That.next('.js_date_li') : That.parents('li.nav_date').next().length ? That.parents('li.nav_date').next().find('.js_date_li') : null;
	                        if (clickDateO) {
	                            console.log(clickDateO);
	                            clickDateO.trigger('click');
	                        } else {
	                            _self.getNearTime(_ele);
	                        }
	                    } else {
	                        _self.getNearTime(_ele);
	                    }
	                });
	            });
	        },
	        clickTimeNav: function clickTimeNav(_ele) {
	            var _self = this;
	
	            var userData = JSON.parse(_ele.attr('data-miao-userdata')),
	                miaoIdType = _ele.attr('data-miao-id-type');
	            _ele.on('click', '.nav_time', function () {
	                var That = $(this),
	                    ThatDatetime = That.attr('data-datetime'),
	                    ThatPoolId = That.attr('data-sku-pool-id'),
	                    ThatLength = That.attr('data-length'),
	                    miaoStyleType = That.attr('data-style-type');
	                _ele.find('.nav_date_li').removeClass('active');
	                $(this).addClass('active');
	                var params = {
	                    miao_type: this.miaoType,
	                    type: miaoStyleType,
	                    style_color: this.styleColor,
	                    'datetime': ThatDatetime,
	                    'date': ThatDatetime.substr(0, 10),
	                    'endDatetime': That.find('.time-state').attr('data-enddatetime') ? That.find('.time-state').attr('data-enddatetime') : ThatDatetime.substr(0, 10) + ' 23:59:59',
	                    'pool_id': ThatPoolId,
	                    'length': ThatLength,
	                    'shop_type': shop_type,
	                    'is_ls': isLs,
	                    'pc': 1,
	                    'userdata': userData,
	                    'miao_id_type': miaoIdType,
	                    'miao_sort_type': _ele.attr('data-miao-sort-type')
	                };
	                func.getMiaoPoolsData(params, fsid, function (html) {
	                    var $miaoPoolListHtml = $(html);
	
	                    _ele.find('.js_miaosha_content').html($miaoPoolListHtml);
	                    var miaoServerTime = Date.parse(new Date());
	
	                    aTime = { serverTime: miaoServerTime, startTime: params.datetime };
	                    window.MIAOV2CURACTIVETIMEVALLIST.forEach(function (item, index) {
	                        if (item.id == _ele.attr('id') && item.ele && item.ele.countDown) {
	                            clearInterval(item.ele.countDown.timeInterVal);
	                            if (miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))) {
	                                aTime = { serverTime: miaoServerTime, startTime: params.endDatetime, endTime: params.endDatetime };
	                                _ele.countDown.init(aTime, function (t) {
	                                    miaoV2.toEndtimeCallback(t, _ele);
	                                });
	                            } else {
	                                aTime = { serverTime: miaoServerTime, startTime: params.datetime, endTime: params.endDatetime };
	                                _ele.countDown.init(aTime, function (t) {
	                                    miaoV2.timeCallback(t, _ele);
	                                });
	                            }
	                        }
	                    });
	                    var nonStockCount = 0;
	                    _ele.find('.js_miao_item').each(function (index, item) {
	                        console.log($(item).attr('data-state'));
	                        if ($(item).attr('data-state') == 4) {
	                            console.log($(item).attr('data-state') + '==? 4');
	                            nonStockCount++;
	                        }
	                    });
	                    if (nonStockCount == _ele.find('.js_miao_item').length) {
	
	                        var clickTimeO = That.next('.nav_time').length ? That.next('.nav_time') : null;
	                        if (clickTimeO) {
	                            console.log(clickTimeO);
	                            setTimeout(function () {
	                                console.log('setTimeout', clickTimeO);
	                                clickTimeO.trigger('click');
	                            });
	                        }
	                    }
	                });
	            });
	        },
	        init: function init() {
	            this.miaoInit();
	        }
	
	    };
	
	    var SwiperApp = {
	        init: function init() {
	            var cssHtml = '<link rel="stylesheet" href="//g.mdcdn.cn/pc/css/act/swiper.min.css" type="text/css">';
	            $('head').append(cssHtml);
	            var $swiperDoms = $('.swiper-container');
	            var mySwiperList = [];
	            $swiperDoms.each(function (index, item) {
	                var swiperHeight = $(item).attr('swiperHeight');
	                mySwiperList[index] = new Swiper('#' + $(item).attr('id'), {
	                    direction: 'horizontal',
	                    loop: true,
	                    height: swiperHeight,
	
	                    autoplay: 3000
	                });
	            });
	        }
	    };
	
	    var serverTime = window.serverTime ? window.serverTime : Date.parse(new Date());
	
	    var Presell = {
	        eventBind: function eventBind() {
	            $(document).on('click', '.js_presell_coupon_btn', function () {
	                var self = this;
	                var oid = $(this).attr('couponid');
	                var $this = $(this);
	
	                login.start(function () {
	                    if ($this.attr('data-clicked') == 1) {
	                        return;
	                    }
	                    $this.attr('data-clicked', 1);
	
	                    $.ajax({
	                        type: 'GET',
	                        url: '/coupon/get_user_coupon',
	                        data: { obtainId: oid },
	                        timeout: 10000,
	                        dataType: 'json',
	                        success: function success(data) {
	                            var errCode = data.errcode;
	                            if (errCode == 0) {
	                                coupon.popAll('getSuc');
	                            } else if (errCode == 549064771) {
	                                coupon.popAll('getNotTime');
	                            } else if (errCode == 549064739) {
	                                coupon.popAll('getDone');
	                            } else if (errCode == 549064758 || errCode == 549064802) {
	                                coupon.popAll('getNone');
	                            } else {
	                                coupon.popAll('getFailed');
	                            }
	                        },
	                        error: function error() {
	                            coupon.popAll('getFailed');
	                        },
	                        complete: function complete() {
	                            $this.attr('data-clicked', 0);
	                        }
	                    });
	                }, function () {});
	            });
	        },
	        init: function init() {
	            this.eventBind();
	        }
	    };
	
	    var miao_coupon = {
	        url: '/promote/w/mabapp/',
	        couponExchangeScore: function couponExchangeScore() {
	            var that = this;
	            $('.js_get_ms_score_coupon').on('click', function (e) {
	                e.stopPropagation();
	                var $this = $(this);
	                var bid = $this.attr('data-bid');
	                var num = $this.attr('data-num');
	
	                var self = this;
	                login.start(function () {
	                    $.mpopup({
	                        type: 'confirmV2',
	                        icoType: '',
	                        content: '<div style="text-align: center">您确定消费' + num + '积分兑换该券吗?</div>',
	                        destroyAfterClose: false,
	                        buttons: [{ tpl: '<a class="mod_popup_btn" data-mpopup-confirm href="javascript:void(0)">好的</a>' }, { tpl: '<a class="mod_popup_btn" data-mpopup-close href="javascript:void(0)">关闭</a>' }],
	                        onConfirm: function onConfirm() {
	                            that.getCoupon(bid, self);
	                        }
	                    }).show();
	                }, function () {});
	            });
	        },
	        getCoupon: function getCoupon(bid, self) {
	            var that = this;
	            var num = $(self).attr('num');
	
	            var act_id = parseInt($(self).parents('.js_mc_section').data('actid'));
	            var detail_id = parseInt($(self).parents('.js_mc_section').data('actdetail'));
	            var $this = $(self);
	
	            if ($this.attr('data-clicked') == 1) {
	                return;
	            }
	            $this.attr('data-clicked', 1);
	
	            $.ajax({
	                type: 'POST',
	                url: that.url + 'get_user_score_coupon',
	                data: {
	                    act_id: act_id,
	                    detail_id: detail_id
	                },
	                timeout: 10000,
	                dataType: 'json',
	                success: function success(data) {
	                    var errCode = data.errcode;
	                    if (errCode == 0) {
	                        coupon.popAll('getScoreSuc');
	                    } else if (errCode == 549064739) {
	                        coupon.popAll('getScoreDone');
	                    } else if (errCode == 1001) {
	                        coupon.popAll('getScoreNotTime');
	                    } else if (errCode == 549064771) {
	                        coupon.popAll('getNotTime');
	                    } else if (errCode == 549064739) {
	                        coupon.popAll('getDone');
	                    } else if (errCode == 549064758 || errCode == 549064802) {
	                        coupon.popAll('getNone');
	                    } else {
	                        coupon.popAll('getScoreFailed');
	                    }
	                },
	
	                error: function error() {
	                    coupon.popAll('getScoreFailed');
	                },
	                complete: function complete() {
	                    $(self).attr('data-clicked', 0);
	                }
	            });
	        },
	        getMsCoupon: function getMsCoupon() {
	            var that = this;
	            $('.js_get_ms_coupon').on('click', function () {
	                var self = this;
	                var oid = $(this).attr('data-oid');
	                var $this = $(this);
	
	                login.start(function () {
	                    if ($this.attr('data-clicked') == 1) {
	                        return;
	                    }
	                    $this.attr('data-clicked', 1);
	
	                    $.ajax({
	                        type: 'GET',
	                        url: '/coupon/get_user_coupon',
	                        data: { obtainId: oid },
	                        timeout: 10000,
	                        dataType: 'json',
	                        success: function success(data) {
	                            var errCode = data.errcode;
	                            if (errCode == 0) {
	                                coupon.popAll('getSuc');
	                            } else if (errCode == 549064771) {
	                                coupon.popAll('getNotTime');
	                            } else if (errCode == 549064739) {
	                                coupon.popAll('getDone');
	                            } else if (errCode == 549064758 || errCode == 549064802) {
	                                coupon.popAll('getNone');
	                            } else {
	                                coupon.popAll('getFailed');
	                            }
	                        },
	                        error: function error() {
	                            coupon.popAll('getFailed');
	                        },
	                        complete: function complete() {
	                            $this.attr('data-clicked', 0);
	                        }
	                    });
	                }, function () {});
	            });
	        },
	        msTimeEvent: function msTimeEvent(startTime, that) {
	            var timer = countObj.countDown();
	            var timerConfig = {
	                serverTime: serverTime,
	                startTime: startTime
	            };
	
	            timer.init(timerConfig, function (t) {
	                if (t.total >= 0) {
	                    var $count = $(that);
	                    $count.find('.js_day').text(t.days);
	                    $count.find('.js_hour').text(t.hours);
	                    $count.find('.js_min').text(t.minutes);
	                    $count.find('.js_sec').text(t.seconds);
	                    if (t.total == 0) {
	                        $(that).parents('.js_mc_section').removeClass('mc_sec_will_start').removeClass('mc_sec_un_start').addClass('mc_sec_on_going');
	                    }
	                } else {
	                    clearInterval(t.obj.timeInterVal);
	                }
	            });
	        },
	        halfScoreInit: function halfScoreInit() {
	            var that = this;
	            $.ajax({
	                type: 'GET',
	                url: that.url + 'get_user_half_score',
	                data: {},
	                timeout: 10000,
	                dataType: 'json',
	                success: function success(data) {
	                    var errCode = data.errcode;
	                    if (errCode == 0) {
	                        if (data.halfScore == 1) {
	
	                            var $d = $('.js_cost_score');
	                            $d.each(function () {
	                                var $t = $(this);
	                                var originalScore = parseInt($t.text());
	                                var halfScore = parseInt(originalScore / 2);
	                                $t.html(halfScore);
	                                $t.parents('.js_coupon_info').attr('data-num', halfScore);
	                            });
	                        }
	                    }
	                },
	                error: function error() {}
	            });
	        },
	        queryMsCouponInfo: function queryMsCouponInfo(act_id, $this) {
	            var that = this;
	            var actDetailId = $this.data('actdetail');
	
	            $.ajax({
	                url: that.url + 'get_ms_coupon_info',
	                type: 'post',
	                data: {
	                    act_id: act_id
	                },
	                timeout: 10000,
	                dataType: 'json',
	                success: function success(res) {
	                    console.log(res);
	                    if (res.errcode == 0) {
	                        var couponArr = res.couponInfo || [];
	                        couponArr.forEach(function (item) {
	                            if (actDetailId == item.detailId) {
	                                if (document.getElementsByClassName('startTime').length > 0) {
	                                    var startHour = item.start_time.split(' ')[1].split(':')[0];
	                                    $this.find(".startTime").html(startHour + '点开抢');
	                                }
	
	                                var $time = $this.find('.js_ms_time_wrap');
	                                $time.attr('data-start-time', item.start_time).attr('data-stamp', strtotime(item.start_time));
	
	                                var stateVal = parseInt(item.coupon_state);
	                                switch (stateVal) {
	                                    case 1:
	                                        $this.removeClass('mc_sec_over').removeClass('mc_sec_will_start').removeClass('mc_sec_on_going').addClass('mc_sec_un_start');
	                                        that.msTimeEvent(item.start_time, $time);
	                                        break;
	                                    case 2:
	                                        $this.removeClass('mc_sec_over').removeClass('mc_sec_un_start').removeClass('mc_sec_on_going').addClass('mc_sec_will_start');
	                                        that.msTimeEvent(item.start_time, $time);
	                                        break;
	                                    case 3:
	                                        $this.removeClass('mc_sec_will_start').removeClass('mc_sec_un_start').removeClass('mc_sec_over').addClass('mc_sec_on_going');
	                                        break;
	                                    default:
	                                        $this.removeClass('mc_sec_will_start').removeClass('mc_sec_un_start').removeClass('mc_sec_on_going').addClass('mc_sec_over');
	                                        break;
	                                }
	                            }
	                        });
	                    }
	                },
	                fail: function fail(res) {
	                    console.log(res);
	                },
	                complete: function complete(res) {
	                    console.log(res);
	                }
	            });
	        },
	        couponStateInit: function couponStateInit() {
	            var that = this;
	            var $d = $('.js_coupon_info');
	            var bidArr = [];
	            $d.each(function (i) {
	                var $this = $(this);
	                bidArr.push($this.data('bid'));
	            });
	
	            var actidArr = [];
	            var $p = $('.js_mc_section');
	            $p.each(function (i) {
	                var $this = $(this);
	                actidArr.push($this.data('actid'));
	                that.queryMsCouponInfo($this.data('actid'), $this);
	            });
	            if (actidArr.length <= 0) {
	                return;
	            }
	        },
	        pageInit: function pageInit() {
	            if (isLs == 0) {
	                this.halfScoreInit();
	            }
	
	            this.couponStateInit();
	        },
	        init: function init() {
	            this.pageInit();
	            this.getMsCoupon();
	            this.couponExchangeScore();
	        },
	        countDownInit: function countDownInit() {
	            var that = this;
	            $('.js_ms_time_wrap').each(function () {
	                var _this = this;
	                var time = $(_this).attr('data-start-time'),
	                    timeStamp = $(_this).attr('data-stamp');
	                var current = new Date().getTime();
	                if (parseInt(timeStamp) > current) {
	                    that.msTimeEvent(time, _this);
	                } else {
	                    $(_this).parents('.js_mc_section').removeClass('mc_sec_will_start').removeClass('mc_sec_un_start').addClass('mc_sec_on_going');
	                }
	            });
	        }
	    };
	
	    var PageCountTime = {
	        init: function init() {
	            var that = this;
	            var pageData = $('#pageDataCache').attr('data-pageconf') ? JSON.parse($('#pageDataCache').attr('data-pageconf')) : {};
	            if (pageData && pageData.is_show_counting_time == 1) {
	                var strDom = '<div class="counting_time_box js_counting_time hide">' + '<div class="counting_time-content">' + '距离活动开始还有0天0时0分0秒' + '</div>' + '</div>';
	                if ($('.event_mod_lift_style_3.h5_top').length > 0) {
	                    $('.event_mod_lift_style_3').append(strDom);
	                    $('body').addClass('content_lift-show_coutting_time');
	                } else {
	                    $('body').prepend(strDom);
	                    $('.counting_time_box').addClass('fixed');
	                    $('body').addClass('content-show_coutting_time');
	                }
	                setTimeout(function () {
	                    $('.js_counting_time').removeClass('hide');
	                    var offTimeStamp = new Date(iosFixedDate(pageData['offline_time'])).getTime();
	                    var onlineTimeStamp = new Date(iosFixedDate(pageData['online_time'])).getTime();
	                    var nowTimeStamp = new Date().getTime();
	                    if (onlineTimeStamp > nowTimeStamp) {
	                        setInterval(function () {
	                            that.updategetYMDhms(nowTimeStamp, iosFixedDate(pageData['online_time']), '开始');
	                        }, 1000);
	                    } else if (offTimeStamp > nowTimeStamp) {
	                        setInterval(function () {
	                            that.updategetYMDhms(nowTimeStamp, iosFixedDate(pageData['offline_time']), '结束');
	                        }, 1000);
	                    } else {}
	                });
	            }
	        },
	
	        count: 0,
	        updategetYMDhms: function updategetYMDhms(start, end, type) {
	            this.count += 1;
	            var date1 = new Date(start);
	            var date2 = new Date(end);
	            var s1 = date1.getTime();
	            var s2 = date2.getTime();
	            var total = (s2 - s1) / 1000 - this.count;
	            var day = parseInt(total / (24 * 60 * 60));
	            var afterDay = total - day * 24 * 60 * 60;
	            var hour = parseInt(afterDay / (60 * 60));
	            var afterHour = total - day * 24 * 60 * 60 - hour * 60 * 60;
	            var min = parseInt(afterHour / 60);
	            var afterMin = total - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60;
	            var second = parseInt(afterMin);
	            var textRes = '距离活动' + type + '还有';
	
	            $('.counting_time-content').text(textRes + day + ' 天 ' + hour + ' 时 ' + min + ' 分 ' + second + ' 秒');
	        }
	    };
	
	    var initialize = function initialize() {
	        product.init();
	        lazy.init_bg();
	        lazy.init_pool();
	        lift.init();
	        coupon.init();
	        giftPack.init();
	        rule.init();
	        cart.init();
	        miaoV2.init();
	        miao_coupon.init();
	        SwiperApp.init();
	        Presell.init();
	        linkPopLayer.init();
	        PageCountTime.init();
	        widgetVipcard.init({ login: login });
	
	        widgetMiaoCouponlist.init();
	        widgetCouponlist.init();
	        $('#link-1572441144402,#link-1572441149842').on('click', function () {
	            if ($(this).attr('id') == 'link-1572441149842') {
	                alert('很遗憾，由于金勋章点亮目标未完成，抽奖开放需延期~');
	            }
	            if ($(this).attr('id') == 'link-1572441144402') {
	                alert('很遗憾，由于银勋章点亮目标未完成，周边开放需延期~');
	            }
	        });
	    };
	    var LoadingWrap = {
	        operateLoading: function operateLoading(type) {
	            var $loader_wrap = $(".loader_wrap");
	            if (type == 'show') {
	                $loader_wrap.addClass("show");
	            } else {
	                $loader_wrap.removeClass("show");
	            }
	        }
	
	    };
	
	    var PageManage = {
	        init: function init() {
	            try {
	                LoadingWrap.operateLoading('show');
	                var pageData = $('#pageDataCache').attr('data-pageconf') ? JSON.parse($('#pageDataCache').attr('data-pageconf')) : {};
	                if (pageData.offline_time) {
	                    pageData.offline_time = pageData.offline_time.replace(/-/g, '/');
	                }
	                if (pageData.offline_time && new Date(pageData.offline_time).getTime() - serverTime <= 0) {
	                    if ($('.md-popup').length == 0) {
	                        var data = {
	                            title: '',
	                            content: '目前该卖场已经下线啦~,正在为您跳转到指定页面.....',
	                            btnConfirmTxt: '好的~~'
	                        };
	                        var output = dialogTpl(data);
	                        $('body').append(output);
	                    } else if ($('.md-popup').length > 0) {
	                        $('.md-popup').addClass('md-popup-in');
	                        $('.md-popup-backdrop').addClass('md-active');
	                    }
	                    setTimeout(function () {
	                        location.href = pageData.offline_url ? pageData.offline_url : '//m.midea.cn';
	                    }, 2000);
	                } else {
	                    initialize();
	                }
	                LoadingWrap.operateLoading('hide');
	            } catch (e) {
	                alert(e);
	            }
	        }
	    };
	
	    wx.miniProgram.getEnv(function (res) {
	
	        window.IsWxMiniProgram = res.miniprogram;
	        console.log(res.miniprogram);
	        if (!hasInitOnce) {
	            PageManage.init();
	            hasInitOnce = true;
	        }
	    });
	
	    if (!hasInitOnce) {
	        PageManage.init();
	        hasInitOnce = true;
	    }
	} catch (e) {
	    alert('err');
	    alert(e);
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(12)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(5);
	var createDesc = __webpack_require__(14);
	module.exports = __webpack_require__(3) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(11);
	var IE8_DOM_DEFINE = __webpack_require__(38);
	var toPrimitive = __webpack_require__(27);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(3) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(69);
	var defined = __webpack_require__(17);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(25)('wks');
	var uid = __webpack_require__(15);
	var Symbol = __webpack_require__(1).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = Zepto;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var $ = __webpack_require__(8);
	    var login = __webpack_require__(50).init();
	    var loadCss = __webpack_require__(32);
	    var rnd = new Date().getTime().toString();
	    var cover_id = 'common_login_cover_' + rnd;
	    var phoneid = 'common_login_phone_' + rnd;
	    var getcodeid = 'common_login_get_code_' + rnd;
	    var codeid = 'common_login_code_' + rnd;
	    var submitbtnid = 'common_login_btn_' + rnd;
	    var imglayerid = 'common_login_img_layer_' + rnd;
	    var imgid = 'common_login_img_' + rnd;
	    var imgcodeid = 'common_login_img_input_' + rnd;
	    var imgcodebtnid = 'common_login_img_btn_' + rnd;
	
	    function start_login(success_cb, fail_cb) {
	        var params = {
	            beforerequest: function beforerequest() {
	                $('#' + cover_id).show();
	                $('#' + codeid + ',#' + imgcodeid).val('');
	                window.pop_login_need_reg = true;
	            },
	            phoneid: phoneid,
	            getcodeid: getcodeid,
	            codeid: codeid,
	            submitbtnid: submitbtnid,
	            imglayerid: imglayerid,
	            imgid: imgid,
	            imgcodeid: imgcodeid,
	            imgcodebtnid: imgcodebtnid,
	            success: function success() {
	                $('#' + cover_id + ',#' + imglayerid).hide();
	                $('#' + imgid).attr('src', '');
	
	                if (typeof success_cb == "function") {
	                    var re_login = typeof window.pop_login_need_reg != 'undefined';
	                    success_cb(re_login);
	                }
	            },
	            fail: function fail() {
	                $('#' + cover_id + ',#' + imglayerid).hide();
	                $('#' + imgid).attr('src', '');
	
	                if (typeof fail_cb == "function") {
	                    var re_login = typeof window.pop_login_need_reg != 'undefined';
	                    fail_cb(re_login);
	                }
	            }
	        };
	
	        login.start(params);
	    }
	
	    function init_fn() {
	        if ($('#' + cover_id).length > 0) {
	            return;
	        }
	
	        var str_template = '<div class="common_login_cover" id="common_login_cover_' + rnd + '">\n           <div class="common_login_cover_inner">\n              <div class="js-close-layer close-layer">\n                  <div class="js-close-layer-inner close-layer-inner"></div>\n               </div>\n                <div class="common_login_img_layer" id="common_login_img_layer_' + rnd + '" >\n                    <div class="common_login_row">\n                        <img id="common_login_img_' + rnd + '" src="//img.mdcdn.cn/h5/img/placeholder_10040.png" alt="">\n                    </div>\n                    <div class="common_login_row">\n                        <input class="common_login_img_input" id="common_login_img_input_' + rnd + '" type="text" placeholder="\u56FE\u7247\u9A8C\u8BC1\u7801" >\n                        <div class="common_login_img_btn" id="common_login_img_btn_' + rnd + '" >\u786E \u5B9A</div>\n                    </div>\n                </div>\n                <div class="common_login_row">\n                    <input class="common_login_phone" id="common_login_phone_' + rnd + '" type="text" placeholder="\u8BF7\u8F93\u5165\u624B\u673A\u53F7" >\n                </div>\n                <div class="common_login_row">\n                    <input class="common_login_code" id="common_login_code_' + rnd + '" type="text" placeholder="\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801" >\n                    <div class="common_login_get_code" id="common_login_get_code_' + rnd + '">\u83B7\u53D6\u9A8C\u8BC1\u7801</div>\n                </div>\n                <div class="common_login_btn_out">\n                    <div class="common_login_btn" id="common_login_btn_' + rnd + '">\u786E \u5B9A</div>\n                </div>\n            </div>\n        </div>';
	
	        $('body').append(str_template);
	        $('#' + cover_id + ' .js-close-layer').click(function () {
	            $('#' + cover_id).hide();
	        });
	    }
	
	    exports.init = function () {
	        loadCss.loadCss('https://g.mdcdn.cn/h5/css/act/internal/common_login.css?t=201605123');
	        init_fn();
	        return {
	            start: start_login
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.getUrlParam = function (name, url) {
	    var thatUrl = arguments[1] || window.location.href;
	    var u = thatUrl.split("?"),
	        StrBack = '';
	    if (u.length > 1) {
	        var gg = u[1].split("&");
	        var MaxI = gg.length;
	        var str = arguments[0] + "=";
	        for (var i = 0; i < MaxI; i++) {
	            if (gg[i].indexOf(str) == 0) {
	                StrBack = gg[i].replace(str, "").replace(/#/g, "");
	                StrBack = StrBack.split("#")[0];
	                break;
	            }
	        }
	    }
	    return StrBack;
	};
	
	exports.getUrlItemid = function (skuid) {
	    var fsid = exports.getUrlParam('fsid');
	    var u,
	        params,
	        StrBack = '';
	    if (('' + skuid).length > 16) {
	        skuid = ('' + skuid).substr(16);
	    }
	    return '' + fsid + skuid;
	};
	
	exports.updateParms = function (parms, parmsValue, url) {
	    var newUrlParms = "";
	    var url = arguments[2] || location.href;
	    var newUrlBase = url.substring(0, url.indexOf("?") + 1);
	    var query = url.split('?')[1];
	    if (!query) {
	        return url + '?' + parms + '=' + parmsValue;
	    }
	    var pairs = query.split("&");
	    var flag = 0;
	    for (var i = 0; i < pairs.length; i++) {
	        var pos = pairs[i].indexOf('=');
	        if (pos == -1) continue;
	        var argname = pairs[i].substring(0, pos);
	        var value = pairs[i].substring(pos + 1);
	        if (findText(argname, parms)) {
	            flag = 1;
	            newUrlParms = newUrlParms + (argname + "=" + parmsValue + "&");
	        } else {
	            newUrlParms += argname + "=" + value + "&";
	        }
	    }
	
	    if (flag == 0) {
	        return url + '&' + parms + '=' + parmsValue;
	    } else {
	        return newUrlBase + newUrlParms.substring(0, newUrlParms.length - 1);
	    }
	};
	
	var findText = function findText(urlString, keyWord) {
	    return urlString.toLowerCase().indexOf(keyWord.toLowerCase()) != -1 ? true : false;
	};
	
	exports.updateUrl = function (url) {
	    var curUrl = location.href,
	        newUrl = '';
	
	    if (exports.getUrlParam('fsid') !== '') {
	        var curFsid = exports.getUrlParam('fsid');
	        var curVersion = curFsid.slice(0, 2);
	        var curSellerId = curFsid.slice(2, 9);
	        var curDisId = curFsid.slice(9, 16);
	    } else {
	        var curFsid = '1002887510100510';
	        var curVersion = '10';
	        var curSellerId = '0288751';
	        var curDisId = '0100510';
	    }
	
	    if (exports.getUrlParam('itemid', url) !== '') {
	        var itemid = exports.getUrlParam('itemid', url);
	        var disSkuId = itemid.slice(16);
	        var newItemId = curVersion + curSellerId + curDisId + disSkuId;
	        newUrl = exports.updateParms('itemid', newItemId, url);
	    } else {
	        if (url.indexOf('detail') > -1 && exports.getUrlParam('id', url) !== '') {
	            var disSkuId = exports.getUrlParam('id', url);
	            var newItemId = curVersion + curSellerId + curDisId + disSkuId;
	            newUrl = exports.updateParms('itemid', newItemId, url);
	        } else {
	            newUrl = exports.updateParms('fsid', curFsid, url);
	        }
	    }
	
	    if (newUrl !== '') {
	        url = newUrl;
	    }
	
	    if (exports.getUrlParam('fsid', url) !== '') {
	        newUrl = exports.updateParms('fsid', curFsid, url);
	    }
	
	    return newUrl;
	};
	
	exports.throttle = function (method, context) {
	    clearTimeout(method.tId);
	    method.tId = setTimeout(function () {
	        method.call(context);
	    }, 200);
	};
	
	exports.getGoodsData = function (goodsIds, func) {
	
	    $.ajax({
	        type: 'get',
	        async: false,
	        url: '//event.midea.cn/promote/w/mabapp/get_dis_sku_by_ids?ids=' + goodsIds.toString(),
	        dataType: "jsonp",
	        jsonp: "callback",
	        success: function success(data) {
	
	            func(data.data);
	        },
	        error: function error() {}
	    });
	};
	exports.getGoodsActData = function (data, func) {
	    $.ajax({
	        url: '//event.midea.cn/promote/w/mabapp/get_dis_sku_act_info',
	        async: false,
	        data: data,
	        dataType: "jsonp",
	        jsonp: "callback",
	        success: function success(res) {
	            func(res);
	        }
	
	    });
	};
	
	exports.getPoolsData = function (poolId, pollLen, fsid, shopType, proPrice, func, extraData) {
	    console.log(fsid);
	    if (fsid) {
	        var fsidStr = '&fsid=' + fsid;
	    } else {
	        var fsidStr = '';
	    }
	
	    $.ajax({
	        type: 'get',
	        async: false,
	        url: '//event.midea.cn/promote/w/mabapp/get_pool?id=' + poolId + '&length=' + pollLen + '&shop_type=' + shopType + '&proprice=' + proPrice + fsidStr + '&tao_id_type=' + (extraData && extraData.taoIdType ? extraData.taoIdType : ''),
	        dataType: "jsonp",
	        jsonp: "callback",
	        success: function success(data) {
	            if (data.errcode === 0) {
	                func(data.data);
	            }
	        },
	        error: function error() {}
	    });
	};
	
	exports.getMiaoPoolsData = function (params, fsid, func) {
	    var miaoShaGoodsHtml = '';
	    if (fsid) {
	        var fsidStr = '?fsid=' + fsid;
	    } else {
	        var fsidStr = '?fsid=1000000000100511';
	    }
	    $.ajax({
	        type: 'get',
	        url: '//event.midea.cn/promote/w/mabapp/get_miao_goods' + fsidStr,
	        data: params,
	        dataType: 'jsonp',
	        jsonp: 'callback',
	        success: function success(data) {
	            miaoShaGoodsHtml = data.miaoShaGoodsHtml;
	            func(miaoShaGoodsHtml);
	        },
	        error: function error() {},
	        complete: function complete() {
	            return miaoShaGoodsHtml;
	        }
	    });
	};
	exports.timestampToTime = function (timestamp) {
	    var date = new Date(timestamp);
	    var Y = date.getFullYear() + '-';
	    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	    var D = date.getDate() + ' ';
	    var h = date.getHours() + ':';
	    var m = date.getMinutes() + ':';
	    var s = date.getSeconds();
	    return Y + M + D + h + m + s;
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(43);
	var enumBugKeys = __webpack_require__(18);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(5).f;
	var has = __webpack_require__(2);
	var TAG = __webpack_require__(7)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(25)('keys');
	var uid = __webpack_require__(15);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var core = __webpack_require__(16);
	var LIBRARY = __webpack_require__(20);
	var wksExt = __webpack_require__(29);
	var defineProperty = __webpack_require__(5).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(7);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var countDown = function countDown() {
	        this.timeInterVal = null;
	        this.init = function (timeObj, callback) {
	            this.curTime = timeObj.serverTime || Date.parse(new Date());
	            this.leftTime = timeObj.startTime.indexOf && timeObj.startTime.indexOf('-') >= 0 ? Date.parse(timeObj.startTime.replace(/-/g, '/')) - this.curTime : Date.parse(timeObj.startTime) - this.curTime;
	            var self = this;
	            this.updateTime(callback);
	
	            if (self.timeInterVal) {
	                clearInterval(self.timeInterVal);
	            }
	            if (timeObj.index) {
	                self.index = timeObj.index;
	            }
	            this.timeInterVal = setInterval(function () {
	                self.updateTime(callback);
	            }, 1000);
	        };
	
	        this.updateTime = function (callback) {
	            var self = this;
	            var t = self.getRemainTime();
	            callback(t);
	        };
	
	        this.getRemainTime = function () {
	            var self = this;
	            this.leftTime = this.leftTime - 1000;
	            var t = this.leftTime;
	            var seconds = Math.floor(t / 1000 % 60);
	            var minutes = Math.floor(t / 1000 / 60 % 60);
	            var hours = Math.floor(t / (1000 * 60 * 60) % 24);
	            var days = Math.floor(t / (1000 * 60 * 60 * 24));
	            return {
	                'obj': self,
	                'total': t,
	                'days': days,
	                'hours': ('0' + hours).slice(-2),
	                'minutes': ('0' + minutes).slice(-2),
	                'seconds': ('0' + seconds).slice(-2)
	            };
	        };
	    };
	
	    exports.countDown = function () {
	        return new countDown();
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	"use strict";
	
	function getCookie(name) {
	    var reg = new RegExp("(^| )" + name + "(?:=([^;]*))?(;|$)"),
	        val = document.cookie.match(reg);
	    return val ? val[2] ? unescape(val[2]) : "" : "";
	}
	function getCookieV2(name) {
	    var reg = new RegExp("(^| )" + name + "(?:=([^;]*))?(;|$)"),
	        val = document.cookie.match(reg);
	    return val ? val[2] ? decodeURIComponent(val[2]) : "" : "";
	}
	function setCookie(name, value, expires, path, domain, secure) {
	    var exp = new Date(),
	        expires = arguments[2] || null,
	        path = arguments[3] || "/",
	        domain = arguments[4] || null,
	        secure = arguments[5] || false;
	    expires ? exp.setMinutes(exp.getMinutes() + parseInt(expires)) : "";
	    document.cookie = name + '=' + escape(value) + (expires ? ';expires=' + exp.toGMTString() : '') + (path ? ';path=' + path : '') + (domain ? ';domain=' + domain : '') + (secure ? ';secure' : '');
	}
	function setCookieV2(name, value, expires, path, domain, secure) {
	    var exp = new Date(),
	        expires = arguments[2] || null,
	        path = arguments[3] || "/",
	        domain = arguments[4] || null,
	        secure = arguments[5] || false;
	    expires ? exp.setMinutes(exp.getMinutes() + parseInt(expires)) : "";
	    document.cookie = name + '=' + encodeURIComponent(value) + (expires ? ';expires=' + exp.toGMTString() : '') + (path ? ';path=' + path : '') + (domain ? ';domain=' + domain : '') + (secure ? ';secure' : '');
	}
	function delCookie(name, path, domain, secure) {
	    var value = getCookie(name);
	    if (value != null) {
	        var exp = new Date();
	        exp.setMinutes(exp.getMinutes() - 1000);
	        path = path || "/";
	        document.cookie = name + '=;expires=' + exp.toGMTString() + (path ? ';path=' + path : '') + (domain ? ';domain=' + domain : '') + (secure ? ';secure' : '');
	    }
	}
	
	module.exports = {
	    get: getCookie,
	    set: setCookie,
	    getC: getCookieV2,
	    setC: setCookieV2,
	    del: delCookie
	};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	
	    function $loadCss(path, callback) {
	        if (!path) {
	            return;
	        }
	        var l;
	        if (!window["_loadCss"] || window["_loadCss"].indexOf(path) < 0) {
	            l = document.createElement('link');
	            l.setAttribute('type', 'text/css');
	            l.setAttribute('rel', 'stylesheet');
	            l.setAttribute('href', path);
	            l.setAttribute("id", "loadCss" + Math.random());
	            document.getElementsByTagName("head")[0].appendChild(l);
	            window["_loadCss"] ? window["_loadCss"] += "|" + path : window["_loadCss"] = "|" + path;
	        }
	
	        l && typeof callback == "function" && (l.onload = callback);
	
	        return true;
	    }
	    exports.loadCss = $loadCss;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(8);
	
	var Mpopup = function Mpopup(options) {
	    this.options = $.extend({}, Mpopup.defaults, options);
	
	    this.style = '<style type="text/css" id="mpopupStyle">.mod_tips_popup{opacity:0;-webkit-transition:opacity linear .2s;z-index:-1;position:fixed;max-width: 50%;left:50%;top:20%;box-sizing:border-box;padding:15px;-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-o-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);width:auto;margin-left:auto;border-radius:10px;background-color:rgba(0,0,0,0.83)}.mod_tips_popup.no_transform{width:50%;margin-left:-25%;-webkit-transform: rotateX(0);-moz-transform: rotateX(0);-o-transform: rotateX(0);-ms-transform: rotateX(0);transform: rotateX(0);}.mod_tips_popup.mod_tips_popup_show{opacity:1;z-index:10000}.mod_tips_popup .mod_tips_cnt{color:#fff;text-align:center}.mod_tips_popup .mod_tips_cnt .mod_tips_ico{display:block;margin:0 auto 10px}.mod_tips_popup  .mod_tips_ico_right{width:31px;height:19px;background:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAA6CAMAAAAHgr5qAAAAn1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8Kd3m4AAAANHRSTlMABQPz+ewJExwY4tknDeTTzjgxIgvdthHoyMTBppeSg1tFLA8HurGiilZPSz6qnXxzYa1sYvLAsgAAAYtJREFUWMO12NlygjAAheEEF3ABFcV937e22ub9n60jHiedQRhCT/47wfkcZEmCsFJ4O0thpYVSKoDNlh8tBb+jirvx5bl61rUm3+nyDDL/n/6EfKLLB8hnujyFfGHDzgfkFV3eW5P7kK/W5A5d3tmS5QRySJfHkNd0eWRNbkNu2pLLdHnbgtxly9UGZE8ka45LC/lfufROdh97RrKgHEGuvdv7E+9rF7J79SxZ3J97W1tz2X/Jbsovl2FXjeVAxVUgJ/NgNwztzRDyQKTmlVRcZGQPKpkyqsGu9/LLLuThRohctm8qBz7vm+bHqY/PRI56nLOSPO+NquG15ArEu1r9IJ/d1feY+X1byyVvaU8b1ITclgWfkV6qrJ6NJG3MQGvIY8hmdtZIF0KeSPYoqmX22N+BvHO4MxYt9x32POuKjXuHMjsM9bYVNn077DntBRumDnsmfn7J9PXDCR8O5FWPlmf0tdpSy+wVJpoLYtO/8lFQO9iR8Q4CLciwfnPyJSw0h2yjZRBdRKF+AXABgz00U2lzAAAAAElFTkSuQmCC") no-repeat;background-size:30px auto}.mod_tips_popup  .mod_tips_ico_error{width:22px;height:22px;background:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAMAAADUivDaAAAAe1BMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////NgkbwAAAAKHRSTlMAAQQHCg7q4tkRyqbUr6PlwLm1md3QzMiVw7yqnpCzgsVf7mZKQS8oNgOW6wAAAWlJREFUWMOd0dlywjAMhWHLZSv7vtOQAsXv/4RV00zPeIaB5j9Xtix9F1YIX0UZA0wsi7sLKaVdhELfh++hSDKIkIpwST+ZRiqk0g/Q0CA14ibpC2RQwa/r6rqPjYWzjzBDgkpvzYx4rto33g6NXJCxqsqz+A9hJwEYuUAMCX1vg0acSnhkDKvnecSCDEPCa0PC2gVoxP2v8Obn18aHYcGNnownAjHirCqvXCBGLjQyqCBjZFTwtGQECUMXoGFzCcSggoyDYUGGBGAs0196EoAhgRtc0DZ9L1gYpToD40JmUKHXlQGFVosadqiFEGpjbFgghoSlC5mBBGjYQEKdtgwmyDhaA6HrQmZMZAAhN6ggY2ENBGTYWMIjoyMDCLnBhNyggoytPRPaIUDDjhKAIWHiwqu8y4CCjFxYSGhgYEHGiQsycqHjAjRsKwEaEqhxhYIbn9XoLZwkMKMIVwnMuIVwWQ5cgMaoV4Zv6hd0ggaJuq4AAAAASUVORK5CYII=") no-repeat;background-size:22px auto}.mod_tips_popup  .mod_tips_ico_info{width:30px;height:30px;background:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAMAAADUivDaAAAAjVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8DizOFAAAALnRSTlMArDSB9e3YtBsUPtR6JPpODAfaeF8u8MUpwa6OnpJCyJk6HuOiZOfmsHNySMxX8IUYOgAAAhFJREFUWMOtmOdu6kAQhY/xete9N3pPCEnm/R/vStElSgjrMQznDxKyP6097YxhVZBVSxN5aepFZlllAe7UNtaKqJyamePMzLQkUjreYrT8s6Z0HYdJcfmnSMJ4nZI+++MAc0VdvcMf7eqO1JyHFJWixQQWTRakqmKYsIrIaTCgxqFohQG5pDMwyjS59jCeaJODVb6hkyXESURHjNKRogQ31L+2K4zUqn3tb5xh/zLBaE1e9n/OEUSthWBhtPr6fRgKcZdCMtfRrHGnanJ/Ixe4W4ufB8+1zq3JEvxOaMtdMb3bCJ8eTW2t4p3i79pUDmyapR9kDZWjLnU7px7Wq7zKjuhpfjnEAQMI147A4f8x3qh5FNHQ29dv2eFRBLryq9NS/Tiipi0AV/mPI3zlAtBrPI7AWgOBiiWIWAXIKJQgQspQpYkE0VOFZVlIEPl+CTOFBIGpQWRkCBPBm8kQMw+pI0M46TMQ8gd5xuuUB1WaWkW5lCZ4klZ8mcVcmXHFflIHrti5luMStQnTcpjGV2SfDZjGx7RfRjVtmSHAqiv5UYQmy8GMImYgHlP62A0NRHYs+8rJaDMwlnlz0JMbqJPdHOxGWJQNUTthLApjlIp63jBGSWbX5Kbx2dYVgZYaaLmNly8T8pXmosCMXaxMIF7v5EumfNUVL9wj1/6SVHe99neKyrN/R/re+vhgKwH5J5B/sT0yx2fHhIoAAAAASUVORK5CYII=") no-repeat;background-size:30px auto;}.mod_tips_popup  .mod_tips_ico_star{width:30px;height:29px;background:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABXCAMAAACz6KLuAAAAnFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+TINBkAAAAM3RSTlMAAgX7IwzzNlY/t7CbMOjayLyYi4R/eGxCGRAKCPfupqGTY1ErJ93OxHBnW01HquLVOpczDW4QAAACUklEQVRYw7TS2W6CYBiE4fmhbBYXBGUROHDBWDRq5v7vraYx1ioQK9//XMDkPRi8bjMty+kGGoT8EUJczKsYwizeWJA1480MohYmfy0gac47cwjKTd4xc/l7aDiJYfIP04CUJR98iUUXfFBIZdd8UkOEsvnEVpDgsoErEl2yQSmRvWejvUD0iI1G/bMPbHFAX0e2OKInj6089FOxVYVeHHZw0MeJHU7oYchOQ7zH+kh2FTtVu+TDwj/k6Xnpj/mysb88pzk6GalThxO+aRLWTmrgUbZeRUFBAUUQrdYZrlRsU5gdK1wYW2qwNQD41MIHMmqSIaEmCVxq4sKjJh4samIBEbWIAKiAGgQKF2pAcQMF3Lbll6/bupYB9Sm9rGf7uxZ7yU0YCIIAWmMPNsh8jAkSBBL+wiDCInX/u0ViQWTCuGc6wztArWrRXYVBg7kykqvBA7OKmtwUJXtlgNdkr+Cw5j+t4dSPkxw/u49WFdUqCDZU+gZelL2Bh02E5IgdXIdMNjLNsDNmsDH8fDBYCi8LKizgw1LBal9n2ZfnEKkwhY+aCjV8pFRIFQWJWRFLFQvZhSoXyN60R6+spEoJGZUg6ugfDMmBSgdIdlTaQTKhW1HQbQLJkS61BWxNl6O6IKMBbgYjOigLMuzhrjd0/fvt9nwi6za/k13GJ/bhO3h6TvAgOafyWi7fINMlnlhOg2+RE5uqdzh0KjadgpbfYo4W8yJoGU4y3pUWAlvyLksgyBtFFv3WPIcoz25FnsHT7FbzzxweTH7e7hHg0N0ODP74AY0RLzpq6NE6AAAAAElFTkSuQmCC") no-repeat;background-size:30px auto}.mod_tips_loading{width:68px;height:68px;margin-left:auto;top:40%}.mod_tips_loading.no_transform{width: 68px;left: 50%;   margin-left: -34px;-webkit-transform: rotateX(0);-moz-transform: rotateX(0);-o-transform: rotateX(0);-ms-transform: rotateX(0);transform: rotateX(0);}.mod_tips_loading .loader{-webkit-transform:scale(.5);transform:scale(.5);height:32px;margin-left:7px;margin-top:5px}.ball-spin-fade-loader{position:relative}.ball-spin-fade-loader > div:nth-child(1){top:25px;left:0;-webkit-animation:ball-spin-fade-loader 1s 0s infinite linear;animation:ball-spin-fade-loader 1s 0s infinite linear}.ball-spin-fade-loader > div:nth-child(2){top:17.04545px;left:17.04545px;-webkit-animation:ball-spin-fade-loader 1s .12s infinite linear;animation:ball-spin-fade-loader 1s .12s infinite linear}.ball-spin-fade-loader > div:nth-child(3){top:0;left:25px;-webkit-animation:ball-spin-fade-loader 1s .24s infinite linear;animation:ball-spin-fade-loader 1s .24s infinite linear}.ball-spin-fade-loader > div:nth-child(4){top:-17.04545px;left:17.04545px;-webkit-animation:ball-spin-fade-loader 1s .36s infinite linear;animation:ball-spin-fade-loader 1s .36s infinite linear}.ball-spin-fade-loader > div:nth-child(5){top:-25px;left:0;-webkit-animation:ball-spin-fade-loader 1s .48s infinite linear;animation:ball-spin-fade-loader 1s .48s infinite linear}.ball-spin-fade-loader > div:nth-child(6){top:-17.04545px;left:-17.04545px;-webkit-animation:ball-spin-fade-loader 1s .6s infinite linear;animation:ball-spin-fade-loader 1s .6s infinite linear}.ball-spin-fade-loader > div:nth-child(7){top:0;left:-25px;-webkit-animation:ball-spin-fade-loader 1s .72s infinite linear;animation:ball-spin-fade-loader 1s .72s infinite linear}.ball-spin-fade-loader > div:nth-child(8){top:17.04545px;left:-17.04545px;-webkit-animation:ball-spin-fade-loader 1s .84s infinite linear;animation:ball-spin-fade-loader 1s .84s infinite linear}.ball-spin-fade-loader > div{background-color:#fff;width:15px;height:15px;border-radius:100%;margin:2px;-webkit-animation-fill-mode:both;animation-fill-mode:both;position:absolute}@-webkit-keyframes ball-spin-fade-loader{50%{opacity:.3;-webkit-transform:scale(0.4);transform:scale(0.4)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-spin-fade-loader{50%{opacity:.3;-webkit-transform:scale(0.4);transform:scale(0.4)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.mod_popup.mod_popup_show{opacity:1;z-index:10000}.mod_popup{position:fixed;z-index:-1;top:100px;left:50%;width:60%;margin-left:-30%;background:#fff;border-radius:5px;opacity:0;-webkit-transition:opacity linear .2s;z-index:-1}.mod_popup_confirm_hd{padding:25px 20px 10px;text-align:center;font-size:16px}.mod_popup_confirm_bd{padding:0 20px 10px}.mod_popup_confirm_ft{margin-top:15px;text-align:center;border-top:#eee solid 1px}.mod_popup_confirm_ft .mod_popup_btn{height:46px;line-height:46px;font-size:15px;color:#008fdb}.mod_popup_btns_inline .mod_popup_btn{position:relative;float:left;width:50%}.mod_popup_btns_inline .mod_popup_btn:first-child::after{content:"";position:absolute;width:1px;height:100%;background:#eee;right:0;top:0}.mod_popup_btns_block .mod_popup_btn{display:block;border-top:#eee solid 1px}.mod_popup_btns_block .mod_popup_btn:first-child{border-top:none}.mod_popup .mod_popup_confirm_ft:first-child{margin-top:0;border-top:none}</style>';
	    this.loadingTpl = '<div class="mod_tips_popup mod_tips_loading" id="tips"><div class="loader"><div class="loader-inner ball-spin-fade-loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div></div>';
	    this.loadingToggleCls = 'mod_tips_popup_show';
	    this.confirmV2Tpl = '<div class="mod_popup mod_popup_confirm"><h3 class="mod_popup_confirm_hd">{#title#}</h3><div class="mod_popup_confirm_bd J_popup_confirm_content">{#content#}</div>{#buttons#}</div>';
	    this.popupToggleCls = 'mod_popup_show';
	    this.buttonsPopupTpl = '<div class="mod_popup mod_popup_button">{#buttons#}</div>';
	
	    this._init();
	};
	
	Mpopup._list = {};
	
	Mpopup.prototype = {
	    constructor: Mpopup,
	
	    _init: function _init() {
	        var opts = this.options,
	            cls = opts.className,
	            self = this;
	        this.id = opts.id || 'Mpopup' + new Date().getTime() + parseInt(Math.random() * 100);
	
	        if (Mpopup._list[this.id]) {
	            this.$popup = $('#' + this.id);
	            return;
	        }
	        Mpopup._list[this.id] = this;
	        if ($('#' + this.id).length == 0) {
	            this._create();
	        }
	
	        if ($('#mpopupStyle').length == 0) {
	            $('head').append(this.style);
	        }
	
	        this._getPopupElem();
	        this.$popup.css(opts.css || {});
	        this.$popup.addClass(this.options.setClass || '');
	
	        this.hasMask = opts.mask;
	        this.onShow = opts.onShow;
	        this.onClose = opts.onClose;
	        this.onConfirm = opts.onConfirm;
	
	        this._bindEvent();
	    },
	    _getPopupElem: function _getPopupElem() {
	        var opts = this.options;
	        if (opts.id == '') {
	            var $popup = $('#' + this.id).children().eq(0);
	        } else {
	            var $popup = $('#' + this.id);
	        }
	        this.$popup = $popup;
	    },
	
	    _bindEvent: function _bindEvent() {
	        var self = this;
	
	        this.$popup.find('[data-mpopup-close]').on('click', function (e) {
	            e.preventDefault;
	            self.close();
	        });
	
	        this.confirm();
	    },
	
	    _create: function _create() {
	        var opts = this.options,
	            popupTpl = opts.popupTpl,
	            contentTpl = opts.contentTpl,
	            content = opts.content,
	            title = opts.title,
	            contentTxt = opts.contentTxt,
	            appendTo = opts.popupAppendTo == '' ? 'body' : opts.popupAppendTo,
	            icoHtml = '',
	            buttonsHtml = '',
	            contentHtml = '',
	            popupHtml = '';
	
	        if (opts.type == 'confirm') {
	            if (opts.icoType !== '') {
	
	                icoHtml = this._getIcoHtml();
	            } else {
	                icoHtml = '';
	            }
	            if (opts.buttons !== null) {
	                buttonsHtml = this._getButtonsHtml();
	            } else {
	                buttonsHtml = '';
	            }
	
	            contentHtml = contentTpl.replace(/\{#contentTxt#\}/, contentTxt).replace(/\{#icoType#\}/, icoHtml).replace(/\{#buttons#\}/, buttonsHtml);
	
	            popupHtml = popupTpl.replace(/\{#content#\}/, contentHtml);
	        } else if (opts.type == 'info') {
	            opts.contentAppendTo = '.J_tips_content';
	            if (opts.icoType !== '') {
	
	                icoHtml = this._getIcoHtml();
	            } else {
	                icoHtml = '';
	            }
	            buttonsHtml = '';
	
	            contentHtml = contentTpl.replace(/\{#contentTxt#\}/, contentTxt).replace(/\{#icoType#\}/, icoHtml).replace(/\{#buttons#\}/, buttonsHtml);
	
	            popupHtml = popupTpl.replace(/\{#content#\}/, contentHtml);
	        } else if (opts.type == 'loading') {
	
	            popupHtml = this.loadingTpl;
	        } else if (opts.type == 'confirmV2') {
	            opts.contentAppendTo = '.J_popup_confirm_content';
	            contentTpl = this.confirmV2Tpl;
	
	            if (opts.buttons !== null) {
	                buttonsHtml = this._getButtonsHtml();
	            } else {
	                buttonsHtml = '';
	            }
	            popupHtml = contentTpl.replace(/\{#content#\}/, content).replace(/\{#title#\}/, title).replace(/\{#buttons#\}/, buttonsHtml);
	        } else if (opts.type == 'buttons') {
	            contentTpl = this.buttonsPopupTpl;
	            if (opts.buttons !== null) {
	                buttonsHtml = this._getButtonsHtml();
	            } else {
	                buttonsHtml = '';
	            }
	            popupHtml = contentTpl.replace(/\{#buttons#\}/, buttonsHtml);
	        }
	
	        var $html = $('<div id="' + this.id + '" >' + popupHtml + '</div>');
	        if (!this._isSupport('transform')) {
	            $html.addClass('no_transform');
	        }
	        $html.appendTo(appendTo);
	    },
	
	    _getIcoHtml: function _getIcoHtml() {
	
	        var opts = this.options;
	        for (var i in opts.icoTypeGroup) {
	            if (this.options.icoType == opts.icoTypeGroup[i].type) {
	                return opts.icoTypeGroup[i].tpl;
	            }
	        }
	    },
	
	    _getButtonsHtml: function _getButtonsHtml() {
	        var opts = this.options;
	        var buttonHtml = '',
	            buttonWrap = '';
	        if (opts.buttons.length > 2 || opts.type == 'buttons') {
	
	            buttonWrap = '<div class="mod_popup_confirm_ft mod_popup_btns_block">{#buttons#}</div>';
	        } else if (opts.buttons.length == 1) {
	            buttonWrap = '<div class="mod_popup_confirm_ft mod_popup_btns_block">{#buttons#}</div>';
	        } else {
	            buttonWrap = '<div class="mod_popup_confirm_ft mod_popup_btns_inline">{#buttons#}</div>';
	        }
	        for (var i = 0; i < opts.buttons.length; i++) {
	            buttonHtml += opts.buttons[i].tpl;
	        }
	
	        buttonHtml = buttonWrap.replace(/\{#buttons#\}/, buttonHtml);
	
	        return buttonHtml;
	    },
	
	    _isSupport: function _isSupport(prop) {
	
	        var div = document.createElement('div'),
	            vendors = 'Khtml O Moz Webkit'.split(' '),
	            len = vendors.length;
	        if (prop in div.style) return true;
	        if ('-ms-' + prop in div.style) return true;
	        prop = prop.replace(/^[a-z]/, function (val) {
	            return val.toUpperCase();
	        });
	        while (len--) {
	            if (vendors[len] + prop in div.style) {
	                return true;
	            }
	        }
	        return false;
	    },
	
	    setContent: function setContent(tpl) {
	        var opts = this.options;
	
	        if (opts.contentAppendTo == '') {
	            return;
	        }
	
	        if (!tpl) {
	
	            this.$popup.find(opts.contentAppendTo).html(opts.contentTpl);
	        } else {
	
	            this.$popup.find(opts.contentAppendTo).html(tpl);
	        }
	
	        return this;
	    },
	
	    show: function show(clsName) {
	        var self = this;
	        if (this.isShow) {
	            return;
	        }
	
	        var opts = this.options;
	
	        var $popup = this.$popup;
	
	        if (clsName !== undefined) {
	
	            this.toggleClass = clsName;
	            setTimeout(function () {
	                $popup.toggleClass(clsName);
	            }, 0);
	        } else {
	            if (opts.toggleCls !== '') {
	                this.toggleClass = opts.toggleCls;
	                if (opts.type == 'loading') {
	                    this.toggleClass = this.loadingToggleCls;
	                } else if (opts.type == 'confirmV2' || opts.type == 'buttons') {
	                    this.toggleClass = this.popupToggleCls;
	                }
	                var toggleCls = this.toggleClass;
	                setTimeout(function () {
	                    $popup.toggleClass(toggleCls);
	                }, 0);
	            } else {
	                $popup.show();
	            }
	        }
	
	        if (typeof this.onShow === 'function') {
	            this.onShow($('#' + this.id));
	        }
	
	        $(this).trigger('show:mpopup', [this.$popup]);
	
	        if (opts.autoClose) {
	            window.setTimeout(function () {
	                self.close(this.toggleClass);
	            }, opts.autoClose);
	        }
	
	        if (this.hasMask) {
	            Mpopup.mask.show();
	            if (opts.clickMaskClose) {
	                $('#mpopupMask').on('click', function (e) {
	                    e.preventDefault();
	
	                    self.close();
	                });
	            }
	        }
	        this.isShow = true;
	
	        return this;
	    },
	
	    confirm: function confirm() {
	        var self = this;
	        var opts = self.options;
	
	        self.$popup.find('[data-mpopup-confirm]').on('click', function (e) {
	            e.preventDefault;
	            if (typeof self.onConfirm === 'function') {
	                self.onConfirm($(e.target));
	            }
	
	            $(self).trigger('confirm:mpopup', [$(e.target)]);
	
	            if (opts.destroyAfterClose) {
	                self.destory();
	            } else {
	                self.hide();
	            }
	        });
	
	        return this;
	    },
	
	    hide: function hide() {
	
	        if (!this.isShow) {
	            return;
	        }
	
	        var opts = this.options;
	
	        var $popup = this.$popup;
	
	        var closeMask = true;
	
	        if (this.toggleClass !== undefined) {
	            $popup.toggleClass(this.toggleClass);
	        } else {
	            $popup.hide();
	        }
	
	        if (this.hasMask) {
	            for (var id in Mpopup._list) {
	
	                var instance = Mpopup._list[id];
	
	                if (instance !== this && instance.hasMask && instance.isShow) {
	                    closeMask = false;
	                    break;
	                }
	            }
	            if (closeMask) {
	                closeMask && Mpopup.mask.hide();
	            }
	        }
	        this.isShow = false;
	
	        $(this).trigger('hide:mpopup', [this.$popup]);
	        return this;
	    },
	
	    close: function close() {
	
	        var opts = this.options;
	        if (typeof this.onClose === 'function') {
	            this.onClose($('#' + this.id));
	        }
	
	        if (opts.destroyAfterClose) {
	
	            this.destory();
	        } else {
	
	            this.hide();
	        }
	
	        $(this).trigger('close:mpopup', [this.$popup]);
	    },
	
	    destory: function destory() {
	        var self = this;
	        var opts = this.options;
	        var $popup = this.$popup;
	
	        this.hide();
	
	        if (this.toggleClass) {
	            if ($popup.css('-webkit-transition-duration') !== '0s') {
	
	                $popup.on('webkitTransitionEnd', function () {
	                    if (!Mpopup._list[self.id]) {
	                        return;
	                    }
	                    $('#' + self.id).remove();
	                    delete Mpopup._list[self.id];
	                }, false);
	            } else {
	                $('#' + this.id).remove();
	                delete Mpopup._list[this.id];
	            }
	        } else {
	            $('#' + this.id).remove();
	            delete Mpopup._list[this.id];
	        }
	
	        $(this).trigger('destory:mpopup', []);
	    },
	
	    css: function css(style) {
	        this.$popup.css(style);
	        return this;
	    }
	};
	
	Mpopup.mask = {
	
	    isShow: false,
	
	    layer: null,
	
	    show: function show() {
	        if (this.isShow) {
	            return;
	        }
	        if (!this.layer) {
	            this.layer = $('<div id="mpopupMask" />').css({
	                position: 'fixed',
	                left: 0,
	                top: 0,
	                height: '100%',
	                width: '100%',
	                background: 'rgba(0,0,0,0.2)',
	
	                zIndex: 999
	            }).appendTo('body');
	        }
	        this.layer.show();
	        this.isShow = true;
	    },
	
	    hide: function hide() {
	        if (!this.isShow || !this.layer) {
	            return;
	        }
	        this.layer.hide();
	        this.isShow = false;
	    },
	
	    setStyle: function setStyle(background, opacity) {
	        this.layer.css({
	            background: background,
	            opacity: opacity
	        });
	    },
	
	    setZIndex: function setZIndex(zIndex) {
	        this.layer.css('z-Index', zIndex);
	    }
	};
	
	Mpopup.defaults = {
	    id: '',
	    type: 'confirm',
	    popupAppendTo: '',
	    popupTpl: '<div class="mod_tips_popup">{#content#}</div>',
	    contentTpl: '<div class="mod_tips_cnt">{#icoType#}<div class="J_tips_content">{#contentTxt#}</div></div><div class="mod_tips_ft">{#buttons#}</div>',
	    contentAppendTo: '.mod_tips_cnt',
	    content: '',
	    contentTxt: '',
	    toggleCls: 'mod_tips_popup_show',
	    title: '',
	    css: null,
	    setClass: null,
	    mask: true,
	    destroyAfterClose: false,
	    clickMaskClose: false,
	    autoClose: false,
	    zIndex: null,
	    icoType: 'info',
	    icoTypeGroup: [{ type: 'info', tpl: '<i class="mod_tips_ico mod_tips_ico_info"></i>' }, { type: 'right', tpl: '<i class="mod_tips_ico mod_tips_ico_right"></i>' }, { type: 'error', tpl: '<i class="mod_tips_ico mod_tips_ico_error"></i>' }, { type: 'star', tpl: '<i class="mod_tips_ico mod_tips_ico_star"></i>' }],
	    buttons: [{ tpl: '<a  class="mod_popup_btn " href="javascript:void(0)" data-mpopup-confirm>确认</a>' }, { tpl: '<a  class="mod_popup_btn" data-mpopup-close href="javascript:void(0)">取消</a>' }],
	    onConfirm: null,
	    onShow: null,
	    onClose: null
	};
	
	window.Mpopup = Mpopup;
	
	$.mpopup = function (options) {
	    return new Mpopup(options);
	};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(33);
	var login = __webpack_require__(9).init();
	
	var opt = {
	  type: 'loading',
	  content: '',
	  icoType: '',
	  mask: true
	};
	
	var opt2 = {
	  type: 'info',
	  content: '',
	  icoType: 'right',
	  autoClose: 3000,
	  mask: true
	};
	
	var opt3 = {
	  type: 'info',
	  content: '',
	  icoType: 'info',
	  mask: true,
	  autoClose: 3000
	};
	
	var opt4 = {
	  type: 'info',
	  content: '',
	  icoType: 'error',
	  autoClose: 3000,
	  mask: true
	};
	
	var oLoad = $.mpopup(opt);
	
	var oSuccess = $.mpopup(opt2);
	
	var oWarn = $.mpopup(opt3);
	
	var oFail = $.mpopup(opt4);
	
	var couponActiveClassName = 'coupon__item--active';
	var couponReceivedClassName = 'coupon__item--received';
	
	function getCoupon(e, callback) {
	  var $this = $(this);
	  var obtainId = $this.data('obtain-id');
	  var btnDes = '已领取';
	
	  if ($this.data('click') == 0) {
	    $this.data('click', 1);
	  } else {
	    return;
	  }
	
	  login.start(function () {
	    oLoad.show();
	    $.ajax({
	      type: 'GET',
	      url: '/coupon/get_user_coupon',
	      dataType: "json",
	      data: {
	        obtainId: obtainId
	      },
	      error: function error() {
	        oLoad.close();
	        oFail.setContent('领取失败，请稍后再试！').show();
	      },
	      success: function success(response) {
	        oLoad.close();
	
	        if (response.errcode == 0) {
	          if ($this.hasClass(couponActiveClassName)) {
	            $this.removeClass(couponActiveClassName);
	          }
	          if (!$this.hasClass(couponReceivedClassName)) {
	            $this.addClass(couponReceivedClassName);
	          }
	          oSuccess.setContent('领取成功!<br/>请在个人中心-我的优惠券查看').show();
	          $this.find(".coupon__status span").html(btnDes);
	          $this.find(".coupon__status a").show();
	        } else if (response.errcode == 0x20BA1023) {
	          if ($this.hasClass(couponActiveClassName)) {
	            $this.removeClass(couponActiveClassName);
	          }
	          if (!$this.hasClass(couponReceivedClassName)) {
	            $this.addClass(couponReceivedClassName);
	          }
	
	          oWarn.setContent('你已领取！').show();
	          $this.find(".coupon__status span").html(btnDes);
	        } else if (response.errcode == 0x20BA1036) {
	          oWarn.setContent('已结束发放，下次请早哦！').show();
	          $this.find(".coupon__status span").html("");
	          $this.append('<div class="mc_modal_over" style="display: block;">\n            <p class="mc_modal_tips">\u5DF2\u62A2\u5149</p>\n          </div>');
	        } else if (response.errcode == 549064752 || response.errcode == 549064759) {
	          $this.hide();
	          oWarn.setContent('已结束发放，下次请早哦！').show();
	          $this.find(".coupon__status span").html("");
	          $this.append('<div class="mc_modal_over" style="display: block;">\n            <p class="mc_modal_tips">\u5DF2\u62A2\u5149</p>\n          </div>');
	        } else if (response.errcode == "539299862" || response.errcode == "539299865") {
	          location.href = '//' + location.host + "/mlogin/check_user?rurl=" + encodeURIComponent(location.href);
	        } else if (response.errcode == 549068803) {
	          oWarn.setContent('啊哦，您当前不是付费会员哦~').show();
	        } else if (response.errcode == 549068804) {
	          var buttons = [{ tpl: '<a class="mod_popup_btn" href="/">去升级</a>' }, { tpl: '<a class="mod_popup_btn" data-mpopup-close href="javascript:void(0)">我知道了</a>' }];
	          $.mpopup({
	            type: 'confirmV2',
	            content: '<div style="text-align: center">您当前等级不满足领取条件，快去升级吧~</div>',
	            destroyAfterClose: true,
	            buttons: buttons
	          }).show();
	        } else {
	          oFail.setContent('领取失败:' + (response.errmsg ? response.errmsg : '请稍后再试~')).show();
	        }
	      }
	    });
	  });
	}
	
	module.exports = {
	  oLoad: oLoad,
	  oFail: oFail,
	  oWarn: oWarn,
	  oSuccess: oSuccess,
	  getCoupon: getCoupon
	};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var document = __webpack_require__(1).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var core = __webpack_require__(16);
	var ctx = __webpack_require__(66);
	var hide = __webpack_require__(4);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(3) && !__webpack_require__(12)(function () {
	  return Object.defineProperty(__webpack_require__(36)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(20);
	var $export = __webpack_require__(37);
	var redefine = __webpack_require__(44);
	var hide = __webpack_require__(4);
	var has = __webpack_require__(2);
	var Iterators = __webpack_require__(19);
	var $iterCreate = __webpack_require__(71);
	var setToStringTag = __webpack_require__(23);
	var getPrototypeOf = __webpack_require__(77);
	var ITERATOR = __webpack_require__(7)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(11);
	var dPs = __webpack_require__(74);
	var enumBugKeys = __webpack_require__(18);
	var IE_PROTO = __webpack_require__(24)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(36)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(68).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(43);
	var hiddenKeys = __webpack_require__(18).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(2);
	var toIObject = __webpack_require__(6);
	var arrayIndexOf = __webpack_require__(65)(false);
	var IE_PROTO = __webpack_require__(24)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// doT.js
	// 2011-2014, Laura Doktorova, https://github.com/olado/doT
	// Licensed under the MIT license.
	
	(function () {
		"use strict";
	
		var doT = {
			name: "doT",
			version: "1.1.1",
			templateSettings: {
				evaluate:    /\{\{([\s\S]+?(\}?)+)\}\}/g,
				interpolate: /\{\{=([\s\S]+?)\}\}/g,
				encode:      /\{\{!([\s\S]+?)\}\}/g,
				use:         /\{\{#([\s\S]+?)\}\}/g,
				useParams:   /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
				define:      /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
				defineParams:/^\s*([\w$]+):([\s\S]+)/,
				conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
				iterate:     /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
				varname:	"it",
				strip:		true,
				append:		true,
				selfcontained: false,
				doNotSkipEncoded: false
			},
			template: undefined, //fn, compile template
			compile:  undefined, //fn, for express
			log: true
		}, _globals;
	
		doT.encodeHTMLSource = function(doNotSkipEncoded) {
			var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
				matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
			return function(code) {
				return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
			};
		};
	
		_globals = (function(){ return this || (0,eval)("this"); }());
	
		/* istanbul ignore else */
		if (typeof module !== "undefined" && module.exports) {
			module.exports = doT;
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return doT;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			_globals.doT = doT;
		}
	
		var startend = {
			append: { start: "'+(",      end: ")+'",      startencode: "'+encodeHTML(" },
			split:  { start: "';out+=(", end: ");out+='", startencode: "';out+=encodeHTML(" }
		}, skip = /$^/;
	
		function resolveDefs(c, block, def) {
			return ((typeof block === "string") ? block : block.toString())
			.replace(c.define || skip, function(m, code, assign, value) {
				if (code.indexOf("def.") === 0) {
					code = code.substring(4);
				}
				if (!(code in def)) {
					if (assign === ":") {
						if (c.defineParams) value.replace(c.defineParams, function(m, param, v) {
							def[code] = {arg: param, text: v};
						});
						if (!(code in def)) def[code]= value;
					} else {
						new Function("def", "def['"+code+"']=" + value)(def);
					}
				}
				return "";
			})
			.replace(c.use || skip, function(m, code) {
				if (c.useParams) code = code.replace(c.useParams, function(m, s, d, param) {
					if (def[d] && def[d].arg && param) {
						var rw = (d+":"+param).replace(/'|\\/g, "_");
						def.__exp = def.__exp || {};
						def.__exp[rw] = def[d].text.replace(new RegExp("(^|[^\\w$])" + def[d].arg + "([^\\w$])", "g"), "$1" + param + "$2");
						return s + "def.__exp['"+rw+"']";
					}
				});
				var v = new Function("def", "return " + code)(def);
				return v ? resolveDefs(c, v, def) : v;
			});
		}
	
		function unescape(code) {
			return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
		}
	
		doT.template = function(tmpl, c, def) {
			c = c || doT.templateSettings;
			var cse = c.append ? startend.append : startend.split, needhtmlencode, sid = 0, indv,
				str  = (c.use || c.define) ? resolveDefs(c, tmpl, def || {}) : tmpl;
	
			str = ("var out='" + (c.strip ? str.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g," ")
						.replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g,""): str)
				.replace(/'|\\/g, "\\$&")
				.replace(c.interpolate || skip, function(m, code) {
					return cse.start + unescape(code) + cse.end;
				})
				.replace(c.encode || skip, function(m, code) {
					needhtmlencode = true;
					return cse.startencode + unescape(code) + cse.end;
				})
				.replace(c.conditional || skip, function(m, elsecase, code) {
					return elsecase ?
						(code ? "';}else if(" + unescape(code) + "){out+='" : "';}else{out+='") :
						(code ? "';if(" + unescape(code) + "){out+='" : "';}out+='");
				})
				.replace(c.iterate || skip, function(m, iterate, vname, iname) {
					if (!iterate) return "';} } out+='";
					sid+=1; indv=iname || "i"+sid; iterate=unescape(iterate);
					return "';var arr"+sid+"="+iterate+";if(arr"+sid+"){var "+vname+","+indv+"=-1,l"+sid+"=arr"+sid+".length-1;while("+indv+"<l"+sid+"){"
						+vname+"=arr"+sid+"["+indv+"+=1];out+='";
				})
				.replace(c.evaluate || skip, function(m, code) {
					return "';" + unescape(code) + "out+='";
				})
				+ "';return out;")
				.replace(/\n/g, "\\n").replace(/\t/g, '\\t').replace(/\r/g, "\\r")
				.replace(/(\s|;|\}|^|\{)out\+='';/g, '$1').replace(/\+''/g, "");
				//.replace(/(\s|;|\}|^|\{)out\+=''\+/g,'$1out+=');
	
			if (needhtmlencode) {
				if (!c.selfcontained && _globals && !_globals._encodeHTML) _globals._encodeHTML = doT.encodeHTMLSource(c.doNotSkipEncoded);
				str = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : ("
					+ doT.encodeHTMLSource.toString() + "(" + (c.doNotSkipEncoded || '') + "));"
					+ str;
			}
			try {
				return new Function(c.varname, str);
			} catch (e) {
				/* istanbul ignore else */
				if (typeof console !== "undefined") console.log("Could not create a template function: " + str);
				throw e;
			}
		};
	
		doT.compile = function(tmpl, def) {
			return doT.template(tmpl, null, def);
		};
	}());


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	! function (e, n) {
	  module.exports = n(e)
	}(window, function (e, n) {
	  function i(n, i, t) {
	    e.WeixinJSBridge ? WeixinJSBridge.invoke(n, o(i),
	    function(e) {
	      c(n, e, t)
	    }) : u(n, t)
	  }
	  function t(n, i, t) {
	    e.WeixinJSBridge ? WeixinJSBridge.on(n,
	    function(e) {
	      t && t.trigger && t.trigger(e),
	      c(n, e, i)
	    }) : t ? u(n, t) : u(n, i)
	  }
	  function o(e) {
	    return e = e || {},
	    e.appId = C.appId,
	    e.verifyAppId = C.appId,
	    e.verifySignType = "sha1",
	    e.verifyTimestamp = C.timestamp + "",
	    e.verifyNonceStr = C.nonceStr,
	    e.verifySignature = C.signature,
	    e
	  }
	  function r(e) {
	    return {
	      timeStamp: e.timestamp + "",
	      nonceStr: e.nonceStr,
	      package: e.package,
	      paySign: e.paySign,
	      signType: e.signType || "SHA1"
	    }
	  }
	  function a(e) {
	    return e.postalCode = e.addressPostalCode,
	    delete e.addressPostalCode,
	    e.provinceName = e.proviceFirstStageName,
	    delete e.proviceFirstStageName,
	    e.cityName = e.addressCitySecondStageName,
	    delete e.addressCitySecondStageName,
	    e.countryName = e.addressCountiesThirdStageName,
	    delete e.addressCountiesThirdStageName,
	    e.detailInfo = e.addressDetailInfo,
	    delete e.addressDetailInfo,
	    e
	  }
	  function c(e, n, i) {
	    "openEnterpriseChat" == e && (n.errCode = n.err_code),
	    delete n.err_code,
	    delete n.err_desc,
	    delete n.err_detail;
	    var t = n.errMsg;
	    t || (t = n.err_msg, delete n.err_msg, t = s(e, t), n.errMsg = t),
	    (i = i || {})._complete && (i._complete(n), delete i._complete),
	    t = n.errMsg || "",
	    C.debug && !i.isInnerInvoke && alert(JSON.stringify(n));
	    var o = t.indexOf(":");
	    switch (t.substring(o + 1)) {
	    case "ok":
	      i.success && i.success(n);
	      break;
	    case "cancel":
	      i.cancel && i.cancel(n);
	      break;
	    default:
	      i.fail && i.fail(n)
	    }
	    i.complete && i.complete(n)
	  }
	  function s(e, n) {
	    var i = e,
	    t = v[i];
	    t && (i = t);
	    var o = "ok";
	    if (n) {
	      var r = n.indexOf(":");
	      "confirm" == (o = n.substring(r + 1)) && (o = "ok"),
	      "failed" == o && (o = "fail"),
	      -1 != o.indexOf("failed_") && (o = o.substring(7)),
	      -1 != o.indexOf("fail_") && (o = o.substring(5)),
	      "access denied" != (o = (o = o.replace(/_/g, " ")).toLowerCase()) && "no permission to execute" != o || (o = "permission denied"),
	      "config" == i && "function not exist" == o && (o = "ok"),
	      "" == o && (o = "fail")
	    }
	    return n = i + ":" + o
	  }
	  function d(e) {
	    if (e) {
	      for (var n = 0,
	      i = e.length; n < i; ++n) {
	        var t = e[n],
	        o = h[t];
	        o && (e[n] = o)
	      }
	      return e
	    }
	  }
	  function u(e, n) {
	    if (! (!C.debug || n && n.isInnerInvoke)) {
	      var i = v[e];
	      i && (e = i),
	      n && n._complete && delete n._complete,
	      console.log('"' + e + '",', n || "")
	    }
	  }
	  function l(e) {
	    if (! (k || w || C.debug || x < "6.0.2" || V.systemType < 0)) {
	      var n = new Image;
	      V.appId = C.appId,
	      V.initTime = A.initEndTime - A.initStartTime,
	      V.preVerifyTime = A.preVerifyEndTime - A.preVerifyStartTime,
	      N.getNetworkType({
	        isInnerInvoke: !0,
	        success: function(e) {
	          V.networkType = e.networkType;
	          var i = "https://open.weixin.qq.com/sdk/report?v=" + V.version + "&o=" + V.isPreVerifyOk + "&s=" + V.systemType + "&c=" + V.clientVersion + "&a=" + V.appId + "&n=" + V.networkType + "&i=" + V.initTime + "&p=" + V.preVerifyTime + "&u=" + V.url;
	          n.src = i
	        }
	      })
	    }
	  }
	  function p() {
	    return (new Date).getTime()
	  }
	  function f(n) {
	    T && (e.WeixinJSBridge ? n() : S.addEventListener && S.addEventListener("WeixinJSBridgeReady", n, !1))
	  }
	  function m() {
	    N.invoke || (N.invoke = function(n, i, t) {
	      e.WeixinJSBridge && WeixinJSBridge.invoke(n, o(i), t)
	    },
	    N.on = function(n, i) {
	      e.WeixinJSBridge && WeixinJSBridge.on(n, i)
	    })
	  }
	  function g(e) {
	    if ("string" == typeof e && e.length > 0) {
	      var n = e.split("?")[0],
	      i = e.split("?")[1];
	      return n += ".html",
	      void 0 !== i ? n + "?" + i: n
	    }
	  }
	  if (!e.jWeixin) {
	    var h = {
	      config: "preVerifyJSAPI",
	      onMenuShareTimeline: "menu:share:timeline",
	      onMenuShareAppMessage: "menu:share:appmessage",
	      onMenuShareQQ: "menu:share:qq",
	      onMenuShareWeibo: "menu:share:weiboApp",
	      onMenuShareQZone: "menu:share:QZone",
	      previewImage: "imagePreview",
	      getLocation: "geoLocation",
	      openProductSpecificView: "openProductViewWithPid",
	      addCard: "batchAddCard",
	      openCard: "batchViewCard",
	      chooseWXPay: "getBrandWCPayRequest",
	      openEnterpriseRedPacket: "getRecevieBizHongBaoRequest",
	      startSearchBeacons: "startMonitoringBeacons",
	      stopSearchBeacons: "stopMonitoringBeacons",
	      onSearchBeacons: "onBeaconsInRange",
	      consumeAndShareCard: "consumedShareCard",
	      openAddress: "editAddress"
	    },
	    v = function() {
	      var e = {};
	      for (var n in h) e[h[n]] = n;
	      return e
	    } (),
	    S = e.document,
	    I = S.title,
	    y = navigator.userAgent.toLowerCase(),
	    _ = navigator.platform.toLowerCase(),
	    k = !(!_.match("mac") && !_.match("win")),
	    w = -1 != y.indexOf("wxdebugger"),
	    T = -1 != y.indexOf("micromessenger"),
	    M = -1 != y.indexOf("android"),
	    P = -1 != y.indexOf("iphone") || -1 != y.indexOf("ipad"),
	    x = function() {
	      var e = y.match(/micromessenger\/(\d+\.\d+\.\d+)/) || y.match(/micromessenger\/(\d+\.\d+)/);
	      return e ? e[1] : ""
	    } (),
	    A = {
	      initStartTime: p(),
	      initEndTime: 0,
	      preVerifyStartTime: 0,
	      preVerifyEndTime: 0
	    },
	    V = {
	      version: 1,
	      appId: "",
	      initTime: 0,
	      preVerifyTime: 0,
	      networkType: "",
	      isPreVerifyOk: 1,
	      systemType: P ? 1 : M ? 2 : -1,
	      clientVersion: x,
	      url: encodeURIComponent(location.href)
	    },
	    C = {},
	    L = {
	      _completes: []
	    },
	    B = {
	      state: 0,
	      data: {}
	    };
	    f(function() {
	      A.initEndTime = p()
	    });
	    var O = !1,
	    E = [],
	    N = {
	      config: function(e) {
	        C = e,
	        u("config", e);
	        var n = !1 !== C.check;
	        f(function() {
	          if (n) i(h.config, {
	            verifyJsApiList: d(C.jsApiList)
	          },
	          function() {
	            L._complete = function(e) {
	              A.preVerifyEndTime = p(),
	              B.state = 1,
	              B.data = e
	            },
	            L.success = function(e) {
	              V.isPreVerifyOk = 0
	            },
	            L.fail = function(e) {
	              L._fail ? L._fail(e) : B.state = -1
	            };
	            var e = L._completes;
	            return e.push(function() {
	              l()
	            }),
	            L.complete = function(n) {
	              for (var i = 0,
	              t = e.length; i < t; ++i) e[i]();
	              L._completes = []
	            },
	            L
	          } ()),
	          A.preVerifyStartTime = p();
	          else {
	            B.state = 1;
	            for (var e = L._completes,
	            t = 0,
	            o = e.length; t < o; ++t) e[t]();
	            L._completes = []
	          }
	        }),
	        m()
	      },
	      ready: function(e) {
	        0 != B.state ? e() : (L._completes.push(e), !T && C.debug && e())
	      },
	      error: function(e) {
	        x < "6.0.2" || ( - 1 == B.state ? e(B.data) : L._fail = e)
	      },
	      checkJsApi: function(e) {
	        var n = function(e) {
	          var n = e.checkResult;
	          for (var i in n) {
	            var t = v[i];
	            t && (n[t] = n[i], delete n[i])
	          }
	          return e
	        };
	        i("checkJsApi", {
	          jsApiList: d(e.jsApiList)
	        },
	        (e._complete = function(e) {
	          if (M) {
	            var i = e.checkResult;
	            i && (e.checkResult = JSON.parse(i))
	          }
	          e = n(e)
	        },
	        e))
	      },
	      onMenuShareTimeline: function(e) {
	        t(h.onMenuShareTimeline, {
	          complete: function() {
	            i("shareTimeline", {
	              title: e.title || I,
	              desc: e.title || I,
	              img_url: e.imgUrl || "",
	              link: e.link || location.href,
	              type: e.type || "link",
	              data_url: e.dataUrl || ""
	            },
	            e)
	          }
	        },
	        e)
	      },
	      onMenuShareAppMessage: function(e) {
	        t(h.onMenuShareAppMessage, {
	          complete: function(n) {
	            "favorite" === n.scene ? i("sendAppMessage", {
	              title: e.title || I,
	              desc: e.desc || "",
	              link: e.link || location.href,
	              img_url: e.imgUrl || "",
	              type: e.type || "link",
	              data_url: e.dataUrl || ""
	            }) : i("sendAppMessage", {
	              title: e.title || I,
	              desc: e.desc || "",
	              link: e.link || location.href,
	              img_url: e.imgUrl || "",
	              type: e.type || "link",
	              data_url: e.dataUrl || ""
	            },
	            e)
	          }
	        },
	        e)
	      },
	      onMenuShareQQ: function(e) {
	        t(h.onMenuShareQQ, {
	          complete: function() {
	            i("shareQQ", {
	              title: e.title || I,
	              desc: e.desc || "",
	              img_url: e.imgUrl || "",
	              link: e.link || location.href
	            },
	            e)
	          }
	        },
	        e)
	      },
	      onMenuShareWeibo: function(e) {
	        t(h.onMenuShareWeibo, {
	          complete: function() {
	            i("shareWeiboApp", {
	              title: e.title || I,
	              desc: e.desc || "",
	              img_url: e.imgUrl || "",
	              link: e.link || location.href
	            },
	            e)
	          }
	        },
	        e)
	      },
	      onMenuShareQZone: function(e) {
	        t(h.onMenuShareQZone, {
	          complete: function() {
	            i("shareQZone", {
	              title: e.title || I,
	              desc: e.desc || "",
	              img_url: e.imgUrl || "",
	              link: e.link || location.href
	            },
	            e)
	          }
	        },
	        e)
	      },
	      updateTimelineShareData: function(e) {
	        i("updateTimelineShareData", {
	          title: e.title,
	          link: e.link,
	          imgUrl: e.imgUrl
	        },
	        e)
	      },
	      updateAppMessageShareData: function(e) {
	        i("updateAppMessageShareData", {
	          title: e.title,
	          desc: e.desc,
	          link: e.link,
	          imgUrl: e.imgUrl
	        },
	        e)
	      },
	      startRecord: function(e) {
	        i("startRecord", {},
	        e)
	      },
	      stopRecord: function(e) {
	        i("stopRecord", {},
	        e)
	      },
	      onVoiceRecordEnd: function(e) {
	        t("onVoiceRecordEnd", e)
	      },
	      playVoice: function(e) {
	        i("playVoice", {
	          localId: e.localId
	        },
	        e)
	      },
	      pauseVoice: function(e) {
	        i("pauseVoice", {
	          localId: e.localId
	        },
	        e)
	      },
	      stopVoice: function(e) {
	        i("stopVoice", {
	          localId: e.localId
	        },
	        e)
	      },
	      onVoicePlayEnd: function(e) {
	        t("onVoicePlayEnd", e)
	      },
	      uploadVoice: function(e) {
	        i("uploadVoice", {
	          localId: e.localId,
	          isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
	        },
	        e)
	      },
	      downloadVoice: function(e) {
	        i("downloadVoice", {
	          serverId: e.serverId,
	          isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
	        },
	        e)
	      },
	      translateVoice: function(e) {
	        i("translateVoice", {
	          localId: e.localId,
	          isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
	        },
	        e)
	      },
	      chooseImage: function(e) {
	        i("chooseImage", {
	          scene: "1|2",
	          count: e.count || 9,
	          sizeType: e.sizeType || ["original", "compressed"],
	          sourceType: e.sourceType || ["album", "camera"]
	        },
	        (e._complete = function(e) {
	          if (M) {
	            var n = e.localIds;
	            try {
	              n && (e.localIds = JSON.parse(n))
	            } catch(e) {}
	          }
	        },
	        e))
	      },
	      getLocation: function(e) {},
	      previewImage: function(e) {
	        i(h.previewImage, {
	          current: e.current,
	          urls: e.urls
	        },
	        e)
	      },
	      uploadImage: function(e) {
	        i("uploadImage", {
	          localId: e.localId,
	          isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
	        },
	        e)
	      },
	      downloadImage: function(e) {
	        i("downloadImage", {
	          serverId: e.serverId,
	          isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
	        },
	        e)
	      },
	      getLocalImgData: function(e) { ! 1 === O ? (O = !0, i("getLocalImgData", {
	          localId: e.localId
	        },
	        (e._complete = function(e) {
	          if (O = !1, E.length > 0) {
	            var n = E.shift();
	            wx.getLocalImgData(n)
	          }
	        },
	        e))) : E.push(e)
	      },
	      getNetworkType: function(e) {
	        var n = function(e) {
	          var n = e.errMsg;
	          e.errMsg = "getNetworkType:ok";
	          var i = e.subtype;
	          if (delete e.subtype, i) e.networkType = i;
	          else {
	            var t = n.indexOf(":"),
	            o = n.substring(t + 1);
	            switch (o) {
	            case "wifi":
	            case "edge":
	            case "wwan":
	              e.networkType = o;
	              break;
	            default:
	              e.errMsg = "getNetworkType:fail"
	            }
	          }
	          return e
	        };
	        i("getNetworkType", {},
	        (e._complete = function(e) {
	          e = n(e)
	        },
	        e))
	      },
	      openLocation: function(e) {
	        i("openLocation", {
	          latitude: e.latitude,
	          longitude: e.longitude,
	          name: e.name || "",
	          address: e.address || "",
	          scale: e.scale || 28,
	          infoUrl: e.infoUrl || ""
	        },
	        e)
	      },
	      getLocation: function(e) {
	        e = e || {},
	        i(h.getLocation, {
	          type: e.type || "wgs84"
	        },
	        (e._complete = function(e) {
	          delete e.type
	        },
	        e))
	      },
	      hideOptionMenu: function(e) {
	        i("hideOptionMenu", {},
	        e)
	      },
	      showOptionMenu: function(e) {
	        i("showOptionMenu", {},
	        e)
	      },
	      closeWindow: function(e) {
	        i("closeWindow", {},
	        e = e || {})
	      },
	      hideMenuItems: function(e) {
	        i("hideMenuItems", {
	          menuList: e.menuList
	        },
	        e)
	      },
	      showMenuItems: function(e) {
	        i("showMenuItems", {
	          menuList: e.menuList
	        },
	        e)
	      },
	      hideAllNonBaseMenuItem: function(e) {
	        i("hideAllNonBaseMenuItem", {},
	        e)
	      },
	      showAllNonBaseMenuItem: function(e) {
	        i("showAllNonBaseMenuItem", {},
	        e)
	      },
	      scanQRCode: function(e) {
	        i("scanQRCode", {
	          needResult: (e = e || {}).needResult || 0,
	          scanType: e.scanType || ["qrCode", "barCode"]
	        },
	        (e._complete = function(e) {
	          if (P) {
	            var n = e.resultStr;
	            if (n) {
	              var i = JSON.parse(n);
	              e.resultStr = i && i.scan_code && i.scan_code.scan_result
	            }
	          }
	        },
	        e))
	      },
	      openAddress: function(e) {
	        i(h.openAddress, {},
	        (e._complete = function(e) {
	          e = a(e)
	        },
	        e))
	      },
	      openProductSpecificView: function(e) {
	        i(h.openProductSpecificView, {
	          pid: e.productId,
	          view_type: e.viewType || 0,
	          ext_info: e.extInfo
	        },
	        e)
	      },
	      addCard: function(e) {
	        for (var n = e.cardList,
	        t = [], o = 0, r = n.length; o < r; ++o) {
	          var a = n[o],
	          c = {
	            card_id: a.cardId,
	            card_ext: a.cardExt
	          };
	          t.push(c)
	        }
	        i(h.addCard, {
	          card_list: t
	        },
	        (e._complete = function(e) {
	          var n = e.card_list;
	          if (n) {
	            for (var i = 0,
	            t = (n = JSON.parse(n)).length; i < t; ++i) {
	              var o = n[i];
	              o.cardId = o.card_id,
	              o.cardExt = o.card_ext,
	              o.isSuccess = !!o.is_succ,
	              delete o.card_id,
	              delete o.card_ext,
	              delete o.is_succ
	            }
	            e.cardList = n,
	            delete e.card_list
	          }
	        },
	        e))
	      },
	      chooseCard: function(e) {
	        i("chooseCard", {
	          app_id: C.appId,
	          location_id: e.shopId || "",
	          sign_type: e.signType || "SHA1",
	          card_id: e.cardId || "",
	          card_type: e.cardType || "",
	          card_sign: e.cardSign,
	          time_stamp: e.timestamp + "",
	          nonce_str: e.nonceStr
	        },
	        (e._complete = function(e) {
	          e.cardList = e.choose_card_info,
	          delete e.choose_card_info
	        },
	        e))
	      },
	      openCard: function(e) {
	        for (var n = e.cardList,
	        t = [], o = 0, r = n.length; o < r; ++o) {
	          var a = n[o],
	          c = {
	            card_id: a.cardId,
	            code: a.code
	          };
	          t.push(c)
	        }
	        i(h.openCard, {
	          card_list: t
	        },
	        e)
	      },
	      consumeAndShareCard: function(e) {
	        i(h.consumeAndShareCard, {
	          consumedCardId: e.cardId,
	          consumedCode: e.code
	        },
	        e)
	      },
	      chooseWXPay: function(e) {
	        i(h.chooseWXPay, r(e), e)
	      },
	      openEnterpriseRedPacket: function(e) {
	        i(h.openEnterpriseRedPacket, r(e), e)
	      },
	      startSearchBeacons: function(e) {
	        i(h.startSearchBeacons, {
	          ticket: e.ticket
	        },
	        e)
	      },
	      stopSearchBeacons: function(e) {
	        i(h.stopSearchBeacons, {},
	        e)
	      },
	      onSearchBeacons: function(e) {
	        t(h.onSearchBeacons, e)
	      },
	      openEnterpriseChat: function(e) {
	        i("openEnterpriseChat", {
	          useridlist: e.userIds,
	          chatname: e.groupName
	        },
	        e)
	      },
	      launchMiniProgram: function(e) {
	        i("launchMiniProgram", {
	          targetAppId: e.targetAppId,
	          path: g(e.path),
	          envVersion: e.envVersion
	        },
	        e)
	      },
	      miniProgram: {
	        navigateBack: function(e) {
	          e = e || {},
	          f(function() {
	            i("invokeMiniProgramAPI", {
	              name: "navigateBack",
	              arg: {
	                delta: e.delta || 1
	              }
	            },
	            e)
	          })
	        },
	        navigateTo: function(e) {
	          f(function() {
	            i("invokeMiniProgramAPI", {
	              name: "navigateTo",
	              arg: {
	                url: e.url
	              }
	            },
	            e)
	          })
	        },
	        redirectTo: function(e) {
	          f(function() {
	            i("invokeMiniProgramAPI", {
	              name: "redirectTo",
	              arg: {
	                url: e.url
	              }
	            },
	            e)
	          })
	        },
	        switchTab: function(e) {
	          f(function() {
	            i("invokeMiniProgramAPI", {
	              name: "switchTab",
	              arg: {
	                url: e.url
	              }
	            },
	            e)
	          })
	        },
	        reLaunch: function(e) {
	          f(function() {
	            i("invokeMiniProgramAPI", {
	              name: "reLaunch",
	              arg: {
	                url: e.url
	              }
	            },
	            e)
	          })
	        },
	        postMessage: function(e) {
	          f(function() {
	            i("invokeMiniProgramAPI", {
	              name: "postMessage",
	              arg: e.data || {}
	            },
	            e)
	          })
	        },
	        getEnv: function(n) {
	          f(function() {
	            n({
	              miniprogram: "miniprogram" === e.__wxjs_environment
	            })
	          })
	        }
	      }
	    },
	    b = 1,
	    R = {};
	    return S.addEventListener("error",
	    function(e) {
	      if (!M) {
	        var n = e.target,
	        i = n.tagName,
	        t = n.src;
	        if (("IMG" == i || "VIDEO" == i || "AUDIO" == i || "SOURCE" == i) && -1 != t.indexOf("wxlocalresource://")) {
	          e.preventDefault(),
	          e.stopPropagation();
	          var o = n["wx-id"];
	          if (o || (o = b++, n["wx-id"] = o), R[o]) return;
	          R[o] = !0,
	          wx.ready(function() {
	            wx.getLocalImgData({
	              localId: t,
	              success: function(e) {
	                n.src = e.localData
	              }
	            })
	          })
	        }
	      }
	    },
	    !0),
	    S.addEventListener("load",
	    function(e) {
	      if (!M) {
	        var n = e.target,
	        i = n.tagName;
	        n.src;
	        if ("IMG" == i || "VIDEO" == i || "AUDIO" == i || "SOURCE" == i) {
	          var t = n["wx-id"];
	          t && (R[t] = !1)
	        }
	      }
	    },
	    !0),
	    n && (e.wx = e.jWeixin = N),
	    N
	  }
	});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    function $loadUrl(o) {
	        o.element = o.element || 'script';
	        var el = document.createElement(o.element);
	        el.charset = o.charset || 'utf-8';
	        o.onBeforeSend && o.onBeforeSend(el);
	        el.onload = el.onreadystatechange = function () {
	            if (/loaded|complete/i.test(this.readyState) || navigator.userAgent.toLowerCase().indexOf("msie") == -1) {
	                o.onload && o.onload();
	                clear();
	            }
	        };
	        el.onerror = function () {
	            clear();
	        };
	        el.src = o.url;
	        document.getElementsByTagName('head')[0].appendChild(el);
	
	        function clear() {
	            if (!el) {
	                return;
	            }
	            el.onload = el.onreadystatechange = el.onerror = null;
	            el.parentNode && el.parentNode.removeChild(el);
	            el = null;
	        }
	    }
	    exports.get = $loadUrl;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var $ = __webpack_require__(8);
	    var cookie = __webpack_require__(31);
	    var default_config = {
	        beforerequest: function beforerequest() {},
	        phoneid: '',
	        getcodeid: '',
	        codeid: '',
	        submitbtnid: '',
	        imglayerid: '',
	        imgid: '',
	        imgcodeid: '',
	        imgcodebtnid: '',
	        success: function success() {},
	        fail: function fail() {}
	    };
	
	    var detect_api_url = '/mlogin/is_login';
	    var get_verify_code_url = '/my/index/getverifycodeV2';
	    var getimageverifycode_url = '/my/index/getimageverifycode';
	    var login_api_url = '/mlogin/create_member_by_mobile';
	
	    var isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1;
	    var no_ui_login_requesting = false;
	
	    function start(incom_config) {
	        var config = $.extend(default_config, incom_config);
	        make_request(detect_api_url, {}, function (resp) {
	            if (!resp) {
	                config.fail({ errcode: 1, errmsg: 'ajax error!' });
	            }
	            if (resp.errcode != 0) {
	                login_api_url = resp.data.loginUrl;
	                if (isWx && resp.errcode == 539299862) {
	                    window.location = login_api_url + encodeURIComponent(window.location.href);
	                } else {
	                    config.beforerequest();
	                    var hasImgVerifyDom = false;
	                    if (config.imglayerid != '' && config.imgid != '' && config.imgcodeid != '' && config.imgcodebtnid != '') {
	                        hasImgVerifyDom = true;
	                    }
	                    bind_event(config, hasImgVerifyDom);
	                }
	            } else {
	                config.success(resp);
	            }
	        });
	    }
	
	    function bind_event(config, has_img_verify_logic) {
	        has_img_verify_logic = has_img_verify_logic || false;
	        var $phone_input = $('#' + config.phoneid);
	        var $get_code_btn = $('#' + config.getcodeid);
	        var $code_input = $('#' + config.codeid);
	        var $submit_btn = $('#' + config.submitbtnid);
	
	        if (has_img_verify_logic) {
	            var $img_layer = $('#' + config.imglayerid);
	            var $img_pic = $('#' + config.imgid);
	            var $img_code_input = $('#' + config.imgcodeid);
	            var $img_code_btn = $('#' + config.imgcodebtnid);
	            $img_layer.addClass('hide').hide();
	            $img_code_input.val('');
	        }
	
	        $get_code_btn.off('click.no_ui_login').on('click.no_ui_login', function (e) {
	            if ($get_code_btn.attr('data-disable')) {
	                return;
	            }
	            var phone_no = $.trim($phone_input.val());
	            if (!is_phone_no(phone_no)) {
	                alert('请输入正确的手机号');
	                return;
	            }
	
	            $get_code_btn.addClass('disable').attr('data-disable', 1);
	
	            var total = 60;
	            var timer = null;
	            timer = setInterval(function () {
	                if (total <= 1) {
	                    clearInterval(timer);
	                    $get_code_btn.removeClass('disable').removeAttr('data-disable').html('获取验证码');
	                } else {
	                    total--;
	                    $get_code_btn.html(total + 's后再试');
	                }
	            }, 1000);
	
	            make_request(get_verify_code_url, {
	                mobile: phone_no,
	                sceneid: isWx ? 2 : 1
	            }, function (resp) {
	                if (resp.errCode == 539365412) {
	                    if (has_img_verify_logic) {
	                        $img_pic.attr("src", getimageverifycode_url + "?mobile=" + phone_no + "&t= " + Math.random());
	                        $img_layer.removeClass('hide').show();
	                    }
	                } else if (resp.errCode == 539365411) {
	                    if (has_img_verify_logic) {
	                        alert('图片验证码错误');
	                        $img_pic.attr("src", getimageverifycode_url + "?mobile=" + phone_no + "&t= " + Math.random());
	                        $img_layer.removeClass('hide').show();
	                    }
	                }
	            });
	        });
	        if (has_img_verify_logic) {
	            $img_pic.off('click.no_ui_login').on('click.no_ui_login', function (e) {
	                var phone_no = $.trim($phone_input.val());
	                if (!is_phone_no(phone_no)) {
	                    alert('请输入正确的手机号');
	                    $img_layer.addClass('hide').hide();
	                    return;
	                }
	                $img_pic.attr("src", getimageverifycode_url + "?mobile=" + phone_no + "&t= " + Math.random());
	            });
	
	            $img_code_btn.off('click.no_ui_login').on('click.no_ui_login', function (e) {
	                var phone_no = $.trim($phone_input.val());
	                if (!is_phone_no(phone_no)) {
	                    alert('请输入正确的手机号');
	                    $img_layer.addClass('hide').hide();
	                    return;
	                }
	                var img_verify_code = $.trim($img_code_input.val());
	                if (img_verify_code == '') {
	                    alert('请输入图片验证码');
	                    return;
	                }
	
	                $img_layer.addClass('hide').hide();
	
	                make_request(get_verify_code_url, {
	                    mobile: phone_no,
	                    strImageVerifyCode: img_verify_code,
	                    sceneid: isWx ? 2 : 1
	                }, function (resp) {
	                    if (resp.errCode == 539365412) {
	                        if (has_img_verify_logic) {
	                            $img_pic.attr("src", getimageverifycode_url + "?mobile=" + phone_no + "&t= " + Math.random());
	                            $img_layer.removeClass('hide').show();
	                        }
	                    } else if (resp.errCode == 539365411) {
	                        if (has_img_verify_logic) {
	                            alert('图片验证码错误');
	                            $img_pic.attr("src", getimageverifycode_url + "?mobile=" + phone_no + "&t= " + Math.random());
	                            $img_layer.removeClass('hide').show();
	                            $img_code_input.val('');
	                        }
	                    }
	                });
	            });
	        }
	
	        $submit_btn.off('click.no_ui_login').on('click.no_ui_login', function (e) {
	            var phone_no = $.trim($phone_input.val());
	            if (!is_phone_no(phone_no)) {
	                alert('请输入正确的手机号');
	                return;
	            }
	
	            var verify_code = $.trim($code_input.val());
	            if (verify_code == '') {
	                alert('请输入验证码');
	                return;
	            }
	            if (no_ui_login_requesting) {
	                return;
	            }
	
	            no_ui_login_requesting = true;
	            make_request(login_api_url, {
	                mobile: phone_no,
	                verifycode: verify_code,
	                reqtype: 1
	            }, function (resp) {
	                if (resp.errcode != 0) {
	                    if (resp.errmsg) {
	                        alert(resp.errmsg);
	                    }
	                } else {
	                    if (resp.data && resp.data.uid) {
	                        var domain = '.' + location.host.split('.').slice(-2).join('.');
	                        cookie.setC('uid', resp.data.uid, 30 * 24 * 60, '/', domain);
	                        cookie.setC('sukey', resp.data.sukey, 30 * 24 * 60, '/', domain);
	                    }
	                    config.success(resp);
	                }
	            }, function () {
	                config.fail();
	            }, function () {
	                no_ui_login_requesting = false;
	            });
	        });
	    }
	
	    function is_phone_no(phone) {
	        if (/^1\d{10}$/.test(phone)) {
	            return true;
	        }
	        return false;
	    }
	
	    function make_request(url, data, success_cb, error_cb, complete_cb) {
	        data = data || {};
	        success_cb = success_cb || function () {};
	        error_cb = error_cb || function () {};
	        complete_cb = complete_cb || function () {};
	
	        $.ajax({
	            type: 'GET',
	            url: url,
	            data: data,
	            dataType: 'json',
	            timeout: 10000,
	            cache: false,
	            xhrFields: {
	                withCredentials: true
	            },
	            beforeSend: function beforeSend(xhr) {
	                xhr.withCredentials = true;
	            },
	            success: function success(response) {
	                success_cb(response);
	            },
	            error: function error(a, b, c) {
	                error_cb(a, b, c);
	            },
	            complete: function complete(xhr, status) {
	                complete_cb();
	            }
	        });
	    }
	    exports.init = function () {
	        return {
	            start: start
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var $ = __webpack_require__(8);
	    var login = __webpack_require__(48).init();
	    var loadCss = __webpack_require__(32);
	    var rnd = new Date().getTime().toString();
	    var cover_id = 'common_login_cover_' + rnd;
	    var phoneid = 'common_login_phone_' + rnd;
	    var getcodeid = 'common_login_get_code_' + rnd;
	    var codeid = 'common_login_code_' + rnd;
	    var submitbtnid = 'common_login_btn_' + rnd;
	    var imglayerid = 'common_login_img_layer_' + rnd;
	    var imgid = 'common_login_img_' + rnd;
	    var imgcodeid = 'common_login_img_input_' + rnd;
	    var imgcodebtnid = 'common_login_img_btn_' + rnd;
	
	    function start_login(success_cb, fail_cb) {
	        var params = {
	            beforerequest: function beforerequest() {
	                $('#' + cover_id).show();
	                $('#' + codeid + ',#' + imgcodeid).val('');
	                window.pop_login_need_reg = true;
	            },
	            phoneid: phoneid,
	            getcodeid: getcodeid,
	            codeid: codeid,
	            submitbtnid: submitbtnid,
	            imglayerid: imglayerid,
	            imgid: imgid,
	            imgcodeid: imgcodeid,
	            imgcodebtnid: imgcodebtnid,
	            success: function success() {
	                $('#' + cover_id + ',#' + imglayerid).hide();
	                $('#' + imgid).attr('src', '');
	
	                if (typeof success_cb == "function") {
	                    var re_login = typeof window.pop_login_need_reg != 'undefined';
	                    success_cb(re_login);
	                }
	            },
	            fail: function fail() {
	                $('#' + cover_id + ',#' + imglayerid).hide();
	                $('#' + imgid).attr('src', '');
	
	                if (typeof fail_cb == "function") {
	                    var re_login = typeof window.pop_login_need_reg != 'undefined';
	                    fail_cb(re_login);
	                }
	            }
	        };
	
	        login.start(params);
	    }
	
	    function init_fn() {
	        if ($('#' + cover_id).length > 0) {
	            return;
	        }
	
	        var str_template = '<div class="common_login_cover" id="common_login_cover_' + rnd + '">\n           <div class="common_login_cover_inner">\n              <div class="js-close-layer close-layer">\n                  <div class="js-close-layer-inner close-layer-inner"></div>\n               </div>\n                <div class="common_login_img_layer" id="common_login_img_layer_' + rnd + '" >\n                    <div class="common_login_row">\n                        <img id="common_login_img_' + rnd + '" src="//img.mdcdn.cn/h5/img/placeholder_10040.png" alt="">\n                    </div>\n                    <div class="common_login_row">\n                        <input class="common_login_img_input" id="common_login_img_input_' + rnd + '" type="text" placeholder="\u56FE\u7247\u9A8C\u8BC1\u7801" >\n                        <div class="common_login_img_btn" id="common_login_img_btn_' + rnd + '" >\u786E \u5B9A</div>\n                    </div>\n                </div>\n                <div class="common_login_row">\n                    <input class="common_login_phone" id="common_login_phone_' + rnd + '" type="text" placeholder="\u8BF7\u8F93\u5165\u624B\u673A\u53F7" >\n                </div>\n                <div class="common_login_row">\n                    <input class="common_login_code" id="common_login_code_' + rnd + '" type="text" placeholder="\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801" >\n                    <div class="common_login_get_code" id="common_login_get_code_' + rnd + '">\u83B7\u53D6\u9A8C\u8BC1\u7801</div>\n                </div>\n                <div class="common_login_btn_out">\n                    <div class="common_login_btn" id="common_login_btn_' + rnd + '">\u786E \u5B9A</div>\n                </div>\n            </div>\n        </div>';
	
	        $('body').append(str_template);
	        $('#' + cover_id + ' .js-close-layer').click(function () {
	            $('#' + cover_id).hide();
	        });
	    }
	
	    exports.init = function () {
	        loadCss.loadCss('https://g.mdcdn.cn/h5/css/act/internal/common_login.css?t=201605123');
	        init_fn();
	        return {
	            start: start_login
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var $ = __webpack_require__(8);
	    var cookie = __webpack_require__(31);
	    var default_config = {
	        beforerequest: function beforerequest() {},
	        phoneid: '',
	        getcodeid: '',
	        codeid: '',
	        submitbtnid: '',
	        imglayerid: '',
	        imgid: '',
	        imgcodeid: '',
	        imgcodebtnid: '',
	        success: function success() {},
	        fail: function fail() {}
	    };
	
	    var detect_api_url = '/mlogin/is_login';
	    var get_verify_code_url = '/my/index/getverifycodeV2';
	    var getimageverifycode_url = '/my/index/getimageverifycode';
	    var login_api_url = '/mlogin/create_member_by_mobile';
	
	    var isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1;
	    var no_ui_login_requesting = false;
	
	    function start(incom_config) {
	        var config = $.extend(default_config, incom_config);
	        make_request(detect_api_url, {}, function (resp) {
	            if (!resp) {
	                config.fail({ errcode: 1, errmsg: 'ajax error!' });
	            }
	            if (resp.errcode != 0) {
	                if (window.location.search.indexOf('appview=1') > -1) {
	                    console.log('JS call native Login');
	                    try {
	                        if (md && md.bridge) {
	                            console.log(2);
	                            var cmdEntity = md.bridge.cmdEntityFactory.createDisplayLoginViewCmdEntity(null, function (response) {
	                                console.log('response: ', response);
	                                log('response: ', response);
	                            });
	                            console.log(cmdEntity);
	                            md.bridge.bridgeAPI.sendCmd(cmdEntity);
	                            return;
	                        }
	                    } catch (err) {
	                        console.error(err);
	                    }
	                }
	                login_api_url = resp.data.loginUrl;
	                if (isWx && resp.errcode == 539299862) {
	                    window.location = login_api_url + encodeURIComponent(window.location.href);
	                } else {
	                    config.beforerequest();
	                    var hasImgVerifyDom = false;
	                    if (config.imglayerid != '' && config.imgid != '' && config.imgcodeid != '' && config.imgcodebtnid != '') {
	                        hasImgVerifyDom = true;
	                    }
	                    bind_event(config, hasImgVerifyDom);
	                }
	            } else {
	                config.success(resp);
	            }
	        });
	    }
	
	    function bind_event(config, has_img_verify_logic) {
	        has_img_verify_logic = has_img_verify_logic || false;
	        var $phone_input = $('#' + config.phoneid);
	        var $get_code_btn = $('#' + config.getcodeid);
	        var $code_input = $('#' + config.codeid);
	        var $submit_btn = $('#' + config.submitbtnid);
	
	        if (has_img_verify_logic) {
	            var $img_layer = $('#' + config.imglayerid);
	            var $img_pic = $('#' + config.imgid);
	            var $img_code_input = $('#' + config.imgcodeid);
	            var $img_code_btn = $('#' + config.imgcodebtnid);
	            $img_layer.addClass('hide').hide();
	            $img_code_input.val('');
	        }
	
	        $get_code_btn.off('click.no_ui_login').on('click.no_ui_login', function (e) {
	            if ($get_code_btn.attr('data-disable')) {
	                return;
	            }
	            var phone_no = $.trim($phone_input.val());
	            if (!is_phone_no(phone_no)) {
	                alert('请输入正确的手机号');
	                return;
	            }
	
	            $get_code_btn.addClass('disable').attr('data-disable', 1);
	            var total = 60;
	            var timer = null;
	            timer = setInterval(function () {
	                if (total <= 1) {
	                    clearInterval(timer);
	                    $get_code_btn.removeClass('disable').removeAttr('data-disable').html('获取验证码');
	                } else {
	                    total--;
	                    $get_code_btn.html(total + 's后再试');
	                }
	            }, 1000);
	
	
	            make_request(get_verify_code_url, {
	                mobile: phone_no,
	                sceneid: isWx ? 2 : 1
	            }, function (resp) {
	                if (resp.errCode == 539365412) {
	                    if (has_img_verify_logic) {
	                        $img_pic.attr("src", getimageverifycode_url + "?mobile=" + phone_no + "&t= " + Math.random());
	                        $img_layer.removeClass('hide').show();
	                    }
	                } else if (resp.errCode == 539365411) {
	                    if (has_img_verify_logic) {
	                        alert('图片验证码错误');
	                        $img_pic.attr("src", getimageverifycode_url + "?mobile=" + phone_no + "&t= " + Math.random());
	                        $img_layer.removeClass('hide').show();
	                    }
	                }
	            });
	        });
	        if (has_img_verify_logic) {
	            $img_pic.off('click.no_ui_login').on('click.no_ui_login', function (e) {
	                var phone_no = $.trim($phone_input.val());
	                if (!is_phone_no(phone_no)) {
	                    alert('请输入正确的手机号');
	                    $img_layer.addClass('hide').hide();
	                    return;
	                }
	                $img_pic.attr("src", getimageverifycode_url + "?mobile=" + phone_no + "&t= " + Math.random());
	            });
	
	            $img_code_btn.off('click.no_ui_login').on('click.no_ui_login', function (e) {
	                var phone_no = $.trim($phone_input.val());
	                if (!is_phone_no(phone_no)) {
	                    alert('请输入正确的手机号');
	                    $img_layer.addClass('hide').hide();
	                    return;
	                }
	                var img_verify_code = $.trim($img_code_input.val());
	                if (img_verify_code == '') {
	                    alert('请输入图片验证码');
	                    return;
	                }
	
	                $img_layer.addClass('hide').hide();
	
	                make_request(get_verify_code_url, {
	                    mobile: phone_no,
	                    strImageVerifyCode: img_verify_code,
	                    sceneid: isWx ? 2 : 1
	                }, function (resp) {
	                    if (resp.errCode == 539365412) {
	                        if (has_img_verify_logic) {
	                            $img_pic.attr("src", getimageverifycode_url + "?mobile=" + phone_no + "&t= " + Math.random());
	                            $img_layer.removeClass('hide').show();
	                        }
	                    } else if (resp.errCode == 539365411) {
	                        if (has_img_verify_logic) {
	                            alert('图片验证码错误');
	                            $img_pic.attr("src", getimageverifycode_url + "?mobile=" + phone_no + "&t= " + Math.random());
	                            $img_layer.removeClass('hide').show();
	                            $img_code_input.val('');
	                        }
	                    }
	                });
	            });
	        }
	
	        $submit_btn.off('click.no_ui_login').on('click.no_ui_login', function (e) {
	            var phone_no = $.trim($phone_input.val());
	            if (!is_phone_no(phone_no)) {
	                alert('请输入正确的手机号');
	                return;
	            }
	
	            var verify_code = $.trim($code_input.val());
	            if (verify_code == '') {
	                alert('请输入验证码');
	                return;
	            }
	            if (no_ui_login_requesting) {
	                return;
	            }
	
	            no_ui_login_requesting = true;
	            make_request(login_api_url, {
	                mobile: phone_no,
	                verifycode: verify_code,
	                reqtype: 1
	            }, function (resp) {
	                if (resp.errcode != 0) {
	                    if (resp.errmsg) {
	                        alert(resp.errmsg);
	                    }
	                } else {
	                    if (resp.data && resp.data.uid) {
	                        var domain = '.' + location.host.split('.').slice(-2).join('.');
	                        cookie.setC('uid', resp.data.uid, 30 * 24 * 60, '/', domain);
	                        cookie.setC('sukey', resp.data.sukey, 30 * 24 * 60, '/', domain);
	                    }
	
	                    window.report_ocpm && typeof window.report_ocpm == 'function' && window.report_ocpm();
	
	                    config.success(resp);
	                }
	            }, function () {
	                config.fail();
	            }, function () {
	                no_ui_login_requesting = false;
	            });
	        });
	    }
	
	    function is_phone_no(phone) {
	        if (/^1\d{10}$/.test(phone)) {
	            return true;
	        }
	        return false;
	    }
	
	    function make_request(url, data, success_cb, error_cb, complete_cb) {
	        data = data || {};
	        success_cb = success_cb || function () {};
	        error_cb = error_cb || function () {};
	        complete_cb = complete_cb || function () {};
	
	        $.ajax({
	            type: 'GET',
	            url: url,
	            data: data,
	            dataType: 'json',
	            timeout: 10000,
	            cache: false,
	            xhrFields: {
	                withCredentials: true
	            },
	            beforeSend: function beforeSend(xhr) {
	                xhr.withCredentials = true;
	            },
	            success: function success(response) {
	                success_cb(response);
	            },
	            error: function error(a, b, c) {
	                error_cb(a, b, c);
	            },
	            complete: function complete(xhr, status) {
	                complete_cb();
	            }
	        });
	    }
	    exports.init = function () {
	        return {
	            start: start
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(60);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function defineMustache(global, factory) {
	  if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object" && exports && typeof exports.nodeName !== "string") {
	    factory(exports);
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    global.Mustache = {};
	    factory(global.Mustache);
	  }
	})(undefined, function mustacheFactory(mustache) {
	  var objectToString = Object.prototype.toString;
	  var isArray = Array.isArray || function isArrayPolyfill(object) {
	    return objectToString.call(object) === "[object Array]";
	  };
	
	  function isFunction(object) {
	    return typeof object === "function";
	  }
	
	  function typeStr(obj) {
	    return isArray(obj) ? "array" : typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj);
	  }
	
	  function escapeRegExp(string) {
	    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
	  }
	
	  function hasProperty(obj, propName) {
	    return obj != null && (typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj)) === "object" && propName in obj;
	  }
	
	  var regExpTest = RegExp.prototype.test;
	
	  function testRegExp(re, string) {
	    return regExpTest.call(re, string);
	  }
	
	  var nonSpaceRe = /\S/;
	
	  function isWhitespace(string) {
	    return !testRegExp(nonSpaceRe, string);
	  }
	
	  var entityMap = {
	    "&": "&amp;",
	    "<": "&lt;",
	    ">": "&gt;",
	    '"': "&quot;",
	    "'": "&#39;",
	    "/": "&#x2F;",
	    "`": "&#x60;",
	    "=": "&#x3D;"
	  };
	
	  function escapeHtml(string) {
	    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
	      return entityMap[s];
	    });
	  }
	
	  var whiteRe = /\s*/;
	  var spaceRe = /\s+/;
	  var equalsRe = /\s*=/;
	  var curlyRe = /\s*\}/;
	  var tagRe = /#|\^|\/|>|\{|&|=|!/;
	
	  function parseTemplate(template, tags) {
	    if (!template) return [];
	    var sections = [];
	    var tokens = [];
	    var spaces = [];
	    var hasTag = false;
	    var nonSpace = false;
	
	    function stripSpace() {
	      if (hasTag && !nonSpace) {
	        while (spaces.length) {
	          delete tokens[spaces.pop()];
	        }
	      } else {
	        spaces = [];
	      }
	      hasTag = false;
	      nonSpace = false;
	    }
	
	    var openingTagRe, closingTagRe, closingCurlyRe;
	
	    function compileTags(tagsToCompile) {
	      if (typeof tagsToCompile === "string") tagsToCompile = tagsToCompile.split(spaceRe, 2);
	      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error("Invalid tags: " + tagsToCompile);
	      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
	      closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
	      closingCurlyRe = new RegExp("\\s*" + escapeRegExp("}" + tagsToCompile[1]));
	    }
	
	    compileTags(tags || mustache.tags);
	    var scanner = new Scanner(template);
	    var start, type, value, chr, token, openSection;
	    while (!scanner.eos()) {
	      start = scanner.pos;
	      value = scanner.scanUntil(openingTagRe);
	      if (value) {
	        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
	          chr = value.charAt(i);
	          if (isWhitespace(chr)) {
	            spaces.push(tokens.length);
	          } else {
	            nonSpace = true;
	          }
	          tokens.push(["text", chr, start, start + 1]);
	          start += 1;
	          if (chr === "\n") stripSpace();
	        }
	      }
	      if (!scanner.scan(openingTagRe)) break;
	      hasTag = true;
	      type = scanner.scan(tagRe) || "name";
	      scanner.scan(whiteRe);
	      if (type === "=") {
	        value = scanner.scanUntil(equalsRe);
	        scanner.scan(equalsRe);
	        scanner.scanUntil(closingTagRe);
	      } else if (type === "{") {
	        value = scanner.scanUntil(closingCurlyRe);
	        scanner.scan(curlyRe);
	        scanner.scanUntil(closingTagRe);
	        type = "&";
	      } else {
	        value = scanner.scanUntil(closingTagRe);
	      }
	      if (!scanner.scan(closingTagRe)) throw new Error("Unclosed tag at " + scanner.pos);
	      token = [type, value, start, scanner.pos];
	      tokens.push(token);
	      if (type === "#" || type === "^") {
	        sections.push(token);
	      } else if (type === "/") {
	        openSection = sections.pop();
	        if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
	        if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
	      } else if (type === "name" || type === "{" || type === "&") {
	        nonSpace = true;
	      } else if (type === "=") {
	        compileTags(value);
	      }
	    }
	    openSection = sections.pop();
	    if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
	    return nestTokens(squashTokens(tokens));
	  }
	
	  function squashTokens(tokens) {
	    var squashedTokens = [];
	    var token, lastToken;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      token = tokens[i];
	      if (token) {
	        if (token[0] === "text" && lastToken && lastToken[0] === "text") {
	          lastToken[1] += token[1];
	          lastToken[3] = token[3];
	        } else {
	          squashedTokens.push(token);
	          lastToken = token;
	        }
	      }
	    }
	    return squashedTokens;
	  }
	
	  function nestTokens(tokens) {
	    var nestedTokens = [];
	    var collector = nestedTokens;
	    var sections = [];
	    var token, section;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      token = tokens[i];
	      switch (token[0]) {
	        case "#":
	        case "^":
	          collector.push(token);
	          sections.push(token);
	          collector = token[4] = [];
	          break;
	        case "/":
	          section = sections.pop();
	          section[5] = token[2];
	          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
	          break;
	        default:
	          collector.push(token);
	      }
	    }
	    return nestedTokens;
	  }
	
	  function Scanner(string) {
	    this.string = string;
	    this.tail = string;
	    this.pos = 0;
	  }
	
	  Scanner.prototype.eos = function eos() {
	    return this.tail === "";
	  };
	  Scanner.prototype.scan = function scan(re) {
	    var match = this.tail.match(re);
	    if (!match || match.index !== 0) return "";
	    var string = match[0];
	    this.tail = this.tail.substring(string.length);
	    this.pos += string.length;
	    return string;
	  };
	  Scanner.prototype.scanUntil = function scanUntil(re) {
	    var index = this.tail.search(re),
	        match;
	    switch (index) {
	      case -1:
	        match = this.tail;
	        this.tail = "";
	        break;
	      case 0:
	        match = "";
	        break;
	      default:
	        match = this.tail.substring(0, index);
	        this.tail = this.tail.substring(index);
	    }
	    this.pos += match.length;
	    return match;
	  };
	  function Context(view, parentContext) {
	    this.view = view;
	    this.cache = { ".": this.view };
	    this.parent = parentContext;
	  }
	
	  Context.prototype.push = function push(view) {
	    return new Context(view, this);
	  };
	  Context.prototype.lookup = function lookup(name) {
	    var cache = this.cache;
	    var value;
	    if (cache.hasOwnProperty(name)) {
	      value = cache[name];
	    } else {
	      var context = this,
	          names,
	          index,
	          lookupHit = false;
	      while (context) {
	        if (name.indexOf(".") > 0) {
	          value = context.view;
	          names = name.split(".");
	          index = 0;
	          while (value != null && index < names.length) {
	            if (index === names.length - 1) lookupHit = hasProperty(value, names[index]);
	            value = value[names[index++]];
	          }
	        } else {
	          value = context.view[name];
	          lookupHit = hasProperty(context.view, name);
	        }
	        if (lookupHit) break;
	        context = context.parent;
	      }
	      cache[name] = value;
	    }
	    if (isFunction(value)) value = value.call(this.view);
	    return value;
	  };
	  function Writer() {
	    this.cache = {};
	  }
	
	  Writer.prototype.clearCache = function clearCache() {
	    this.cache = {};
	  };
	  Writer.prototype.parse = function parse(template, tags) {
	    var cache = this.cache;
	    var tokens = cache[template];
	    if (tokens == null) tokens = cache[template] = parseTemplate(template, tags);
	    return tokens;
	  };
	  Writer.prototype.render = function render(template, view, partials) {
	    var tokens = this.parse(template);
	    var context = view instanceof Context ? view : new Context(view);
	    return this.renderTokens(tokens, context, partials, template);
	  };
	  Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate) {
	    var buffer = "";
	    var token, symbol, value;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      value = undefined;
	      token = tokens[i];
	      symbol = token[0];
	      if (symbol === "#") value = this.renderSection(token, context, partials, originalTemplate);else if (symbol === "^") value = this.renderInverted(token, context, partials, originalTemplate);else if (symbol === ">") value = this.renderPartial(token, context, partials, originalTemplate);else if (symbol === "&") value = this.unescapedValue(token, context);else if (symbol === "name") value = this.escapedValue(token, context);else if (symbol === "text") value = this.rawValue(token);
	      if (value !== undefined) buffer += value;
	    }
	    return buffer;
	  };
	  Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate) {
	    var self = this;
	    var buffer = "";
	    var value = context.lookup(token[1]);
	
	    function subRender(template) {
	      return self.render(template, context, partials);
	    }
	
	    if (!value) return;
	    if (isArray(value)) {
	      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
	        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
	      }
	    } else if ((typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === "object" || typeof value === "string" || typeof value === "number") {
	      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
	    } else if (isFunction(value)) {
	      if (typeof originalTemplate !== "string") throw new Error("Cannot use higher-order sections without the original template");
	      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
	      if (value != null) buffer += value;
	    } else {
	      buffer += this.renderTokens(token[4], context, partials, originalTemplate);
	    }
	    return buffer;
	  };
	  Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate) {
	    var value = context.lookup(token[1]);
	    if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate);
	  };
	  Writer.prototype.renderPartial = function renderPartial(token, context, partials) {
	    if (!partials) return;
	    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
	    if (value != null) return this.renderTokens(this.parse(value), context, partials, value);
	  };
	  Writer.prototype.unescapedValue = function unescapedValue(token, context) {
	    var value = context.lookup(token[1]);
	    if (value != null) return value;
	  };
	  Writer.prototype.escapedValue = function escapedValue(token, context) {
	    var value = context.lookup(token[1]);
	    if (value != null) return mustache.escape(value);
	  };
	  Writer.prototype.rawValue = function rawValue(token) {
	    return token[1];
	  };
	  mustache.name = "mustache.js";
	  mustache.version = "2.2.1";
	  mustache.tags = ["{{", "}}"];
	  var defaultWriter = new Writer();
	  mustache.clearCache = function clearCache() {
	    return defaultWriter.clearCache();
	  };
	  mustache.parse = function parse(template, tags) {
	    return defaultWriter.parse(template, tags);
	  };
	  mustache.render = function render(template, view, partials) {
	    if (typeof template !== "string") {
	      throw new TypeError('Invalid template! Template should be a "string" ' + 'but "' + typeStr(template) + '" was given as the first ' + "argument for mustache#render(template, view, partials)");
	    }
	    return defaultWriter.render(template, view, partials);
	  };
	  mustache.to_html = function to_html(template, view, partials, send) {
	    var result = mustache.render(template, view, partials);
	    if (isFunction(send)) {
	      send(result);
	    } else {
	      return result;
	    }
	  };
	  mustache.escape = escapeHtml;
	  mustache.Scanner = Scanner;
	  mustache.Context = Context;
	  mustache.Writer = Writer;
	});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var mLoadUrl = __webpack_require__(47);
	
	    exports.rd = function (opt) {
	        var oParams = {
	            curl: location.href,
	            rurl: document.referrer,
	            serviceid: 10,
	            mtag: '',
	
	            skuid: '',
	
	            shopid: '',
	
	            command: '',
	
	            dealid: '',
	            callback: 'rdcb'
	        },
	            arrParams = [];
	
	        for (var key in oParams) {
	            var v = opt[key];
	            if (v) {
	                oParams[key] = v;
	            }
	
	            arrParams.push(key + '=' + encodeURIComponent(oParams[key]));
	        }
	
	        mLoadUrl.get({
	            url: 'https://m.midea.cn/common/log/rd?' + arrParams.join('&')
	        });
	    };
	
	    exports.itil = function (opt) {
	        var oParams = {
	            id: '',
	
	            state: 1,
	            callback: 'itilcb'
	        },
	            arrParams = [];
	
	        for (var key in oParams) {
	            var v = opt[key];
	            if (v) {
	                oParams[key] = v;
	            }
	
	            arrParams.push(key + '=' + encodeURIComponent(oParams[key]));
	        }
	
	        mLoadUrl.get({
	            url: 'https://m.midea.cn/common/log/itil?' + arrParams.join('&')
	        });
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	var func = __webpack_require__(10);
	var wx = __webpack_require__(46);
	var IsWxMiniProgram = false;
	var miniapp = func.getUrlParam('miniapp');
	window.miniapp = miniapp;
	var portalPathList = __webpack_require__(54);
	
	var link = {
	      bindEvent: function bindEvent() {
	            $('.js-widget-link,.widget_link').on('click', function () {
	                  var $link = $(this).find('.link_a');
	                  var isCart = $link.hasClass('js_widget_cart');
	                  var href = $link.attr('href');
	
	                  var itemid = func.getUrlParam('itemid');
	                  itemid = itemid ? itemid : func.getUrlParam('itemid', href);
	                  var urlSplits = href.split('?');
	                  var hostPath = urlSplits[0] ? urlSplits[0] : '';
	                  var hashStr = decodeURIComponent(urlSplits && urlSplits[1] ? urlSplits[1] : '');
	
	                  var appid = $link.attr('data-appid');
	                  var navigateUrl = '';
	
	                  if (portalPathList.indexOf(hostPath) >= 0) {
	                        navigateUrl = hostPath + '?' + hashStr;
	                        wx.miniProgram.navigateTo({
	                              url: navigateUrl
	                        });
	                        return false;
	                  } else if (href.indexOf('/page/index/index') > -1) {
	
	                              navigateUrl = '/page/index/index';
	                        } else if (href.indexOf('/pages/act/sign/sign') > -1) {
	
	                              navigateUrl = '/pages/act/sign/sign?' + hashStr;
	                        } else if (href.indexOf('/pages/act/score/exchange_detail/exchange_detail') > -1) {
	
	                              navigateUrl = '/pages/act/score/exchange_detail/exchange_detail?' + hashStr;
	                        } else if (href.indexOf('subpackage/page/user/coupon/coupon') > -1) {
	
	                              navigateUrl = '/subpackage/page/user/coupon/coupon';
	                        } else if (href.indexOf('/subpackage/page/user/pro/detail/detail') > -1) {
	
	                              navigateUrl = '/subpackage/page/user/pro/detail/detail';
	                        } else if (href.indexOf('/detail/index/sale') > -1) {
	
	                              navigateUrl = '/page/detail/detail?type=sale&itemid=' + itemid;
	                        } else if (href.indexOf('/detail/index/package_list') > -1) {
	
	                              navigateUrl = '/page/package_list/package_list?' + hashStr;
	                        } else if (href.indexOf('/detail/index/miao') > -1) {
	
	                              navigateUrl = '/page/detail/detail?type=miao&itemid=' + itemid;
	                        } else if (href.indexOf('search') > -1) {
	
	                              navigateUrl = '/page/search/search_sku/search_sku?' + hashStr;
	                        } else if (href.indexOf('category') > -1) {
	
	                              navigateUrl = '/page/search/categoryIndex/category?' + hashStr;
	                        } else if (href.indexOf('/detail/index') > -1) {
	                              console.log(itemid);
	                              console.log('普通商详');
	
	                              navigateUrl = '/page/detail/detail?itemid=' + itemid;
	                        } else if (/\/[0-9]{22}\.html/.test(href)) {
	
	                              var _itemid = /[0-9]{22}\.html/.exec(href)[0].replace('.html', '');
	                              console.log('普通商详');
	                              console.log(_itemid);
	                              navigateUrl = '/page/detail/detail?itemid=' + _itemid;
	                        } else if (href.indexOf('/next/tuan/active2') > -1) {
	
	                              var id = func.getUrlParam('id', href);
	
	                              navigateUrl = '/activity/page/tuan/detail/detail?saler_activeid=' + id;
	                        } else if (href.indexOf('confirmorder') > -1) {
	
	                              console.log('确认订单页');
	                              console.log(hashStr);
	                              navigateUrl = '/page/detail/detail?itemid=' + hashStr;
	                        } else if (href.indexOf('/promote/promote') > -1) {
	                              var _id = func.getUrlParam('id', href);
	                              console.log('其他卖场页');
	
	                              navigateUrl = '/page/web_view_promote/web_view_promote?id=' + _id;
	                        } else if (href.indexOf('/cart?') > -1) {
	                              console.log(itemid);
	                              console.log('购物车');
	
	                              navigateUrl = '/page/cart/cart?itemid=' + itemid;
	                        } else if (isCart) {
	                              return false;
	                        } else {
	                              window.location.href = href;
	                              return false;
	                        }
	                  if (miniapp == 'portal') {
	                        wx.miniProgram.navigateTo({
	                              url: '/pages/web_view_promote/web_view_promote?mpappid=wx255b67a1403adbc2' + '&mppath=' + encodeURIComponent(navigateUrl)
	                        });
	                        return false;
	                  } else {
	                        if (appid) {
	                              wx.miniProgram.navigateTo({
	                                    url: '/page/web_view_promote/web_view_promote?mpappid=' + appid + '&mppath=' + encodeURIComponent(navigateUrl)
	                              });
	                              return false;
	                        }if (href.indexOf('/cart?') > -1) {
	                              wx.miniProgram.switchTab({
	                                    url: navigateUrl
	                              });
	                              return false;
	                        }
	                        wx.miniProgram.navigateTo({
	                              url: navigateUrl
	                        });
	                        return false;
	                  }
	            });
	      },
	      init: function init() {
	            this.bindEvent();
	      }
	};
	
	var widgets4Link = {
	      bindEvent: function bindEvent() {
	            $('.widget-pool-goodslist,.js-pool-miao-v2,.js-pool-presell,.widget_img_link').on('click', 'a', function () {
	                  var $link = $(this);
	                  var href = $link.attr('href');
	
	                  var itemid = func.getUrlParam('itemid');
	                  var urlSplits = href.split('?');
	                  var hashStr = urlSplits && urlSplits[1] ? urlSplits[1] : '';
	                  var appid = $link.attr('data-appid');
	                  var navigateUrl = '';
	                  if (href.indexOf('/detail/index/sale') > -1) {
	
	                        navigateUrl = '/page/detail/detail?type=sale&' + hashStr;
	                  } else if (href.indexOf('/detail/index/miao') > -1) {
	
	                        navigateUrl = '/page/detail/detail?type=miao&' + hashStr;
	                  } else if (href.indexOf('/detail/index') > -1) {
	                        console.log(itemid);
	                        console.log('普通商详');
	
	                        navigateUrl = '/page/detail/detail?' + hashStr;
	                  } else {
	                        window.location.href = href;
	                        return false;
	                  }
	                  if (miniapp == 'portal') {
	                        wx.miniProgram.navigateTo({
	                              url: '/pages/web_view_promote/web_view_promote?mpappid=wx255b67a1403adbc2' + '&mppath=' + encodeURIComponent(navigateUrl)
	                        });
	                  } else {
	                        wx.miniProgram.navigateTo({
	                              url: navigateUrl
	                        });
	                        return false;
	                  }
	            });
	      },
	      init: function init() {
	            this.bindEvent();
	      }
	};
	
	var mimiProgram = {
	      bindTipBtnEvent: function bindTipBtnEvent() {
	            $('.tip_btn').on('click', function () {
	                  var $link = $(this);
	                  var href = $link.attr('href');
	
	                  var urlSplits = href.split('?');
	                  var hashStr = urlSplits && urlSplits[1] ? urlSplits[1] : '';
	                  if (href.indexOf('/cart?') > -1) {
	                        navigateUrl = '/page/cart/cart?' + hashStr;
	                  }
	                  if (miniapp == 'portal') {
	                        wx.miniProgram.navigateTo({
	                              url: '/pages/web_view_promote/web_view_promote?mpappid=wx255b67a1403adbc2' + '&mppath=' + encodeURIComponent(navigateUrl)
	                        });
	                  } else {
	                        if (href.indexOf('/cart?') > -1) {
	                              wx.miniProgram.switchTab({
	                                    url: navigateUrl
	                              });
	                              return false;
	                        }
	                        wx.miniProgram.navigateTo({
	                              url: navigateUrl
	                        });
	                        return false;
	                  }
	            });
	      }
	};
	
	wx.miniProgram.getEnv(function (res) {
	      IsWxMiniProgram = res.miniprogram;
	      console.log(res.miniprogram);
	      if (IsWxMiniProgram) {
	            link.init();
	            widgets4Link.init();
	      }
	});
	module.exports = mimiProgram;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['/pages/index/index', '/pages/user_right/coupon/coupon_center', '/pages/web_view/web_view', '/pages/user/growth/growth', '/pages/act/score/score', '/pages/act/score/exchange_detail/exchange_detail', '/pages/act/score/my_list/my_list'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DoT = __webpack_require__(45);
	
	var _require = __webpack_require__(34),
	    getCoupon = _require.getCoupon;
	
	window.isOw = 1;
	module.exports = {
		bindEvent: function bindEvent() {
			var _that = this;
	
			$('.coupon-wrap--active').click(getCoupon);
		},
		getCouponListData: function getCouponListData(params, callback) {
			$.ajax({
				url: '//event.midea.cn/promote/w/mabapp/get_coupon_list_by_bids',
				'type': 'GET',
				'data': params,
				'dataType': 'jsonp',
				'timeout': 10000,
				success: function success(res) {
					console.log(res);
					if (res.errcode == 0) {
						callback && callback(res.data);
					} else {
						alert('query user info fail');
					}
				}
			});
		},
		renderData: function renderData() {
			var _that = this;
			$('.couponlistTpl').each(function (index, item) {
				var batch_ids = $(item).parents('.floor_content').find('.widget-couponlist').attr('data-batch-ids');
				var params = {
					batch_ids: batch_ids
				};
				_that.getCouponListData(params, function (res) {
	
					$(item).parents('.floor_content').find('.widget-couponlist').html(DoT.template($(item).html())({ data: res }));
					if (index == $('.couponlistTpl').length - 1) {
						_that.bindEvent();
					}
				});
			});
		},
		init: function init() {
			this.renderData();
		}
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Fun = __webpack_require__(10);
	var countObj = __webpack_require__(30);
	
	var _require = __webpack_require__(34),
	    getCoupon = _require.getCoupon;
	
	function iosFixedDate(strDatetime) {
	    return strDatetime ? strDatetime.replace(/-/g, '/') : '';
	};
	
	var miaoCouponList = {
	    bindEvent: function bindEvent(_ele) {
	        var _that = this;
	
	        $(_ele).on('click', '.coupon-wrap--active', getCoupon);
	        $('.coupon__btn').click(function (e) {
	            e.stopPropagation();
	        });
	    },
	    getCouponListData: function getCouponListData(params, func) {
	        params.from = 'tool';
	        $.ajax({
	            type: 'get',
	            url: '//event.midea.cn/promote/w/mabapp/get_miao_couponlist',
	            data: params,
	            dataType: 'jsonp',
	            jsonp: 'callback',
	            success: function success(data) {
	                var miaoShaGoodsHtml = data.miaoShaGoodsHtml;
	                func(miaoShaGoodsHtml);
	            },
	            error: function error() {},
	            complete: function complete() {}
	        });
	    },
	    eventBind: function eventBind() {},
	    init: function init() {
	        window.MIAOV2CURACTIVETIMEVALLIST = [];
	        var _self = this;
	        var $willMiaoPoolList = $('.js-miao-couponlist');
	        if ($willMiaoPoolList.length > 0) {
	            $willMiaoPoolList.each(function (index, item) {
	                var _ele = $(this);
	                var miaoStyleType = $(this).attr('data-miao-style-type'),
	                    miaoData = JSON.parse($(this).attr('data-miao-data')),
	                    isShowNav = $(this).attr('data-is-show-nav'),
	                    styleColor = $(this).attr('data-miao-style-color'),
	                    userData = JSON.parse($(this).attr('data-miao-userdata'));
	
	                _self.miaoStyleType = miaoStyleType;
	                _self.styleColor = styleColor;
	                $(this).html('');
	                var params = {
	                    type: miaoStyleType,
	                    style_color: styleColor,
	                    pc: 1
	                };
	                var endTime = userData.miao_data[0].end_time ? userData.miao_data[0].end_time : "23:59";
	                params.date = userData.miao_data[0].date;
	                params.datetime = userData.miao_data[0].date + ' ' + userData.miao_data[0].time + ':00';
	                params.endDatetime = userData.miao_data[0].date + ' ' + endTime + ':00';
	                params.batch_ids = userData.miao_data[0].batch_ids;
	                params.userdata = userData;
	                params.shop_type = window.shop_type;
	                params.is_ls = window.isLs;
	                params.fsid = window.fsid;
	
	                _self.getCouponListData(params, function (html) {
	                    html = '<div class="floor_bg js_miaosha_content">' + html + '</div>';
	                    var $miaoPoolListHtml = $(html);
	                    _ele.append($miaoPoolListHtml);
	                    var miaoServerTime = Date.parse(new Date());
	                    var aTime = { serverTime: miaoServerTime, startTime: params.datetime };
	                    _self.clickDateNav(_ele);
	                    _self.clickTimeNav(_ele);
	                    _self.countDownInit(_ele, aTime);
	                    _self.bindEvent(_ele);
	                    window.MIAOV2CURACTIVETIMEVALLIST.push({
	                        id: _ele.attr('id'),
	                        ele: _ele
	                    });
	                    if (miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))) {
	                        aTime = { serverTime: miaoServerTime, startTime: params.endDatetime, endTime: params.endDatetime };
	                        _ele.countDown.init(aTime, function (t) {
	                            _self.toEndtimeCallback(t, _ele);
	                        });
	                    } else {
	                        aTime = { serverTime: miaoServerTime, startTime: params.datetime, endTime: params.endDatetime };
	                        _ele.countDown.init(aTime, function (t) {
	                            _self.timeCallback(t, _ele);
	                        });
	                    }
	
	
	                    if (userData.time_nav_type == 2) {
	                        _self.getNearTime(_ele);
	                    } else {
	                        _self.getNearDate(_ele);
	                    }
	                });
	            });
	        }
	    },
	    clickDateNav: function clickDateNav(_ele) {
	        var _self = this;
	        var userData = JSON.parse(_ele.attr('data-miao-userdata')),
	            miaoIdType = _ele.attr('data-miao-id-type');
	        _ele.on('click', '.js_date_li', function () {
	            var That = $(this),
	                ThatDatetime = That.attr('data-datetime'),
	                ThatBatchIds = That.attr('data-batch-ids'),
	                miaoStyleType = That.attr('data-style-type');
	            _ele.find('.nav_date_li').removeClass('active');
	            $(this).addClass('active');
	            var params = {
	                type: miaoStyleType,
	                style_color: _self.styleColor,
	                'datetime': ThatDatetime,
	                'endDatetime': That.attr('data-enddatetime') ? That.attr('data-enddatetime') : ThatDatetime.substr(0, 10) + ' 23:59:59',
	                'date': ThatDatetime.substr(0, 10),
	                'batch_ids': ThatBatchIds,
	                'shop_type': shop_type,
	                'is_ls': window.isLs,
	                'pc': 1,
	                'userdata': userData,
	                fsid: fsid
	            };
	            _self.getCouponListData(params, function (html) {
	                var $miaoPoolListHtml = $(html);
	
	                _ele.find('.js_miaosha_content').html($miaoPoolListHtml);
	                var miaoServerTime = Date.parse(new Date());
	
	                var aTime = { serverTime: miaoServerTime, startTime: params.datetime };
	                window.MIAOV2CURACTIVETIMEVALLIST.forEach(function (item, index) {
	                    if (item.id == _ele.attr('id') && item.ele && item.ele.countDown) {
	                        clearInterval(item.ele.countDown.timeInterVal);
	                        if (miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))) {
	                            aTime = { serverTime: miaoServerTime, startTime: params.endDatetime, endTime: params.endDatetime };
	                            _ele.countDown.init(aTime, function (t) {
	                                _self.toEndtimeCallback(t, _ele);
	                            });
	                        } else {
	                            aTime = { serverTime: miaoServerTime, startTime: params.datetime, endTime: params.endDatetime };
	                            _ele.countDown.init(aTime, function (t) {
	                                _self.timeCallback(t, _ele);
	                            });
	                        }
	                    }
	                });
	                var nonStockCount = 0;
	                _ele.find('.js_miao_item').each(function (index, item) {
	                    if ($(item).attr('data-state') == 4) {
	                        nonStockCount++;
	                    }
	                });
	                if (nonStockCount == _ele.find('.js_miao_item').length) {
	                    console.log(That.parents('li.nav_date'));
	                    console.log(That.parents('li.nav_date').next());
	                    var clickDateO = That.next('.js_date_li').length ? That.next('.js_date_li') : That.parents('li.nav_date').next().length ? That.parents('li.nav_date').next().find('.js_date_li') : null;
	                    if (clickDateO) {
	                        console.log(clickDateO);
	                        clickDateO.trigger('click');
	                    } else {
	                        _self.getNearTime(_ele);
	                    }
	                } else {
	                    _self.getNearTime(_ele);
	                }
	                _self.bindEvent(_ele);
	            });
	        });
	    },
	    clickTimeNav: function clickTimeNav(_ele) {
	        var _self = this;
	        var userData = JSON.parse(_ele.attr('data-miao-userdata')),
	            miaoIdType = _ele.attr('data-miao-id-type');
	        _ele.on('click', '.nav_time', function () {
	            var That = $(this),
	                ThatDatetime = That.attr('data-datetime'),
	                ThatBatchIds = That.attr('data-batch-ids'),
	                miaoStyleType = That.attr('data-style-type');
	            _ele.find('.nav_date_li').removeClass('active');
	            $(this).addClass('active');
	            var params = {
	                type: miaoStyleType,
	                style_color: _self.styleColor,
	                'datetime': ThatDatetime,
	                'date': ThatDatetime.substr(0, 10),
	                'endDatetime': That.attr('data-enddatetime') ? That.attr('data-enddatetime') : ThatDatetime.substr(0, 10) + ' 23:59:59',
	                'batch_ids': ThatBatchIds,
	                'shop_type': shop_type,
	                'is_ls': window.isLs,
	                'pc': 1,
	                'userdata': userData,
	                'fsid': fsid
	            };
	            _self.getCouponListData(params, function (html) {
	                var $miaoPoolListHtml = $(html);
	
	                _ele.find('.js_miaosha_content').html($miaoPoolListHtml);
	                var miaoServerTime = Date.parse(new Date());
	
	                var aTime = { serverTime: miaoServerTime, startTime: params.datetime };
	                window.MIAOV2CURACTIVETIMEVALLIST.forEach(function (item, index) {
	                    if (item.id == _ele.attr('id') && item.ele && item.ele.countDown) {
	                        clearInterval(item.ele.countDown.timeInterVal);
	                        if (miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))) {
	                            aTime = { serverTime: miaoServerTime, startTime: params.endDatetime, endTime: params.endDatetime };
	                            _ele.countDown.init(aTime, function (t) {
	                                _self.toEndtimeCallback(t, _ele);
	                            });
	                        } else {
	                            aTime = { serverTime: miaoServerTime, startTime: params.datetime, endTime: params.endDatetime };
	                            _ele.countDown.init(aTime, function (t) {
	                                _self.timeCallback(t, _ele);
	                            });
	                        }
	                    }
	                });
	                var nonStockCount = 0;
	                _ele.find('.js_miao_item').each(function (index, item) {
	                    console.log($(item).attr('data-state'));
	                    if ($(item).attr('data-state') == 4) {
	                        console.log($(item).attr('data-state') + '==? 4');
	                        nonStockCount++;
	                    }
	                });
	                if (nonStockCount == _ele.find('.js_miao_item').length) {
	
	                    var clickTimeO = That.next('.nav_time').length ? That.next('.nav_time') : null;
	                    if (clickTimeO) {
	                        console.log(clickTimeO);
	                        setTimeout(function () {
	                            console.log('setTimeout', clickTimeO);
	                            clickTimeO.trigger('click');
	                        });
	                    }
	                }
	                _self.bindEvent(_ele);
	            });
	        });
	    },
	
	    countDownInit: function countDownInit(_ele, aTime) {
	        if (_ele.length > 0) {
	            var userData = JSON.parse(_ele.attr('data-miao-userdata'));
	            var $miao_count = _ele.find('.js_miao_count');
	            var miaoServerTime = Date.parse(new Date());
	            if ($miao_count[0]) {
	                _ele.countDown = countObj.countDown();
	            }
	        }
	    },
	    toEndtimeCallback: function toEndtimeCallback(t, _ele) {
	        if (t.total > 0) {
	            this.timeStart(t, _ele);
	        } else {
	            this.timeEnd(t, _ele);
	        }
	    },
	    timeBeforeLong: function timeBeforeLong(t, _ele) {
	        _ele.find('.mc_modal_over').hide();
	        _ele.find('.mc_btn_will_start').show().find('.mc_modal_tips').text('未开始');
	
	        var $count = _ele.find('.js_miao_count');
	        $count.find('.js_count_d').text(t.days);
	        $count.find('.js_count_h').text(t.hours);
	        $count.find('.js_count_m').text(t.minutes);
	        $count.find('.js_count_s').text(t.seconds);
	    },
	
	    timeBefore: function timeBefore(t, _ele) {
	        _ele.find('.mc_modal_over').hide();
	        _ele.find('.mc_btn_will_start').show().find('.mc_modal_tips').text('即将开始');
	
	        var $count = _ele.find('.js_miao_count');
	        $count.find('.js_count_d').text(t.days);
	        $count.find('.js_count_h').text(t.hours);
	        $count.find('.js_count_m').text(t.minutes);
	        $count.find('.js_count_s').text(t.seconds);
	    },
	    timeCallback: function timeCallback(t, _ele) {
	        var _self = this;
	        if (t.total > 30 * 60 * 1000) {
	            _self.timeBeforeLong(t, _ele);
	        } else if (t.total > 0) {
	            _self.timeBefore(t, _ele);
	        } else if (t.total <= 0) {
	
	            var nextEndTime;
	            var myMiaoServerTime = new Date(Fun.timestampToTime(parseInt(window.miaoServerTime))).getTime();
	
	            if (_ele.attr('data-miao-time-nav-type') == '1') {
	                var $dateli = _ele.find('.nav_date_li.active');
	                if ($dateli.attr('data-endtime')) {
	                    nextEndTime = iosFixedDate($dateli.attr('data-date') + ' ' + $dateli.attr('data-endtime'));
	                } else {
	                    nextEndTime = iosFixedDate($dateli.attr('data-date') + ' 23:59:59');
	                }
	            } else if (_ele.attr('data-miao-time-nav-type') == '2') {
	                var $timeli = _ele.find('.nav_time.active');
	                if ($timeli.attr('data-endtime')) {
	                    nextEndTime = iosFixedDate($timeli.attr('data-date') + ' ' + $timeli.attr('data-endtime'));
	                } else {
	                    nextEndTime = iosFixedDate($timeli.attr('data-date') + ' 23:59:59');
	                }
	            } else {
	                nextEndTime = iosFixedDate(_ele.find('.nav_time.active').find('.time_area_v2').attr('data-enddatetime'));
	            }
	
	            _self.startSwitchCountDownInit({ serverTime: myMiaoServerTime, startTime: nextEndTime }, _ele);
	        }
	    },
	    startSwitchCountDownInit: function startSwitchCountDownInit(aTime, _ele) {
	        var _self = this;
	
	        window.MIAOV2CURACTIVETIMEVALLIST.forEach(function (item, index) {
	            if (item.id == _ele.attr('id') && item.ele && item.ele.countDown) {
	                clearInterval(item.ele.countDown.timeInterVal);
	                item.ele.countDown.init(aTime, function (t) {
	                    _self.toEndtimeCallback(t, _ele);
	                });
	            }
	        });
	    },
	    timeStart: function timeStart(t, _ele) {
	        _ele.find('.mc_modal_over').hide();
	
	        var $count = _ele.find('.js_miao_count');
	        $count.find('.mc_time_state_desc').text('距离当前场结束剩余');
	        $count.find('.js_count_d').text(t.days);
	        $count.find('.js_count_h').text(t.hours);
	        $count.find('.js_count_m').text(t.minutes);
	        $count.find('.js_count_s').text(t.seconds);
	    },
	    timeEnd: function timeEnd(t, _ele) {
	
	        _ele.find('.mc_modal_over').hide();
	        _ele.find('.mc_modal_time_over').show();
	    },
	    getNearTime: function getNearTime(_ele) {
	        console.log(_ele);
	        var curDate = new Date();
	        var hour = curDate.getHours() > 9 ? curDate.getHours() : '0' + curDate.getHours();
	        var min = curDate.getMinutes() > 9 ? curDate.getMinutes() : '0' + curDate.getMinutes();
	        var time = hour + ':' + min + ':00';
	        var year = curDate.getFullYear();
	        var mon = curDate.getMonth() + 1;
	        mon = (mon + '').length > 1 ? mon : '0' + mon;
	        var date = curDate.getDate() > 9 ? curDate.getDate() : '0' + curDate.getDate();
	        date = year + '-' + mon + '-' + date;
	        var dateTime = date + ' ' + time;
	
	        var clickTimeO;
	        var lTime = '',
	            hTime = '';
	        _ele.find('.nav_time').each(function (index, item) {
	
	            if (new Date(dateTime).getTime() >= new Date($(item).attr('data-datetime')).getTime()) {
	                lTime = $(item);
	            } else {
	                if (index == _ele.find('.nav_time').length - 1 && !lTime) {
	                    lTime = $(_ele.find('.nav_time')[0]);
	                } else {
	                    hTime = $(item);
	                }
	            }
	        });
	        clickTimeO = lTime;
	
	        if (clickTimeO) {
	
	            clickTimeO.trigger('click');
	        }
	    },
	    getNearDate: function getNearDate(_ele) {
	        console.log(_ele);
	        var curDate = new Date();
	        var hour = curDate.getHours() > 9 ? curDate.getHours() : '0' + curDate.getHours();
	        var min = curDate.getMinutes() > 9 ? curDate.getMinutes() : '0' + curDate.getMinutes();
	        var time = hour + ':' + min + ':00';
	        var year = curDate.getFullYear();
	        var mon = curDate.getMonth() + 1;
	        mon = (mon + '').length > 1 ? mon : '0' + mon;
	
	        var date = curDate.getDate() > 9 ? curDate.getDate() : '0' + curDate.getDate();
	        date = year + '-' + mon + '-' + date;
	
	        var clickDateO;
	        var lDate = '',
	            hDate = '';
	
	        _ele.find('.js_date_li').each(function (index, item) {
	            console.log('date:', date);
	            console.log('data-date:', $(item));
	            console.log('data-date:', $(item).attr('data-date'));
	            if (new Date(date).getTime() >= new Date($(item).attr('data-date')).getTime()) {
	                console.log('lDate data-date:', $(item).attr('data-date'));
	                lDate = $(item);
	            } else {
	                if (index == _ele.find('.js_date_li').length - 1 && date > $(item).attr('data-date')) {
	                    console.log('lDate else data-date:', $(item).attr('data-date'));
	                    lDate = $(_ele.find('.js_date_li')[0]);
	                } else {
	                    console.log('hDate else data-date:', $(item).attr('data-date'));
	                    hDate = $(item);
	                }
	            }
	        });
	        clickDateO = lDate;
	
	
	        if (clickDateO) {
	            console.log(clickDateO);
	            clickDateO.trigger('click');
	        }
	    }
	};
	
	module.exports = miaoCouponList;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DoT = __webpack_require__(45);
	
	module.exports = {
		query_vip_info: function query_vip_info(callback) {
			$.ajax({
				url: '//mvip.midea.cn/my/muc/promote_user_info',
				'type': 'GET',
				'data': {},
				'dataType': 'jsonp',
				'timeout': 10000,
				success: function success(res) {
					console.log(res);
					if (res.err_code == 0) {
						callback && callback(res.data);
					} else {
						console.log(res.errmsg);
					}
				}
			});
		},
		render: function render(data) {
			$('.js_widget_vipcard').each(function (index, item) {
				var widgetConf = $(item).attr('data-widget-conf');
				if (widgetConf) {
					widgetConf = JSON.parse($(item).attr('data-widget-conf'));
					data.welfareH5Href = data.welfareH5Href + '?mtag=' + widgetConf.welfare_link_mtag;
					data.welfareSPHref = data.welfareSPHref + '?mtag=' + widgetConf.welfare_link_mtag;
					data.signinHref = data.signinHref + '?mtag=' + widgetConf.signin_link_mtag;
					data.signinSPHref = data.signinSPHref + '?mtag=' + widgetConf.signin_link_mtag;
					$(item).html(DoT.template($('#vipcardTmpl').html())({ data: { vipData: data } }));
	
	
					$('#user_info_box').addClass(data.level_bg_name);
					var rightImgName = '';
					if (data.nProFlag != 0) {
						rightImgName = 'pro';
					} else if (data.vip_level == 1) {
						rightImgName = 'common';
					} else if (data.vip_level == 2) {
						rightImgName = 'gold';
					} else if (data.vip_level == 3) {
						rightImgName = 'diamond';
					} else {
						rightImgName = 'common';
					}
	
					if (widgetConf['vip_right_img_' + rightImgName]) {
						$('.vip_right_img_box').attr('src', widgetConf['vip_right_img_' + rightImgName]);
					} else {
						$('.vip_right_img_box').css('display', 'none');
						$('.more-right').css('display', 'none');
						$('#user_info_box').css('padding-bottom', 0);
					}
				}
			});
		},
		eventBind: function eventBind(data) {
			$('#go_to_signin a').on('click', function () {
				if (IsWxMiniProgram) {
					if (window.miniapp == 'portal') {
						wx.miniProgram.navigateTo({
							url: data.signinSPHref
						});
						return false;
					}
					wx.miniProgram.navigateTo({
						url: '/page/web_view_promote/web_view_promote?mpappid=' + data.spAppId + '&mppath=' + encodeURIComponent(data.signinSPHref)
					});
					return false;
				}
				return true;
			});
			$('.more-right a').on('click', function () {
				if (IsWxMiniProgram) {
					if (window.miniapp == 'portal') {
						wx.miniProgram.switchTab({
							url: data.welfareSPHref
						});
						return false;
					}
					wx.miniProgram.navigateTo({
						url: '/page/web_view_promote/web_view_promote?mpappid=' + data.spAppId + '&mppath=' + encodeURIComponent(data.welfareSPHref)
					});
					return false;
				}
				return true;
			});
		},
		init: function init(options) {
			var that = this;
			if ($('.js_widget_vipcard').length > 0) {
				if (options) {
					console.log('IsWxMiniProgram');
					console.log(window.IsWxMiniProgram);
					options.login.start(function () {
						that.query_vip_info(function (data) {
							that.render(data);
							that.eventBind(data);
						});
					});
				}
			}
		}
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(61), __esModule: true };

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(62), __esModule: true };

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(59);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(58);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(85);
	__webpack_require__(83);
	__webpack_require__(86);
	__webpack_require__(87);
	module.exports = __webpack_require__(16).Symbol;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(84);
	__webpack_require__(88);
	module.exports = __webpack_require__(29).f('iterator');


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(6);
	var toLength = __webpack_require__(80);
	var toAbsoluteIndex = __webpack_require__(79);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(63);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(21);
	var gOPS = __webpack_require__(42);
	var pIE = __webpack_require__(22);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(1).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(35);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(35);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(40);
	var descriptor = __webpack_require__(14);
	var setToStringTag = __webpack_require__(23);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(4)(IteratorPrototype, __webpack_require__(7)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(15)('meta');
	var isObject = __webpack_require__(13);
	var has = __webpack_require__(2);
	var setDesc = __webpack_require__(5).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(12)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(5);
	var anObject = __webpack_require__(11);
	var getKeys = __webpack_require__(21);
	
	module.exports = __webpack_require__(3) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(22);
	var createDesc = __webpack_require__(14);
	var toIObject = __webpack_require__(6);
	var toPrimitive = __webpack_require__(27);
	var has = __webpack_require__(2);
	var IE8_DOM_DEFINE = __webpack_require__(38);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(3) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(6);
	var gOPN = __webpack_require__(41).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(2);
	var toObject = __webpack_require__(81);
	var IE_PROTO = __webpack_require__(24)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(26);
	var defined = __webpack_require__(17);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(26);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(26);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(17);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(64);
	var step = __webpack_require__(72);
	var Iterators = __webpack_require__(19);
	var toIObject = __webpack_require__(6);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(39)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 83 */
/***/ (function(module, exports) {



/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(78)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(39)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(1);
	var has = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(3);
	var $export = __webpack_require__(37);
	var redefine = __webpack_require__(44);
	var META = __webpack_require__(73).KEY;
	var $fails = __webpack_require__(12);
	var shared = __webpack_require__(25);
	var setToStringTag = __webpack_require__(23);
	var uid = __webpack_require__(15);
	var wks = __webpack_require__(7);
	var wksExt = __webpack_require__(29);
	var wksDefine = __webpack_require__(28);
	var enumKeys = __webpack_require__(67);
	var isArray = __webpack_require__(70);
	var anObject = __webpack_require__(11);
	var toIObject = __webpack_require__(6);
	var toPrimitive = __webpack_require__(27);
	var createDesc = __webpack_require__(14);
	var _create = __webpack_require__(40);
	var gOPNExt = __webpack_require__(76);
	var $GOPD = __webpack_require__(75);
	var $DP = __webpack_require__(5);
	var $keys = __webpack_require__(21);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(41).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(22).f = $propertyIsEnumerable;
	  __webpack_require__(42).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(20)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(4)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('asyncIterator');


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('observable');


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82);
	var global = __webpack_require__(1);
	var hide = __webpack_require__(4);
	var Iterators = __webpack_require__(19);
	var TO_STRING_TAG = __webpack_require__(7)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 *  Copyright 2011 Twitter, Inc.
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *  http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	
	(function (Hogan) {
	  // Setup regex  assignments
	  // remove whitespace according to Mustache spec
	  var rIsWhitespace = /\S/,
	      rQuot = /\"/g,
	      rNewline =  /\n/g,
	      rCr = /\r/g,
	      rSlash = /\\/g,
	      rLineSep = /\u2028/,
	      rParagraphSep = /\u2029/;
	
	  Hogan.tags = {
	    '#': 1, '^': 2, '<': 3, '$': 4,
	    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
	    '{': 10, '&': 11, '_t': 12
	  };
	
	  Hogan.scan = function scan(text, delimiters) {
	    var len = text.length,
	        IN_TEXT = 0,
	        IN_TAG_TYPE = 1,
	        IN_TAG = 2,
	        state = IN_TEXT,
	        tagType = null,
	        tag = null,
	        buf = '',
	        tokens = [],
	        seenTag = false,
	        i = 0,
	        lineStart = 0,
	        otag = '{{',
	        ctag = '}}';
	
	    function addBuf() {
	      if (buf.length > 0) {
	        tokens.push({tag: '_t', text: new String(buf)});
	        buf = '';
	      }
	    }
	
	    function lineIsWhitespace() {
	      var isAllWhitespace = true;
	      for (var j = lineStart; j < tokens.length; j++) {
	        isAllWhitespace =
	          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
	          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
	        if (!isAllWhitespace) {
	          return false;
	        }
	      }
	
	      return isAllWhitespace;
	    }
	
	    function filterLine(haveSeenTag, noNewLine) {
	      addBuf();
	
	      if (haveSeenTag && lineIsWhitespace()) {
	        for (var j = lineStart, next; j < tokens.length; j++) {
	          if (tokens[j].text) {
	            if ((next = tokens[j+1]) && next.tag == '>') {
	              // set indent to token value
	              next.indent = tokens[j].text.toString()
	            }
	            tokens.splice(j, 1);
	          }
	        }
	      } else if (!noNewLine) {
	        tokens.push({tag:'\n'});
	      }
	
	      seenTag = false;
	      lineStart = tokens.length;
	    }
	
	    function changeDelimiters(text, index) {
	      var close = '=' + ctag,
	          closeIndex = text.indexOf(close, index),
	          delimiters = trim(
	            text.substring(text.indexOf('=', index) + 1, closeIndex)
	          ).split(' ');
	
	      otag = delimiters[0];
	      ctag = delimiters[delimiters.length - 1];
	
	      return closeIndex + close.length - 1;
	    }
	
	    if (delimiters) {
	      delimiters = delimiters.split(' ');
	      otag = delimiters[0];
	      ctag = delimiters[1];
	    }
	
	    for (i = 0; i < len; i++) {
	      if (state == IN_TEXT) {
	        if (tagChange(otag, text, i)) {
	          --i;
	          addBuf();
	          state = IN_TAG_TYPE;
	        } else {
	          if (text.charAt(i) == '\n') {
	            filterLine(seenTag);
	          } else {
	            buf += text.charAt(i);
	          }
	        }
	      } else if (state == IN_TAG_TYPE) {
	        i += otag.length - 1;
	        tag = Hogan.tags[text.charAt(i + 1)];
	        tagType = tag ? text.charAt(i + 1) : '_v';
	        if (tagType == '=') {
	          i = changeDelimiters(text, i);
	          state = IN_TEXT;
	        } else {
	          if (tag) {
	            i++;
	          }
	          state = IN_TAG;
	        }
	        seenTag = i;
	      } else {
	        if (tagChange(ctag, text, i)) {
	          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
	                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
	          buf = '';
	          i += ctag.length - 1;
	          state = IN_TEXT;
	          if (tagType == '{') {
	            if (ctag == '}}') {
	              i++;
	            } else {
	              cleanTripleStache(tokens[tokens.length - 1]);
	            }
	          }
	        } else {
	          buf += text.charAt(i);
	        }
	      }
	    }
	
	    filterLine(seenTag, true);
	
	    return tokens;
	  }
	
	  function cleanTripleStache(token) {
	    if (token.n.substr(token.n.length - 1) === '}') {
	      token.n = token.n.substring(0, token.n.length - 1);
	    }
	  }
	
	  function trim(s) {
	    if (s.trim) {
	      return s.trim();
	    }
	
	    return s.replace(/^\s*|\s*$/g, '');
	  }
	
	  function tagChange(tag, text, index) {
	    if (text.charAt(index) != tag.charAt(0)) {
	      return false;
	    }
	
	    for (var i = 1, l = tag.length; i < l; i++) {
	      if (text.charAt(index + i) != tag.charAt(i)) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  // the tags allowed inside super templates
	  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};
	
	  function buildTree(tokens, kind, stack, customTags) {
	    var instructions = [],
	        opener = null,
	        tail = null,
	        token = null;
	
	    tail = stack[stack.length - 1];
	
	    while (tokens.length > 0) {
	      token = tokens.shift();
	
	      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
	        throw new Error('Illegal content in < super tag.');
	      }
	
	      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
	        stack.push(token);
	        token.nodes = buildTree(tokens, token.tag, stack, customTags);
	      } else if (token.tag == '/') {
	        if (stack.length === 0) {
	          throw new Error('Closing tag without opener: /' + token.n);
	        }
	        opener = stack.pop();
	        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
	          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
	        }
	        opener.end = token.i;
	        return instructions;
	      } else if (token.tag == '\n') {
	        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
	      }
	
	      instructions.push(token);
	    }
	
	    if (stack.length > 0) {
	      throw new Error('missing closing tag: ' + stack.pop().n);
	    }
	
	    return instructions;
	  }
	
	  function isOpener(token, tags) {
	    for (var i = 0, l = tags.length; i < l; i++) {
	      if (tags[i].o == token.n) {
	        token.tag = '#';
	        return true;
	      }
	    }
	  }
	
	  function isCloser(close, open, tags) {
	    for (var i = 0, l = tags.length; i < l; i++) {
	      if (tags[i].c == close && tags[i].o == open) {
	        return true;
	      }
	    }
	  }
	
	  function stringifySubstitutions(obj) {
	    var items = [];
	    for (var key in obj) {
	      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
	    }
	    return "{ " + items.join(",") + " }";
	  }
	
	  function stringifyPartials(codeObj) {
	    var partials = [];
	    for (var key in codeObj.partials) {
	      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
	    }
	    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
	  }
	
	  Hogan.stringify = function(codeObj, text, options) {
	    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
	  }
	
	  var serialNo = 0;
	  Hogan.generate = function(tree, text, options) {
	    serialNo = 0;
	    var context = { code: '', subs: {}, partials: {} };
	    Hogan.walk(tree, context);
	
	    if (options.asString) {
	      return this.stringify(context, text, options);
	    }
	
	    return this.makeTemplate(context, text, options);
	  }
	
	  Hogan.wrapMain = function(code) {
	    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
	  }
	
	  Hogan.template = Hogan.Template;
	
	  Hogan.makeTemplate = function(codeObj, text, options) {
	    var template = this.makePartials(codeObj);
	    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
	    return new this.template(template, text, this, options);
	  }
	
	  Hogan.makePartials = function(codeObj) {
	    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
	    for (key in template.partials) {
	      template.partials[key] = this.makePartials(template.partials[key]);
	    }
	    for (key in codeObj.subs) {
	      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
	    }
	    return template;
	  }
	
	  function esc(s) {
	    return s.replace(rSlash, '\\\\')
	            .replace(rQuot, '\\\"')
	            .replace(rNewline, '\\n')
	            .replace(rCr, '\\r')
	            .replace(rLineSep, '\\u2028')
	            .replace(rParagraphSep, '\\u2029');
	  }
	
	  function chooseMethod(s) {
	    return (~s.indexOf('.')) ? 'd' : 'f';
	  }
	
	  function createPartial(node, context) {
	    var prefix = "<" + (context.prefix || "");
	    var sym = prefix + node.n + serialNo++;
	    context.partials[sym] = {name: node.n, partials: {}};
	    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
	    return sym;
	  }
	
	  Hogan.codegen = {
	    '#': function(node, context) {
	      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
	                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
	                      't.rs(c,p,' + 'function(c,p,t){';
	      Hogan.walk(node.nodes, context);
	      context.code += '});c.pop();}';
	    },
	
	    '^': function(node, context) {
	      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
	      Hogan.walk(node.nodes, context);
	      context.code += '};';
	    },
	
	    '>': createPartial,
	    '<': function(node, context) {
	      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
	      Hogan.walk(node.nodes, ctx);
	      var template = context.partials[createPartial(node, context)];
	      template.subs = ctx.subs;
	      template.partials = ctx.partials;
	    },
	
	    '$': function(node, context) {
	      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
	      Hogan.walk(node.nodes, ctx);
	      context.subs[node.n] = ctx.code;
	      if (!context.inPartial) {
	        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
	      }
	    },
	
	    '\n': function(node, context) {
	      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
	    },
	
	    '_v': function(node, context) {
	      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
	    },
	
	    '_t': function(node, context) {
	      context.code += write('"' + esc(node.text) + '"');
	    },
	
	    '{': tripleStache,
	
	    '&': tripleStache
	  }
	
	  function tripleStache(node, context) {
	    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
	  }
	
	  function write(s) {
	    return 't.b(' + s + ');';
	  }
	
	  Hogan.walk = function(nodelist, context) {
	    var func;
	    for (var i = 0, l = nodelist.length; i < l; i++) {
	      func = Hogan.codegen[nodelist[i].tag];
	      func && func(nodelist[i], context);
	    }
	    return context;
	  }
	
	  Hogan.parse = function(tokens, text, options) {
	    options = options || {};
	    return buildTree(tokens, '', [], options.sectionTags || []);
	  }
	
	  Hogan.cache = {};
	
	  Hogan.cacheKey = function(text, options) {
	    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
	  }
	
	  Hogan.compile = function(text, options) {
	    options = options || {};
	    var key = Hogan.cacheKey(text, options);
	    var template = this.cache[key];
	
	    if (template) {
	      var partials = template.partials;
	      for (var name in partials) {
	        delete partials[name].instance;
	      }
	      return template;
	    }
	
	    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
	    return this.cache[key] = template;
	  }
	})( true ? exports : Hogan);


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 *  Copyright 2011 Twitter, Inc.
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *  http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	
	// This file is for use with Node.js. See dist/ for browser files.
	
	var Hogan = __webpack_require__(89);
	Hogan.Template = __webpack_require__(91).Template;
	Hogan.template = Hogan.Template;
	module.exports = Hogan;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 *  Copyright 2011 Twitter, Inc.
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *  http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	
	var Hogan = {};
	
	(function (Hogan) {
	  Hogan.Template = function (codeObj, text, compiler, options) {
	    codeObj = codeObj || {};
	    this.r = codeObj.code || this.r;
	    this.c = compiler;
	    this.options = options || {};
	    this.text = text || '';
	    this.partials = codeObj.partials || {};
	    this.subs = codeObj.subs || {};
	    this.buf = '';
	  }
	
	  Hogan.Template.prototype = {
	    // render: replaced by generated code.
	    r: function (context, partials, indent) { return ''; },
	
	    // variable escaping
	    v: hoganEscape,
	
	    // triple stache
	    t: coerceToString,
	
	    render: function render(context, partials, indent) {
	      return this.ri([context], partials || {}, indent);
	    },
	
	    // render internal -- a hook for overrides that catches partials too
	    ri: function (context, partials, indent) {
	      return this.r(context, partials, indent);
	    },
	
	    // ensurePartial
	    ep: function(symbol, partials) {
	      var partial = this.partials[symbol];
	
	      // check to see that if we've instantiated this partial before
	      var template = partials[partial.name];
	      if (partial.instance && partial.base == template) {
	        return partial.instance;
	      }
	
	      if (typeof template == 'string') {
	        if (!this.c) {
	          throw new Error("No compiler available.");
	        }
	        template = this.c.compile(template, this.options);
	      }
	
	      if (!template) {
	        return null;
	      }
	
	      // We use this to check whether the partials dictionary has changed
	      this.partials[symbol].base = template;
	
	      if (partial.subs) {
	        // Make sure we consider parent template now
	        if (!partials.stackText) partials.stackText = {};
	        for (key in partial.subs) {
	          if (!partials.stackText[key]) {
	            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
	          }
	        }
	        template = createSpecializedPartial(template, partial.subs, partial.partials,
	          this.stackSubs, this.stackPartials, partials.stackText);
	      }
	      this.partials[symbol].instance = template;
	
	      return template;
	    },
	
	    // tries to find a partial in the current scope and render it
	    rp: function(symbol, context, partials, indent) {
	      var partial = this.ep(symbol, partials);
	      if (!partial) {
	        return '';
	      }
	
	      return partial.ri(context, partials, indent);
	    },
	
	    // render a section
	    rs: function(context, partials, section) {
	      var tail = context[context.length - 1];
	
	      if (!isArray(tail)) {
	        section(context, partials, this);
	        return;
	      }
	
	      for (var i = 0; i < tail.length; i++) {
	        context.push(tail[i]);
	        section(context, partials, this);
	        context.pop();
	      }
	    },
	
	    // maybe start a section
	    s: function(val, ctx, partials, inverted, start, end, tags) {
	      var pass;
	
	      if (isArray(val) && val.length === 0) {
	        return false;
	      }
	
	      if (typeof val == 'function') {
	        val = this.ms(val, ctx, partials, inverted, start, end, tags);
	      }
	
	      pass = !!val;
	
	      if (!inverted && pass && ctx) {
	        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
	      }
	
	      return pass;
	    },
	
	    // find values with dotted names
	    d: function(key, ctx, partials, returnFound) {
	      var found,
	          names = key.split('.'),
	          val = this.f(names[0], ctx, partials, returnFound),
	          doModelGet = this.options.modelGet,
	          cx = null;
	
	      if (key === '.' && isArray(ctx[ctx.length - 2])) {
	        val = ctx[ctx.length - 1];
	      } else {
	        for (var i = 1; i < names.length; i++) {
	          found = findInScope(names[i], val, doModelGet);
	          if (found !== undefined) {
	            cx = val;
	            val = found;
	          } else {
	            val = '';
	          }
	        }
	      }
	
	      if (returnFound && !val) {
	        return false;
	      }
	
	      if (!returnFound && typeof val == 'function') {
	        ctx.push(cx);
	        val = this.mv(val, ctx, partials);
	        ctx.pop();
	      }
	
	      return val;
	    },
	
	    // find values with normal names
	    f: function(key, ctx, partials, returnFound) {
	      var val = false,
	          v = null,
	          found = false,
	          doModelGet = this.options.modelGet;
	
	      for (var i = ctx.length - 1; i >= 0; i--) {
	        v = ctx[i];
	        val = findInScope(key, v, doModelGet);
	        if (val !== undefined) {
	          found = true;
	          break;
	        }
	      }
	
	      if (!found) {
	        return (returnFound) ? false : "";
	      }
	
	      if (!returnFound && typeof val == 'function') {
	        val = this.mv(val, ctx, partials);
	      }
	
	      return val;
	    },
	
	    // higher order templates
	    ls: function(func, cx, partials, text, tags) {
	      var oldTags = this.options.delimiters;
	
	      this.options.delimiters = tags;
	      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
	      this.options.delimiters = oldTags;
	
	      return false;
	    },
	
	    // compile text
	    ct: function(text, cx, partials) {
	      if (this.options.disableLambda) {
	        throw new Error('Lambda features disabled.');
	      }
	      return this.c.compile(text, this.options).render(cx, partials);
	    },
	
	    // template result buffering
	    b: function(s) { this.buf += s; },
	
	    fl: function() { var r = this.buf; this.buf = ''; return r; },
	
	    // method replace section
	    ms: function(func, ctx, partials, inverted, start, end, tags) {
	      var textSource,
	          cx = ctx[ctx.length - 1],
	          result = func.call(cx);
	
	      if (typeof result == 'function') {
	        if (inverted) {
	          return true;
	        } else {
	          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
	          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
	        }
	      }
	
	      return result;
	    },
	
	    // method replace variable
	    mv: function(func, ctx, partials) {
	      var cx = ctx[ctx.length - 1];
	      var result = func.call(cx);
	
	      if (typeof result == 'function') {
	        return this.ct(coerceToString(result.call(cx)), cx, partials);
	      }
	
	      return result;
	    },
	
	    sub: function(name, context, partials, indent) {
	      var f = this.subs[name];
	      if (f) {
	        this.activeSub = name;
	        f(context, partials, this, indent);
	        this.activeSub = false;
	      }
	    }
	
	  };
	
	  //Find a key in an object
	  function findInScope(key, scope, doModelGet) {
	    var val;
	
	    if (scope && typeof scope == 'object') {
	
	      if (scope[key] !== undefined) {
	        val = scope[key];
	
	      // try lookup with get for backbone or similar model data
	      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
	        val = scope.get(key);
	      }
	    }
	
	    return val;
	  }
	
	  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
	    function PartialTemplate() {};
	    PartialTemplate.prototype = instance;
	    function Substitutions() {};
	    Substitutions.prototype = instance.subs;
	    var key;
	    var partial = new PartialTemplate();
	    partial.subs = new Substitutions();
	    partial.subsText = {};  //hehe. substext.
	    partial.buf = '';
	
	    stackSubs = stackSubs || {};
	    partial.stackSubs = stackSubs;
	    partial.subsText = stackText;
	    for (key in subs) {
	      if (!stackSubs[key]) stackSubs[key] = subs[key];
	    }
	    for (key in stackSubs) {
	      partial.subs[key] = stackSubs[key];
	    }
	
	    stackPartials = stackPartials || {};
	    partial.stackPartials = stackPartials;
	    for (key in partials) {
	      if (!stackPartials[key]) stackPartials[key] = partials[key];
	    }
	    for (key in stackPartials) {
	      partial.partials[key] = stackPartials[key];
	    }
	
	    return partial;
	  }
	
	  var rAmp = /&/g,
	      rLt = /</g,
	      rGt = />/g,
	      rApos = /\'/g,
	      rQuot = /\"/g,
	      hChars = /[&<>\"\']/;
	
	  function coerceToString(val) {
	    return String((val === null || val === undefined) ? '' : val);
	  }
	
	  function hoganEscape(str) {
	    str = coerceToString(str);
	    return hChars.test(str) ?
	      str
	        .replace(rAmp, '&amp;')
	        .replace(rLt, '&lt;')
	        .replace(rGt, '&gt;')
	        .replace(rApos, '&#39;')
	        .replace(rQuot, '&quot;') :
	      str;
	  }
	
	  var isArray = Array.isArray || function(a) {
	    return Object.prototype.toString.call(a) === '[object Array]';
	  };
	
	})( true ? exports : Hogan);


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var H = __webpack_require__(90);
	module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<style>\r");t.b("\n" + i);t.b(".md-popup {\r");t.b("\n" + i);t.b("    position: fixed;\r");t.b("\n" + i);t.b("    top: 50%;\r");t.b("\n" + i);t.b("    left: 50%;\r");t.b("\n" + i);t.b("    z-index: 10000;\r");t.b("\n" + i);t.b("    display: none;\r");t.b("\n" + i);t.b("    width: 270px;\r");t.b("\n" + i);t.b("    overflow: hidden;\r");t.b("\n" + i);t.b("    color: #000;\r");t.b("\n" + i);t.b("    text-align: center;\r");t.b("\n" + i);t.b("    border-radius: 13px;\r");t.b("\n" + i);t.b("    opacity: 0;\r");t.b("\n" + i);t.b("    -webkit-transition-property: -webkit-transform,opacity;\r");t.b("\n" + i);t.b("    transition-property: transform,opacity;\r");t.b("\n" + i);t.b("    -webkit-transform: translate3d(-50%,-50%,0) scale(1.185);\r");t.b("\n" + i);t.b("    transform: translate3d(-50%,-50%,0) scale(1.185);\r");t.b("\n" + i);t.b("}\r");t.b("\n" + i);t.b(".md-popup.md-popup-in {\r");t.b("\n" + i);t.b("    display: block;\r");t.b("\n" + i);t.b("    opacity: 1;\r");t.b("\n" + i);t.b("    -webkit-transition-duration: 400ms;\r");t.b("\n" + i);t.b("    transition-duration: 400ms;\r");t.b("\n" + i);t.b("    -webkit-transform: translate3d(-50%,-50%,0) scale(1);\r");t.b("\n" + i);t.b("    transform: translate3d(-50%,-50%,0) scale(1);\r");t.b("\n" + i);t.b("}\r");t.b("\n" + i);t.b(".md-popup-inner {\r");t.b("\n" + i);t.b("    position: relative;\r");t.b("\n" + i);t.b("    padding: 15px;\r");t.b("\n" + i);t.b("    background: rgba(255,255,255,.95);\r");t.b("\n" + i);t.b("    border-radius: 13px 13px 0 0;\r");t.b("\n" + i);t.b("}\r");t.b("\n" + i);t.b(".md-popup-title {\r");t.b("\n" + i);t.b("    font-size: 18px;\r");t.b("\n" + i);t.b("    font-weight: 500;\r");t.b("\n" + i);t.b("    text-align: center;\r");t.b("\n" + i);t.b("}\r");t.b("\n" + i);t.b(".md-popup-title+.md-popup-text {\r");t.b("\n" + i);t.b("    margin: 5px 0 0;\r");t.b("\n" + i);t.b("    font-family: inherit;\r");t.b("\n" + i);t.b("    font-size: 14px;\r");t.b("\n" + i);t.b("}\r");t.b("\n" + i);t.b(".md-popup-buttons {\r");t.b("\n" + i);t.b("    position: relative;\r");t.b("\n" + i);t.b("    display: -webkit-box;\r");t.b("\n" + i);t.b("    display: -webkit-flex;\r");t.b("\n" + i);t.b("    display: flex;\r");t.b("\n" + i);t.b("    height: 44px;\r");t.b("\n" + i);t.b("    -webkit-box-pack: center;\r");t.b("\n" + i);t.b("    -webkit-justify-content: center;\r");t.b("\n" + i);t.b("    justify-content: center;\r");t.b("\n" + i);t.b("}\r");t.b("\n" + i);t.b(".md-popup-button {\r");t.b("\n" + i);t.b("    position: relative;\r");t.b("\n" + i);t.b("    display: block;\r");t.b("\n" + i);t.b("    width: 100%;\r");t.b("\n" + i);t.b("    height: 44px;\r");t.b("\n" + i);t.b("    box-sizing: border-box;\r");t.b("\n" + i);t.b("    padding: 0 5px;\r");t.b("\n" + i);t.b("    overflow: hidden;\r");t.b("\n" + i);t.b("    font-size: 17px;\r");t.b("\n" + i);t.b("    line-height: 44px;\r");t.b("\n" + i);t.b("    color: #007aff;\r");t.b("\n" + i);t.b("    text-align: center;\r");t.b("\n" + i);t.b("    text-overflow: ellipsis;\r");t.b("\n" + i);t.b("    white-space: nowrap;\r");t.b("\n" + i);t.b("    cursor: pointer;\r");t.b("\n" + i);t.b("    background: rgba(255,255,255,.95);\r");t.b("\n" + i);t.b("    -webkit-box-flex: 1;\r");t.b("\n" + i);t.b("}\r");t.b("\n" + i);t.b(".md-popup-button:first-child:last-child {\r");t.b("\n" + i);t.b("    border-radius: 0 0 13px 13px;\r");t.b("\n" + i);t.b("}\r");t.b("\n" + i);t.b(".md-popup-button.md-popup-button-bold {\r");t.b("\n" + i);t.b("    font-weight: 600;\r");t.b("\n" + i);t.b("}\r");t.b("\n" + i);t.b(".md-popup-backdrop {\r");t.b("\n" + i);t.b("    position: fixed;\r");t.b("\n" + i);t.b("    top: 0;\r");t.b("\n" + i);t.b("    right: 0;\r");t.b("\n" + i);t.b("    bottom: 0;\r");t.b("\n" + i);t.b("    left: 0;\r");t.b("\n" + i);t.b("    z-index: 998;\r");t.b("\n" + i);t.b("    background: rgba(0,0,0,.4);\r");t.b("\n" + i);t.b("    transition-duration: 400ms;\r");t.b("\n" + i);t.b("    opacity: 0;\r");t.b("\n" + i);t.b("    display: none;\r");t.b("\n" + i);t.b("}\r");t.b("\n" + i);t.b(".md-popup-backdrop.md-active {\r");t.b("\n" + i);t.b("    opacity: 1;\r");t.b("\n" + i);t.b("    display: block;\r");t.b("\n" + i);t.b("}\r");t.b("\n" + i);t.b("</style>\r");t.b("\n" + i);t.b("\r");t.b("\n" + i);t.b("<div class=\"md-popup md-popup-in\">\r");t.b("\n" + i);t.b("	<div class=\"md-popup-inner\">\r");t.b("\n" + i);t.b("		<div class=\"md-popup-title\">");t.b(t.v(t.f("title",c,p,0)));t.b("</div>\r");t.b("\n" + i);t.b("		<div class=\"md-popup-text\">");t.b(t.t(t.f("content",c,p,0)));t.b("</div>\r");t.b("\n" + i);t.b("	</div>\r");t.b("\n" + i);t.b("	<div class=\"md-popup-buttons\">\r");t.b("\n" + i);t.b("		<span class=\"md-popup-button md-popup-button-bold confirm\">");t.b(t.v(t.f("btnConfirmTxt",c,p,0)));t.b("</span>\r");t.b("\n" + i);if(t.s(t.f("btnCancelTxt",c,p,1),c,p,0,2498,2565,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("		<span class=\"md-popup-button\">");t.b(t.v(t.f("btnCancelTxt",c,p,0)));t.b("</span>\r");t.b("\n" + i);});c.pop();}t.b("	</div>\r");t.b("\n" + i);t.b("</div>\r");t.b("\n" + i);t.b("<div class=\"md-popup-backdrop md-active\"></div>");return t.fl(); },partials: {}, subs: {  }}, "<style>\r\n.md-popup {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    z-index: 10000;\r\n    display: none;\r\n    width: 270px;\r\n    overflow: hidden;\r\n    color: #000;\r\n    text-align: center;\r\n    border-radius: 13px;\r\n    opacity: 0;\r\n    -webkit-transition-property: -webkit-transform,opacity;\r\n    transition-property: transform,opacity;\r\n    -webkit-transform: translate3d(-50%,-50%,0) scale(1.185);\r\n    transform: translate3d(-50%,-50%,0) scale(1.185);\r\n}\r\n.md-popup.md-popup-in {\r\n    display: block;\r\n    opacity: 1;\r\n    -webkit-transition-duration: 400ms;\r\n    transition-duration: 400ms;\r\n    -webkit-transform: translate3d(-50%,-50%,0) scale(1);\r\n    transform: translate3d(-50%,-50%,0) scale(1);\r\n}\r\n.md-popup-inner {\r\n    position: relative;\r\n    padding: 15px;\r\n    background: rgba(255,255,255,.95);\r\n    border-radius: 13px 13px 0 0;\r\n}\r\n.md-popup-title {\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    text-align: center;\r\n}\r\n.md-popup-title+.md-popup-text {\r\n    margin: 5px 0 0;\r\n    font-family: inherit;\r\n    font-size: 14px;\r\n}\r\n.md-popup-buttons {\r\n    position: relative;\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: flex;\r\n    height: 44px;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    justify-content: center;\r\n}\r\n.md-popup-button {\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 44px;\r\n    box-sizing: border-box;\r\n    padding: 0 5px;\r\n    overflow: hidden;\r\n    font-size: 17px;\r\n    line-height: 44px;\r\n    color: #007aff;\r\n    text-align: center;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    cursor: pointer;\r\n    background: rgba(255,255,255,.95);\r\n    -webkit-box-flex: 1;\r\n}\r\n.md-popup-button:first-child:last-child {\r\n    border-radius: 0 0 13px 13px;\r\n}\r\n.md-popup-button.md-popup-button-bold {\r\n    font-weight: 600;\r\n}\r\n.md-popup-backdrop {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 998;\r\n    background: rgba(0,0,0,.4);\r\n    transition-duration: 400ms;\r\n    opacity: 0;\r\n    display: none;\r\n}\r\n.md-popup-backdrop.md-active {\r\n    opacity: 1;\r\n    display: block;\r\n}\r\n</style>\r\n\r\n<div class=\"md-popup md-popup-in\">\r\n\t<div class=\"md-popup-inner\">\r\n\t\t<div class=\"md-popup-title\">{{title}}</div>\r\n\t\t<div class=\"md-popup-text\">{{{content}}}</div>\r\n\t</div>\r\n\t<div class=\"md-popup-buttons\">\r\n\t\t<span class=\"md-popup-button md-popup-button-bold confirm\">{{btnConfirmTxt}}</span>\r\n        {{#btnCancelTxt}}\r\n\t\t<span class=\"md-popup-button\">{{btnCancelTxt}}</span>\r\n        {{/btnCancelTxt}}\r\n\t</div>\r\n</div>\r\n<div class=\"md-popup-backdrop md-active\"></div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Swiper 4.4.6
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * http://www.idangero.us/swiper/
	 *
	 * Copyright 2014-2018 Vladimir Kharlampidi
	 *
	 * Released under the MIT License
	 *
	 * Released on: December 19, 2018
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Swiper = factory());
	}(this, (function () { 'use strict';
	
	  /**
	   * SSR Window 1.0.1
	   * Better handling for window object in SSR environment
	   * https://github.com/nolimits4web/ssr-window
	   *
	   * Copyright 2018, Vladimir Kharlampidi
	   *
	   * Licensed under MIT
	   *
	   * Released on: July 18, 2018
	   */
	  var doc = (typeof document === 'undefined') ? {
	    body: {},
	    addEventListener: function addEventListener() {},
	    removeEventListener: function removeEventListener() {},
	    activeElement: {
	      blur: function blur() {},
	      nodeName: '',
	    },
	    querySelector: function querySelector() {
	      return null;
	    },
	    querySelectorAll: function querySelectorAll() {
	      return [];
	    },
	    getElementById: function getElementById() {
	      return null;
	    },
	    createEvent: function createEvent() {
	      return {
	        initEvent: function initEvent() {},
	      };
	    },
	    createElement: function createElement() {
	      return {
	        children: [],
	        childNodes: [],
	        style: {},
	        setAttribute: function setAttribute() {},
	        getElementsByTagName: function getElementsByTagName() {
	          return [];
	        },
	      };
	    },
	    location: { hash: '' },
	  } : document; // eslint-disable-line
	
	  var win = (typeof window === 'undefined') ? {
	    document: doc,
	    navigator: {
	      userAgent: '',
	    },
	    location: {},
	    history: {},
	    CustomEvent: function CustomEvent() {
	      return this;
	    },
	    addEventListener: function addEventListener() {},
	    removeEventListener: function removeEventListener() {},
	    getComputedStyle: function getComputedStyle() {
	      return {
	        getPropertyValue: function getPropertyValue() {
	          return '';
	        },
	      };
	    },
	    Image: function Image() {},
	    Date: function Date() {},
	    screen: {},
	    setTimeout: function setTimeout() {},
	    clearTimeout: function clearTimeout() {},
	  } : window; // eslint-disable-line
	
	  /**
	   * Dom7 2.1.2
	   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	   * http://framework7.io/docs/dom.html
	   *
	   * Copyright 2018, Vladimir Kharlampidi
	   * The iDangero.us
	   * http://www.idangero.us/
	   *
	   * Licensed under MIT
	   *
	   * Released on: September 13, 2018
	   */
	
	  var Dom7 = function Dom7(arr) {
	    var self = this;
	    // Create array-like object
	    for (var i = 0; i < arr.length; i += 1) {
	      self[i] = arr[i];
	    }
	    self.length = arr.length;
	    // Return collection with methods
	    return this;
	  };
	
	  function $(selector, context) {
	    var arr = [];
	    var i = 0;
	    if (selector && !context) {
	      if (selector instanceof Dom7) {
	        return selector;
	      }
	    }
	    if (selector) {
	        // String
	      if (typeof selector === 'string') {
	        var els;
	        var tempParent;
	        var html = selector.trim();
	        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	          var toCreate = 'div';
	          if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
	          if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
	          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
	          if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
	          if (html.indexOf('<option') === 0) { toCreate = 'select'; }
	          tempParent = doc.createElement(toCreate);
	          tempParent.innerHTML = html;
	          for (i = 0; i < tempParent.childNodes.length; i += 1) {
	            arr.push(tempParent.childNodes[i]);
	          }
	        } else {
	          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
	            // Pure ID selector
	            els = [doc.getElementById(selector.trim().split('#')[1])];
	          } else {
	            // Other selectors
	            els = (context || doc).querySelectorAll(selector.trim());
	          }
	          for (i = 0; i < els.length; i += 1) {
	            if (els[i]) { arr.push(els[i]); }
	          }
	        }
	      } else if (selector.nodeType || selector === win || selector === doc) {
	        // Node/element
	        arr.push(selector);
	      } else if (selector.length > 0 && selector[0].nodeType) {
	        // Array of elements or instance of Dom
	        for (i = 0; i < selector.length; i += 1) {
	          arr.push(selector[i]);
	        }
	      }
	    }
	    return new Dom7(arr);
	  }
	
	  $.fn = Dom7.prototype;
	  $.Class = Dom7;
	  $.Dom7 = Dom7;
	
	  function unique(arr) {
	    var uniqueArray = [];
	    for (var i = 0; i < arr.length; i += 1) {
	      if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
	    }
	    return uniqueArray;
	  }
	
	  // Classes and attributes
	  function addClass(className) {
	    if (typeof className === 'undefined') {
	      return this;
	    }
	    var classes = className.split(' ');
	    for (var i = 0; i < classes.length; i += 1) {
	      for (var j = 0; j < this.length; j += 1) {
	        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.add(classes[i]); }
	      }
	    }
	    return this;
	  }
	  function removeClass(className) {
	    var classes = className.split(' ');
	    for (var i = 0; i < classes.length; i += 1) {
	      for (var j = 0; j < this.length; j += 1) {
	        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.remove(classes[i]); }
	      }
	    }
	    return this;
	  }
	  function hasClass(className) {
	    if (!this[0]) { return false; }
	    return this[0].classList.contains(className);
	  }
	  function toggleClass(className) {
	    var classes = className.split(' ');
	    for (var i = 0; i < classes.length; i += 1) {
	      for (var j = 0; j < this.length; j += 1) {
	        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.toggle(classes[i]); }
	      }
	    }
	    return this;
	  }
	  function attr(attrs, value) {
	    var arguments$1 = arguments;
	
	    if (arguments.length === 1 && typeof attrs === 'string') {
	      // Get attr
	      if (this[0]) { return this[0].getAttribute(attrs); }
	      return undefined;
	    }
	
	    // Set attrs
	    for (var i = 0; i < this.length; i += 1) {
	      if (arguments$1.length === 2) {
	        // String
	        this[i].setAttribute(attrs, value);
	      } else {
	        // Object
	        // eslint-disable-next-line
	        for (var attrName in attrs) {
	          this[i][attrName] = attrs[attrName];
	          this[i].setAttribute(attrName, attrs[attrName]);
	        }
	      }
	    }
	    return this;
	  }
	  // eslint-disable-next-line
	  function removeAttr(attr) {
	    for (var i = 0; i < this.length; i += 1) {
	      this[i].removeAttribute(attr);
	    }
	    return this;
	  }
	  function data(key, value) {
	    var el;
	    if (typeof value === 'undefined') {
	      el = this[0];
	      // Get value
	      if (el) {
	        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
	          return el.dom7ElementDataStorage[key];
	        }
	
	        var dataKey = el.getAttribute(("data-" + key));
	        if (dataKey) {
	          return dataKey;
	        }
	        return undefined;
	      }
	      return undefined;
	    }
	
	    // Set value
	    for (var i = 0; i < this.length; i += 1) {
	      el = this[i];
	      if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
	      el.dom7ElementDataStorage[key] = value;
	    }
	    return this;
	  }
	  // Transforms
	  // eslint-disable-next-line
	  function transform(transform) {
	    for (var i = 0; i < this.length; i += 1) {
	      var elStyle = this[i].style;
	      elStyle.webkitTransform = transform;
	      elStyle.transform = transform;
	    }
	    return this;
	  }
	  function transition(duration) {
	    if (typeof duration !== 'string') {
	      duration = duration + "ms"; // eslint-disable-line
	    }
	    for (var i = 0; i < this.length; i += 1) {
	      var elStyle = this[i].style;
	      elStyle.webkitTransitionDuration = duration;
	      elStyle.transitionDuration = duration;
	    }
	    return this;
	  }
	  // Events
	  function on() {
	    var assign;
	
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	    var eventType = args[0];
	    var targetSelector = args[1];
	    var listener = args[2];
	    var capture = args[3];
	    if (typeof args[1] === 'function') {
	      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	      targetSelector = undefined;
	    }
	    if (!capture) { capture = false; }
	
	    function handleLiveEvent(e) {
	      var target = e.target;
	      if (!target) { return; }
	      var eventData = e.target.dom7EventData || [];
	      if (eventData.indexOf(e) < 0) {
	        eventData.unshift(e);
	      }
	      if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
	      else {
	        var parents = $(target).parents(); // eslint-disable-line
	        for (var k = 0; k < parents.length; k += 1) {
	          if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
	        }
	      }
	    }
	    function handleEvent(e) {
	      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
	      if (eventData.indexOf(e) < 0) {
	        eventData.unshift(e);
	      }
	      listener.apply(this, eventData);
	    }
	    var events = eventType.split(' ');
	    var j;
	    for (var i = 0; i < this.length; i += 1) {
	      var el = this[i];
	      if (!targetSelector) {
	        for (j = 0; j < events.length; j += 1) {
	          var event = events[j];
	          if (!el.dom7Listeners) { el.dom7Listeners = {}; }
	          if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
	          el.dom7Listeners[event].push({
	            listener: listener,
	            proxyListener: handleEvent,
	          });
	          el.addEventListener(event, handleEvent, capture);
	        }
	      } else {
	        // Live events
	        for (j = 0; j < events.length; j += 1) {
	          var event$1 = events[j];
	          if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
	          if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
	          el.dom7LiveListeners[event$1].push({
	            listener: listener,
	            proxyListener: handleLiveEvent,
	          });
	          el.addEventListener(event$1, handleLiveEvent, capture);
	        }
	      }
	    }
	    return this;
	  }
	  function off() {
	    var assign;
	
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	    var eventType = args[0];
	    var targetSelector = args[1];
	    var listener = args[2];
	    var capture = args[3];
	    if (typeof args[1] === 'function') {
	      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	      targetSelector = undefined;
	    }
	    if (!capture) { capture = false; }
	
	    var events = eventType.split(' ');
	    for (var i = 0; i < events.length; i += 1) {
	      var event = events[i];
	      for (var j = 0; j < this.length; j += 1) {
	        var el = this[j];
	        var handlers = (void 0);
	        if (!targetSelector && el.dom7Listeners) {
	          handlers = el.dom7Listeners[event];
	        } else if (targetSelector && el.dom7LiveListeners) {
	          handlers = el.dom7LiveListeners[event];
	        }
	        if (handlers && handlers.length) {
	          for (var k = handlers.length - 1; k >= 0; k -= 1) {
	            var handler = handlers[k];
	            if (listener && handler.listener === listener) {
	              el.removeEventListener(event, handler.proxyListener, capture);
	              handlers.splice(k, 1);
	            } else if (!listener) {
	              el.removeEventListener(event, handler.proxyListener, capture);
	              handlers.splice(k, 1);
	            }
	          }
	        }
	      }
	    }
	    return this;
	  }
	  function trigger() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var events = args[0].split(' ');
	    var eventData = args[1];
	    for (var i = 0; i < events.length; i += 1) {
	      var event = events[i];
	      for (var j = 0; j < this.length; j += 1) {
	        var el = this[j];
	        var evt = (void 0);
	        try {
	          evt = new win.CustomEvent(event, {
	            detail: eventData,
	            bubbles: true,
	            cancelable: true,
	          });
	        } catch (e) {
	          evt = doc.createEvent('Event');
	          evt.initEvent(event, true, true);
	          evt.detail = eventData;
	        }
	        // eslint-disable-next-line
	        el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
	        el.dispatchEvent(evt);
	        el.dom7EventData = [];
	        delete el.dom7EventData;
	      }
	    }
	    return this;
	  }
	  function transitionEnd(callback) {
	    var events = ['webkitTransitionEnd', 'transitionend'];
	    var dom = this;
	    var i;
	    function fireCallBack(e) {
	      /* jshint validthis:true */
	      if (e.target !== this) { return; }
	      callback.call(this, e);
	      for (i = 0; i < events.length; i += 1) {
	        dom.off(events[i], fireCallBack);
	      }
	    }
	    if (callback) {
	      for (i = 0; i < events.length; i += 1) {
	        dom.on(events[i], fireCallBack);
	      }
	    }
	    return this;
	  }
	  function outerWidth(includeMargins) {
	    if (this.length > 0) {
	      if (includeMargins) {
	        // eslint-disable-next-line
	        var styles = this.styles();
	        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
	      }
	      return this[0].offsetWidth;
	    }
	    return null;
	  }
	  function outerHeight(includeMargins) {
	    if (this.length > 0) {
	      if (includeMargins) {
	        // eslint-disable-next-line
	        var styles = this.styles();
	        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
	      }
	      return this[0].offsetHeight;
	    }
	    return null;
	  }
	  function offset() {
	    if (this.length > 0) {
	      var el = this[0];
	      var box = el.getBoundingClientRect();
	      var body = doc.body;
	      var clientTop = el.clientTop || body.clientTop || 0;
	      var clientLeft = el.clientLeft || body.clientLeft || 0;
	      var scrollTop = el === win ? win.scrollY : el.scrollTop;
	      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
	      return {
	        top: (box.top + scrollTop) - clientTop,
	        left: (box.left + scrollLeft) - clientLeft,
	      };
	    }
	
	    return null;
	  }
	  function styles() {
	    if (this[0]) { return win.getComputedStyle(this[0], null); }
	    return {};
	  }
	  function css(props, value) {
	    var i;
	    if (arguments.length === 1) {
	      if (typeof props === 'string') {
	        if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
	      } else {
	        for (i = 0; i < this.length; i += 1) {
	          // eslint-disable-next-line
	          for (var prop in props) {
	            this[i].style[prop] = props[prop];
	          }
	        }
	        return this;
	      }
	    }
	    if (arguments.length === 2 && typeof props === 'string') {
	      for (i = 0; i < this.length; i += 1) {
	        this[i].style[props] = value;
	      }
	      return this;
	    }
	    return this;
	  }
	  // Iterate over the collection passing elements to `callback`
	  function each(callback) {
	    // Don't bother continuing without a callback
	    if (!callback) { return this; }
	    // Iterate over the current collection
	    for (var i = 0; i < this.length; i += 1) {
	      // If the callback returns false
	      if (callback.call(this[i], i, this[i]) === false) {
	        // End the loop early
	        return this;
	      }
	    }
	    // Return `this` to allow chained DOM operations
	    return this;
	  }
	  // eslint-disable-next-line
	  function html(html) {
	    if (typeof html === 'undefined') {
	      return this[0] ? this[0].innerHTML : undefined;
	    }
	
	    for (var i = 0; i < this.length; i += 1) {
	      this[i].innerHTML = html;
	    }
	    return this;
	  }
	  // eslint-disable-next-line
	  function text(text) {
	    if (typeof text === 'undefined') {
	      if (this[0]) {
	        return this[0].textContent.trim();
	      }
	      return null;
	    }
	
	    for (var i = 0; i < this.length; i += 1) {
	      this[i].textContent = text;
	    }
	    return this;
	  }
	  function is(selector) {
	    var el = this[0];
	    var compareWith;
	    var i;
	    if (!el || typeof selector === 'undefined') { return false; }
	    if (typeof selector === 'string') {
	      if (el.matches) { return el.matches(selector); }
	      else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
	      else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }
	
	      compareWith = $(selector);
	      for (i = 0; i < compareWith.length; i += 1) {
	        if (compareWith[i] === el) { return true; }
	      }
	      return false;
	    } else if (selector === doc) { return el === doc; }
	    else if (selector === win) { return el === win; }
	
	    if (selector.nodeType || selector instanceof Dom7) {
	      compareWith = selector.nodeType ? [selector] : selector;
	      for (i = 0; i < compareWith.length; i += 1) {
	        if (compareWith[i] === el) { return true; }
	      }
	      return false;
	    }
	    return false;
	  }
	  function index() {
	    var child = this[0];
	    var i;
	    if (child) {
	      i = 0;
	      // eslint-disable-next-line
	      while ((child = child.previousSibling) !== null) {
	        if (child.nodeType === 1) { i += 1; }
	      }
	      return i;
	    }
	    return undefined;
	  }
	  // eslint-disable-next-line
	  function eq(index) {
	    if (typeof index === 'undefined') { return this; }
	    var length = this.length;
	    var returnIndex;
	    if (index > length - 1) {
	      return new Dom7([]);
	    }
	    if (index < 0) {
	      returnIndex = length + index;
	      if (returnIndex < 0) { return new Dom7([]); }
	      return new Dom7([this[returnIndex]]);
	    }
	    return new Dom7([this[index]]);
	  }
	  function append() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var newChild;
	
	    for (var k = 0; k < args.length; k += 1) {
	      newChild = args[k];
	      for (var i = 0; i < this.length; i += 1) {
	        if (typeof newChild === 'string') {
	          var tempDiv = doc.createElement('div');
	          tempDiv.innerHTML = newChild;
	          while (tempDiv.firstChild) {
	            this[i].appendChild(tempDiv.firstChild);
	          }
	        } else if (newChild instanceof Dom7) {
	          for (var j = 0; j < newChild.length; j += 1) {
	            this[i].appendChild(newChild[j]);
	          }
	        } else {
	          this[i].appendChild(newChild);
	        }
	      }
	    }
	
	    return this;
	  }
	  function prepend(newChild) {
	    var i;
	    var j;
	    for (i = 0; i < this.length; i += 1) {
	      if (typeof newChild === 'string') {
	        var tempDiv = doc.createElement('div');
	        tempDiv.innerHTML = newChild;
	        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	        }
	      } else if (newChild instanceof Dom7) {
	        for (j = 0; j < newChild.length; j += 1) {
	          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	        }
	      } else {
	        this[i].insertBefore(newChild, this[i].childNodes[0]);
	      }
	    }
	    return this;
	  }
	  function next(selector) {
	    if (this.length > 0) {
	      if (selector) {
	        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
	          return new Dom7([this[0].nextElementSibling]);
	        }
	        return new Dom7([]);
	      }
	
	      if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
	      return new Dom7([]);
	    }
	    return new Dom7([]);
	  }
	  function nextAll(selector) {
	    var nextEls = [];
	    var el = this[0];
	    if (!el) { return new Dom7([]); }
	    while (el.nextElementSibling) {
	      var next = el.nextElementSibling; // eslint-disable-line
	      if (selector) {
	        if ($(next).is(selector)) { nextEls.push(next); }
	      } else { nextEls.push(next); }
	      el = next;
	    }
	    return new Dom7(nextEls);
	  }
	  function prev(selector) {
	    if (this.length > 0) {
	      var el = this[0];
	      if (selector) {
	        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
	          return new Dom7([el.previousElementSibling]);
	        }
	        return new Dom7([]);
	      }
	
	      if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
	      return new Dom7([]);
	    }
	    return new Dom7([]);
	  }
	  function prevAll(selector) {
	    var prevEls = [];
	    var el = this[0];
	    if (!el) { return new Dom7([]); }
	    while (el.previousElementSibling) {
	      var prev = el.previousElementSibling; // eslint-disable-line
	      if (selector) {
	        if ($(prev).is(selector)) { prevEls.push(prev); }
	      } else { prevEls.push(prev); }
	      el = prev;
	    }
	    return new Dom7(prevEls);
	  }
	  function parent(selector) {
	    var parents = []; // eslint-disable-line
	    for (var i = 0; i < this.length; i += 1) {
	      if (this[i].parentNode !== null) {
	        if (selector) {
	          if ($(this[i].parentNode).is(selector)) { parents.push(this[i].parentNode); }
	        } else {
	          parents.push(this[i].parentNode);
	        }
	      }
	    }
	    return $(unique(parents));
	  }
	  function parents(selector) {
	    var parents = []; // eslint-disable-line
	    for (var i = 0; i < this.length; i += 1) {
	      var parent = this[i].parentNode; // eslint-disable-line
	      while (parent) {
	        if (selector) {
	          if ($(parent).is(selector)) { parents.push(parent); }
	        } else {
	          parents.push(parent);
	        }
	        parent = parent.parentNode;
	      }
	    }
	    return $(unique(parents));
	  }
	  function closest(selector) {
	    var closest = this; // eslint-disable-line
	    if (typeof selector === 'undefined') {
	      return new Dom7([]);
	    }
	    if (!closest.is(selector)) {
	      closest = closest.parents(selector).eq(0);
	    }
	    return closest;
	  }
	  function find(selector) {
	    var foundElements = [];
	    for (var i = 0; i < this.length; i += 1) {
	      var found = this[i].querySelectorAll(selector);
	      for (var j = 0; j < found.length; j += 1) {
	        foundElements.push(found[j]);
	      }
	    }
	    return new Dom7(foundElements);
	  }
	  function children(selector) {
	    var children = []; // eslint-disable-line
	    for (var i = 0; i < this.length; i += 1) {
	      var childNodes = this[i].childNodes;
	
	      for (var j = 0; j < childNodes.length; j += 1) {
	        if (!selector) {
	          if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
	        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
	          children.push(childNodes[j]);
	        }
	      }
	    }
	    return new Dom7(unique(children));
	  }
	  function remove() {
	    for (var i = 0; i < this.length; i += 1) {
	      if (this[i].parentNode) { this[i].parentNode.removeChild(this[i]); }
	    }
	    return this;
	  }
	  function add() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var dom = this;
	    var i;
	    var j;
	    for (i = 0; i < args.length; i += 1) {
	      var toAdd = $(args[i]);
	      for (j = 0; j < toAdd.length; j += 1) {
	        dom[dom.length] = toAdd[j];
	        dom.length += 1;
	      }
	    }
	    return dom;
	  }
	
	  var Methods = {
	    addClass: addClass,
	    removeClass: removeClass,
	    hasClass: hasClass,
	    toggleClass: toggleClass,
	    attr: attr,
	    removeAttr: removeAttr,
	    data: data,
	    transform: transform,
	    transition: transition,
	    on: on,
	    off: off,
	    trigger: trigger,
	    transitionEnd: transitionEnd,
	    outerWidth: outerWidth,
	    outerHeight: outerHeight,
	    offset: offset,
	    css: css,
	    each: each,
	    html: html,
	    text: text,
	    is: is,
	    index: index,
	    eq: eq,
	    append: append,
	    prepend: prepend,
	    next: next,
	    nextAll: nextAll,
	    prev: prev,
	    prevAll: prevAll,
	    parent: parent,
	    parents: parents,
	    closest: closest,
	    find: find,
	    children: children,
	    remove: remove,
	    add: add,
	    styles: styles,
	  };
	
	  Object.keys(Methods).forEach(function (methodName) {
	    $.fn[methodName] = Methods[methodName];
	  });
	
	  var Utils = {
	    deleteProps: function deleteProps(obj) {
	      var object = obj;
	      Object.keys(object).forEach(function (key) {
	        try {
	          object[key] = null;
	        } catch (e) {
	          // no getter for object
	        }
	        try {
	          delete object[key];
	        } catch (e) {
	          // something got wrong
	        }
	      });
	    },
	    nextTick: function nextTick(callback, delay) {
	      if ( delay === void 0 ) delay = 0;
	
	      return setTimeout(callback, delay);
	    },
	    now: function now() {
	      return Date.now();
	    },
	    getTranslate: function getTranslate(el, axis) {
	      if ( axis === void 0 ) axis = 'x';
	
	      var matrix;
	      var curTransform;
	      var transformMatrix;
	
	      var curStyle = win.getComputedStyle(el, null);
	
	      if (win.WebKitCSSMatrix) {
	        curTransform = curStyle.transform || curStyle.webkitTransform;
	        if (curTransform.split(',').length > 6) {
	          curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
	        }
	        // Some old versions of Webkit choke when 'none' is passed; pass
	        // empty string instead in this case
	        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	      } else {
	        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	        matrix = transformMatrix.toString().split(',');
	      }
	
	      if (axis === 'x') {
	        // Latest Chrome and webkits Fix
	        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
	        // Crazy IE10 Matrix
	        else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
	        // Normal Browsers
	        else { curTransform = parseFloat(matrix[4]); }
	      }
	      if (axis === 'y') {
	        // Latest Chrome and webkits Fix
	        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
	        // Crazy IE10 Matrix
	        else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
	        // Normal Browsers
	        else { curTransform = parseFloat(matrix[5]); }
	      }
	      return curTransform || 0;
	    },
	    parseUrlQuery: function parseUrlQuery(url) {
	      var query = {};
	      var urlToParse = url || win.location.href;
	      var i;
	      var params;
	      var param;
	      var length;
	      if (typeof urlToParse === 'string' && urlToParse.length) {
	        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
	        params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
	        length = params.length;
	
	        for (i = 0; i < length; i += 1) {
	          param = params[i].replace(/#\S+/g, '').split('=');
	          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
	        }
	      }
	      return query;
	    },
	    isObject: function isObject(o) {
	      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
	    },
	    extend: function extend() {
	      var args = [], len$1 = arguments.length;
	      while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];
	
	      var to = Object(args[0]);
	      for (var i = 1; i < args.length; i += 1) {
	        var nextSource = args[i];
	        if (nextSource !== undefined && nextSource !== null) {
	          var keysArray = Object.keys(Object(nextSource));
	          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	            var nextKey = keysArray[nextIndex];
	            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	            if (desc !== undefined && desc.enumerable) {
	              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	                Utils.extend(to[nextKey], nextSource[nextKey]);
	              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	                to[nextKey] = {};
	                Utils.extend(to[nextKey], nextSource[nextKey]);
	              } else {
	                to[nextKey] = nextSource[nextKey];
	              }
	            }
	          }
	        }
	      }
	      return to;
	    },
	  };
	
	  var Support = (function Support() {
	    var testDiv = doc.createElement('div');
	    return {
	      touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
	        return !!((win.navigator.maxTouchPoints > 0) || ('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
	      }()),
	
	      pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent || ('maxTouchPoints' in win.navigator)),
	      prefixedPointerEvents: !!win.navigator.msPointerEnabled,
	
	      transition: (function checkTransition() {
	        var style = testDiv.style;
	        return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
	      }()),
	      transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
	        var style = testDiv.style;
	        return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
	      }()),
	
	      flexbox: (function checkFlexbox() {
	        var style = testDiv.style;
	        var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
	        for (var i = 0; i < styles.length; i += 1) {
	          if (styles[i] in style) { return true; }
	        }
	        return false;
	      }()),
	
	      observer: (function checkObserver() {
	        return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
	      }()),
	
	      passiveListener: (function checkPassiveListener() {
	        var supportsPassive = false;
	        try {
	          var opts = Object.defineProperty({}, 'passive', {
	            // eslint-disable-next-line
	            get: function get() {
	              supportsPassive = true;
	            },
	          });
	          win.addEventListener('testPassiveListener', null, opts);
	        } catch (e) {
	          // No support
	        }
	        return supportsPassive;
	      }()),
	
	      gestures: (function checkGestures() {
	        return 'ongesturestart' in win;
	      }()),
	    };
	  }());
	
	  var SwiperClass = function SwiperClass(params) {
	    if ( params === void 0 ) params = {};
	
	    var self = this;
	    self.params = params;
	
	    // Events
	    self.eventsListeners = {};
	
	    if (self.params && self.params.on) {
	      Object.keys(self.params.on).forEach(function (eventName) {
	        self.on(eventName, self.params.on[eventName]);
	      });
	    }
	  };
	
	  var staticAccessors = { components: { configurable: true } };
	
	  SwiperClass.prototype.on = function on (events, handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') { return self; }
	    var method = priority ? 'unshift' : 'push';
	    events.split(' ').forEach(function (event) {
	      if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
	      self.eventsListeners[event][method](handler);
	    });
	    return self;
	  };
	
	  SwiperClass.prototype.once = function once (events, handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') { return self; }
	    function onceHandler() {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	      handler.apply(self, args);
	      self.off(events, onceHandler);
	    }
	    return self.on(events, onceHandler, priority);
	  };
	
	  SwiperClass.prototype.off = function off (events, handler) {
	    var self = this;
	    if (!self.eventsListeners) { return self; }
	    events.split(' ').forEach(function (event) {
	      if (typeof handler === 'undefined') {
	        self.eventsListeners[event] = [];
	      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
	        self.eventsListeners[event].forEach(function (eventHandler, index) {
	          if (eventHandler === handler) {
	            self.eventsListeners[event].splice(index, 1);
	          }
	        });
	      }
	    });
	    return self;
	  };
	
	  SwiperClass.prototype.emit = function emit () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	    var self = this;
	    if (!self.eventsListeners) { return self; }
	    var events;
	    var data;
	    var context;
	    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	      events = args[0];
	      data = args.slice(1, args.length);
	      context = self;
	    } else {
	      events = args[0].events;
	      data = args[0].data;
	      context = args[0].context || self;
	    }
	    var eventsArray = Array.isArray(events) ? events : events.split(' ');
	    eventsArray.forEach(function (event) {
	      if (self.eventsListeners && self.eventsListeners[event]) {
	        var handlers = [];
	        self.eventsListeners[event].forEach(function (eventHandler) {
	          handlers.push(eventHandler);
	        });
	        handlers.forEach(function (eventHandler) {
	          eventHandler.apply(context, data);
	        });
	      }
	    });
	    return self;
	  };
	
	  SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
	    var instance = this;
	    if (!instance.modules) { return; }
	    Object.keys(instance.modules).forEach(function (moduleName) {
	      var module = instance.modules[moduleName];
	      // Extend params
	      if (module.params) {
	        Utils.extend(instanceParams, module.params);
	      }
	    });
	  };
	
	  SwiperClass.prototype.useModules = function useModules (modulesParams) {
	      if ( modulesParams === void 0 ) modulesParams = {};
	
	    var instance = this;
	    if (!instance.modules) { return; }
	    Object.keys(instance.modules).forEach(function (moduleName) {
	      var module = instance.modules[moduleName];
	      var moduleParams = modulesParams[moduleName] || {};
	      // Extend instance methods and props
	      if (module.instance) {
	        Object.keys(module.instance).forEach(function (modulePropName) {
	          var moduleProp = module.instance[modulePropName];
	          if (typeof moduleProp === 'function') {
	            instance[modulePropName] = moduleProp.bind(instance);
	          } else {
	            instance[modulePropName] = moduleProp;
	          }
	        });
	      }
	      // Add event listeners
	      if (module.on && instance.on) {
	        Object.keys(module.on).forEach(function (moduleEventName) {
	          instance.on(moduleEventName, module.on[moduleEventName]);
	        });
	      }
	
	      // Module create callback
	      if (module.create) {
	        module.create.bind(instance)(moduleParams);
	      }
	    });
	  };
	
	  staticAccessors.components.set = function (components) {
	    var Class = this;
	    if (!Class.use) { return; }
	    Class.use(components);
	  };
	
	  SwiperClass.installModule = function installModule (module) {
	      var params = [], len = arguments.length - 1;
	      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];
	
	    var Class = this;
	    if (!Class.prototype.modules) { Class.prototype.modules = {}; }
	    var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
	    Class.prototype.modules[name] = module;
	    // Prototype
	    if (module.proto) {
	      Object.keys(module.proto).forEach(function (key) {
	        Class.prototype[key] = module.proto[key];
	      });
	    }
	    // Class
	    if (module.static) {
	      Object.keys(module.static).forEach(function (key) {
	        Class[key] = module.static[key];
	      });
	    }
	    // Callback
	    if (module.install) {
	      module.install.apply(Class, params);
	    }
	    return Class;
	  };
	
	  SwiperClass.use = function use (module) {
	      var params = [], len = arguments.length - 1;
	      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];
	
	    var Class = this;
	    if (Array.isArray(module)) {
	      module.forEach(function (m) { return Class.installModule(m); });
	      return Class;
	    }
	    return Class.installModule.apply(Class, [ module ].concat( params ));
	  };
	
	  Object.defineProperties( SwiperClass, staticAccessors );
	
	  function updateSize () {
	    var swiper = this;
	    var width;
	    var height;
	    var $el = swiper.$el;
	    if (typeof swiper.params.width !== 'undefined') {
	      width = swiper.params.width;
	    } else {
	      width = $el[0].clientWidth;
	    }
	    if (typeof swiper.params.height !== 'undefined') {
	      height = swiper.params.height;
	    } else {
	      height = $el[0].clientHeight;
	    }
	    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
	      return;
	    }
	
	    // Subtract paddings
	    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
	    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);
	
	    Utils.extend(swiper, {
	      width: width,
	      height: height,
	      size: swiper.isHorizontal() ? width : height,
	    });
	  }
	
	  function updateSlides () {
	    var swiper = this;
	    var params = swiper.params;
	
	    var $wrapperEl = swiper.$wrapperEl;
	    var swiperSize = swiper.size;
	    var rtl = swiper.rtlTranslate;
	    var wrongRTL = swiper.wrongRTL;
	    var isVirtual = swiper.virtual && params.virtual.enabled;
	    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
	    var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
	    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	    var snapGrid = [];
	    var slidesGrid = [];
	    var slidesSizesGrid = [];
	
	    var offsetBefore = params.slidesOffsetBefore;
	    if (typeof offsetBefore === 'function') {
	      offsetBefore = params.slidesOffsetBefore.call(swiper);
	    }
	
	    var offsetAfter = params.slidesOffsetAfter;
	    if (typeof offsetAfter === 'function') {
	      offsetAfter = params.slidesOffsetAfter.call(swiper);
	    }
	
	    var previousSnapGridLength = swiper.snapGrid.length;
	    var previousSlidesGridLength = swiper.snapGrid.length;
	
	    var spaceBetween = params.spaceBetween;
	    var slidePosition = -offsetBefore;
	    var prevSlideSize = 0;
	    var index = 0;
	    if (typeof swiperSize === 'undefined') {
	      return;
	    }
	    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	      spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
	    }
	
	    swiper.virtualSize = -spaceBetween;
	
	    // reset margins
	    if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
	    else { slides.css({ marginRight: '', marginBottom: '' }); }
	
	    var slidesNumberEvenToRows;
	    if (params.slidesPerColumn > 1) {
	      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
	        slidesNumberEvenToRows = slidesLength;
	      } else {
	        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
	      }
	      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
	        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
	      }
	    }
	
	    // Calc slides
	    var slideSize;
	    var slidesPerColumn = params.slidesPerColumn;
	    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
	    for (var i = 0; i < slidesLength; i += 1) {
	      slideSize = 0;
	      var slide = slides.eq(i);
	      if (params.slidesPerColumn > 1) {
	        // Set slides order
	        var newSlideOrderIndex = (void 0);
	        var column = (void 0);
	        var row = (void 0);
	        if (params.slidesPerColumnFill === 'column') {
	          column = Math.floor(i / slidesPerColumn);
	          row = i - (column * slidesPerColumn);
	          if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
	            row += 1;
	            if (row >= slidesPerColumn) {
	              row = 0;
	              column += 1;
	            }
	          }
	          newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
	          slide
	            .css({
	              '-webkit-box-ordinal-group': newSlideOrderIndex,
	              '-moz-box-ordinal-group': newSlideOrderIndex,
	              '-ms-flex-order': newSlideOrderIndex,
	              '-webkit-order': newSlideOrderIndex,
	              order: newSlideOrderIndex,
	            });
	        } else {
	          row = Math.floor(i / slidesPerRow);
	          column = i - (row * slidesPerRow);
	        }
	        slide
	          .css(
	            ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
	            (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
	          )
	          .attr('data-swiper-column', column)
	          .attr('data-swiper-row', row);
	      }
	      if (slide.css('display') === 'none') { continue; } // eslint-disable-line
	
	      if (params.slidesPerView === 'auto') {
	        var slideStyles = win.getComputedStyle(slide[0], null);
	        var currentTransform = slide[0].style.transform;
	        var currentWebKitTransform = slide[0].style.webkitTransform;
	        if (currentTransform) {
	          slide[0].style.transform = 'none';
	        }
	        if (currentWebKitTransform) {
	          slide[0].style.webkitTransform = 'none';
	        }
	        if (params.roundLengths) {
	          slideSize = swiper.isHorizontal()
	            ? slide.outerWidth(true)
	            : slide.outerHeight(true);
	        } else {
	          // eslint-disable-next-line
	          if (swiper.isHorizontal()) {
	            var width = parseFloat(slideStyles.getPropertyValue('width'));
	            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
	            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
	            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
	            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
	            var boxSizing = slideStyles.getPropertyValue('box-sizing');
	            if (boxSizing && boxSizing === 'border-box') {
	              slideSize = width + marginLeft + marginRight;
	            } else {
	              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
	            }
	          } else {
	            var height = parseFloat(slideStyles.getPropertyValue('height'));
	            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
	            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
	            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
	            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
	            var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
	            if (boxSizing$1 && boxSizing$1 === 'border-box') {
	              slideSize = height + marginTop + marginBottom;
	            } else {
	              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
	            }
	          }
	        }
	        if (currentTransform) {
	          slide[0].style.transform = currentTransform;
	        }
	        if (currentWebKitTransform) {
	          slide[0].style.webkitTransform = currentWebKitTransform;
	        }
	        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
	      } else {
	        slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
	        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
	
	        if (slides[i]) {
	          if (swiper.isHorizontal()) {
	            slides[i].style.width = slideSize + "px";
	          } else {
	            slides[i].style.height = slideSize + "px";
	          }
	        }
	      }
	      if (slides[i]) {
	        slides[i].swiperSlideSize = slideSize;
	      }
	      slidesSizesGrid.push(slideSize);
	
	
	      if (params.centeredSlides) {
	        slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
	        if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	        if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	        if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
	        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
	        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	        slidesGrid.push(slidePosition);
	      } else {
	        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
	        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	        slidesGrid.push(slidePosition);
	        slidePosition = slidePosition + slideSize + spaceBetween;
	      }
	
	      swiper.virtualSize += slideSize + spaceBetween;
	
	      prevSlideSize = slideSize;
	
	      index += 1;
	    }
	    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	    var newSlidesGrid;
	
	    if (
	      rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	      $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
	    }
	    if (!Support.flexbox || params.setWrapperSize) {
	      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	    }
	
	    if (params.slidesPerColumn > 1) {
	      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
	      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
	      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	      if (params.centeredSlides) {
	        newSlidesGrid = [];
	        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
	          var slidesGridItem = snapGrid[i$1];
	          if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
	          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
	        }
	        snapGrid = newSlidesGrid;
	      }
	    }
	
	    // Remove last grid elements depending on width
	    if (!params.centeredSlides) {
	      newSlidesGrid = [];
	      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
	        var slidesGridItem$1 = snapGrid[i$2];
	        if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
	        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
	          newSlidesGrid.push(slidesGridItem$1);
	        }
	      }
	      snapGrid = newSlidesGrid;
	      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	        snapGrid.push(swiper.virtualSize - swiperSize);
	      }
	    }
	    if (snapGrid.length === 0) { snapGrid = [0]; }
	
	    if (params.spaceBetween !== 0) {
	      if (swiper.isHorizontal()) {
	        if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
	        else { slides.css({ marginRight: (spaceBetween + "px") }); }
	      } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
	    }
	
	    if (params.centerInsufficientSlides) {
	      var allSlidesSize = 0;
	      slidesSizesGrid.forEach(function (slideSizeValue) {
	        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	      });
	      allSlidesSize -= params.spaceBetween;
	      if (allSlidesSize < swiperSize) {
	        var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
	        snapGrid.forEach(function (snap, snapIndex) {
	          snapGrid[snapIndex] = snap - allSlidesOffset;
	        });
	        slidesGrid.forEach(function (snap, snapIndex) {
	          slidesGrid[snapIndex] = snap + allSlidesOffset;
	        });
	      }
	    }
	
	    Utils.extend(swiper, {
	      slides: slides,
	      snapGrid: snapGrid,
	      slidesGrid: slidesGrid,
	      slidesSizesGrid: slidesSizesGrid,
	    });
	
	    if (slidesLength !== previousSlidesLength) {
	      swiper.emit('slidesLengthChange');
	    }
	    if (snapGrid.length !== previousSnapGridLength) {
	      if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
	      swiper.emit('snapGridLengthChange');
	    }
	    if (slidesGrid.length !== previousSlidesGridLength) {
	      swiper.emit('slidesGridLengthChange');
	    }
	
	    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
	      swiper.updateSlidesOffset();
	    }
	  }
	
	  function updateAutoHeight (speed) {
	    var swiper = this;
	    var activeSlides = [];
	    var newHeight = 0;
	    var i;
	    if (typeof speed === 'number') {
	      swiper.setTransition(speed);
	    } else if (speed === true) {
	      swiper.setTransition(swiper.params.speed);
	    }
	    // Find slides currently in view
	    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	        var index = swiper.activeIndex + i;
	        if (index > swiper.slides.length) { break; }
	        activeSlides.push(swiper.slides.eq(index)[0]);
	      }
	    } else {
	      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
	    }
	
	    // Find new height from highest slide in view
	    for (i = 0; i < activeSlides.length; i += 1) {
	      if (typeof activeSlides[i] !== 'undefined') {
	        var height = activeSlides[i].offsetHeight;
	        newHeight = height > newHeight ? height : newHeight;
	      }
	    }
	
	    // Update Height
	    if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
	  }
	
	  function updateSlidesOffset () {
	    var swiper = this;
	    var slides = swiper.slides;
	    for (var i = 0; i < slides.length; i += 1) {
	      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	    }
	  }
	
	  function updateSlidesProgress (translate) {
	    if ( translate === void 0 ) translate = (this && this.translate) || 0;
	
	    var swiper = this;
	    var params = swiper.params;
	
	    var slides = swiper.slides;
	    var rtl = swiper.rtlTranslate;
	
	    if (slides.length === 0) { return; }
	    if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }
	
	    var offsetCenter = -translate;
	    if (rtl) { offsetCenter = translate; }
	
	    // Visible Slides
	    slides.removeClass(params.slideVisibleClass);
	
	    swiper.visibleSlidesIndexes = [];
	    swiper.visibleSlides = [];
	
	    for (var i = 0; i < slides.length; i += 1) {
	      var slide = slides[i];
	      var slideProgress = (
	        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
	      ) / (slide.swiperSlideSize + params.spaceBetween);
	      if (params.watchSlidesVisibility) {
	        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	        var isVisible = (slideBefore >= 0 && slideBefore < swiper.size)
	                  || (slideAfter > 0 && slideAfter <= swiper.size)
	                  || (slideBefore <= 0 && slideAfter >= swiper.size);
	        if (isVisible) {
	          swiper.visibleSlides.push(slide);
	          swiper.visibleSlidesIndexes.push(i);
	          slides.eq(i).addClass(params.slideVisibleClass);
	        }
	      }
	      slide.progress = rtl ? -slideProgress : slideProgress;
	    }
	    swiper.visibleSlides = $(swiper.visibleSlides);
	  }
	
	  function updateProgress (translate) {
	    if ( translate === void 0 ) translate = (this && this.translate) || 0;
	
	    var swiper = this;
	    var params = swiper.params;
	
	    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	    var progress = swiper.progress;
	    var isBeginning = swiper.isBeginning;
	    var isEnd = swiper.isEnd;
	    var wasBeginning = isBeginning;
	    var wasEnd = isEnd;
	    if (translatesDiff === 0) {
	      progress = 0;
	      isBeginning = true;
	      isEnd = true;
	    } else {
	      progress = (translate - swiper.minTranslate()) / (translatesDiff);
	      isBeginning = progress <= 0;
	      isEnd = progress >= 1;
	    }
	    Utils.extend(swiper, {
	      progress: progress,
	      isBeginning: isBeginning,
	      isEnd: isEnd,
	    });
	
	    if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }
	
	    if (isBeginning && !wasBeginning) {
	      swiper.emit('reachBeginning toEdge');
	    }
	    if (isEnd && !wasEnd) {
	      swiper.emit('reachEnd toEdge');
	    }
	    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
	      swiper.emit('fromEdge');
	    }
	
	    swiper.emit('progress', progress);
	  }
	
	  function updateSlidesClasses () {
	    var swiper = this;
	
	    var slides = swiper.slides;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	    var activeIndex = swiper.activeIndex;
	    var realIndex = swiper.realIndex;
	    var isVirtual = swiper.virtual && params.virtual.enabled;
	
	    slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));
	
	    var activeSlide;
	    if (isVirtual) {
	      activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
	    } else {
	      activeSlide = slides.eq(activeIndex);
	    }
	
	    // Active classes
	    activeSlide.addClass(params.slideActiveClass);
	
	    if (params.loop) {
	      // Duplicate to all looped slides
	      if (activeSlide.hasClass(params.slideDuplicateClass)) {
	        $wrapperEl
	          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
	          .addClass(params.slideDuplicateActiveClass);
	      } else {
	        $wrapperEl
	          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
	          .addClass(params.slideDuplicateActiveClass);
	      }
	    }
	    // Next Slide
	    var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
	    if (params.loop && nextSlide.length === 0) {
	      nextSlide = slides.eq(0);
	      nextSlide.addClass(params.slideNextClass);
	    }
	    // Prev Slide
	    var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
	    if (params.loop && prevSlide.length === 0) {
	      prevSlide = slides.eq(-1);
	      prevSlide.addClass(params.slidePrevClass);
	    }
	    if (params.loop) {
	      // Duplicate to all looped slides
	      if (nextSlide.hasClass(params.slideDuplicateClass)) {
	        $wrapperEl
	          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	          .addClass(params.slideDuplicateNextClass);
	      } else {
	        $wrapperEl
	          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	          .addClass(params.slideDuplicateNextClass);
	      }
	      if (prevSlide.hasClass(params.slideDuplicateClass)) {
	        $wrapperEl
	          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	          .addClass(params.slideDuplicatePrevClass);
	      } else {
	        $wrapperEl
	          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	          .addClass(params.slideDuplicatePrevClass);
	      }
	    }
	  }
	
	  function updateActiveIndex (newActiveIndex) {
	    var swiper = this;
	    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	    var slidesGrid = swiper.slidesGrid;
	    var snapGrid = swiper.snapGrid;
	    var params = swiper.params;
	    var previousIndex = swiper.activeIndex;
	    var previousRealIndex = swiper.realIndex;
	    var previousSnapIndex = swiper.snapIndex;
	    var activeIndex = newActiveIndex;
	    var snapIndex;
	    if (typeof activeIndex === 'undefined') {
	      for (var i = 0; i < slidesGrid.length; i += 1) {
	        if (typeof slidesGrid[i + 1] !== 'undefined') {
	          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
	            activeIndex = i;
	          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	            activeIndex = i + 1;
	          }
	        } else if (translate >= slidesGrid[i]) {
	          activeIndex = i;
	        }
	      }
	      // Normalize slideIndex
	      if (params.normalizeSlideIndex) {
	        if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
	      }
	    }
	    if (snapGrid.indexOf(translate) >= 0) {
	      snapIndex = snapGrid.indexOf(translate);
	    } else {
	      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
	    }
	    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
	    if (activeIndex === previousIndex) {
	      if (snapIndex !== previousSnapIndex) {
	        swiper.snapIndex = snapIndex;
	        swiper.emit('snapIndexChange');
	      }
	      return;
	    }
	
	    // Get real index
	    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
	
	    Utils.extend(swiper, {
	      snapIndex: snapIndex,
	      realIndex: realIndex,
	      previousIndex: previousIndex,
	      activeIndex: activeIndex,
	    });
	    swiper.emit('activeIndexChange');
	    swiper.emit('snapIndexChange');
	    if (previousRealIndex !== realIndex) {
	      swiper.emit('realIndexChange');
	    }
	    swiper.emit('slideChange');
	  }
	
	  function updateClickedSlide (e) {
	    var swiper = this;
	    var params = swiper.params;
	    var slide = $(e.target).closest(("." + (params.slideClass)))[0];
	    var slideFound = false;
	    if (slide) {
	      for (var i = 0; i < swiper.slides.length; i += 1) {
	        if (swiper.slides[i] === slide) { slideFound = true; }
	      }
	    }
	
	    if (slide && slideFound) {
	      swiper.clickedSlide = slide;
	      if (swiper.virtual && swiper.params.virtual.enabled) {
	        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
	      } else {
	        swiper.clickedIndex = $(slide).index();
	      }
	    } else {
	      swiper.clickedSlide = undefined;
	      swiper.clickedIndex = undefined;
	      return;
	    }
	    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	      swiper.slideToClickedSlide();
	    }
	  }
	
	  var update = {
	    updateSize: updateSize,
	    updateSlides: updateSlides,
	    updateAutoHeight: updateAutoHeight,
	    updateSlidesOffset: updateSlidesOffset,
	    updateSlidesProgress: updateSlidesProgress,
	    updateProgress: updateProgress,
	    updateSlidesClasses: updateSlidesClasses,
	    updateActiveIndex: updateActiveIndex,
	    updateClickedSlide: updateClickedSlide,
	  };
	
	  function getTranslate (axis) {
	    if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';
	
	    var swiper = this;
	
	    var params = swiper.params;
	    var rtl = swiper.rtlTranslate;
	    var translate = swiper.translate;
	    var $wrapperEl = swiper.$wrapperEl;
	
	    if (params.virtualTranslate) {
	      return rtl ? -translate : translate;
	    }
	
	    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
	    if (rtl) { currentTranslate = -currentTranslate; }
	
	    return currentTranslate || 0;
	  }
	
	  function setTranslate (translate, byController) {
	    var swiper = this;
	    var rtl = swiper.rtlTranslate;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	    var progress = swiper.progress;
	    var x = 0;
	    var y = 0;
	    var z = 0;
	
	    if (swiper.isHorizontal()) {
	      x = rtl ? -translate : translate;
	    } else {
	      y = translate;
	    }
	
	    if (params.roundLengths) {
	      x = Math.floor(x);
	      y = Math.floor(y);
	    }
	
	    if (!params.virtualTranslate) {
	      if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
	      else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
	    }
	    swiper.previousTranslate = swiper.translate;
	    swiper.translate = swiper.isHorizontal() ? x : y;
	
	    // Check if we need to update progress
	    var newProgress;
	    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	    if (translatesDiff === 0) {
	      newProgress = 0;
	    } else {
	      newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
	    }
	    if (newProgress !== progress) {
	      swiper.updateProgress(translate);
	    }
	
	    swiper.emit('setTranslate', swiper.translate, byController);
	  }
	
	  function minTranslate () {
	    return (-this.snapGrid[0]);
	  }
	
	  function maxTranslate () {
	    return (-this.snapGrid[this.snapGrid.length - 1]);
	  }
	
	  var translate = {
	    getTranslate: getTranslate,
	    setTranslate: setTranslate,
	    minTranslate: minTranslate,
	    maxTranslate: maxTranslate,
	  };
	
	  function setTransition (duration, byController) {
	    var swiper = this;
	
	    swiper.$wrapperEl.transition(duration);
	
	    swiper.emit('setTransition', duration, byController);
	  }
	
	  function transitionStart (runCallbacks, direction) {
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var activeIndex = swiper.activeIndex;
	    var params = swiper.params;
	    var previousIndex = swiper.previousIndex;
	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	
	    var dir = direction;
	    if (!dir) {
	      if (activeIndex > previousIndex) { dir = 'next'; }
	      else if (activeIndex < previousIndex) { dir = 'prev'; }
	      else { dir = 'reset'; }
	    }
	
	    swiper.emit('transitionStart');
	
	    if (runCallbacks && activeIndex !== previousIndex) {
	      if (dir === 'reset') {
	        swiper.emit('slideResetTransitionStart');
	        return;
	      }
	      swiper.emit('slideChangeTransitionStart');
	      if (dir === 'next') {
	        swiper.emit('slideNextTransitionStart');
	      } else {
	        swiper.emit('slidePrevTransitionStart');
	      }
	    }
	  }
	
	  function transitionEnd$1 (runCallbacks, direction) {
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var activeIndex = swiper.activeIndex;
	    var previousIndex = swiper.previousIndex;
	    swiper.animating = false;
	    swiper.setTransition(0);
	
	    var dir = direction;
	    if (!dir) {
	      if (activeIndex > previousIndex) { dir = 'next'; }
	      else if (activeIndex < previousIndex) { dir = 'prev'; }
	      else { dir = 'reset'; }
	    }
	
	    swiper.emit('transitionEnd');
	
	    if (runCallbacks && activeIndex !== previousIndex) {
	      if (dir === 'reset') {
	        swiper.emit('slideResetTransitionEnd');
	        return;
	      }
	      swiper.emit('slideChangeTransitionEnd');
	      if (dir === 'next') {
	        swiper.emit('slideNextTransitionEnd');
	      } else {
	        swiper.emit('slidePrevTransitionEnd');
	      }
	    }
	  }
	
	  var transition$1 = {
	    setTransition: setTransition,
	    transitionStart: transitionStart,
	    transitionEnd: transitionEnd$1,
	  };
	
	  function slideTo (index, speed, runCallbacks, internal) {
	    if ( index === void 0 ) index = 0;
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var slideIndex = index;
	    if (slideIndex < 0) { slideIndex = 0; }
	
	    var params = swiper.params;
	    var snapGrid = swiper.snapGrid;
	    var slidesGrid = swiper.slidesGrid;
	    var previousIndex = swiper.previousIndex;
	    var activeIndex = swiper.activeIndex;
	    var rtl = swiper.rtlTranslate;
	    if (swiper.animating && params.preventInteractionOnTransition) {
	      return false;
	    }
	
	    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
	    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
	
	    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
	      swiper.emit('beforeSlideChangeStart');
	    }
	
	    var translate = -snapGrid[snapIndex];
	
	    // Update progress
	    swiper.updateProgress(translate);
	
	    // Normalize slideIndex
	    if (params.normalizeSlideIndex) {
	      for (var i = 0; i < slidesGrid.length; i += 1) {
	        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
	          slideIndex = i;
	        }
	      }
	    }
	    // Directions locks
	    if (swiper.initialized && slideIndex !== activeIndex) {
	      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
	        return false;
	      }
	      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	        if ((activeIndex || 0) !== slideIndex) { return false; }
	      }
	    }
	
	    var direction;
	    if (slideIndex > activeIndex) { direction = 'next'; }
	    else if (slideIndex < activeIndex) { direction = 'prev'; }
	    else { direction = 'reset'; }
	
	
	    // Update Index
	    if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
	      swiper.updateActiveIndex(slideIndex);
	      // Update Height
	      if (params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	      swiper.updateSlidesClasses();
	      if (params.effect !== 'slide') {
	        swiper.setTranslate(translate);
	      }
	      if (direction !== 'reset') {
	        swiper.transitionStart(runCallbacks, direction);
	        swiper.transitionEnd(runCallbacks, direction);
	      }
	      return false;
	    }
	
	    if (speed === 0 || !Support.transition) {
	      swiper.setTransition(0);
	      swiper.setTranslate(translate);
	      swiper.updateActiveIndex(slideIndex);
	      swiper.updateSlidesClasses();
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.transitionStart(runCallbacks, direction);
	      swiper.transitionEnd(runCallbacks, direction);
	    } else {
	      swiper.setTransition(speed);
	      swiper.setTranslate(translate);
	      swiper.updateActiveIndex(slideIndex);
	      swiper.updateSlidesClasses();
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.transitionStart(runCallbacks, direction);
	      if (!swiper.animating) {
	        swiper.animating = true;
	        if (!swiper.onSlideToWrapperTransitionEnd) {
	          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
	            if (!swiper || swiper.destroyed) { return; }
	            if (e.target !== this) { return; }
	            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	            swiper.onSlideToWrapperTransitionEnd = null;
	            delete swiper.onSlideToWrapperTransitionEnd;
	            swiper.transitionEnd(runCallbacks, direction);
	          };
	        }
	        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	      }
	    }
	
	    return true;
	  }
	
	  function slideToLoop (index, speed, runCallbacks, internal) {
	    if ( index === void 0 ) index = 0;
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var newIndex = index;
	    if (swiper.params.loop) {
	      newIndex += swiper.loopedSlides;
	    }
	
	    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
	  }
	
	  /* eslint no-unused-vars: "off" */
	  function slideNext (speed, runCallbacks, internal) {
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var params = swiper.params;
	    var animating = swiper.animating;
	    if (params.loop) {
	      if (animating) { return false; }
	      swiper.loopFix();
	      // eslint-disable-next-line
	      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
	    }
	    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
	  }
	
	  /* eslint no-unused-vars: "off" */
	  function slidePrev (speed, runCallbacks, internal) {
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var params = swiper.params;
	    var animating = swiper.animating;
	    var snapGrid = swiper.snapGrid;
	    var slidesGrid = swiper.slidesGrid;
	    var rtlTranslate = swiper.rtlTranslate;
	
	    if (params.loop) {
	      if (animating) { return false; }
	      swiper.loopFix();
	      // eslint-disable-next-line
	      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	    }
	    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
	    function normalize(val) {
	      if (val < 0) { return -Math.floor(Math.abs(val)); }
	      return Math.floor(val);
	    }
	    var normalizedTranslate = normalize(translate);
	    var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
	    var normalizedSlidesGrid = slidesGrid.map(function (val) { return normalize(val); });
	
	    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
	    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
	    var prevIndex;
	    if (typeof prevSnap !== 'undefined') {
	      prevIndex = slidesGrid.indexOf(prevSnap);
	      if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
	    }
	    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	  }
	
	  /* eslint no-unused-vars: "off" */
	  function slideReset (speed, runCallbacks, internal) {
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	  }
	
	  /* eslint no-unused-vars: "off" */
	  function slideToClosest (speed, runCallbacks, internal) {
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var index = swiper.activeIndex;
	    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);
	
	    if (snapIndex < swiper.snapGrid.length - 1) {
	      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	
	      var currentSnap = swiper.snapGrid[snapIndex];
	      var nextSnap = swiper.snapGrid[snapIndex + 1];
	
	      if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
	        index = swiper.params.slidesPerGroup;
	      }
	    }
	
	    return swiper.slideTo(index, speed, runCallbacks, internal);
	  }
	
	  function slideToClickedSlide () {
	    var swiper = this;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	
	    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	    var slideToIndex = swiper.clickedIndex;
	    var realIndex;
	    if (params.loop) {
	      if (swiper.animating) { return; }
	      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	      if (params.centeredSlides) {
	        if (
	          (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
	          || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
	        ) {
	          swiper.loopFix();
	          slideToIndex = $wrapperEl
	            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	            .eq(0)
	            .index();
	
	          Utils.nextTick(function () {
	            swiper.slideTo(slideToIndex);
	          });
	        } else {
	          swiper.slideTo(slideToIndex);
	        }
	      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	        swiper.loopFix();
	        slideToIndex = $wrapperEl
	          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	          .eq(0)
	          .index();
	
	        Utils.nextTick(function () {
	          swiper.slideTo(slideToIndex);
	        });
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    } else {
	      swiper.slideTo(slideToIndex);
	    }
	  }
	
	  var slide = {
	    slideTo: slideTo,
	    slideToLoop: slideToLoop,
	    slideNext: slideNext,
	    slidePrev: slidePrev,
	    slideReset: slideReset,
	    slideToClosest: slideToClosest,
	    slideToClickedSlide: slideToClickedSlide,
	  };
	
	  function loopCreate () {
	    var swiper = this;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	    // Remove duplicated slides
	    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();
	
	    var slides = $wrapperEl.children(("." + (params.slideClass)));
	
	    if (params.loopFillGroupWithBlank) {
	      var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
	      if (blankSlidesNum !== params.slidesPerGroup) {
	        for (var i = 0; i < blankSlidesNum; i += 1) {
	          var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
	          $wrapperEl.append(blankNode);
	        }
	        slides = $wrapperEl.children(("." + (params.slideClass)));
	      }
	    }
	
	    if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }
	
	    swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
	    swiper.loopedSlides += params.loopAdditionalSlides;
	    if (swiper.loopedSlides > slides.length) {
	      swiper.loopedSlides = slides.length;
	    }
	
	    var prependSlides = [];
	    var appendSlides = [];
	    slides.each(function (index, el) {
	      var slide = $(el);
	      if (index < swiper.loopedSlides) { appendSlides.push(el); }
	      if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
	      slide.attr('data-swiper-slide-index', index);
	    });
	    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
	      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
	    }
	    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
	      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
	    }
	  }
	
	  function loopFix () {
	    var swiper = this;
	    var params = swiper.params;
	    var activeIndex = swiper.activeIndex;
	    var slides = swiper.slides;
	    var loopedSlides = swiper.loopedSlides;
	    var allowSlidePrev = swiper.allowSlidePrev;
	    var allowSlideNext = swiper.allowSlideNext;
	    var snapGrid = swiper.snapGrid;
	    var rtl = swiper.rtlTranslate;
	    var newIndex;
	    swiper.allowSlidePrev = true;
	    swiper.allowSlideNext = true;
	
	    var snapTranslate = -snapGrid[activeIndex];
	    var diff = snapTranslate - swiper.getTranslate();
	
	
	    // Fix For Negative Oversliding
	    if (activeIndex < loopedSlides) {
	      newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
	      newIndex += loopedSlides;
	      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
	      if (slideChanged && diff !== 0) {
	        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	      }
	    } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex >= slides.length - loopedSlides)) {
	      // Fix For Positive Oversliding
	      newIndex = -slides.length + activeIndex + loopedSlides;
	      newIndex += loopedSlides;
	      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
	      if (slideChanged$1 && diff !== 0) {
	        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	      }
	    }
	    swiper.allowSlidePrev = allowSlidePrev;
	    swiper.allowSlideNext = allowSlideNext;
	  }
	
	  function loopDestroy () {
	    var swiper = this;
	    var $wrapperEl = swiper.$wrapperEl;
	    var params = swiper.params;
	    var slides = swiper.slides;
	    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + ",." + (params.slideClass) + "." + (params.slideBlankClass))).remove();
	    slides.removeAttr('data-swiper-slide-index');
	  }
	
	  var loop = {
	    loopCreate: loopCreate,
	    loopFix: loopFix,
	    loopDestroy: loopDestroy,
	  };
	
	  function setGrabCursor (moving) {
	    var swiper = this;
	    if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
	    var el = swiper.el;
	    el.style.cursor = 'move';
	    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	    el.style.cursor = moving ? 'grabbing' : 'grab';
	  }
	
	  function unsetGrabCursor () {
	    var swiper = this;
	    if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
	    swiper.el.style.cursor = '';
	  }
	
	  var grabCursor = {
	    setGrabCursor: setGrabCursor,
	    unsetGrabCursor: unsetGrabCursor,
	  };
	
	  function appendSlide (slides) {
	    var swiper = this;
	    var $wrapperEl = swiper.$wrapperEl;
	    var params = swiper.params;
	    if (params.loop) {
	      swiper.loopDestroy();
	    }
	    if (typeof slides === 'object' && 'length' in slides) {
	      for (var i = 0; i < slides.length; i += 1) {
	        if (slides[i]) { $wrapperEl.append(slides[i]); }
	      }
	    } else {
	      $wrapperEl.append(slides);
	    }
	    if (params.loop) {
	      swiper.loopCreate();
	    }
	    if (!(params.observer && Support.observer)) {
	      swiper.update();
	    }
	  }
	
	  function prependSlide (slides) {
	    var swiper = this;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	    var activeIndex = swiper.activeIndex;
	
	    if (params.loop) {
	      swiper.loopDestroy();
	    }
	    var newActiveIndex = activeIndex + 1;
	    if (typeof slides === 'object' && 'length' in slides) {
	      for (var i = 0; i < slides.length; i += 1) {
	        if (slides[i]) { $wrapperEl.prepend(slides[i]); }
	      }
	      newActiveIndex = activeIndex + slides.length;
	    } else {
	      $wrapperEl.prepend(slides);
	    }
	    if (params.loop) {
	      swiper.loopCreate();
	    }
	    if (!(params.observer && Support.observer)) {
	      swiper.update();
	    }
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	
	  function addSlide (index, slides) {
	    var swiper = this;
	    var $wrapperEl = swiper.$wrapperEl;
	    var params = swiper.params;
	    var activeIndex = swiper.activeIndex;
	    var activeIndexBuffer = activeIndex;
	    if (params.loop) {
	      activeIndexBuffer -= swiper.loopedSlides;
	      swiper.loopDestroy();
	      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
	    }
	    var baseLength = swiper.slides.length;
	    if (index <= 0) {
	      swiper.prependSlide(slides);
	      return;
	    }
	    if (index >= baseLength) {
	      swiper.appendSlide(slides);
	      return;
	    }
	    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
	
	    var slidesBuffer = [];
	    for (var i = baseLength - 1; i >= index; i -= 1) {
	      var currentSlide = swiper.slides.eq(i);
	      currentSlide.remove();
	      slidesBuffer.unshift(currentSlide);
	    }
	
	    if (typeof slides === 'object' && 'length' in slides) {
	      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
	        if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
	      }
	      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
	    } else {
	      $wrapperEl.append(slides);
	    }
	
	    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
	      $wrapperEl.append(slidesBuffer[i$2]);
	    }
	
	    if (params.loop) {
	      swiper.loopCreate();
	    }
	    if (!(params.observer && Support.observer)) {
	      swiper.update();
	    }
	    if (params.loop) {
	      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	    } else {
	      swiper.slideTo(newActiveIndex, 0, false);
	    }
	  }
	
	  function removeSlide (slidesIndexes) {
	    var swiper = this;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	    var activeIndex = swiper.activeIndex;
	
	    var activeIndexBuffer = activeIndex;
	    if (params.loop) {
	      activeIndexBuffer -= swiper.loopedSlides;
	      swiper.loopDestroy();
	      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
	    }
	    var newActiveIndex = activeIndexBuffer;
	    var indexToRemove;
	
	    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
	      for (var i = 0; i < slidesIndexes.length; i += 1) {
	        indexToRemove = slidesIndexes[i];
	        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	      }
	      newActiveIndex = Math.max(newActiveIndex, 0);
	    } else {
	      indexToRemove = slidesIndexes;
	      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	      newActiveIndex = Math.max(newActiveIndex, 0);
	    }
	
	    if (params.loop) {
	      swiper.loopCreate();
	    }
	
	    if (!(params.observer && Support.observer)) {
	      swiper.update();
	    }
	    if (params.loop) {
	      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	    } else {
	      swiper.slideTo(newActiveIndex, 0, false);
	    }
	  }
	
	  function removeAllSlides () {
	    var swiper = this;
	
	    var slidesIndexes = [];
	    for (var i = 0; i < swiper.slides.length; i += 1) {
	      slidesIndexes.push(i);
	    }
	    swiper.removeSlide(slidesIndexes);
	  }
	
	  var manipulation = {
	    appendSlide: appendSlide,
	    prependSlide: prependSlide,
	    addSlide: addSlide,
	    removeSlide: removeSlide,
	    removeAllSlides: removeAllSlides,
	  };
	
	  var Device = (function Device() {
	    var ua = win.navigator.userAgent;
	
	    var device = {
	      ios: false,
	      android: false,
	      androidChrome: false,
	      desktop: false,
	      windows: false,
	      iphone: false,
	      ipod: false,
	      ipad: false,
	      cordova: win.cordova || win.phonegap,
	      phonegap: win.cordova || win.phonegap,
	    };
	
	    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	
	
	    // Windows
	    if (windows) {
	      device.os = 'windows';
	      device.osVersion = windows[2];
	      device.windows = true;
	    }
	    // Android
	    if (android && !windows) {
	      device.os = 'android';
	      device.osVersion = android[2];
	      device.android = true;
	      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
	    }
	    if (ipad || iphone || ipod) {
	      device.os = 'ios';
	      device.ios = true;
	    }
	    // iOS
	    if (iphone && !ipod) {
	      device.osVersion = iphone[2].replace(/_/g, '.');
	      device.iphone = true;
	    }
	    if (ipad) {
	      device.osVersion = ipad[2].replace(/_/g, '.');
	      device.ipad = true;
	    }
	    if (ipod) {
	      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	      device.iphone = true;
	    }
	    // iOS 8+ changed UA
	    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
	      if (device.osVersion.split('.')[0] === '10') {
	        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
	      }
	    }
	
	    // Desktop
	    device.desktop = !(device.os || device.android || device.webView);
	
	    // Webview
	    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);
	
	    // Minimal UI
	    if (device.os && device.os === 'ios') {
	      var osVersionArr = device.osVersion.split('.');
	      var metaViewport = doc.querySelector('meta[name="viewport"]');
	      device.minimalUi = !device.webView
	        && (ipod || iphone)
	        && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7)
	        && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
	    }
	
	    // Pixel Ratio
	    device.pixelRatio = win.devicePixelRatio || 1;
	
	    // Export object
	    return device;
	  }());
	
	  function onTouchStart (event) {
	    var swiper = this;
	    var data = swiper.touchEventsData;
	    var params = swiper.params;
	    var touches = swiper.touches;
	    if (swiper.animating && params.preventInteractionOnTransition) {
	      return;
	    }
	    var e = event;
	    if (e.originalEvent) { e = e.originalEvent; }
	    data.isTouchEvent = e.type === 'touchstart';
	    if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
	    if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
	    if (data.isTouched && data.isMoved) { return; }
	    if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
	      swiper.allowClick = true;
	      return;
	    }
	    if (params.swipeHandler) {
	      if (!$(e).closest(params.swipeHandler)[0]) { return; }
	    }
	
	    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	    var startX = touches.currentX;
	    var startY = touches.currentY;
	
	    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
	
	    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
	    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
	    if (
	      edgeSwipeDetection
	      && ((startX <= edgeSwipeThreshold)
	      || (startX >= win.screen.width - edgeSwipeThreshold))
	    ) {
	      return;
	    }
	
	    Utils.extend(data, {
	      isTouched: true,
	      isMoved: false,
	      allowTouchCallbacks: true,
	      isScrolling: undefined,
	      startMoving: undefined,
	    });
	
	    touches.startX = startX;
	    touches.startY = startY;
	    data.touchStartTime = Utils.now();
	    swiper.allowClick = true;
	    swiper.updateSize();
	    swiper.swipeDirection = undefined;
	    if (params.threshold > 0) { data.allowThresholdMove = false; }
	    if (e.type !== 'touchstart') {
	      var preventDefault = true;
	      if ($(e.target).is(data.formElements)) { preventDefault = false; }
	      if (
	        doc.activeElement
	        && $(doc.activeElement).is(data.formElements)
	        && doc.activeElement !== e.target
	      ) {
	        doc.activeElement.blur();
	      }
	
	      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
	      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
	        e.preventDefault();
	      }
	    }
	    swiper.emit('touchStart', e);
	  }
	
	  function onTouchMove (event) {
	    var swiper = this;
	    var data = swiper.touchEventsData;
	    var params = swiper.params;
	    var touches = swiper.touches;
	    var rtl = swiper.rtlTranslate;
	    var e = event;
	    if (e.originalEvent) { e = e.originalEvent; }
	    if (!data.isTouched) {
	      if (data.startMoving && data.isScrolling) {
	        swiper.emit('touchMoveOpposite', e);
	      }
	      return;
	    }
	    if (data.isTouchEvent && e.type === 'mousemove') { return; }
	    var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	    var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	    if (e.preventedByNestedSwiper) {
	      touches.startX = pageX;
	      touches.startY = pageY;
	      return;
	    }
	    if (!swiper.allowTouchMove) {
	      // isMoved = true;
	      swiper.allowClick = false;
	      if (data.isTouched) {
	        Utils.extend(touches, {
	          startX: pageX,
	          startY: pageY,
	          currentX: pageX,
	          currentY: pageY,
	        });
	        data.touchStartTime = Utils.now();
	      }
	      return;
	    }
	    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
	      if (swiper.isVertical()) {
	        // Vertical
	        if (
	          (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
	          || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
	        ) {
	          data.isTouched = false;
	          data.isMoved = false;
	          return;
	        }
	      } else if (
	        (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
	        || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
	      ) {
	        return;
	      }
	    }
	    if (data.isTouchEvent && doc.activeElement) {
	      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
	        data.isMoved = true;
	        swiper.allowClick = false;
	        return;
	      }
	    }
	    if (data.allowTouchCallbacks) {
	      swiper.emit('touchMove', e);
	    }
	    if (e.targetTouches && e.targetTouches.length > 1) { return; }
	
	    touches.currentX = pageX;
	    touches.currentY = pageY;
	
	    var diffX = touches.currentX - touches.startX;
	    var diffY = touches.currentY - touches.startY;
	    if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }
	
	    if (typeof data.isScrolling === 'undefined') {
	      var touchAngle;
	      if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
	        data.isScrolling = false;
	      } else {
	        // eslint-disable-next-line
	        if ((diffX * diffX) + (diffY * diffY) >= 25) {
	          touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
	          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
	        }
	      }
	    }
	    if (data.isScrolling) {
	      swiper.emit('touchMoveOpposite', e);
	    }
	    if (typeof data.startMoving === 'undefined') {
	      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	        data.startMoving = true;
	      }
	    }
	    if (data.isScrolling) {
	      data.isTouched = false;
	      return;
	    }
	    if (!data.startMoving) {
	      return;
	    }
	    swiper.allowClick = false;
	    e.preventDefault();
	    if (params.touchMoveStopPropagation && !params.nested) {
	      e.stopPropagation();
	    }
	
	    if (!data.isMoved) {
	      if (params.loop) {
	        swiper.loopFix();
	      }
	      data.startTranslate = swiper.getTranslate();
	      swiper.setTransition(0);
	      if (swiper.animating) {
	        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
	      }
	      data.allowMomentumBounce = false;
	      // Grab Cursor
	      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	        swiper.setGrabCursor(true);
	      }
	      swiper.emit('sliderFirstMove', e);
	    }
	    swiper.emit('sliderMove', e);
	    data.isMoved = true;
	
	    var diff = swiper.isHorizontal() ? diffX : diffY;
	    touches.diff = diff;
	
	    diff *= params.touchRatio;
	    if (rtl) { diff = -diff; }
	
	    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	    data.currentTranslate = diff + data.startTranslate;
	
	    var disableParentSwiper = true;
	    var resistanceRatio = params.resistanceRatio;
	    if (params.touchReleaseOnEdges) {
	      resistanceRatio = 0;
	    }
	    if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
	      disableParentSwiper = false;
	      if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
	    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
	      disableParentSwiper = false;
	      if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
	    }
	
	    if (disableParentSwiper) {
	      e.preventedByNestedSwiper = true;
	    }
	
	    // Directions locks
	    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	      data.currentTranslate = data.startTranslate;
	    }
	    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	      data.currentTranslate = data.startTranslate;
	    }
	
	
	    // Threshold
	    if (params.threshold > 0) {
	      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	        if (!data.allowThresholdMove) {
	          data.allowThresholdMove = true;
	          touches.startX = touches.currentX;
	          touches.startY = touches.currentY;
	          data.currentTranslate = data.startTranslate;
	          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	          return;
	        }
	      } else {
	        data.currentTranslate = data.startTranslate;
	        return;
	      }
	    }
	
	    if (!params.followFinger) { return; }
	
	    // Update active index in free mode
	    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	    if (params.freeMode) {
	      // Velocity
	      if (data.velocities.length === 0) {
	        data.velocities.push({
	          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
	          time: data.touchStartTime,
	        });
	      }
	      data.velocities.push({
	        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
	        time: Utils.now(),
	      });
	    }
	    // Update progress
	    swiper.updateProgress(data.currentTranslate);
	    // Update translate
	    swiper.setTranslate(data.currentTranslate);
	  }
	
	  function onTouchEnd (event) {
	    var swiper = this;
	    var data = swiper.touchEventsData;
	
	    var params = swiper.params;
	    var touches = swiper.touches;
	    var rtl = swiper.rtlTranslate;
	    var $wrapperEl = swiper.$wrapperEl;
	    var slidesGrid = swiper.slidesGrid;
	    var snapGrid = swiper.snapGrid;
	    var e = event;
	    if (e.originalEvent) { e = e.originalEvent; }
	    if (data.allowTouchCallbacks) {
	      swiper.emit('touchEnd', e);
	    }
	    data.allowTouchCallbacks = false;
	    if (!data.isTouched) {
	      if (data.isMoved && params.grabCursor) {
	        swiper.setGrabCursor(false);
	      }
	      data.isMoved = false;
	      data.startMoving = false;
	      return;
	    }
	    // Return Grab Cursor
	    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	      swiper.setGrabCursor(false);
	    }
	
	    // Time diff
	    var touchEndTime = Utils.now();
	    var timeDiff = touchEndTime - data.touchStartTime;
	
	    // Tap, doubleTap, Click
	    if (swiper.allowClick) {
	      swiper.updateClickedSlide(e);
	      swiper.emit('tap', e);
	      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
	        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
	        data.clickTimeout = Utils.nextTick(function () {
	          if (!swiper || swiper.destroyed) { return; }
	          swiper.emit('click', e);
	        }, 300);
	      }
	      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
	        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
	        swiper.emit('doubleTap', e);
	      }
	    }
	
	    data.lastClickTime = Utils.now();
	    Utils.nextTick(function () {
	      if (!swiper.destroyed) { swiper.allowClick = true; }
	    });
	
	    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
	      data.isTouched = false;
	      data.isMoved = false;
	      data.startMoving = false;
	      return;
	    }
	    data.isTouched = false;
	    data.isMoved = false;
	    data.startMoving = false;
	
	    var currentPos;
	    if (params.followFinger) {
	      currentPos = rtl ? swiper.translate : -swiper.translate;
	    } else {
	      currentPos = -data.currentTranslate;
	    }
	
	    if (params.freeMode) {
	      if (currentPos < -swiper.minTranslate()) {
	        swiper.slideTo(swiper.activeIndex);
	        return;
	      }
	      if (currentPos > -swiper.maxTranslate()) {
	        if (swiper.slides.length < snapGrid.length) {
	          swiper.slideTo(snapGrid.length - 1);
	        } else {
	          swiper.slideTo(swiper.slides.length - 1);
	        }
	        return;
	      }
	
	      if (params.freeModeMomentum) {
	        if (data.velocities.length > 1) {
	          var lastMoveEvent = data.velocities.pop();
	          var velocityEvent = data.velocities.pop();
	
	          var distance = lastMoveEvent.position - velocityEvent.position;
	          var time = lastMoveEvent.time - velocityEvent.time;
	          swiper.velocity = distance / time;
	          swiper.velocity /= 2;
	          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
	            swiper.velocity = 0;
	          }
	          // this implies that the user stopped moving a finger then released.
	          // There would be no events with distance zero, so the last event is stale.
	          if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
	            swiper.velocity = 0;
	          }
	        } else {
	          swiper.velocity = 0;
	        }
	        swiper.velocity *= params.freeModeMomentumVelocityRatio;
	
	        data.velocities.length = 0;
	        var momentumDuration = 1000 * params.freeModeMomentumRatio;
	        var momentumDistance = swiper.velocity * momentumDuration;
	
	        var newPosition = swiper.translate + momentumDistance;
	        if (rtl) { newPosition = -newPosition; }
	
	        var doBounce = false;
	        var afterBouncePosition;
	        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
	        var needsLoopFix;
	        if (newPosition < swiper.maxTranslate()) {
	          if (params.freeModeMomentumBounce) {
	            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
	              newPosition = swiper.maxTranslate() - bounceAmount;
	            }
	            afterBouncePosition = swiper.maxTranslate();
	            doBounce = true;
	            data.allowMomentumBounce = true;
	          } else {
	            newPosition = swiper.maxTranslate();
	          }
	          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
	        } else if (newPosition > swiper.minTranslate()) {
	          if (params.freeModeMomentumBounce) {
	            if (newPosition - swiper.minTranslate() > bounceAmount) {
	              newPosition = swiper.minTranslate() + bounceAmount;
	            }
	            afterBouncePosition = swiper.minTranslate();
	            doBounce = true;
	            data.allowMomentumBounce = true;
	          } else {
	            newPosition = swiper.minTranslate();
	          }
	          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
	        } else if (params.freeModeSticky) {
	          var nextSlide;
	          for (var j = 0; j < snapGrid.length; j += 1) {
	            if (snapGrid[j] > -newPosition) {
	              nextSlide = j;
	              break;
	            }
	          }
	
	          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
	            newPosition = snapGrid[nextSlide];
	          } else {
	            newPosition = snapGrid[nextSlide - 1];
	          }
	          newPosition = -newPosition;
	        }
	        if (needsLoopFix) {
	          swiper.once('transitionEnd', function () {
	            swiper.loopFix();
	          });
	        }
	        // Fix duration
	        if (swiper.velocity !== 0) {
	          if (rtl) {
	            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
	          } else {
	            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
	          }
	        } else if (params.freeModeSticky) {
	          swiper.slideToClosest();
	          return;
	        }
	
	        if (params.freeModeMomentumBounce && doBounce) {
	          swiper.updateProgress(afterBouncePosition);
	          swiper.setTransition(momentumDuration);
	          swiper.setTranslate(newPosition);
	          swiper.transitionStart(true, swiper.swipeDirection);
	          swiper.animating = true;
	          $wrapperEl.transitionEnd(function () {
	            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
	            swiper.emit('momentumBounce');
	
	            swiper.setTransition(params.speed);
	            swiper.setTranslate(afterBouncePosition);
	            $wrapperEl.transitionEnd(function () {
	              if (!swiper || swiper.destroyed) { return; }
	              swiper.transitionEnd();
	            });
	          });
	        } else if (swiper.velocity) {
	          swiper.updateProgress(newPosition);
	          swiper.setTransition(momentumDuration);
	          swiper.setTranslate(newPosition);
	          swiper.transitionStart(true, swiper.swipeDirection);
	          if (!swiper.animating) {
	            swiper.animating = true;
	            $wrapperEl.transitionEnd(function () {
	              if (!swiper || swiper.destroyed) { return; }
	              swiper.transitionEnd();
	            });
	          }
	        } else {
	          swiper.updateProgress(newPosition);
	        }
	
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	      } else if (params.freeModeSticky) {
	        swiper.slideToClosest();
	        return;
	      }
	
	      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
	        swiper.updateProgress();
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	      }
	      return;
	    }
	
	    // Find current slide
	    var stopIndex = 0;
	    var groupSize = swiper.slidesSizesGrid[0];
	    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
	      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
	        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
	          stopIndex = i;
	          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
	        }
	      } else if (currentPos >= slidesGrid[i]) {
	        stopIndex = i;
	        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	      }
	    }
	
	    // Find current slide size
	    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	
	    if (timeDiff > params.longSwipesMs) {
	      // Long touches
	      if (!params.longSwipes) {
	        swiper.slideTo(swiper.activeIndex);
	        return;
	      }
	      if (swiper.swipeDirection === 'next') {
	        if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
	        else { swiper.slideTo(stopIndex); }
	      }
	      if (swiper.swipeDirection === 'prev') {
	        if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
	        else { swiper.slideTo(stopIndex); }
	      }
	    } else {
	      // Short swipes
	      if (!params.shortSwipes) {
	        swiper.slideTo(swiper.activeIndex);
	        return;
	      }
	      if (swiper.swipeDirection === 'next') {
	        swiper.slideTo(stopIndex + params.slidesPerGroup);
	      }
	      if (swiper.swipeDirection === 'prev') {
	        swiper.slideTo(stopIndex);
	      }
	    }
	  }
	
	  function onResize () {
	    var swiper = this;
	
	    var params = swiper.params;
	    var el = swiper.el;
	
	    if (el && el.offsetWidth === 0) { return; }
	
	    // Breakpoints
	    if (params.breakpoints) {
	      swiper.setBreakpoint();
	    }
	
	    // Save locks
	    var allowSlideNext = swiper.allowSlideNext;
	    var allowSlidePrev = swiper.allowSlidePrev;
	    var snapGrid = swiper.snapGrid;
	
	    // Disable locks on resize
	    swiper.allowSlideNext = true;
	    swiper.allowSlidePrev = true;
	
	    swiper.updateSize();
	    swiper.updateSlides();
	
	    if (params.freeMode) {
	      var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
	      swiper.setTranslate(newTranslate);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	
	      if (params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	    } else {
	      swiper.updateSlidesClasses();
	      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	      } else {
	        swiper.slideTo(swiper.activeIndex, 0, false, true);
	      }
	    }
	    // Return locks after resize
	    swiper.allowSlidePrev = allowSlidePrev;
	    swiper.allowSlideNext = allowSlideNext;
	
	    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
	      swiper.checkOverflow();
	    }
	  }
	
	  function onClick (e) {
	    var swiper = this;
	    if (!swiper.allowClick) {
	      if (swiper.params.preventClicks) { e.preventDefault(); }
	      if (swiper.params.preventClicksPropagation && swiper.animating) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	      }
	    }
	  }
	
	  function attachEvents() {
	    var swiper = this;
	    var params = swiper.params;
	    var touchEvents = swiper.touchEvents;
	    var el = swiper.el;
	    var wrapperEl = swiper.wrapperEl;
	
	    {
	      swiper.onTouchStart = onTouchStart.bind(swiper);
	      swiper.onTouchMove = onTouchMove.bind(swiper);
	      swiper.onTouchEnd = onTouchEnd.bind(swiper);
	    }
	
	    swiper.onClick = onClick.bind(swiper);
	
	    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
	    var capture = !!params.nested;
	
	    // Touch Events
	    {
	      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	        target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
	        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
	        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
	      } else {
	        if (Support.touch) {
	          var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	          target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	          target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
	          target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	        }
	        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	          target.addEventListener('mousedown', swiper.onTouchStart, false);
	          doc.addEventListener('mousemove', swiper.onTouchMove, capture);
	          doc.addEventListener('mouseup', swiper.onTouchEnd, false);
	        }
	      }
	      // Prevent Links Clicks
	      if (params.preventClicks || params.preventClicksPropagation) {
	        target.addEventListener('click', swiper.onClick, true);
	      }
	    }
	
	    // Resize handler
	    swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
	  }
	
	  function detachEvents() {
	    var swiper = this;
	
	    var params = swiper.params;
	    var touchEvents = swiper.touchEvents;
	    var el = swiper.el;
	    var wrapperEl = swiper.wrapperEl;
	
	    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
	    var capture = !!params.nested;
	
	    // Touch Events
	    {
	      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	        target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
	        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
	      } else {
	        if (Support.touch) {
	          var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	          target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	          target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	          target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	        }
	        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	          target.removeEventListener('mousedown', swiper.onTouchStart, false);
	          doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
	          doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
	        }
	      }
	      // Prevent Links Clicks
	      if (params.preventClicks || params.preventClicksPropagation) {
	        target.removeEventListener('click', swiper.onClick, true);
	      }
	    }
	
	    // Resize handler
	    swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
	  }
	
	  var events = {
	    attachEvents: attachEvents,
	    detachEvents: detachEvents,
	  };
	
	  function setBreakpoint () {
	    var swiper = this;
	    var activeIndex = swiper.activeIndex;
	    var initialized = swiper.initialized;
	    var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
	    var params = swiper.params;
	    var breakpoints = params.breakpoints;
	    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }
	
	    // Set breakpoint for window width and update parameters
	    var breakpoint = swiper.getBreakpoint(breakpoints);
	
	    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
	      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
	      if (breakpointOnlyParams) {
	        ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
	          var paramValue = breakpointOnlyParams[param];
	          if (typeof paramValue === 'undefined') { return; }
	          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
	            breakpointOnlyParams[param] = 'auto';
	          } else if (param === 'slidesPerView') {
	            breakpointOnlyParams[param] = parseFloat(paramValue);
	          } else {
	            breakpointOnlyParams[param] = parseInt(paramValue, 10);
	          }
	        });
	      }
	
	      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
	      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView);
	
	      Utils.extend(swiper.params, breakpointParams);
	
	      Utils.extend(swiper, {
	        allowTouchMove: swiper.params.allowTouchMove,
	        allowSlideNext: swiper.params.allowSlideNext,
	        allowSlidePrev: swiper.params.allowSlidePrev,
	      });
	
	      swiper.currentBreakpoint = breakpoint;
	
	      if (needsReLoop && initialized) {
	        swiper.loopDestroy();
	        swiper.loopCreate();
	        swiper.updateSlides();
	        swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
	      }
	      swiper.emit('breakpoint', breakpointParams);
	    }
	  }
	
	  function getBreakpoint (breakpoints) {
	    var swiper = this;
	    // Get breakpoint for window width
	    if (!breakpoints) { return undefined; }
	    var breakpoint = false;
	    var points = [];
	    Object.keys(breakpoints).forEach(function (point) {
	      points.push(point);
	    });
	    points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
	    for (var i = 0; i < points.length; i += 1) {
	      var point = points[i];
	      if (swiper.params.breakpointsInverse) {
	        if (point <= win.innerWidth) {
	          breakpoint = point;
	        }
	      } else if (point >= win.innerWidth && !breakpoint) {
	        breakpoint = point;
	      }
	    }
	    return breakpoint || 'max';
	  }
	
	  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };
	
	  var Browser = (function Browser() {
	    function isSafari() {
	      var ua = win.navigator.userAgent.toLowerCase();
	      return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
	    }
	    return {
	      isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
	      isEdge: !!win.navigator.userAgent.match(/Edge/g),
	      isSafari: isSafari(),
	      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
	    };
	  }());
	
	  function addClasses () {
	    var swiper = this;
	    var classNames = swiper.classNames;
	    var params = swiper.params;
	    var rtl = swiper.rtl;
	    var $el = swiper.$el;
	    var suffixes = [];
	
	    suffixes.push(params.direction);
	
	    if (params.freeMode) {
	      suffixes.push('free-mode');
	    }
	    if (!Support.flexbox) {
	      suffixes.push('no-flexbox');
	    }
	    if (params.autoHeight) {
	      suffixes.push('autoheight');
	    }
	    if (rtl) {
	      suffixes.push('rtl');
	    }
	    if (params.slidesPerColumn > 1) {
	      suffixes.push('multirow');
	    }
	    if (Device.android) {
	      suffixes.push('android');
	    }
	    if (Device.ios) {
	      suffixes.push('ios');
	    }
	    // WP8 Touch Events Fix
	    if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	      suffixes.push(("wp8-" + (params.direction)));
	    }
	
	    suffixes.forEach(function (suffix) {
	      classNames.push(params.containerModifierClass + suffix);
	    });
	
	    $el.addClass(classNames.join(' '));
	  }
	
	  function removeClasses () {
	    var swiper = this;
	    var $el = swiper.$el;
	    var classNames = swiper.classNames;
	
	    $el.removeClass(classNames.join(' '));
	  }
	
	  var classes = { addClasses: addClasses, removeClasses: removeClasses };
	
	  function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
	    var image;
	    function onReady() {
	      if (callback) { callback(); }
	    }
	    if (!imageEl.complete || !checkForComplete) {
	      if (src) {
	        image = new win.Image();
	        image.onload = onReady;
	        image.onerror = onReady;
	        if (sizes) {
	          image.sizes = sizes;
	        }
	        if (srcset) {
	          image.srcset = srcset;
	        }
	        if (src) {
	          image.src = src;
	        }
	      } else {
	        onReady();
	      }
	    } else {
	      // image already loaded...
	      onReady();
	    }
	  }
	
	  function preloadImages () {
	    var swiper = this;
	    swiper.imagesToLoad = swiper.$el.find('img');
	    function onReady() {
	      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
	      if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
	      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
	        if (swiper.params.updateOnImagesReady) { swiper.update(); }
	        swiper.emit('imagesReady');
	      }
	    }
	    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
	      var imageEl = swiper.imagesToLoad[i];
	      swiper.loadImage(
	        imageEl,
	        imageEl.currentSrc || imageEl.getAttribute('src'),
	        imageEl.srcset || imageEl.getAttribute('srcset'),
	        imageEl.sizes || imageEl.getAttribute('sizes'),
	        true,
	        onReady
	      );
	    }
	  }
	
	  var images = {
	    loadImage: loadImage,
	    preloadImages: preloadImages,
	  };
	
	  function checkOverflow() {
	    var swiper = this;
	    var wasLocked = swiper.isLocked;
	
	    swiper.isLocked = swiper.snapGrid.length === 1;
	    swiper.allowSlideNext = !swiper.isLocked;
	    swiper.allowSlidePrev = !swiper.isLocked;
	
	    // events
	    if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }
	
	    if (wasLocked && wasLocked !== swiper.isLocked) {
	      swiper.isEnd = false;
	      swiper.navigation.update();
	    }
	  }
	
	  var checkOverflow$1 = { checkOverflow: checkOverflow };
	
	  var defaults = {
	    init: true,
	    direction: 'horizontal',
	    touchEventsTarget: 'container',
	    initialSlide: 0,
	    speed: 300,
	    //
	    preventInteractionOnTransition: false,
	
	    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
	    edgeSwipeDetection: false,
	    edgeSwipeThreshold: 20,
	
	    // Free mode
	    freeMode: false,
	    freeModeMomentum: true,
	    freeModeMomentumRatio: 1,
	    freeModeMomentumBounce: true,
	    freeModeMomentumBounceRatio: 1,
	    freeModeMomentumVelocityRatio: 1,
	    freeModeSticky: false,
	    freeModeMinimumVelocity: 0.02,
	
	    // Autoheight
	    autoHeight: false,
	
	    // Set wrapper width
	    setWrapperSize: false,
	
	    // Virtual Translate
	    virtualTranslate: false,
	
	    // Effects
	    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	
	    // Breakpoints
	    breakpoints: undefined,
	    breakpointsInverse: false,
	
	    // Slides grid
	    spaceBetween: 0,
	    slidesPerView: 1,
	    slidesPerColumn: 1,
	    slidesPerColumnFill: 'column',
	    slidesPerGroup: 1,
	    centeredSlides: false,
	    slidesOffsetBefore: 0, // in px
	    slidesOffsetAfter: 0, // in px
	    normalizeSlideIndex: true,
	    centerInsufficientSlides: false,
	
	    // Disable swiper and hide navigation when container not overflow
	    watchOverflow: false,
	
	    // Round length
	    roundLengths: false,
	
	    // Touches
	    touchRatio: 1,
	    touchAngle: 45,
	    simulateTouch: true,
	    shortSwipes: true,
	    longSwipes: true,
	    longSwipesRatio: 0.5,
	    longSwipesMs: 300,
	    followFinger: true,
	    allowTouchMove: true,
	    threshold: 0,
	    touchMoveStopPropagation: true,
	    touchStartPreventDefault: true,
	    touchStartForcePreventDefault: false,
	    touchReleaseOnEdges: false,
	
	    // Unique Navigation Elements
	    uniqueNavElements: true,
	
	    // Resistance
	    resistance: true,
	    resistanceRatio: 0.85,
	
	    // Progress
	    watchSlidesProgress: false,
	    watchSlidesVisibility: false,
	
	    // Cursor
	    grabCursor: false,
	
	    // Clicks
	    preventClicks: true,
	    preventClicksPropagation: true,
	    slideToClickedSlide: false,
	
	    // Images
	    preloadImages: true,
	    updateOnImagesReady: true,
	
	    // loop
	    loop: false,
	    loopAdditionalSlides: 0,
	    loopedSlides: null,
	    loopFillGroupWithBlank: false,
	
	    // Swiping/no swiping
	    allowSlidePrev: true,
	    allowSlideNext: true,
	    swipeHandler: null, // '.swipe-handler',
	    noSwiping: true,
	    noSwipingClass: 'swiper-no-swiping',
	    noSwipingSelector: null,
	
	    // Passive Listeners
	    passiveListeners: true,
	
	    // NS
	    containerModifierClass: 'swiper-container-', // NEW
	    slideClass: 'swiper-slide',
	    slideBlankClass: 'swiper-slide-invisible-blank',
	    slideActiveClass: 'swiper-slide-active',
	    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	    slideVisibleClass: 'swiper-slide-visible',
	    slideDuplicateClass: 'swiper-slide-duplicate',
	    slideNextClass: 'swiper-slide-next',
	    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	    slidePrevClass: 'swiper-slide-prev',
	    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	    wrapperClass: 'swiper-wrapper',
	
	    // Callbacks
	    runCallbacksOnInit: true,
	  };
	
	  var prototypes = {
	    update: update,
	    translate: translate,
	    transition: transition$1,
	    slide: slide,
	    loop: loop,
	    grabCursor: grabCursor,
	    manipulation: manipulation,
	    events: events,
	    breakpoints: breakpoints,
	    checkOverflow: checkOverflow$1,
	    classes: classes,
	    images: images,
	  };
	
	  var extendedDefaults = {};
	
	  var Swiper = /*@__PURE__*/(function (SwiperClass$$1) {
	    function Swiper() {
	      var assign;
	
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	      var el;
	      var params;
	      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
	        params = args[0];
	      } else {
	        (assign = args, el = assign[0], params = assign[1]);
	      }
	      if (!params) { params = {}; }
	
	      params = Utils.extend({}, params);
	      if (el && !params.el) { params.el = el; }
	
	      SwiperClass$$1.call(this, params);
	
	      Object.keys(prototypes).forEach(function (prototypeGroup) {
	        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
	          if (!Swiper.prototype[protoMethod]) {
	            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	          }
	        });
	      });
	
	      // Swiper Instance
	      var swiper = this;
	      if (typeof swiper.modules === 'undefined') {
	        swiper.modules = {};
	      }
	      Object.keys(swiper.modules).forEach(function (moduleName) {
	        var module = swiper.modules[moduleName];
	        if (module.params) {
	          var moduleParamName = Object.keys(module.params)[0];
	          var moduleParams = module.params[moduleParamName];
	          if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
	          if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
	          if (params[moduleParamName] === true) {
	            params[moduleParamName] = { enabled: true };
	          }
	          if (
	            typeof params[moduleParamName] === 'object'
	            && !('enabled' in params[moduleParamName])
	          ) {
	            params[moduleParamName].enabled = true;
	          }
	          if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
	        }
	      });
	
	      // Extend defaults with modules params
	      var swiperParams = Utils.extend({}, defaults);
	      swiper.useModulesParams(swiperParams);
	
	      // Extend defaults with passed params
	      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
	      swiper.originalParams = Utils.extend({}, swiper.params);
	      swiper.passedParams = Utils.extend({}, params);
	
	      // Save Dom lib
	      swiper.$ = $;
	
	      // Find el
	      var $el = $(swiper.params.el);
	      el = $el[0];
	
	      if (!el) {
	        return undefined;
	      }
	
	      if ($el.length > 1) {
	        var swipers = [];
	        $el.each(function (index, containerEl) {
	          var newParams = Utils.extend({}, params, { el: containerEl });
	          swipers.push(new Swiper(newParams));
	        });
	        return swipers;
	      }
	
	      el.swiper = swiper;
	      $el.data('swiper', swiper);
	
	      // Find Wrapper
	      var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));
	
	      // Extend Swiper
	      Utils.extend(swiper, {
	        $el: $el,
	        el: el,
	        $wrapperEl: $wrapperEl,
	        wrapperEl: $wrapperEl[0],
	
	        // Classes
	        classNames: [],
	
	        // Slides
	        slides: $(),
	        slidesGrid: [],
	        snapGrid: [],
	        slidesSizesGrid: [],
	
	        // isDirection
	        isHorizontal: function isHorizontal() {
	          return swiper.params.direction === 'horizontal';
	        },
	        isVertical: function isVertical() {
	          return swiper.params.direction === 'vertical';
	        },
	        // RTL
	        rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	        wrongRTL: $wrapperEl.css('display') === '-webkit-box',
	
	        // Indexes
	        activeIndex: 0,
	        realIndex: 0,
	
	        //
	        isBeginning: true,
	        isEnd: false,
	
	        // Props
	        translate: 0,
	        previousTranslate: 0,
	        progress: 0,
	        velocity: 0,
	        animating: false,
	
	        // Locks
	        allowSlideNext: swiper.params.allowSlideNext,
	        allowSlidePrev: swiper.params.allowSlidePrev,
	
	        // Touch Events
	        touchEvents: (function touchEvents() {
	          var touch = ['touchstart', 'touchmove', 'touchend'];
	          var desktop = ['mousedown', 'mousemove', 'mouseup'];
	          if (Support.pointerEvents) {
	            desktop = ['pointerdown', 'pointermove', 'pointerup'];
	          } else if (Support.prefixedPointerEvents) {
	            desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
	          }
	          swiper.touchEventsTouch = {
	            start: touch[0],
	            move: touch[1],
	            end: touch[2],
	          };
	          swiper.touchEventsDesktop = {
	            start: desktop[0],
	            move: desktop[1],
	            end: desktop[2],
	          };
	          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
	        }()),
	        touchEventsData: {
	          isTouched: undefined,
	          isMoved: undefined,
	          allowTouchCallbacks: undefined,
	          touchStartTime: undefined,
	          isScrolling: undefined,
	          currentTranslate: undefined,
	          startTranslate: undefined,
	          allowThresholdMove: undefined,
	          // Form elements to match
	          formElements: 'input, select, option, textarea, button, video',
	          // Last click time
	          lastClickTime: Utils.now(),
	          clickTimeout: undefined,
	          // Velocities
	          velocities: [],
	          allowMomentumBounce: undefined,
	          isTouchEvent: undefined,
	          startMoving: undefined,
	        },
	
	        // Clicks
	        allowClick: true,
	
	        // Touches
	        allowTouchMove: swiper.params.allowTouchMove,
	
	        touches: {
	          startX: 0,
	          startY: 0,
	          currentX: 0,
	          currentY: 0,
	          diff: 0,
	        },
	
	        // Images
	        imagesToLoad: [],
	        imagesLoaded: 0,
	
	      });
	
	      // Install Modules
	      swiper.useModules();
	
	      // Init
	      if (swiper.params.init) {
	        swiper.init();
	      }
	
	      // Return app instance
	      return swiper;
	    }
	
	    if ( SwiperClass$$1 ) Swiper.__proto__ = SwiperClass$$1;
	    Swiper.prototype = Object.create( SwiperClass$$1 && SwiperClass$$1.prototype );
	    Swiper.prototype.constructor = Swiper;
	
	    var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };
	
	    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
	      var swiper = this;
	      var params = swiper.params;
	      var slides = swiper.slides;
	      var slidesGrid = swiper.slidesGrid;
	      var swiperSize = swiper.size;
	      var activeIndex = swiper.activeIndex;
	      var spv = 1;
	      if (params.centeredSlides) {
	        var slideSize = slides[activeIndex].swiperSlideSize;
	        var breakLoop;
	        for (var i = activeIndex + 1; i < slides.length; i += 1) {
	          if (slides[i] && !breakLoop) {
	            slideSize += slides[i].swiperSlideSize;
	            spv += 1;
	            if (slideSize > swiperSize) { breakLoop = true; }
	          }
	        }
	        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
	          if (slides[i$1] && !breakLoop) {
	            slideSize += slides[i$1].swiperSlideSize;
	            spv += 1;
	            if (slideSize > swiperSize) { breakLoop = true; }
	          }
	        }
	      } else {
	        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
	          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
	            spv += 1;
	          }
	        }
	      }
	      return spv;
	    };
	
	    Swiper.prototype.update = function update$$1 () {
	      var swiper = this;
	      if (!swiper || swiper.destroyed) { return; }
	      var snapGrid = swiper.snapGrid;
	      var params = swiper.params;
	      // Breakpoints
	      if (params.breakpoints) {
	        swiper.setBreakpoint();
	      }
	      swiper.updateSize();
	      swiper.updateSlides();
	      swiper.updateProgress();
	      swiper.updateSlidesClasses();
	
	      function setTranslate() {
	        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
	        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	        swiper.setTranslate(newTranslate);
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	      }
	      var translated;
	      if (swiper.params.freeMode) {
	        setTranslate();
	        if (swiper.params.autoHeight) {
	          swiper.updateAutoHeight();
	        }
	      } else {
	        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	        } else {
	          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	        }
	        if (!translated) {
	          setTranslate();
	        }
	      }
	      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
	        swiper.checkOverflow();
	      }
	      swiper.emit('update');
	    };
	
	    Swiper.prototype.init = function init () {
	      var swiper = this;
	      if (swiper.initialized) { return; }
	
	      swiper.emit('beforeInit');
	
	      // Set breakpoint
	      if (swiper.params.breakpoints) {
	        swiper.setBreakpoint();
	      }
	
	      // Add Classes
	      swiper.addClasses();
	
	      // Create loop
	      if (swiper.params.loop) {
	        swiper.loopCreate();
	      }
	
	      // Update size
	      swiper.updateSize();
	
	      // Update slides
	      swiper.updateSlides();
	
	      if (swiper.params.watchOverflow) {
	        swiper.checkOverflow();
	      }
	
	      // Set Grab Cursor
	      if (swiper.params.grabCursor) {
	        swiper.setGrabCursor();
	      }
	
	      if (swiper.params.preloadImages) {
	        swiper.preloadImages();
	      }
	
	      // Slide To Initial Slide
	      if (swiper.params.loop) {
	        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
	      } else {
	        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
	      }
	
	      // Attach events
	      swiper.attachEvents();
	
	      // Init Flag
	      swiper.initialized = true;
	
	      // Emit
	      swiper.emit('init');
	    };
	
	    Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
	      if ( deleteInstance === void 0 ) deleteInstance = true;
	      if ( cleanStyles === void 0 ) cleanStyles = true;
	
	      var swiper = this;
	      var params = swiper.params;
	      var $el = swiper.$el;
	      var $wrapperEl = swiper.$wrapperEl;
	      var slides = swiper.slides;
	
	      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
	        return null;
	      }
	
	      swiper.emit('beforeDestroy');
	
	      // Init Flag
	      swiper.initialized = false;
	
	      // Detach events
	      swiper.detachEvents();
	
	      // Destroy loop
	      if (params.loop) {
	        swiper.loopDestroy();
	      }
	
	      // Cleanup styles
	      if (cleanStyles) {
	        swiper.removeClasses();
	        $el.removeAttr('style');
	        $wrapperEl.removeAttr('style');
	        if (slides && slides.length) {
	          slides
	            .removeClass([
	              params.slideVisibleClass,
	              params.slideActiveClass,
	              params.slideNextClass,
	              params.slidePrevClass ].join(' '))
	            .removeAttr('style')
	            .removeAttr('data-swiper-slide-index')
	            .removeAttr('data-swiper-column')
	            .removeAttr('data-swiper-row');
	        }
	      }
	
	      swiper.emit('destroy');
	
	      // Detach emitter events
	      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
	        swiper.off(eventName);
	      });
	
	      if (deleteInstance !== false) {
	        swiper.$el[0].swiper = null;
	        swiper.$el.data('swiper', null);
	        Utils.deleteProps(swiper);
	      }
	      swiper.destroyed = true;
	
	      return null;
	    };
	
	    Swiper.extendDefaults = function extendDefaults (newDefaults) {
	      Utils.extend(extendedDefaults, newDefaults);
	    };
	
	    staticAccessors.extendedDefaults.get = function () {
	      return extendedDefaults;
	    };
	
	    staticAccessors.defaults.get = function () {
	      return defaults;
	    };
	
	    staticAccessors.Class.get = function () {
	      return SwiperClass$$1;
	    };
	
	    staticAccessors.$.get = function () {
	      return $;
	    };
	
	    Object.defineProperties( Swiper, staticAccessors );
	
	    return Swiper;
	  }(SwiperClass));
	
	  var Device$1 = {
	    name: 'device',
	    proto: {
	      device: Device,
	    },
	    static: {
	      device: Device,
	    },
	  };
	
	  var Support$1 = {
	    name: 'support',
	    proto: {
	      support: Support,
	    },
	    static: {
	      support: Support,
	    },
	  };
	
	  var Browser$1 = {
	    name: 'browser',
	    proto: {
	      browser: Browser,
	    },
	    static: {
	      browser: Browser,
	    },
	  };
	
	  var Resize = {
	    name: 'resize',
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        resize: {
	          resizeHandler: function resizeHandler() {
	            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	            swiper.emit('beforeResize');
	            swiper.emit('resize');
	          },
	          orientationChangeHandler: function orientationChangeHandler() {
	            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	            swiper.emit('orientationchange');
	          },
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        // Emit resize
	        win.addEventListener('resize', swiper.resize.resizeHandler);
	
	        // Emit orientationchange
	        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        win.removeEventListener('resize', swiper.resize.resizeHandler);
	        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	      },
	    },
	  };
	
	  var Observer = {
	    func: win.MutationObserver || win.WebkitMutationObserver,
	    attach: function attach(target, options) {
	      if ( options === void 0 ) options = {};
	
	      var swiper = this;
	
	      var ObserverFunc = Observer.func;
	      var observer = new ObserverFunc(function (mutations) {
	        // The observerUpdate event should only be triggered
	        // once despite the number of mutations.  Additional
	        // triggers are redundant and are very costly
	        if (mutations.length === 1) {
	          swiper.emit('observerUpdate', mutations[0]);
	          return;
	        }
	        var observerUpdate = function observerUpdate() {
	          swiper.emit('observerUpdate', mutations[0]);
	        };
	
	        if (win.requestAnimationFrame) {
	          win.requestAnimationFrame(observerUpdate);
	        } else {
	          win.setTimeout(observerUpdate, 0);
	        }
	      });
	
	      observer.observe(target, {
	        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	        childList: typeof options.childList === 'undefined' ? true : options.childList,
	        characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
	      });
	
	      swiper.observer.observers.push(observer);
	    },
	    init: function init() {
	      var swiper = this;
	      if (!Support.observer || !swiper.params.observer) { return; }
	      if (swiper.params.observeParents) {
	        var containerParents = swiper.$el.parents();
	        for (var i = 0; i < containerParents.length; i += 1) {
	          swiper.observer.attach(containerParents[i]);
	        }
	      }
	      // Observe container
	      swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });
	
	      // Observe wrapper
	      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.observer.observers.forEach(function (observer) {
	        observer.disconnect();
	      });
	      swiper.observer.observers = [];
	    },
	  };
	
	  var Observer$1 = {
	    name: 'observer',
	    params: {
	      observer: false,
	      observeParents: false,
	      observeSlideChildren: false,
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        observer: {
	          init: Observer.init.bind(swiper),
	          attach: Observer.attach.bind(swiper),
	          destroy: Observer.destroy.bind(swiper),
	          observers: [],
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        swiper.observer.init();
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.observer.destroy();
	      },
	    },
	  };
	
	  var Virtual = {
	    update: function update(force) {
	      var swiper = this;
	      var ref = swiper.params;
	      var slidesPerView = ref.slidesPerView;
	      var slidesPerGroup = ref.slidesPerGroup;
	      var centeredSlides = ref.centeredSlides;
	      var ref$1 = swiper.params.virtual;
	      var addSlidesBefore = ref$1.addSlidesBefore;
	      var addSlidesAfter = ref$1.addSlidesAfter;
	      var ref$2 = swiper.virtual;
	      var previousFrom = ref$2.from;
	      var previousTo = ref$2.to;
	      var slides = ref$2.slides;
	      var previousSlidesGrid = ref$2.slidesGrid;
	      var renderSlide = ref$2.renderSlide;
	      var previousOffset = ref$2.offset;
	      swiper.updateActiveIndex();
	      var activeIndex = swiper.activeIndex || 0;
	
	      var offsetProp;
	      if (swiper.rtlTranslate) { offsetProp = 'right'; }
	      else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }
	
	      var slidesAfter;
	      var slidesBefore;
	      if (centeredSlides) {
	        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
	        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
	      } else {
	        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
	        slidesBefore = slidesPerGroup + addSlidesAfter;
	      }
	      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
	      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
	      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
	
	      Utils.extend(swiper.virtual, {
	        from: from,
	        to: to,
	        offset: offset,
	        slidesGrid: swiper.slidesGrid,
	      });
	
	      function onRendered() {
	        swiper.updateSlides();
	        swiper.updateProgress();
	        swiper.updateSlidesClasses();
	        if (swiper.lazy && swiper.params.lazy.enabled) {
	          swiper.lazy.load();
	        }
	      }
	
	      if (previousFrom === from && previousTo === to && !force) {
	        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
	          swiper.slides.css(offsetProp, (offset + "px"));
	        }
	        swiper.updateProgress();
	        return;
	      }
	      if (swiper.params.virtual.renderExternal) {
	        swiper.params.virtual.renderExternal.call(swiper, {
	          offset: offset,
	          from: from,
	          to: to,
	          slides: (function getSlides() {
	            var slidesToRender = [];
	            for (var i = from; i <= to; i += 1) {
	              slidesToRender.push(slides[i]);
	            }
	            return slidesToRender;
	          }()),
	        });
	        onRendered();
	        return;
	      }
	      var prependIndexes = [];
	      var appendIndexes = [];
	      if (force) {
	        swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
	      } else {
	        for (var i = previousFrom; i <= previousTo; i += 1) {
	          if (i < from || i > to) {
	            swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
	          }
	        }
	      }
	      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
	        if (i$1 >= from && i$1 <= to) {
	          if (typeof previousTo === 'undefined' || force) {
	            appendIndexes.push(i$1);
	          } else {
	            if (i$1 > previousTo) { appendIndexes.push(i$1); }
	            if (i$1 < previousFrom) { prependIndexes.push(i$1); }
	          }
	        }
	      }
	      appendIndexes.forEach(function (index) {
	        swiper.$wrapperEl.append(renderSlide(slides[index], index));
	      });
	      prependIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
	        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
	      });
	      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
	      onRendered();
	    },
	    renderSlide: function renderSlide(slide, index) {
	      var swiper = this;
	      var params = swiper.params.virtual;
	      if (params.cache && swiper.virtual.cache[index]) {
	        return swiper.virtual.cache[index];
	      }
	      var $slideEl = params.renderSlide
	        ? $(params.renderSlide.call(swiper, slide, index))
	        : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
	      if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
	      if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
	      return $slideEl;
	    },
	    appendSlide: function appendSlide(slide) {
	      var swiper = this;
	      swiper.virtual.slides.push(slide);
	      swiper.virtual.update(true);
	    },
	    prependSlide: function prependSlide(slide) {
	      var swiper = this;
	      swiper.virtual.slides.unshift(slide);
	      if (swiper.params.virtual.cache) {
	        var cache = swiper.virtual.cache;
	        var newCache = {};
	        Object.keys(cache).forEach(function (cachedIndex) {
	          newCache[cachedIndex + 1] = cache[cachedIndex];
	        });
	        swiper.virtual.cache = newCache;
	      }
	      swiper.virtual.update(true);
	      swiper.slideNext(0);
	    },
	  };
	
	  var Virtual$1 = {
	    name: 'virtual',
	    params: {
	      virtual: {
	        enabled: false,
	        slides: [],
	        cache: true,
	        renderSlide: null,
	        renderExternal: null,
	        addSlidesBefore: 0,
	        addSlidesAfter: 0,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        virtual: {
	          update: Virtual.update.bind(swiper),
	          appendSlide: Virtual.appendSlide.bind(swiper),
	          prependSlide: Virtual.prependSlide.bind(swiper),
	          renderSlide: Virtual.renderSlide.bind(swiper),
	          slides: swiper.params.virtual.slides,
	          cache: {},
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (!swiper.params.virtual.enabled) { return; }
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
	        var overwriteParams = {
	          watchSlidesProgress: true,
	        };
	        Utils.extend(swiper.params, overwriteParams);
	        Utils.extend(swiper.originalParams, overwriteParams);
	
	        if (!swiper.params.initialSlide) {
	          swiper.virtual.update();
	        }
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (!swiper.params.virtual.enabled) { return; }
	        swiper.virtual.update();
	      },
	    },
	  };
	
	  var Keyboard = {
	    handle: function handle(event) {
	      var swiper = this;
	      var rtl = swiper.rtlTranslate;
	      var e = event;
	      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
	      var kc = e.keyCode || e.charCode;
	      // Directions locks
	      if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40))) {
	        return false;
	      }
	      if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38))) {
	        return false;
	      }
	      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
	        return undefined;
	      }
	      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
	        return undefined;
	      }
	      if (swiper.params.keyboard.onlyInViewport && (kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
	        var inView = false;
	        // Check that swiper should be inside of visible area of window
	        if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
	          return undefined;
	        }
	        var windowWidth = win.innerWidth;
	        var windowHeight = win.innerHeight;
	        var swiperOffset = swiper.$el.offset();
	        if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
	        var swiperCoord = [
	          [swiperOffset.left, swiperOffset.top],
	          [swiperOffset.left + swiper.width, swiperOffset.top],
	          [swiperOffset.left, swiperOffset.top + swiper.height],
	          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
	        for (var i = 0; i < swiperCoord.length; i += 1) {
	          var point = swiperCoord[i];
	          if (
	            point[0] >= 0 && point[0] <= windowWidth
	            && point[1] >= 0 && point[1] <= windowHeight
	          ) {
	            inView = true;
	          }
	        }
	        if (!inView) { return undefined; }
	      }
	      if (swiper.isHorizontal()) {
	        if (kc === 37 || kc === 39) {
	          if (e.preventDefault) { e.preventDefault(); }
	          else { e.returnValue = false; }
	        }
	        if ((kc === 39 && !rtl) || (kc === 37 && rtl)) { swiper.slideNext(); }
	        if ((kc === 37 && !rtl) || (kc === 39 && rtl)) { swiper.slidePrev(); }
	      } else {
	        if (kc === 38 || kc === 40) {
	          if (e.preventDefault) { e.preventDefault(); }
	          else { e.returnValue = false; }
	        }
	        if (kc === 40) { swiper.slideNext(); }
	        if (kc === 38) { swiper.slidePrev(); }
	      }
	      swiper.emit('keyPress', kc);
	      return undefined;
	    },
	    enable: function enable() {
	      var swiper = this;
	      if (swiper.keyboard.enabled) { return; }
	      $(doc).on('keydown', swiper.keyboard.handle);
	      swiper.keyboard.enabled = true;
	    },
	    disable: function disable() {
	      var swiper = this;
	      if (!swiper.keyboard.enabled) { return; }
	      $(doc).off('keydown', swiper.keyboard.handle);
	      swiper.keyboard.enabled = false;
	    },
	  };
	
	  var Keyboard$1 = {
	    name: 'keyboard',
	    params: {
	      keyboard: {
	        enabled: false,
	        onlyInViewport: true,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        keyboard: {
	          enabled: false,
	          enable: Keyboard.enable.bind(swiper),
	          disable: Keyboard.disable.bind(swiper),
	          handle: Keyboard.handle.bind(swiper),
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.keyboard.enabled) {
	          swiper.keyboard.enable();
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.keyboard.enabled) {
	          swiper.keyboard.disable();
	        }
	      },
	    },
	  };
	
	  function isEventSupported() {
	    var eventName = 'onwheel';
	    var isSupported = eventName in doc;
	
	    if (!isSupported) {
	      var element = doc.createElement('div');
	      element.setAttribute(eventName, 'return;');
	      isSupported = typeof element[eventName] === 'function';
	    }
	
	    if (!isSupported
	      && doc.implementation
	      && doc.implementation.hasFeature
	      // always returns true in newer browsers as per the standard.
	      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	      && doc.implementation.hasFeature('', '') !== true
	    ) {
	      // This is the only way to test support for the `wheel` event in IE9+.
	      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
	    }
	
	    return isSupported;
	  }
	  var Mousewheel = {
	    lastScrollTime: Utils.now(),
	    event: (function getEvent() {
	      if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
	      return isEventSupported() ? 'wheel' : 'mousewheel';
	    }()),
	    normalize: function normalize(e) {
	      // Reasonable defaults
	      var PIXEL_STEP = 10;
	      var LINE_HEIGHT = 40;
	      var PAGE_HEIGHT = 800;
	
	      var sX = 0;
	      var sY = 0; // spinX, spinY
	      var pX = 0;
	      var pY = 0; // pixelX, pixelY
	
	      // Legacy
	      if ('detail' in e) {
	        sY = e.detail;
	      }
	      if ('wheelDelta' in e) {
	        sY = -e.wheelDelta / 120;
	      }
	      if ('wheelDeltaY' in e) {
	        sY = -e.wheelDeltaY / 120;
	      }
	      if ('wheelDeltaX' in e) {
	        sX = -e.wheelDeltaX / 120;
	      }
	
	      // side scrolling on FF with DOMMouseScroll
	      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
	        sX = sY;
	        sY = 0;
	      }
	
	      pX = sX * PIXEL_STEP;
	      pY = sY * PIXEL_STEP;
	
	      if ('deltaY' in e) {
	        pY = e.deltaY;
	      }
	      if ('deltaX' in e) {
	        pX = e.deltaX;
	      }
	
	      if ((pX || pY) && e.deltaMode) {
	        if (e.deltaMode === 1) { // delta in LINE units
	          pX *= LINE_HEIGHT;
	          pY *= LINE_HEIGHT;
	        } else { // delta in PAGE units
	          pX *= PAGE_HEIGHT;
	          pY *= PAGE_HEIGHT;
	        }
	      }
	
	      // Fall-back if spin cannot be determined
	      if (pX && !sX) {
	        sX = (pX < 1) ? -1 : 1;
	      }
	      if (pY && !sY) {
	        sY = (pY < 1) ? -1 : 1;
	      }
	
	      return {
	        spinX: sX,
	        spinY: sY,
	        pixelX: pX,
	        pixelY: pY,
	      };
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      var swiper = this;
	      swiper.mouseEntered = true;
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      var swiper = this;
	      swiper.mouseEntered = false;
	    },
	    handle: function handle(event) {
	      var e = event;
	      var swiper = this;
	      var params = swiper.params.mousewheel;
	
	      if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }
	
	      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
	      var delta = 0;
	      var rtlFactor = swiper.rtlTranslate ? -1 : 1;
	
	      var data = Mousewheel.normalize(e);
	
	      if (params.forceToAxis) {
	        if (swiper.isHorizontal()) {
	          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
	          else { return true; }
	        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
	        else { return true; }
	      } else {
	        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
	      }
	
	      if (delta === 0) { return true; }
	
	      if (params.invert) { delta = -delta; }
	
	      if (!swiper.params.freeMode) {
	        if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
	          if (delta < 0) {
	            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
	              swiper.slideNext();
	              swiper.emit('scroll', e);
	            } else if (params.releaseOnEdges) { return true; }
	          } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
	            swiper.slidePrev();
	            swiper.emit('scroll', e);
	          } else if (params.releaseOnEdges) { return true; }
	        }
	        swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
	      } else {
	        // Freemode or scrollContainer:
	        if (swiper.params.loop) {
	          swiper.loopFix();
	        }
	        var position = swiper.getTranslate() + (delta * params.sensitivity);
	        var wasBeginning = swiper.isBeginning;
	        var wasEnd = swiper.isEnd;
	
	        if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
	        if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }
	
	        swiper.setTransition(0);
	        swiper.setTranslate(position);
	        swiper.updateProgress();
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	
	        if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
	          swiper.updateSlidesClasses();
	        }
	
	        if (swiper.params.freeModeSticky) {
	          clearTimeout(swiper.mousewheel.timeout);
	          swiper.mousewheel.timeout = Utils.nextTick(function () {
	            swiper.slideToClosest();
	          }, 300);
	        }
	        // Emit event
	        swiper.emit('scroll', e);
	
	        // Stop autoplay
	        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
	        // Return page scroll on edge positions
	        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
	      }
	
	      if (e.preventDefault) { e.preventDefault(); }
	      else { e.returnValue = false; }
	      return false;
	    },
	    enable: function enable() {
	      var swiper = this;
	      if (!Mousewheel.event) { return false; }
	      if (swiper.mousewheel.enabled) { return false; }
	      var target = swiper.$el;
	      if (swiper.params.mousewheel.eventsTarged !== 'container') {
	        target = $(swiper.params.mousewheel.eventsTarged);
	      }
	      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
	      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
	      target.on(Mousewheel.event, swiper.mousewheel.handle);
	      swiper.mousewheel.enabled = true;
	      return true;
	    },
	    disable: function disable() {
	      var swiper = this;
	      if (!Mousewheel.event) { return false; }
	      if (!swiper.mousewheel.enabled) { return false; }
	      var target = swiper.$el;
	      if (swiper.params.mousewheel.eventsTarged !== 'container') {
	        target = $(swiper.params.mousewheel.eventsTarged);
	      }
	      target.off(Mousewheel.event, swiper.mousewheel.handle);
	      swiper.mousewheel.enabled = false;
	      return true;
	    },
	  };
	
	  var Mousewheel$1 = {
	    name: 'mousewheel',
	    params: {
	      mousewheel: {
	        enabled: false,
	        releaseOnEdges: false,
	        invert: false,
	        forceToAxis: false,
	        sensitivity: 1,
	        eventsTarged: 'container',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        mousewheel: {
	          enabled: false,
	          enable: Mousewheel.enable.bind(swiper),
	          disable: Mousewheel.disable.bind(swiper),
	          handle: Mousewheel.handle.bind(swiper),
	          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
	          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
	          lastScrollTime: Utils.now(),
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
	      },
	    },
	  };
	
	  var Navigation = {
	    update: function update() {
	      // Update Navigation Buttons
	      var swiper = this;
	      var params = swiper.params.navigation;
	
	      if (swiper.params.loop) { return; }
	      var ref = swiper.navigation;
	      var $nextEl = ref.$nextEl;
	      var $prevEl = ref.$prevEl;
	
	      if ($prevEl && $prevEl.length > 0) {
	        if (swiper.isBeginning) {
	          $prevEl.addClass(params.disabledClass);
	        } else {
	          $prevEl.removeClass(params.disabledClass);
	        }
	        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	      }
	      if ($nextEl && $nextEl.length > 0) {
	        if (swiper.isEnd) {
	          $nextEl.addClass(params.disabledClass);
	        } else {
	          $nextEl.removeClass(params.disabledClass);
	        }
	        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	      }
	    },
	    onPrevClick: function onPrevClick(e) {
	      var swiper = this;
	      e.preventDefault();
	      if (swiper.isBeginning && !swiper.params.loop) { return; }
	      swiper.slidePrev();
	    },
	    onNextClick: function onNextClick(e) {
	      var swiper = this;
	      e.preventDefault();
	      if (swiper.isEnd && !swiper.params.loop) { return; }
	      swiper.slideNext();
	    },
	    init: function init() {
	      var swiper = this;
	      var params = swiper.params.navigation;
	      if (!(params.nextEl || params.prevEl)) { return; }
	
	      var $nextEl;
	      var $prevEl;
	      if (params.nextEl) {
	        $nextEl = $(params.nextEl);
	        if (
	          swiper.params.uniqueNavElements
	          && typeof params.nextEl === 'string'
	          && $nextEl.length > 1
	          && swiper.$el.find(params.nextEl).length === 1
	        ) {
	          $nextEl = swiper.$el.find(params.nextEl);
	        }
	      }
	      if (params.prevEl) {
	        $prevEl = $(params.prevEl);
	        if (
	          swiper.params.uniqueNavElements
	          && typeof params.prevEl === 'string'
	          && $prevEl.length > 1
	          && swiper.$el.find(params.prevEl).length === 1
	        ) {
	          $prevEl = swiper.$el.find(params.prevEl);
	        }
	      }
	
	      if ($nextEl && $nextEl.length > 0) {
	        $nextEl.on('click', swiper.navigation.onNextClick);
	      }
	      if ($prevEl && $prevEl.length > 0) {
	        $prevEl.on('click', swiper.navigation.onPrevClick);
	      }
	
	      Utils.extend(swiper.navigation, {
	        $nextEl: $nextEl,
	        nextEl: $nextEl && $nextEl[0],
	        $prevEl: $prevEl,
	        prevEl: $prevEl && $prevEl[0],
	      });
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      var ref = swiper.navigation;
	      var $nextEl = ref.$nextEl;
	      var $prevEl = ref.$prevEl;
	      if ($nextEl && $nextEl.length) {
	        $nextEl.off('click', swiper.navigation.onNextClick);
	        $nextEl.removeClass(swiper.params.navigation.disabledClass);
	      }
	      if ($prevEl && $prevEl.length) {
	        $prevEl.off('click', swiper.navigation.onPrevClick);
	        $prevEl.removeClass(swiper.params.navigation.disabledClass);
	      }
	    },
	  };
	
	  var Navigation$1 = {
	    name: 'navigation',
	    params: {
	      navigation: {
	        nextEl: null,
	        prevEl: null,
	
	        hideOnClick: false,
	        disabledClass: 'swiper-button-disabled',
	        hiddenClass: 'swiper-button-hidden',
	        lockClass: 'swiper-button-lock',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        navigation: {
	          init: Navigation.init.bind(swiper),
	          update: Navigation.update.bind(swiper),
	          destroy: Navigation.destroy.bind(swiper),
	          onNextClick: Navigation.onNextClick.bind(swiper),
	          onPrevClick: Navigation.onPrevClick.bind(swiper),
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        swiper.navigation.init();
	        swiper.navigation.update();
	      },
	      toEdge: function toEdge() {
	        var swiper = this;
	        swiper.navigation.update();
	      },
	      fromEdge: function fromEdge() {
	        var swiper = this;
	        swiper.navigation.update();
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.navigation.destroy();
	      },
	      click: function click(e) {
	        var swiper = this;
	        var ref = swiper.navigation;
	        var $nextEl = ref.$nextEl;
	        var $prevEl = ref.$prevEl;
	        if (
	          swiper.params.navigation.hideOnClick
	          && !$(e.target).is($prevEl)
	          && !$(e.target).is($nextEl)
	        ) {
	          if ($nextEl) { $nextEl.toggleClass(swiper.params.navigation.hiddenClass); }
	          if ($prevEl) { $prevEl.toggleClass(swiper.params.navigation.hiddenClass); }
	        }
	      },
	    },
	  };
	
	  var Pagination = {
	    update: function update() {
	      // Render || Update Pagination bullets/items
	      var swiper = this;
	      var rtl = swiper.rtl;
	      var params = swiper.params.pagination;
	      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	      var $el = swiper.pagination.$el;
	      // Current/Total
	      var current;
	      var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	      if (swiper.params.loop) {
	        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
	        if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
	          current -= (slidesLength - (swiper.loopedSlides * 2));
	        }
	        if (current > total - 1) { current -= total; }
	        if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
	      } else if (typeof swiper.snapIndex !== 'undefined') {
	        current = swiper.snapIndex;
	      } else {
	        current = swiper.activeIndex || 0;
	      }
	      // Types
	      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	        var bullets = swiper.pagination.bullets;
	        var firstIndex;
	        var lastIndex;
	        var midIndex;
	        if (params.dynamicBullets) {
	          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
	          $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
	          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
	            swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
	            if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
	              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
	            } else if (swiper.pagination.dynamicBulletIndex < 0) {
	              swiper.pagination.dynamicBulletIndex = 0;
	            }
	          }
	          firstIndex = current - swiper.pagination.dynamicBulletIndex;
	          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
	          midIndex = (lastIndex + firstIndex) / 2;
	        }
	        bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
	        if ($el.length > 1) {
	          bullets.each(function (index, bullet) {
	            var $bullet = $(bullet);
	            var bulletIndex = $bullet.index();
	            if (bulletIndex === current) {
	              $bullet.addClass(params.bulletActiveClass);
	            }
	            if (params.dynamicBullets) {
	              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
	                $bullet.addClass(((params.bulletActiveClass) + "-main"));
	              }
	              if (bulletIndex === firstIndex) {
	                $bullet
	                  .prev()
	                  .addClass(((params.bulletActiveClass) + "-prev"))
	                  .prev()
	                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
	              }
	              if (bulletIndex === lastIndex) {
	                $bullet
	                  .next()
	                  .addClass(((params.bulletActiveClass) + "-next"))
	                  .next()
	                  .addClass(((params.bulletActiveClass) + "-next-next"));
	              }
	            }
	          });
	        } else {
	          var $bullet = bullets.eq(current);
	          $bullet.addClass(params.bulletActiveClass);
	          if (params.dynamicBullets) {
	            var $firstDisplayedBullet = bullets.eq(firstIndex);
	            var $lastDisplayedBullet = bullets.eq(lastIndex);
	            for (var i = firstIndex; i <= lastIndex; i += 1) {
	              bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
	            }
	            $firstDisplayedBullet
	              .prev()
	              .addClass(((params.bulletActiveClass) + "-prev"))
	              .prev()
	              .addClass(((params.bulletActiveClass) + "-prev-prev"));
	            $lastDisplayedBullet
	              .next()
	              .addClass(((params.bulletActiveClass) + "-next"))
	              .next()
	              .addClass(((params.bulletActiveClass) + "-next-next"));
	          }
	        }
	        if (params.dynamicBullets) {
	          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
	          var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
	          var offsetProp = rtl ? 'right' : 'left';
	          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
	        }
	      }
	      if (params.type === 'fraction') {
	        $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
	        $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
	      }
	      if (params.type === 'progressbar') {
	        var progressbarDirection;
	        if (params.progressbarOpposite) {
	          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
	        } else {
	          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
	        }
	        var scale = (current + 1) / total;
	        var scaleX = 1;
	        var scaleY = 1;
	        if (progressbarDirection === 'horizontal') {
	          scaleX = scale;
	        } else {
	          scaleY = scale;
	        }
	        $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
	      }
	      if (params.type === 'custom' && params.renderCustom) {
	        $el.html(params.renderCustom(swiper, current + 1, total));
	        swiper.emit('paginationRender', swiper, $el[0]);
	      } else {
	        swiper.emit('paginationUpdate', swiper, $el[0]);
	      }
	      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    },
	    render: function render() {
	      // Render Container
	      var swiper = this;
	      var params = swiper.params.pagination;
	      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	
	      var $el = swiper.pagination.$el;
	      var paginationHTML = '';
	      if (params.type === 'bullets') {
	        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	        for (var i = 0; i < numberOfBullets; i += 1) {
	          if (params.renderBullet) {
	            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	          } else {
	            paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
	          }
	        }
	        $el.html(paginationHTML);
	        swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
	      }
	      if (params.type === 'fraction') {
	        if (params.renderFraction) {
	          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	        } else {
	          paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
	          + ' / '
	          + "<span class=\"" + (params.totalClass) + "\"></span>";
	        }
	        $el.html(paginationHTML);
	      }
	      if (params.type === 'progressbar') {
	        if (params.renderProgressbar) {
	          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	        } else {
	          paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
	        }
	        $el.html(paginationHTML);
	      }
	      if (params.type !== 'custom') {
	        swiper.emit('paginationRender', swiper.pagination.$el[0]);
	      }
	    },
	    init: function init() {
	      var swiper = this;
	      var params = swiper.params.pagination;
	      if (!params.el) { return; }
	
	      var $el = $(params.el);
	      if ($el.length === 0) { return; }
	
	      if (
	        swiper.params.uniqueNavElements
	        && typeof params.el === 'string'
	        && $el.length > 1
	        && swiper.$el.find(params.el).length === 1
	      ) {
	        $el = swiper.$el.find(params.el);
	      }
	
	      if (params.type === 'bullets' && params.clickable) {
	        $el.addClass(params.clickableClass);
	      }
	
	      $el.addClass(params.modifierClass + params.type);
	
	      if (params.type === 'bullets' && params.dynamicBullets) {
	        $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
	        swiper.pagination.dynamicBulletIndex = 0;
	        if (params.dynamicMainBullets < 1) {
	          params.dynamicMainBullets = 1;
	        }
	      }
	      if (params.type === 'progressbar' && params.progressbarOpposite) {
	        $el.addClass(params.progressbarOppositeClass);
	      }
	
	      if (params.clickable) {
	        $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
	          e.preventDefault();
	          var index = $(this).index() * swiper.params.slidesPerGroup;
	          if (swiper.params.loop) { index += swiper.loopedSlides; }
	          swiper.slideTo(index);
	        });
	      }
	
	      Utils.extend(swiper.pagination, {
	        $el: $el,
	        el: $el[0],
	      });
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      var params = swiper.params.pagination;
	      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	      var $el = swiper.pagination.$el;
	
	      $el.removeClass(params.hiddenClass);
	      $el.removeClass(params.modifierClass + params.type);
	      if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
	      if (params.clickable) {
	        $el.off('click', ("." + (params.bulletClass)));
	      }
	    },
	  };
	
	  var Pagination$1 = {
	    name: 'pagination',
	    params: {
	      pagination: {
	        el: null,
	        bulletElement: 'span',
	        clickable: false,
	        hideOnClick: false,
	        renderBullet: null,
	        renderProgressbar: null,
	        renderFraction: null,
	        renderCustom: null,
	        progressbarOpposite: false,
	        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	        dynamicBullets: false,
	        dynamicMainBullets: 1,
	        formatFractionCurrent: function (number) { return number; },
	        formatFractionTotal: function (number) { return number; },
	        bulletClass: 'swiper-pagination-bullet',
	        bulletActiveClass: 'swiper-pagination-bullet-active',
	        modifierClass: 'swiper-pagination-', // NEW
	        currentClass: 'swiper-pagination-current',
	        totalClass: 'swiper-pagination-total',
	        hiddenClass: 'swiper-pagination-hidden',
	        progressbarFillClass: 'swiper-pagination-progressbar-fill',
	        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
	        clickableClass: 'swiper-pagination-clickable', // NEW
	        lockClass: 'swiper-pagination-lock',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        pagination: {
	          init: Pagination.init.bind(swiper),
	          render: Pagination.render.bind(swiper),
	          update: Pagination.update.bind(swiper),
	          destroy: Pagination.destroy.bind(swiper),
	          dynamicBulletIndex: 0,
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        swiper.pagination.init();
	        swiper.pagination.render();
	        swiper.pagination.update();
	      },
	      activeIndexChange: function activeIndexChange() {
	        var swiper = this;
	        if (swiper.params.loop) {
	          swiper.pagination.update();
	        } else if (typeof swiper.snapIndex === 'undefined') {
	          swiper.pagination.update();
	        }
	      },
	      snapIndexChange: function snapIndexChange() {
	        var swiper = this;
	        if (!swiper.params.loop) {
	          swiper.pagination.update();
	        }
	      },
	      slidesLengthChange: function slidesLengthChange() {
	        var swiper = this;
	        if (swiper.params.loop) {
	          swiper.pagination.render();
	          swiper.pagination.update();
	        }
	      },
	      snapGridLengthChange: function snapGridLengthChange() {
	        var swiper = this;
	        if (!swiper.params.loop) {
	          swiper.pagination.render();
	          swiper.pagination.update();
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.pagination.destroy();
	      },
	      click: function click(e) {
	        var swiper = this;
	        if (
	          swiper.params.pagination.el
	          && swiper.params.pagination.hideOnClick
	          && swiper.pagination.$el.length > 0
	          && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
	        ) {
	          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
	        }
	      },
	    },
	  };
	
	  var Scrollbar = {
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	      var scrollbar = swiper.scrollbar;
	      var rtl = swiper.rtlTranslate;
	      var progress = swiper.progress;
	      var dragSize = scrollbar.dragSize;
	      var trackSize = scrollbar.trackSize;
	      var $dragEl = scrollbar.$dragEl;
	      var $el = scrollbar.$el;
	      var params = swiper.params.scrollbar;
	
	      var newSize = dragSize;
	      var newPos = (trackSize - dragSize) * progress;
	      if (rtl) {
	        newPos = -newPos;
	        if (newPos > 0) {
	          newSize = dragSize - newPos;
	          newPos = 0;
	        } else if (-newPos + dragSize > trackSize) {
	          newSize = trackSize + newPos;
	        }
	      } else if (newPos < 0) {
	        newSize = dragSize + newPos;
	        newPos = 0;
	      } else if (newPos + dragSize > trackSize) {
	        newSize = trackSize - newPos;
	      }
	      if (swiper.isHorizontal()) {
	        if (Support.transforms3d) {
	          $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
	        } else {
	          $dragEl.transform(("translateX(" + newPos + "px)"));
	        }
	        $dragEl[0].style.width = newSize + "px";
	      } else {
	        if (Support.transforms3d) {
	          $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
	        } else {
	          $dragEl.transform(("translateY(" + newPos + "px)"));
	        }
	        $dragEl[0].style.height = newSize + "px";
	      }
	      if (params.hide) {
	        clearTimeout(swiper.scrollbar.timeout);
	        $el[0].style.opacity = 1;
	        swiper.scrollbar.timeout = setTimeout(function () {
	          $el[0].style.opacity = 0;
	          $el.transition(400);
	        }, 1000);
	      }
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	      swiper.scrollbar.$dragEl.transition(duration);
	    },
	    updateSize: function updateSize() {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	
	      var scrollbar = swiper.scrollbar;
	      var $dragEl = scrollbar.$dragEl;
	      var $el = scrollbar.$el;
	
	      $dragEl[0].style.width = '';
	      $dragEl[0].style.height = '';
	      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
	
	      var divider = swiper.size / swiper.virtualSize;
	      var moveDivider = divider * (trackSize / swiper.size);
	      var dragSize;
	      if (swiper.params.scrollbar.dragSize === 'auto') {
	        dragSize = trackSize * divider;
	      } else {
	        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
	      }
	
	      if (swiper.isHorizontal()) {
	        $dragEl[0].style.width = dragSize + "px";
	      } else {
	        $dragEl[0].style.height = dragSize + "px";
	      }
	
	      if (divider >= 1) {
	        $el[0].style.display = 'none';
	      } else {
	        $el[0].style.display = '';
	      }
	      if (swiper.params.scrollbarHide) {
	        $el[0].style.opacity = 0;
	      }
	      Utils.extend(scrollbar, {
	        trackSize: trackSize,
	        divider: divider,
	        moveDivider: moveDivider,
	        dragSize: dragSize,
	      });
	      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
	    },
	    setDragPosition: function setDragPosition(e) {
	      var swiper = this;
	      var scrollbar = swiper.scrollbar;
	      var rtl = swiper.rtlTranslate;
	      var $el = scrollbar.$el;
	      var dragSize = scrollbar.dragSize;
	      var trackSize = scrollbar.trackSize;
	
	      var pointerPosition;
	      if (swiper.isHorizontal()) {
	        pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
	      } else {
	        pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
	      }
	      var positionRatio;
	      positionRatio = ((pointerPosition) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragSize / 2)) / (trackSize - dragSize);
	      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
	      if (rtl) {
	        positionRatio = 1 - positionRatio;
	      }
	
	      var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);
	
	      swiper.updateProgress(position);
	      swiper.setTranslate(position);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    },
	    onDragStart: function onDragStart(e) {
	      var swiper = this;
	      var params = swiper.params.scrollbar;
	      var scrollbar = swiper.scrollbar;
	      var $wrapperEl = swiper.$wrapperEl;
	      var $el = scrollbar.$el;
	      var $dragEl = scrollbar.$dragEl;
	      swiper.scrollbar.isTouched = true;
	      e.preventDefault();
	      e.stopPropagation();
	
	      $wrapperEl.transition(100);
	      $dragEl.transition(100);
	      scrollbar.setDragPosition(e);
	
	      clearTimeout(swiper.scrollbar.dragTimeout);
	
	      $el.transition(0);
	      if (params.hide) {
	        $el.css('opacity', 1);
	      }
	      swiper.emit('scrollbarDragStart', e);
	    },
	    onDragMove: function onDragMove(e) {
	      var swiper = this;
	      var scrollbar = swiper.scrollbar;
	      var $wrapperEl = swiper.$wrapperEl;
	      var $el = scrollbar.$el;
	      var $dragEl = scrollbar.$dragEl;
	
	      if (!swiper.scrollbar.isTouched) { return; }
	      if (e.preventDefault) { e.preventDefault(); }
	      else { e.returnValue = false; }
	      scrollbar.setDragPosition(e);
	      $wrapperEl.transition(0);
	      $el.transition(0);
	      $dragEl.transition(0);
	      swiper.emit('scrollbarDragMove', e);
	    },
	    onDragEnd: function onDragEnd(e) {
	      var swiper = this;
	
	      var params = swiper.params.scrollbar;
	      var scrollbar = swiper.scrollbar;
	      var $el = scrollbar.$el;
	
	      if (!swiper.scrollbar.isTouched) { return; }
	      swiper.scrollbar.isTouched = false;
	      if (params.hide) {
	        clearTimeout(swiper.scrollbar.dragTimeout);
	        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
	          $el.css('opacity', 0);
	          $el.transition(400);
	        }, 1000);
	      }
	      swiper.emit('scrollbarDragEnd', e);
	      if (params.snapOnRelease) {
	        swiper.slideToClosest();
	      }
	    },
	    enableDraggable: function enableDraggable() {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el) { return; }
	      var scrollbar = swiper.scrollbar;
	      var touchEventsTouch = swiper.touchEventsTouch;
	      var touchEventsDesktop = swiper.touchEventsDesktop;
	      var params = swiper.params;
	      var $el = scrollbar.$el;
	      var target = $el[0];
	      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
	      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	      if (!Support.touch) {
	        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	      } else {
	        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
	        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
	        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
	      }
	    },
	    disableDraggable: function disableDraggable() {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el) { return; }
	      var scrollbar = swiper.scrollbar;
	      var touchEventsTouch = swiper.touchEventsTouch;
	      var touchEventsDesktop = swiper.touchEventsDesktop;
	      var params = swiper.params;
	      var $el = scrollbar.$el;
	      var target = $el[0];
	      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
	      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	      if (!Support.touch) {
	        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	      } else {
	        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
	        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
	        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
	      }
	    },
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el) { return; }
	      var scrollbar = swiper.scrollbar;
	      var $swiperEl = swiper.$el;
	      var params = swiper.params.scrollbar;
	
	      var $el = $(params.el);
	      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
	        $el = $swiperEl.find(params.el);
	      }
	
	      var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
	      if ($dragEl.length === 0) {
	        $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
	        $el.append($dragEl);
	      }
	
	      Utils.extend(scrollbar, {
	        $el: $el,
	        el: $el[0],
	        $dragEl: $dragEl,
	        dragEl: $dragEl[0],
	      });
	
	      if (params.draggable) {
	        scrollbar.enableDraggable();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.scrollbar.disableDraggable();
	    },
	  };
	
	  var Scrollbar$1 = {
	    name: 'scrollbar',
	    params: {
	      scrollbar: {
	        el: null,
	        dragSize: 'auto',
	        hide: false,
	        draggable: false,
	        snapOnRelease: true,
	        lockClass: 'swiper-scrollbar-lock',
	        dragClass: 'swiper-scrollbar-drag',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        scrollbar: {
	          init: Scrollbar.init.bind(swiper),
	          destroy: Scrollbar.destroy.bind(swiper),
	          updateSize: Scrollbar.updateSize.bind(swiper),
	          setTranslate: Scrollbar.setTranslate.bind(swiper),
	          setTransition: Scrollbar.setTransition.bind(swiper),
	          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
	          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
	          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
	          onDragStart: Scrollbar.onDragStart.bind(swiper),
	          onDragMove: Scrollbar.onDragMove.bind(swiper),
	          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
	          isTouched: false,
	          timeout: null,
	          dragTimeout: null,
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        swiper.scrollbar.init();
	        swiper.scrollbar.updateSize();
	        swiper.scrollbar.setTranslate();
	      },
	      update: function update() {
	        var swiper = this;
	        swiper.scrollbar.updateSize();
	      },
	      resize: function resize() {
	        var swiper = this;
	        swiper.scrollbar.updateSize();
	      },
	      observerUpdate: function observerUpdate() {
	        var swiper = this;
	        swiper.scrollbar.updateSize();
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        swiper.scrollbar.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        swiper.scrollbar.setTransition(duration);
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.scrollbar.destroy();
	      },
	    },
	  };
	
	  var Parallax = {
	    setTransform: function setTransform(el, progress) {
	      var swiper = this;
	      var rtl = swiper.rtl;
	
	      var $el = $(el);
	      var rtlFactor = rtl ? -1 : 1;
	
	      var p = $el.attr('data-swiper-parallax') || '0';
	      var x = $el.attr('data-swiper-parallax-x');
	      var y = $el.attr('data-swiper-parallax-y');
	      var scale = $el.attr('data-swiper-parallax-scale');
	      var opacity = $el.attr('data-swiper-parallax-opacity');
	
	      if (x || y) {
	        x = x || '0';
	        y = y || '0';
	      } else if (swiper.isHorizontal()) {
	        x = p;
	        y = '0';
	      } else {
	        y = p;
	        x = '0';
	      }
	
	      if ((x).indexOf('%') >= 0) {
	        x = (parseInt(x, 10) * progress * rtlFactor) + "%";
	      } else {
	        x = (x * progress * rtlFactor) + "px";
	      }
	      if ((y).indexOf('%') >= 0) {
	        y = (parseInt(y, 10) * progress) + "%";
	      } else {
	        y = (y * progress) + "px";
	      }
	
	      if (typeof opacity !== 'undefined' && opacity !== null) {
	        var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
	        $el[0].style.opacity = currentOpacity;
	      }
	      if (typeof scale === 'undefined' || scale === null) {
	        $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
	      } else {
	        var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
	        $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
	      }
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      var $el = swiper.$el;
	      var slides = swiper.slides;
	      var progress = swiper.progress;
	      var snapGrid = swiper.snapGrid;
	      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	        .each(function (index, el) {
	          swiper.parallax.setTransform(el, progress);
	        });
	      slides.each(function (slideIndex, slideEl) {
	        var slideProgress = slideEl.progress;
	        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
	          slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
	        }
	        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
	        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	          .each(function (index, el) {
	            swiper.parallax.setTransform(el, slideProgress);
	          });
	      });
	    },
	    setTransition: function setTransition(duration) {
	      if ( duration === void 0 ) duration = this.params.speed;
	
	      var swiper = this;
	      var $el = swiper.$el;
	      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	        .each(function (index, parallaxEl) {
	          var $parallaxEl = $(parallaxEl);
	          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
	          if (duration === 0) { parallaxDuration = 0; }
	          $parallaxEl.transition(parallaxDuration);
	        });
	    },
	  };
	
	  var Parallax$1 = {
	    name: 'parallax',
	    params: {
	      parallax: {
	        enabled: false,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        parallax: {
	          setTransform: Parallax.setTransform.bind(swiper),
	          setTranslate: Parallax.setTranslate.bind(swiper),
	          setTransition: Parallax.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (!swiper.params.parallax.enabled) { return; }
	        swiper.params.watchSlidesProgress = true;
	        swiper.originalParams.watchSlidesProgress = true;
	      },
	      init: function init() {
	        var swiper = this;
	        if (!swiper.params.parallax) { return; }
	        swiper.parallax.setTranslate();
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (!swiper.params.parallax) { return; }
	        swiper.parallax.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        if (!swiper.params.parallax) { return; }
	        swiper.parallax.setTransition(duration);
	      },
	    },
	  };
	
	  var Zoom = {
	    // Calc Scale From Multi-touches
	    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
	      if (e.targetTouches.length < 2) { return 1; }
	      var x1 = e.targetTouches[0].pageX;
	      var y1 = e.targetTouches[0].pageY;
	      var x2 = e.targetTouches[1].pageX;
	      var y2 = e.targetTouches[1].pageY;
	      var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
	      return distance;
	    },
	    // Events
	    onGestureStart: function onGestureStart(e) {
	      var swiper = this;
	      var params = swiper.params.zoom;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      zoom.fakeGestureTouched = false;
	      zoom.fakeGestureMoved = false;
	      if (!Support.gestures) {
	        if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
	          return;
	        }
	        zoom.fakeGestureTouched = true;
	        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
	      }
	      if (!gesture.$slideEl || !gesture.$slideEl.length) {
	        gesture.$slideEl = $(e.target).closest('.swiper-slide');
	        if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
	        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	        if (gesture.$imageWrapEl.length === 0) {
	          gesture.$imageEl = undefined;
	          return;
	        }
	      }
	      gesture.$imageEl.transition(0);
	      swiper.zoom.isScaling = true;
	    },
	    onGestureChange: function onGestureChange(e) {
	      var swiper = this;
	      var params = swiper.params.zoom;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      if (!Support.gestures) {
	        if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
	          return;
	        }
	        zoom.fakeGestureMoved = true;
	        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
	      }
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	      if (Support.gestures) {
	        zoom.scale = e.scale * zoom.currentScale;
	      } else {
	        zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
	      }
	      if (zoom.scale > gesture.maxRatio) {
	        zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
	      }
	      if (zoom.scale < params.minRatio) {
	        zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
	      }
	      gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	    },
	    onGestureEnd: function onGestureEnd(e) {
	      var swiper = this;
	      var params = swiper.params.zoom;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      if (!Support.gestures) {
	        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
	          return;
	        }
	        if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
	          return;
	        }
	        zoom.fakeGestureTouched = false;
	        zoom.fakeGestureMoved = false;
	      }
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
	      gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	      zoom.currentScale = zoom.scale;
	      zoom.isScaling = false;
	      if (zoom.scale === 1) { gesture.$slideEl = undefined; }
	    },
	    onTouchStart: function onTouchStart(e) {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      var image = zoom.image;
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	      if (image.isTouched) { return; }
	      if (Device.android) { e.preventDefault(); }
	      image.isTouched = true;
	      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	    },
	    onTouchMove: function onTouchMove(e) {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      var image = zoom.image;
	      var velocity = zoom.velocity;
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	      swiper.allowClick = false;
	      if (!image.isTouched || !gesture.$slideEl) { return; }
	
	      if (!image.isMoved) {
	        image.width = gesture.$imageEl[0].offsetWidth;
	        image.height = gesture.$imageEl[0].offsetHeight;
	        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
	        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
	        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
	        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
	        gesture.$imageWrapEl.transition(0);
	        if (swiper.rtl) {
	          image.startX = -image.startX;
	          image.startY = -image.startY;
	        }
	      }
	      // Define if we need image drag
	      var scaledWidth = image.width * zoom.scale;
	      var scaledHeight = image.height * zoom.scale;
	
	      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }
	
	      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	      image.maxX = -image.minX;
	      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	      image.maxY = -image.minY;
	
	      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	
	      if (!image.isMoved && !zoom.isScaling) {
	        if (
	          swiper.isHorizontal()
	          && (
	            (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
	            || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
	          )
	        ) {
	          image.isTouched = false;
	          return;
	        } if (
	          !swiper.isHorizontal()
	          && (
	            (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
	            || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
	          )
	        ) {
	          image.isTouched = false;
	          return;
	        }
	      }
	      e.preventDefault();
	      e.stopPropagation();
	
	      image.isMoved = true;
	      image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
	      image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;
	
	      if (image.currentX < image.minX) {
	        image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
	      }
	      if (image.currentX > image.maxX) {
	        image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
	      }
	
	      if (image.currentY < image.minY) {
	        image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
	      }
	      if (image.currentY > image.maxY) {
	        image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
	      }
	
	      // Velocity
	      if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
	      if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
	      if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
	      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
	      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
	      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
	      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
	      velocity.prevPositionX = image.touchesCurrent.x;
	      velocity.prevPositionY = image.touchesCurrent.y;
	      velocity.prevTime = Date.now();
	
	      gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	    },
	    onTouchEnd: function onTouchEnd() {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      var image = zoom.image;
	      var velocity = zoom.velocity;
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	      if (!image.isTouched || !image.isMoved) {
	        image.isTouched = false;
	        image.isMoved = false;
	        return;
	      }
	      image.isTouched = false;
	      image.isMoved = false;
	      var momentumDurationX = 300;
	      var momentumDurationY = 300;
	      var momentumDistanceX = velocity.x * momentumDurationX;
	      var newPositionX = image.currentX + momentumDistanceX;
	      var momentumDistanceY = velocity.y * momentumDurationY;
	      var newPositionY = image.currentY + momentumDistanceY;
	
	      // Fix duration
	      if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
	      if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
	      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
	
	      image.currentX = newPositionX;
	      image.currentY = newPositionY;
	
	      // Define if we need image drag
	      var scaledWidth = image.width * zoom.scale;
	      var scaledHeight = image.height * zoom.scale;
	      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	      image.maxX = -image.minX;
	      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	      image.maxY = -image.minY;
	      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
	      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
	
	      gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	    },
	    onTransitionEnd: function onTransitionEnd() {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
	        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
	        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
	
	        zoom.scale = 1;
	        zoom.currentScale = 1;
	
	        gesture.$slideEl = undefined;
	        gesture.$imageEl = undefined;
	        gesture.$imageWrapEl = undefined;
	      }
	    },
	    // Toggle Zoom
	    toggle: function toggle(e) {
	      var swiper = this;
	      var zoom = swiper.zoom;
	
	      if (zoom.scale && zoom.scale !== 1) {
	        // Zoom Out
	        zoom.out();
	      } else {
	        // Zoom In
	        zoom.in(e);
	      }
	    },
	    in: function in$1(e) {
	      var swiper = this;
	
	      var zoom = swiper.zoom;
	      var params = swiper.params.zoom;
	      var gesture = zoom.gesture;
	      var image = zoom.image;
	
	      if (!gesture.$slideEl) {
	        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
	        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	      }
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	
	      gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));
	
	      var touchX;
	      var touchY;
	      var offsetX;
	      var offsetY;
	      var diffX;
	      var diffY;
	      var translateX;
	      var translateY;
	      var imageWidth;
	      var imageHeight;
	      var scaledWidth;
	      var scaledHeight;
	      var translateMinX;
	      var translateMinY;
	      var translateMaxX;
	      var translateMaxY;
	      var slideWidth;
	      var slideHeight;
	
	      if (typeof image.touchesStart.x === 'undefined' && e) {
	        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	      } else {
	        touchX = image.touchesStart.x;
	        touchY = image.touchesStart.y;
	      }
	
	      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	      if (e) {
	        slideWidth = gesture.$slideEl[0].offsetWidth;
	        slideHeight = gesture.$slideEl[0].offsetHeight;
	        offsetX = gesture.$slideEl.offset().left;
	        offsetY = gesture.$slideEl.offset().top;
	        diffX = (offsetX + (slideWidth / 2)) - touchX;
	        diffY = (offsetY + (slideHeight / 2)) - touchY;
	
	        imageWidth = gesture.$imageEl[0].offsetWidth;
	        imageHeight = gesture.$imageEl[0].offsetHeight;
	        scaledWidth = imageWidth * zoom.scale;
	        scaledHeight = imageHeight * zoom.scale;
	
	        translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
	        translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
	        translateMaxX = -translateMinX;
	        translateMaxY = -translateMinY;
	
	        translateX = diffX * zoom.scale;
	        translateY = diffY * zoom.scale;
	
	        if (translateX < translateMinX) {
	          translateX = translateMinX;
	        }
	        if (translateX > translateMaxX) {
	          translateX = translateMaxX;
	        }
	
	        if (translateY < translateMinY) {
	          translateY = translateMinY;
	        }
	        if (translateY > translateMaxY) {
	          translateY = translateMaxY;
	        }
	      } else {
	        translateX = 0;
	        translateY = 0;
	      }
	      gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
	      gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	    },
	    out: function out() {
	      var swiper = this;
	
	      var zoom = swiper.zoom;
	      var params = swiper.params.zoom;
	      var gesture = zoom.gesture;
	
	      if (!gesture.$slideEl) {
	        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
	        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	      }
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	
	      zoom.scale = 1;
	      zoom.currentScale = 1;
	      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
	      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
	      gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
	      gesture.$slideEl = undefined;
	    },
	    // Attach/Detach Events
	    enable: function enable() {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      if (zoom.enabled) { return; }
	      zoom.enabled = true;
	
	      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
	
	      // Scale image
	      if (Support.gestures) {
	        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
	        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
	        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
	      } else if (swiper.touchEvents.start === 'touchstart') {
	        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
	        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
	        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
	      }
	
	      // Move image
	      swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
	    },
	    disable: function disable() {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      if (!zoom.enabled) { return; }
	
	      swiper.zoom.enabled = false;
	
	      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
	
	      // Scale image
	      if (Support.gestures) {
	        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
	        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
	        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
	      } else if (swiper.touchEvents.start === 'touchstart') {
	        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
	        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
	        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
	      }
	
	      // Move image
	      swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
	    },
	  };
	
	  var Zoom$1 = {
	    name: 'zoom',
	    params: {
	      zoom: {
	        enabled: false,
	        maxRatio: 3,
	        minRatio: 1,
	        toggle: true,
	        containerClass: 'swiper-zoom-container',
	        zoomedSlideClass: 'swiper-slide-zoomed',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      var zoom = {
	        enabled: false,
	        scale: 1,
	        currentScale: 1,
	        isScaling: false,
	        gesture: {
	          $slideEl: undefined,
	          slideWidth: undefined,
	          slideHeight: undefined,
	          $imageEl: undefined,
	          $imageWrapEl: undefined,
	          maxRatio: 3,
	        },
	        image: {
	          isTouched: undefined,
	          isMoved: undefined,
	          currentX: undefined,
	          currentY: undefined,
	          minX: undefined,
	          minY: undefined,
	          maxX: undefined,
	          maxY: undefined,
	          width: undefined,
	          height: undefined,
	          startX: undefined,
	          startY: undefined,
	          touchesStart: {},
	          touchesCurrent: {},
	        },
	        velocity: {
	          x: undefined,
	          y: undefined,
	          prevPositionX: undefined,
	          prevPositionY: undefined,
	          prevTime: undefined,
	        },
	      };
	
	      ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
	        zoom[methodName] = Zoom[methodName].bind(swiper);
	      });
	      Utils.extend(swiper, {
	        zoom: zoom,
	      });
	
	      var scale = 1;
	      Object.defineProperty(swiper.zoom, 'scale', {
	        get: function get() {
	          return scale;
	        },
	        set: function set(value) {
	          if (scale !== value) {
	            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
	            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
	            swiper.emit('zoomChange', value, imageEl, slideEl);
	          }
	          scale = value;
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.zoom.enabled) {
	          swiper.zoom.enable();
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.zoom.disable();
	      },
	      touchStart: function touchStart(e) {
	        var swiper = this;
	        if (!swiper.zoom.enabled) { return; }
	        swiper.zoom.onTouchStart(e);
	      },
	      touchEnd: function touchEnd(e) {
	        var swiper = this;
	        if (!swiper.zoom.enabled) { return; }
	        swiper.zoom.onTouchEnd(e);
	      },
	      doubleTap: function doubleTap(e) {
	        var swiper = this;
	        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
	          swiper.zoom.toggle(e);
	        }
	      },
	      transitionEnd: function transitionEnd() {
	        var swiper = this;
	        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
	          swiper.zoom.onTransitionEnd();
	        }
	      },
	    },
	  };
	
	  var Lazy = {
	    loadInSlide: function loadInSlide(index, loadInDuplicate) {
	      if ( loadInDuplicate === void 0 ) loadInDuplicate = true;
	
	      var swiper = this;
	      var params = swiper.params.lazy;
	      if (typeof index === 'undefined') { return; }
	      if (swiper.slides.length === 0) { return; }
	      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	
	      var $slideEl = isVirtual
	        ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
	        : swiper.slides.eq(index);
	
	      var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
	      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
	        $images = $images.add($slideEl[0]);
	      }
	      if ($images.length === 0) { return; }
	
	      $images.each(function (imageIndex, imageEl) {
	        var $imageEl = $(imageEl);
	        $imageEl.addClass(params.loadingClass);
	
	        var background = $imageEl.attr('data-background');
	        var src = $imageEl.attr('data-src');
	        var srcset = $imageEl.attr('data-srcset');
	        var sizes = $imageEl.attr('data-sizes');
	
	        swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
	          if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
	          if (background) {
	            $imageEl.css('background-image', ("url(\"" + background + "\")"));
	            $imageEl.removeAttr('data-background');
	          } else {
	            if (srcset) {
	              $imageEl.attr('srcset', srcset);
	              $imageEl.removeAttr('data-srcset');
	            }
	            if (sizes) {
	              $imageEl.attr('sizes', sizes);
	              $imageEl.removeAttr('data-sizes');
	            }
	            if (src) {
	              $imageEl.attr('src', src);
	              $imageEl.removeAttr('data-src');
	            }
	          }
	
	          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
	          $slideEl.find(("." + (params.preloaderClass))).remove();
	          if (swiper.params.loop && loadInDuplicate) {
	            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
	            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
	              var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
	              swiper.lazy.loadInSlide(originalSlide.index(), false);
	            } else {
	              var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
	              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
	            }
	          }
	          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
	        });
	
	        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
	      });
	    },
	    load: function load() {
	      var swiper = this;
	      var $wrapperEl = swiper.$wrapperEl;
	      var swiperParams = swiper.params;
	      var slides = swiper.slides;
	      var activeIndex = swiper.activeIndex;
	      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
	      var params = swiperParams.lazy;
	
	      var slidesPerView = swiperParams.slidesPerView;
	      if (slidesPerView === 'auto') {
	        slidesPerView = 0;
	      }
	
	      function slideExist(index) {
	        if (isVirtual) {
	          if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
	            return true;
	          }
	        } else if (slides[index]) { return true; }
	        return false;
	      }
	      function slideIndex(slideEl) {
	        if (isVirtual) {
	          return $(slideEl).attr('data-swiper-slide-index');
	        }
	        return $(slideEl).index();
	      }
	
	      if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
	      if (swiper.params.watchSlidesVisibility) {
	        $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
	          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
	          swiper.lazy.loadInSlide(index);
	        });
	      } else if (slidesPerView > 1) {
	        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
	          if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
	        }
	      } else {
	        swiper.lazy.loadInSlide(activeIndex);
	      }
	      if (params.loadPrevNext) {
	        if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
	          var amount = params.loadPrevNextAmount;
	          var spv = slidesPerView;
	          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
	          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
	          // Next Slides
	          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
	            if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
	          }
	          // Prev Slides
	          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
	            if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
	          }
	        } else {
	          var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
	          if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }
	
	          var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
	          if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
	        }
	      }
	    },
	  };
	
	  var Lazy$1 = {
	    name: 'lazy',
	    params: {
	      lazy: {
	        enabled: false,
	        loadPrevNext: false,
	        loadPrevNextAmount: 1,
	        loadOnTransitionStart: false,
	
	        elementClass: 'swiper-lazy',
	        loadingClass: 'swiper-lazy-loading',
	        loadedClass: 'swiper-lazy-loaded',
	        preloaderClass: 'swiper-lazy-preloader',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        lazy: {
	          initialImageLoaded: false,
	          load: Lazy.load.bind(swiper),
	          loadInSlide: Lazy.loadInSlide.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
	          swiper.params.preloadImages = false;
	        }
	      },
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
	          swiper.lazy.load();
	        }
	      },
	      scroll: function scroll() {
	        var swiper = this;
	        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
	          swiper.lazy.load();
	        }
	      },
	      resize: function resize() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled) {
	          swiper.lazy.load();
	        }
	      },
	      scrollbarDragMove: function scrollbarDragMove() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled) {
	          swiper.lazy.load();
	        }
	      },
	      transitionStart: function transitionStart() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled) {
	          if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
	            swiper.lazy.load();
	          }
	        }
	      },
	      transitionEnd: function transitionEnd() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
	          swiper.lazy.load();
	        }
	      },
	    },
	  };
	
	  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */
	
	  var Controller = {
	    LinearSpline: function LinearSpline(x, y) {
	      var binarySearch = (function search() {
	        var maxIndex;
	        var minIndex;
	        var guess;
	        return function (array, val) {
	          minIndex = -1;
	          maxIndex = array.length;
	          while (maxIndex - minIndex > 1) {
	            guess = maxIndex + minIndex >> 1;
	            if (array[guess] <= val) {
	              minIndex = guess;
	            } else {
	              maxIndex = guess;
	            }
	          }
	          return maxIndex;
	        };
	      }());
	      this.x = x;
	      this.y = y;
	      this.lastIndex = x.length - 1;
	      // Given an x value (x2), return the expected y2 value:
	      // (x1,y1) is the known point before given value,
	      // (x3,y3) is the known point after given value.
	      var i1;
	      var i3;
	
	      this.interpolate = function interpolate(x2) {
	        if (!x2) { return 0; }
	
	        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	        i3 = binarySearch(this.x, x2);
	        i1 = i3 - 1;
	
	        // We have our indexes i1 & i3, so we can calculate already:
	        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
	      };
	      return this;
	    },
	    // xxx: for now i will just save one spline function to to
	    getInterpolateFunction: function getInterpolateFunction(c) {
	      var swiper = this;
	      if (!swiper.controller.spline) {
	        swiper.controller.spline = swiper.params.loop
	          ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
	          : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
	      }
	    },
	    setTranslate: function setTranslate(setTranslate$1, byController) {
	      var swiper = this;
	      var controlled = swiper.controller.control;
	      var multiplier;
	      var controlledTranslate;
	      function setControlledTranslate(c) {
	        // this will create an Interpolate function based on the snapGrids
	        // x is the Grid of the scrolled scroller and y will be the controlled scroller
	        // it makes sense to create this only once and recall it for the interpolation
	        // the function does a lot of value caching for performance
	        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
	        if (swiper.params.controller.by === 'slide') {
	          swiper.controller.getInterpolateFunction(c);
	          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	          // but it did not work out
	          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
	        }
	
	        if (!controlledTranslate || swiper.params.controller.by === 'container') {
	          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
	          controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
	        }
	
	        if (swiper.params.controller.inverse) {
	          controlledTranslate = c.maxTranslate() - controlledTranslate;
	        }
	        c.updateProgress(controlledTranslate);
	        c.setTranslate(controlledTranslate, swiper);
	        c.updateActiveIndex();
	        c.updateSlidesClasses();
	      }
	      if (Array.isArray(controlled)) {
	        for (var i = 0; i < controlled.length; i += 1) {
	          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	            setControlledTranslate(controlled[i]);
	          }
	        }
	      } else if (controlled instanceof Swiper && byController !== controlled) {
	        setControlledTranslate(controlled);
	      }
	    },
	    setTransition: function setTransition(duration, byController) {
	      var swiper = this;
	      var controlled = swiper.controller.control;
	      var i;
	      function setControlledTransition(c) {
	        c.setTransition(duration, swiper);
	        if (duration !== 0) {
	          c.transitionStart();
	          if (c.params.autoHeight) {
	            Utils.nextTick(function () {
	              c.updateAutoHeight();
	            });
	          }
	          c.$wrapperEl.transitionEnd(function () {
	            if (!controlled) { return; }
	            if (c.params.loop && swiper.params.controller.by === 'slide') {
	              c.loopFix();
	            }
	            c.transitionEnd();
	          });
	        }
	      }
	      if (Array.isArray(controlled)) {
	        for (i = 0; i < controlled.length; i += 1) {
	          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	            setControlledTransition(controlled[i]);
	          }
	        }
	      } else if (controlled instanceof Swiper && byController !== controlled) {
	        setControlledTransition(controlled);
	      }
	    },
	  };
	  var Controller$1 = {
	    name: 'controller',
	    params: {
	      controller: {
	        control: undefined,
	        inverse: false,
	        by: 'slide', // or 'container'
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        controller: {
	          control: swiper.params.controller.control,
	          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
	          setTranslate: Controller.setTranslate.bind(swiper),
	          setTransition: Controller.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      update: function update() {
	        var swiper = this;
	        if (!swiper.controller.control) { return; }
	        if (swiper.controller.spline) {
	          swiper.controller.spline = undefined;
	          delete swiper.controller.spline;
	        }
	      },
	      resize: function resize() {
	        var swiper = this;
	        if (!swiper.controller.control) { return; }
	        if (swiper.controller.spline) {
	          swiper.controller.spline = undefined;
	          delete swiper.controller.spline;
	        }
	      },
	      observerUpdate: function observerUpdate() {
	        var swiper = this;
	        if (!swiper.controller.control) { return; }
	        if (swiper.controller.spline) {
	          swiper.controller.spline = undefined;
	          delete swiper.controller.spline;
	        }
	      },
	      setTranslate: function setTranslate(translate, byController) {
	        var swiper = this;
	        if (!swiper.controller.control) { return; }
	        swiper.controller.setTranslate(translate, byController);
	      },
	      setTransition: function setTransition(duration, byController) {
	        var swiper = this;
	        if (!swiper.controller.control) { return; }
	        swiper.controller.setTransition(duration, byController);
	      },
	    },
	  };
	
	  var a11y = {
	    makeElFocusable: function makeElFocusable($el) {
	      $el.attr('tabIndex', '0');
	      return $el;
	    },
	    addElRole: function addElRole($el, role) {
	      $el.attr('role', role);
	      return $el;
	    },
	    addElLabel: function addElLabel($el, label) {
	      $el.attr('aria-label', label);
	      return $el;
	    },
	    disableEl: function disableEl($el) {
	      $el.attr('aria-disabled', true);
	      return $el;
	    },
	    enableEl: function enableEl($el) {
	      $el.attr('aria-disabled', false);
	      return $el;
	    },
	    onEnterKey: function onEnterKey(e) {
	      var swiper = this;
	      var params = swiper.params.a11y;
	      if (e.keyCode !== 13) { return; }
	      var $targetEl = $(e.target);
	      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
	        if (!(swiper.isEnd && !swiper.params.loop)) {
	          swiper.slideNext();
	        }
	        if (swiper.isEnd) {
	          swiper.a11y.notify(params.lastSlideMessage);
	        } else {
	          swiper.a11y.notify(params.nextSlideMessage);
	        }
	      }
	      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
	        if (!(swiper.isBeginning && !swiper.params.loop)) {
	          swiper.slidePrev();
	        }
	        if (swiper.isBeginning) {
	          swiper.a11y.notify(params.firstSlideMessage);
	        } else {
	          swiper.a11y.notify(params.prevSlideMessage);
	        }
	      }
	      if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
	        $targetEl[0].click();
	      }
	    },
	    notify: function notify(message) {
	      var swiper = this;
	      var notification = swiper.a11y.liveRegion;
	      if (notification.length === 0) { return; }
	      notification.html('');
	      notification.html(message);
	    },
	    updateNavigation: function updateNavigation() {
	      var swiper = this;
	
	      if (swiper.params.loop) { return; }
	      var ref = swiper.navigation;
	      var $nextEl = ref.$nextEl;
	      var $prevEl = ref.$prevEl;
	
	      if ($prevEl && $prevEl.length > 0) {
	        if (swiper.isBeginning) {
	          swiper.a11y.disableEl($prevEl);
	        } else {
	          swiper.a11y.enableEl($prevEl);
	        }
	      }
	      if ($nextEl && $nextEl.length > 0) {
	        if (swiper.isEnd) {
	          swiper.a11y.disableEl($nextEl);
	        } else {
	          swiper.a11y.enableEl($nextEl);
	        }
	      }
	    },
	    updatePagination: function updatePagination() {
	      var swiper = this;
	      var params = swiper.params.a11y;
	      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
	          var $bulletEl = $(bulletEl);
	          swiper.a11y.makeElFocusable($bulletEl);
	          swiper.a11y.addElRole($bulletEl, 'button');
	          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
	        });
	      }
	    },
	    init: function init() {
	      var swiper = this;
	
	      swiper.$el.append(swiper.a11y.liveRegion);
	
	      // Navigation
	      var params = swiper.params.a11y;
	      var $nextEl;
	      var $prevEl;
	      if (swiper.navigation && swiper.navigation.$nextEl) {
	        $nextEl = swiper.navigation.$nextEl;
	      }
	      if (swiper.navigation && swiper.navigation.$prevEl) {
	        $prevEl = swiper.navigation.$prevEl;
	      }
	      if ($nextEl) {
	        swiper.a11y.makeElFocusable($nextEl);
	        swiper.a11y.addElRole($nextEl, 'button');
	        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
	        $nextEl.on('keydown', swiper.a11y.onEnterKey);
	      }
	      if ($prevEl) {
	        swiper.a11y.makeElFocusable($prevEl);
	        swiper.a11y.addElRole($prevEl, 'button');
	        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
	        $prevEl.on('keydown', swiper.a11y.onEnterKey);
	      }
	
	      // Pagination
	      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	        swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }
	
	      var $nextEl;
	      var $prevEl;
	      if (swiper.navigation && swiper.navigation.$nextEl) {
	        $nextEl = swiper.navigation.$nextEl;
	      }
	      if (swiper.navigation && swiper.navigation.$prevEl) {
	        $prevEl = swiper.navigation.$prevEl;
	      }
	      if ($nextEl) {
	        $nextEl.off('keydown', swiper.a11y.onEnterKey);
	      }
	      if ($prevEl) {
	        $prevEl.off('keydown', swiper.a11y.onEnterKey);
	      }
	
	      // Pagination
	      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	        swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	      }
	    },
	  };
	  var A11y = {
	    name: 'a11y',
	    params: {
	      a11y: {
	        enabled: true,
	        notificationClass: 'swiper-notification',
	        prevSlideMessage: 'Previous slide',
	        nextSlideMessage: 'Next slide',
	        firstSlideMessage: 'This is the first slide',
	        lastSlideMessage: 'This is the last slide',
	        paginationBulletMessage: 'Go to slide {{index}}',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        a11y: {
	          liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
	        },
	      });
	      Object.keys(a11y).forEach(function (methodName) {
	        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (!swiper.params.a11y.enabled) { return; }
	        swiper.a11y.init();
	        swiper.a11y.updateNavigation();
	      },
	      toEdge: function toEdge() {
	        var swiper = this;
	        if (!swiper.params.a11y.enabled) { return; }
	        swiper.a11y.updateNavigation();
	      },
	      fromEdge: function fromEdge() {
	        var swiper = this;
	        if (!swiper.params.a11y.enabled) { return; }
	        swiper.a11y.updateNavigation();
	      },
	      paginationUpdate: function paginationUpdate() {
	        var swiper = this;
	        if (!swiper.params.a11y.enabled) { return; }
	        swiper.a11y.updatePagination();
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (!swiper.params.a11y.enabled) { return; }
	        swiper.a11y.destroy();
	      },
	    },
	  };
	
	  var History = {
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.history) { return; }
	      if (!win.history || !win.history.pushState) {
	        swiper.params.history.enabled = false;
	        swiper.params.hashNavigation.enabled = true;
	        return;
	      }
	      var history = swiper.history;
	      history.initialized = true;
	      history.paths = History.getPathValues();
	      if (!history.paths.key && !history.paths.value) { return; }
	      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
	      if (!swiper.params.history.replaceState) {
	        win.addEventListener('popstate', swiper.history.setHistoryPopState);
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (!swiper.params.history.replaceState) {
	        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
	      }
	    },
	    setHistoryPopState: function setHistoryPopState() {
	      var swiper = this;
	      swiper.history.paths = History.getPathValues();
	      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
	    },
	    getPathValues: function getPathValues() {
	      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
	      var total = pathArray.length;
	      var key = pathArray[total - 2];
	      var value = pathArray[total - 1];
	      return { key: key, value: value };
	    },
	    setHistory: function setHistory(key, index) {
	      var swiper = this;
	      if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
	      var slide = swiper.slides.eq(index);
	      var value = History.slugify(slide.attr('data-history'));
	      if (!win.location.pathname.includes(key)) {
	        value = key + "/" + value;
	      }
	      var currentState = win.history.state;
	      if (currentState && currentState.value === value) {
	        return;
	      }
	      if (swiper.params.history.replaceState) {
	        win.history.replaceState({ value: value }, null, value);
	      } else {
	        win.history.pushState({ value: value }, null, value);
	      }
	    },
	    slugify: function slugify(text) {
	      return text.toString().toLowerCase()
	        .replace(/\s+/g, '-')
	        .replace(/[^\w-]+/g, '')
	        .replace(/--+/g, '-')
	        .replace(/^-+/, '')
	        .replace(/-+$/, '');
	    },
	    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
	      var swiper = this;
	      if (value) {
	        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	          var slide = swiper.slides.eq(i);
	          var slideHistory = History.slugify(slide.attr('data-history'));
	          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	            var index = slide.index();
	            swiper.slideTo(index, speed, runCallbacks);
	          }
	        }
	      } else {
	        swiper.slideTo(0, speed, runCallbacks);
	      }
	    },
	  };
	
	  var History$1 = {
	    name: 'history',
	    params: {
	      history: {
	        enabled: false,
	        replaceState: false,
	        key: 'slides',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        history: {
	          init: History.init.bind(swiper),
	          setHistory: History.setHistory.bind(swiper),
	          setHistoryPopState: History.setHistoryPopState.bind(swiper),
	          scrollToSlide: History.scrollToSlide.bind(swiper),
	          destroy: History.destroy.bind(swiper),
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.history.enabled) {
	          swiper.history.init();
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.params.history.enabled) {
	          swiper.history.destroy();
	        }
	      },
	      transitionEnd: function transitionEnd() {
	        var swiper = this;
	        if (swiper.history.initialized) {
	          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
	        }
	      },
	    },
	  };
	
	  var HashNavigation = {
	    onHashCange: function onHashCange() {
	      var swiper = this;
	      var newHash = doc.location.hash.replace('#', '');
	      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
	      if (newHash !== activeSlideHash) {
	        var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
	        if (typeof newIndex === 'undefined') { return; }
	        swiper.slideTo(newIndex);
	      }
	    },
	    setHash: function setHash() {
	      var swiper = this;
	      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
	      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
	        win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
	      } else {
	        var slide = swiper.slides.eq(swiper.activeIndex);
	        var hash = slide.attr('data-hash') || slide.attr('data-history');
	        doc.location.hash = hash || '';
	      }
	    },
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
	      swiper.hashNavigation.initialized = true;
	      var hash = doc.location.hash.replace('#', '');
	      if (hash) {
	        var speed = 0;
	        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	          var slide = swiper.slides.eq(i);
	          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
	          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	            var index = slide.index();
	            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
	          }
	        }
	      }
	      if (swiper.params.hashNavigation.watchState) {
	        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.params.hashNavigation.watchState) {
	        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
	      }
	    },
	  };
	  var HashNavigation$1 = {
	    name: 'hash-navigation',
	    params: {
	      hashNavigation: {
	        enabled: false,
	        replaceState: false,
	        watchState: false,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        hashNavigation: {
	          initialized: false,
	          init: HashNavigation.init.bind(swiper),
	          destroy: HashNavigation.destroy.bind(swiper),
	          setHash: HashNavigation.setHash.bind(swiper),
	          onHashCange: HashNavigation.onHashCange.bind(swiper),
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.hashNavigation.enabled) {
	          swiper.hashNavigation.init();
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.params.hashNavigation.enabled) {
	          swiper.hashNavigation.destroy();
	        }
	      },
	      transitionEnd: function transitionEnd() {
	        var swiper = this;
	        if (swiper.hashNavigation.initialized) {
	          swiper.hashNavigation.setHash();
	        }
	      },
	    },
	  };
	
	  /* eslint no-underscore-dangle: "off" */
	
	  var Autoplay = {
	    run: function run() {
	      var swiper = this;
	      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
	      var delay = swiper.params.autoplay.delay;
	      if ($activeSlideEl.attr('data-swiper-autoplay')) {
	        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
	      }
	      swiper.autoplay.timeout = Utils.nextTick(function () {
	        if (swiper.params.autoplay.reverseDirection) {
	          if (swiper.params.loop) {
	            swiper.loopFix();
	            swiper.slidePrev(swiper.params.speed, true, true);
	            swiper.emit('autoplay');
	          } else if (!swiper.isBeginning) {
	            swiper.slidePrev(swiper.params.speed, true, true);
	            swiper.emit('autoplay');
	          } else if (!swiper.params.autoplay.stopOnLastSlide) {
	            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
	            swiper.emit('autoplay');
	          } else {
	            swiper.autoplay.stop();
	          }
	        } else if (swiper.params.loop) {
	          swiper.loopFix();
	          swiper.slideNext(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.isEnd) {
	          swiper.slideNext(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.params.autoplay.stopOnLastSlide) {
	          swiper.slideTo(0, swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else {
	          swiper.autoplay.stop();
	        }
	      }, delay);
	    },
	    start: function start() {
	      var swiper = this;
	      if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
	      if (swiper.autoplay.running) { return false; }
	      swiper.autoplay.running = true;
	      swiper.emit('autoplayStart');
	      swiper.autoplay.run();
	      return true;
	    },
	    stop: function stop() {
	      var swiper = this;
	      if (!swiper.autoplay.running) { return false; }
	      if (typeof swiper.autoplay.timeout === 'undefined') { return false; }
	
	      if (swiper.autoplay.timeout) {
	        clearTimeout(swiper.autoplay.timeout);
	        swiper.autoplay.timeout = undefined;
	      }
	      swiper.autoplay.running = false;
	      swiper.emit('autoplayStop');
	      return true;
	    },
	    pause: function pause(speed) {
	      var swiper = this;
	      if (!swiper.autoplay.running) { return; }
	      if (swiper.autoplay.paused) { return; }
	      if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
	      swiper.autoplay.paused = true;
	      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
	        swiper.autoplay.paused = false;
	        swiper.autoplay.run();
	      } else {
	        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
	        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
	      }
	    },
	  };
	
	  var Autoplay$1 = {
	    name: 'autoplay',
	    params: {
	      autoplay: {
	        enabled: false,
	        delay: 3000,
	        waitForTransition: true,
	        disableOnInteraction: true,
	        stopOnLastSlide: false,
	        reverseDirection: false,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        autoplay: {
	          running: false,
	          paused: false,
	          run: Autoplay.run.bind(swiper),
	          start: Autoplay.start.bind(swiper),
	          stop: Autoplay.stop.bind(swiper),
	          pause: Autoplay.pause.bind(swiper),
	          onTransitionEnd: function onTransitionEnd(e) {
	            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
	            if (e.target !== this) { return; }
	            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
	            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
	            swiper.autoplay.paused = false;
	            if (!swiper.autoplay.running) {
	              swiper.autoplay.stop();
	            } else {
	              swiper.autoplay.run();
	            }
	          },
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.autoplay.enabled) {
	          swiper.autoplay.start();
	        }
	      },
	      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
	        var swiper = this;
	        if (swiper.autoplay.running) {
	          if (internal || !swiper.params.autoplay.disableOnInteraction) {
	            swiper.autoplay.pause(speed);
	          } else {
	            swiper.autoplay.stop();
	          }
	        }
	      },
	      sliderFirstMove: function sliderFirstMove() {
	        var swiper = this;
	        if (swiper.autoplay.running) {
	          if (swiper.params.autoplay.disableOnInteraction) {
	            swiper.autoplay.stop();
	          } else {
	            swiper.autoplay.pause();
	          }
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.autoplay.running) {
	          swiper.autoplay.stop();
	        }
	      },
	    },
	  };
	
	  var Fade = {
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      var slides = swiper.slides;
	      for (var i = 0; i < slides.length; i += 1) {
	        var $slideEl = swiper.slides.eq(i);
	        var offset = $slideEl[0].swiperSlideOffset;
	        var tx = -offset;
	        if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
	        var ty = 0;
	        if (!swiper.isHorizontal()) {
	          ty = tx;
	          tx = 0;
	        }
	        var slideOpacity = swiper.params.fadeEffect.crossFade
	          ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
	          : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
	        $slideEl
	          .css({
	            opacity: slideOpacity,
	          })
	          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
	      }
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      var slides = swiper.slides;
	      var $wrapperEl = swiper.$wrapperEl;
	      slides.transition(duration);
	      if (swiper.params.virtualTranslate && duration !== 0) {
	        var eventTriggered = false;
	        slides.transitionEnd(function () {
	          if (eventTriggered) { return; }
	          if (!swiper || swiper.destroyed) { return; }
	          eventTriggered = true;
	          swiper.animating = false;
	          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	          for (var i = 0; i < triggerEvents.length; i += 1) {
	            $wrapperEl.trigger(triggerEvents[i]);
	          }
	        });
	      }
	    },
	  };
	
	  var EffectFade = {
	    name: 'effect-fade',
	    params: {
	      fadeEffect: {
	        crossFade: false,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        fadeEffect: {
	          setTranslate: Fade.setTranslate.bind(swiper),
	          setTransition: Fade.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (swiper.params.effect !== 'fade') { return; }
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
	        var overwriteParams = {
	          slidesPerView: 1,
	          slidesPerColumn: 1,
	          slidesPerGroup: 1,
	          watchSlidesProgress: true,
	          spaceBetween: 0,
	          virtualTranslate: true,
	        };
	        Utils.extend(swiper.params, overwriteParams);
	        Utils.extend(swiper.originalParams, overwriteParams);
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (swiper.params.effect !== 'fade') { return; }
	        swiper.fadeEffect.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        if (swiper.params.effect !== 'fade') { return; }
	        swiper.fadeEffect.setTransition(duration);
	      },
	    },
	  };
	
	  var Cube = {
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      var $el = swiper.$el;
	      var $wrapperEl = swiper.$wrapperEl;
	      var slides = swiper.slides;
	      var swiperWidth = swiper.width;
	      var swiperHeight = swiper.height;
	      var rtl = swiper.rtlTranslate;
	      var swiperSize = swiper.size;
	      var params = swiper.params.cubeEffect;
	      var isHorizontal = swiper.isHorizontal();
	      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	      var wrapperRotate = 0;
	      var $cubeShadowEl;
	      if (params.shadow) {
	        if (isHorizontal) {
	          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
	          if ($cubeShadowEl.length === 0) {
	            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
	            $wrapperEl.append($cubeShadowEl);
	          }
	          $cubeShadowEl.css({ height: (swiperWidth + "px") });
	        } else {
	          $cubeShadowEl = $el.find('.swiper-cube-shadow');
	          if ($cubeShadowEl.length === 0) {
	            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
	            $el.append($cubeShadowEl);
	          }
	        }
	      }
	      for (var i = 0; i < slides.length; i += 1) {
	        var $slideEl = slides.eq(i);
	        var slideIndex = i;
	        if (isVirtual) {
	          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
	        }
	        var slideAngle = slideIndex * 90;
	        var round = Math.floor(slideAngle / 360);
	        if (rtl) {
	          slideAngle = -slideAngle;
	          round = Math.floor(-slideAngle / 360);
	        }
	        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	        var tx = 0;
	        var ty = 0;
	        var tz = 0;
	        if (slideIndex % 4 === 0) {
	          tx = -round * 4 * swiperSize;
	          tz = 0;
	        } else if ((slideIndex - 1) % 4 === 0) {
	          tx = 0;
	          tz = -round * 4 * swiperSize;
	        } else if ((slideIndex - 2) % 4 === 0) {
	          tx = swiperSize + (round * 4 * swiperSize);
	          tz = swiperSize;
	        } else if ((slideIndex - 3) % 4 === 0) {
	          tx = -swiperSize;
	          tz = (3 * swiperSize) + (swiperSize * 4 * round);
	        }
	        if (rtl) {
	          tx = -tx;
	        }
	
	        if (!isHorizontal) {
	          ty = tx;
	          tx = 0;
	        }
	
	        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
	        if (progress <= 1 && progress > -1) {
	          wrapperRotate = (slideIndex * 90) + (progress * 90);
	          if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
	        }
	        $slideEl.transform(transform);
	        if (params.slideShadows) {
	          // Set shadows
	          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	          if (shadowBefore.length === 0) {
	            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	            $slideEl.append(shadowBefore);
	          }
	          if (shadowAfter.length === 0) {
	            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	            $slideEl.append(shadowAfter);
	          }
	          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	        }
	      }
	      $wrapperEl.css({
	        '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	        '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	        '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	        'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	      });
	
	      if (params.shadow) {
	        if (isHorizontal) {
	          $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
	        } else {
	          var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
	          var multiplier = 1.5 - (
	            (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
	            + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
	          );
	          var scale1 = params.shadowScale;
	          var scale2 = params.shadowScale / multiplier;
	          var offset = params.shadowOffset;
	          $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
	        }
	      }
	      var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
	      $wrapperEl
	        .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      var $el = swiper.$el;
	      var slides = swiper.slides;
	      slides
	        .transition(duration)
	        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	        .transition(duration);
	      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
	        $el.find('.swiper-cube-shadow').transition(duration);
	      }
	    },
	  };
	
	  var EffectCube = {
	    name: 'effect-cube',
	    params: {
	      cubeEffect: {
	        slideShadows: true,
	        shadow: true,
	        shadowOffset: 20,
	        shadowScale: 0.94,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        cubeEffect: {
	          setTranslate: Cube.setTranslate.bind(swiper),
	          setTransition: Cube.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (swiper.params.effect !== 'cube') { return; }
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	        var overwriteParams = {
	          slidesPerView: 1,
	          slidesPerColumn: 1,
	          slidesPerGroup: 1,
	          watchSlidesProgress: true,
	          resistanceRatio: 0,
	          spaceBetween: 0,
	          centeredSlides: false,
	          virtualTranslate: true,
	        };
	        Utils.extend(swiper.params, overwriteParams);
	        Utils.extend(swiper.originalParams, overwriteParams);
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (swiper.params.effect !== 'cube') { return; }
	        swiper.cubeEffect.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        if (swiper.params.effect !== 'cube') { return; }
	        swiper.cubeEffect.setTransition(duration);
	      },
	    },
	  };
	
	  var Flip = {
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      var slides = swiper.slides;
	      var rtl = swiper.rtlTranslate;
	      for (var i = 0; i < slides.length; i += 1) {
	        var $slideEl = slides.eq(i);
	        var progress = $slideEl[0].progress;
	        if (swiper.params.flipEffect.limitRotation) {
	          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	        }
	        var offset = $slideEl[0].swiperSlideOffset;
	        var rotate = -180 * progress;
	        var rotateY = rotate;
	        var rotateX = 0;
	        var tx = -offset;
	        var ty = 0;
	        if (!swiper.isHorizontal()) {
	          ty = tx;
	          tx = 0;
	          rotateX = -rotateY;
	          rotateY = 0;
	        } else if (rtl) {
	          rotateY = -rotateY;
	        }
	
	        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
	
	        if (swiper.params.flipEffect.slideShadows) {
	          // Set shadows
	          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	          if (shadowBefore.length === 0) {
	            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
	            $slideEl.append(shadowBefore);
	          }
	          if (shadowAfter.length === 0) {
	            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
	            $slideEl.append(shadowAfter);
	          }
	          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	        }
	        $slideEl
	          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
	      }
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      var slides = swiper.slides;
	      var activeIndex = swiper.activeIndex;
	      var $wrapperEl = swiper.$wrapperEl;
	      slides
	        .transition(duration)
	        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	        .transition(duration);
	      if (swiper.params.virtualTranslate && duration !== 0) {
	        var eventTriggered = false;
	        // eslint-disable-next-line
	        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
	          if (eventTriggered) { return; }
	          if (!swiper || swiper.destroyed) { return; }
	          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
	          eventTriggered = true;
	          swiper.animating = false;
	          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	          for (var i = 0; i < triggerEvents.length; i += 1) {
	            $wrapperEl.trigger(triggerEvents[i]);
	          }
	        });
	      }
	    },
	  };
	
	  var EffectFlip = {
	    name: 'effect-flip',
	    params: {
	      flipEffect: {
	        slideShadows: true,
	        limitRotation: true,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        flipEffect: {
	          setTranslate: Flip.setTranslate.bind(swiper),
	          setTransition: Flip.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (swiper.params.effect !== 'flip') { return; }
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	        var overwriteParams = {
	          slidesPerView: 1,
	          slidesPerColumn: 1,
	          slidesPerGroup: 1,
	          watchSlidesProgress: true,
	          spaceBetween: 0,
	          virtualTranslate: true,
	        };
	        Utils.extend(swiper.params, overwriteParams);
	        Utils.extend(swiper.originalParams, overwriteParams);
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (swiper.params.effect !== 'flip') { return; }
	        swiper.flipEffect.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        if (swiper.params.effect !== 'flip') { return; }
	        swiper.flipEffect.setTransition(duration);
	      },
	    },
	  };
	
	  var Coverflow = {
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      var swiperWidth = swiper.width;
	      var swiperHeight = swiper.height;
	      var slides = swiper.slides;
	      var $wrapperEl = swiper.$wrapperEl;
	      var slidesSizesGrid = swiper.slidesSizesGrid;
	      var params = swiper.params.coverflowEffect;
	      var isHorizontal = swiper.isHorizontal();
	      var transform = swiper.translate;
	      var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
	      var rotate = isHorizontal ? params.rotate : -params.rotate;
	      var translate = params.depth;
	      // Each slide offset from center
	      for (var i = 0, length = slides.length; i < length; i += 1) {
	        var $slideEl = slides.eq(i);
	        var slideSize = slidesSizesGrid[i];
	        var slideOffset = $slideEl[0].swiperSlideOffset;
	        var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;
	
	        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
	        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
	        // var rotateZ = 0
	        var translateZ = -translate * Math.abs(offsetMultiplier);
	
	        var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
	        var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;
	
	        // Fix for ultra small values
	        if (Math.abs(translateX) < 0.001) { translateX = 0; }
	        if (Math.abs(translateY) < 0.001) { translateY = 0; }
	        if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
	        if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
	        if (Math.abs(rotateX) < 0.001) { rotateX = 0; }
	
	        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";
	
	        $slideEl.transform(slideTransform);
	        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	        if (params.slideShadows) {
	          // Set shadows
	          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	          if ($shadowBeforeEl.length === 0) {
	            $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	            $slideEl.append($shadowBeforeEl);
	          }
	          if ($shadowAfterEl.length === 0) {
	            $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	            $slideEl.append($shadowAfterEl);
	          }
	          if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
	          if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
	        }
	      }
	
	      // Set correct perspective for IE10
	      if (Support.pointerEvents || Support.prefixedPointerEvents) {
	        var ws = $wrapperEl[0].style;
	        ws.perspectiveOrigin = center + "px 50%";
	      }
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      swiper.slides
	        .transition(duration)
	        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	        .transition(duration);
	    },
	  };
	
	  var EffectCoverflow = {
	    name: 'effect-coverflow',
	    params: {
	      coverflowEffect: {
	        rotate: 50,
	        stretch: 0,
	        depth: 100,
	        modifier: 1,
	        slideShadows: true,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        coverflowEffect: {
	          setTranslate: Coverflow.setTranslate.bind(swiper),
	          setTransition: Coverflow.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (swiper.params.effect !== 'coverflow') { return; }
	
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	
	        swiper.params.watchSlidesProgress = true;
	        swiper.originalParams.watchSlidesProgress = true;
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (swiper.params.effect !== 'coverflow') { return; }
	        swiper.coverflowEffect.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        if (swiper.params.effect !== 'coverflow') { return; }
	        swiper.coverflowEffect.setTransition(duration);
	      },
	    },
	  };
	
	  var Thumbs = {
	    init: function init() {
	      var swiper = this;
	      var ref = swiper.params;
	      var thumbsParams = ref.thumbs;
	      var SwiperClass = swiper.constructor;
	      if (thumbsParams.swiper instanceof SwiperClass) {
	        swiper.thumbs.swiper = thumbsParams.swiper;
	        Utils.extend(swiper.thumbs.swiper.originalParams, {
	          watchSlidesProgress: true,
	          slideToClickedSlide: false,
	        });
	        Utils.extend(swiper.thumbs.swiper.params, {
	          watchSlidesProgress: true,
	          slideToClickedSlide: false,
	        });
	      } else if (Utils.isObject(thumbsParams.swiper)) {
	        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
	          watchSlidesVisibility: true,
	          watchSlidesProgress: true,
	          slideToClickedSlide: false,
	        }));
	        swiper.thumbs.swiperCreated = true;
	      }
	      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
	      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
	    },
	    onThumbClick: function onThumbClick() {
	      var swiper = this;
	      var thumbsSwiper = swiper.thumbs.swiper;
	      if (!thumbsSwiper) { return; }
	      var clickedIndex = thumbsSwiper.clickedIndex;
	      var clickedSlide = thumbsSwiper.clickedSlide;
	      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) { return; }
	      if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
	      var slideToIndex;
	      if (thumbsSwiper.params.loop) {
	        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	      } else {
	        slideToIndex = clickedIndex;
	      }
	      if (swiper.params.loop) {
	        var currentIndex = swiper.activeIndex;
	        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
	          swiper.loopFix();
	          // eslint-disable-next-line
	          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	          currentIndex = swiper.activeIndex;
	        }
	        var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
	        var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
	        if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
	        else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
	        else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
	        else { slideToIndex = prevIndex; }
	      }
	      swiper.slideTo(slideToIndex);
	    },
	    update: function update(initial) {
	      var swiper = this;
	      var thumbsSwiper = swiper.thumbs.swiper;
	      if (!thumbsSwiper) { return; }
	
	      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
	        ? thumbsSwiper.slidesPerViewDynamic()
	        : thumbsSwiper.params.slidesPerView;
	
	      if (swiper.realIndex !== thumbsSwiper.realIndex) {
	        var currentThumbsIndex = thumbsSwiper.activeIndex;
	        var newThumbsIndex;
	        if (thumbsSwiper.params.loop) {
	          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
	            thumbsSwiper.loopFix();
	            // eslint-disable-next-line
	            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
	            currentThumbsIndex = thumbsSwiper.activeIndex;
	          }
	          // Find actual thumbs index to slide to
	          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
	          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
	          if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
	          else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
	          else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = currentThumbsIndex; }
	          else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
	          else { newThumbsIndex = prevThumbsIndex; }
	        } else {
	          newThumbsIndex = swiper.realIndex;
	        }
	        if (thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
	          if (thumbsSwiper.params.centeredSlides) {
	            if (newThumbsIndex > currentThumbsIndex) {
	              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
	            } else {
	              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
	            }
	          } else if (newThumbsIndex > currentThumbsIndex) {
	            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
	          }
	          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
	        }
	      }
	
	      // Activate thumbs
	      var thumbsToActivate = 1;
	      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
	
	      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
	        thumbsToActivate = swiper.params.slidesPerView;
	      }
	
	      thumbsSwiper.slides.removeClass(thumbActiveClass);
	      if (thumbsSwiper.params.loop) {
	        for (var i = 0; i < thumbsToActivate; i += 1) {
	          thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
	        }
	      } else {
	        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
	          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
	        }
	      }
	    },
	  };
	  var Thumbs$1 = {
	    name: 'thumbs',
	    params: {
	      thumbs: {
	        swiper: null,
	        slideThumbActiveClass: 'swiper-slide-thumb-active',
	        thumbsContainerClass: 'swiper-container-thumbs',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        thumbs: {
	          swiper: null,
	          init: Thumbs.init.bind(swiper),
	          update: Thumbs.update.bind(swiper),
	          onThumbClick: Thumbs.onThumbClick.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        var ref = swiper.params;
	        var thumbs = ref.thumbs;
	        if (!thumbs || !thumbs.swiper) { return; }
	        swiper.thumbs.init();
	        swiper.thumbs.update(true);
	      },
	      slideChange: function slideChange() {
	        var swiper = this;
	        if (!swiper.thumbs.swiper) { return; }
	        swiper.thumbs.update();
	      },
	      update: function update() {
	        var swiper = this;
	        if (!swiper.thumbs.swiper) { return; }
	        swiper.thumbs.update();
	      },
	      resize: function resize() {
	        var swiper = this;
	        if (!swiper.thumbs.swiper) { return; }
	        swiper.thumbs.update();
	      },
	      observerUpdate: function observerUpdate() {
	        var swiper = this;
	        if (!swiper.thumbs.swiper) { return; }
	        swiper.thumbs.update();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        var thumbsSwiper = swiper.thumbs.swiper;
	        if (!thumbsSwiper) { return; }
	        thumbsSwiper.setTransition(duration);
	      },
	      beforeDestroy: function beforeDestroy() {
	        var swiper = this;
	        var thumbsSwiper = swiper.thumbs.swiper;
	        if (!thumbsSwiper) { return; }
	        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
	          thumbsSwiper.destroy();
	        }
	      },
	    },
	  };
	
	  // Swiper Class
	
	  var components = [
	    Device$1,
	    Support$1,
	    Browser$1,
	    Resize,
	    Observer$1,
	    Virtual$1,
	    Keyboard$1,
	    Mousewheel$1,
	    Navigation$1,
	    Pagination$1,
	    Scrollbar$1,
	    Parallax$1,
	    Zoom$1,
	    Lazy$1,
	    Controller$1,
	    A11y,
	    History$1,
	    HashNavigation$1,
	    Autoplay$1,
	    EffectFade,
	    EffectCube,
	    EffectFlip,
	    EffectCoverflow,
	    Thumbs$1
	  ];
	
	  if (typeof Swiper.use === 'undefined') {
	    Swiper.use = Swiper.Class.use;
	    Swiper.installModule = Swiper.Class.installModule;
	  }
	
	  Swiper.use(components);
	
	  return Swiper;
	
	})));


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.2052.d9a22.js